'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var classNames = require('classnames');
var nextId = require('react-id-generator');
var ReactDatePicker = require('react-datepicker');
var ja = require('date-fns/locale/ja');
var dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
var isBetween = require('dayjs/plugin/isBetween');
var dateFns = require('date-fns');
var ReactDOM = require('react-dom');
var uuid = require('uuid');
var dialogPolyfill = require('dialog-polyfill');
var reactNumberFormat = require('react-number-format');
var onClickOutside = require('react-onclickoutside');
require('url-search-params-polyfill');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var freeBrandsSvgIcons = require('@fortawesome/free-brands-svg-icons');
var freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
var Card = require('react-credit-cards');
var Payment = require('payment');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var classNames__default = /*#__PURE__*/_interopDefault(classNames);
var nextId__default = /*#__PURE__*/_interopDefault(nextId);
var ReactDatePicker__default = /*#__PURE__*/_interopDefault(ReactDatePicker);
var ja__default = /*#__PURE__*/_interopDefault(ja);
var dayjs__default = /*#__PURE__*/_interopDefault(dayjs);
var utc__default = /*#__PURE__*/_interopDefault(utc);
var timezone__default = /*#__PURE__*/_interopDefault(timezone);
var isBetween__default = /*#__PURE__*/_interopDefault(isBetween);
var ReactDOM__default = /*#__PURE__*/_interopDefault(ReactDOM);
var dialogPolyfill__default = /*#__PURE__*/_interopDefault(dialogPolyfill);
var onClickOutside__default = /*#__PURE__*/_interopDefault(onClickOutside);
var Card__default = /*#__PURE__*/_interopDefault(Card);
var Payment__default = /*#__PURE__*/_interopDefault(Payment);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$R = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/* buttonのブラウザ標準のスタイルは使用しない */\n\nbutton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n/*フォント周りの共通設定、変数*/\n\nbody {\n  color: #1d1c1a;\n}\n";
styleInject(css_248z$R);

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var css_248z$Q = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.form-container-module__GDK__container___dJ5a6 {\n  display: flex;\n  flex-direction: column;\n  padding: 64px;\n  background-color: #fffefc;\n  width: 736px;\n  margin: 40px auto 0;\n}\n\n.form-container-module__GDK__container___dJ5a6 .form-container-module__GDK__form___nWIh0 {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.form-container-module__GDK__container___dJ5a6 .form-container-module__GDK__form___nWIh0 .form-container-module__GDK__item___NectE {\n  width: 100%;\n}\n\n.form-container-module__GDK__container___dJ5a6 .form-container-module__GDK__button___eHn1G {\n  margin-top: 40px;\n}\n\n@media screen and (max-width: 800px) {\n  .form-container-module__GDK__container___dJ5a6 {\n    width: initial;\n    margin: initial;\n    padding: 16px;\n  }\n\n  .form-container-module__GDK__container___dJ5a6 .form-container-module__GDK__form___nWIh0 {\n    gap: 24px;\n  }\n}\n";
var styles$O = {"container":"form-container-module__GDK__container___dJ5a6","form":"form-container-module__GDK__form___nWIh0","item":"form-container-module__GDK__item___NectE","button":"form-container-module__GDK__button___eHn1G"};
styleInject(css_248z$Q);

var _excluded$E = ["children"],
  _excluded2$i = ["children"],
  _excluded3$b = ["children", "maxWidth"];
var FormItem = function FormItem(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$E);
  return React__namespace.default.createElement("div", _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$O.item
  }), children);
};
var Form$1 = function Form(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2$i);
  return React__namespace.default.createElement("div", _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$O.form
  }), children);
};
var FormContainer = function FormContainer(_ref3) {
  var children = _ref3.children,
    maxWidth = _ref3.maxWidth,
    props = _objectWithoutProperties(_ref3, _excluded3$b);
  var style = {
    maxWidth: maxWidth
  };
  return React__namespace.default.createElement("div", _objectSpread2({
    className: styles$O.container,
    style: style
  }, props), children);
};

/**
 * ValueObjectの基本型
 */
var BaseValue = /*#__PURE__*/function () {
  function BaseValue(value) {
    _classCallCheck(this, BaseValue);
    this.value = value;
  }
  return _createClass(BaseValue, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }]);
}();

/**
 * StringLiteralsをベースにした選択可能なValueObjectの基本型
 */
var BaseType = /*#__PURE__*/function (_BaseValue) {
  function BaseType() {
    _classCallCheck(this, BaseType);
    return _callSuper(this, BaseType, arguments);
  }
  _inherits(BaseType, _BaseValue);
  return _createClass(BaseType, [{
    key: "equals",
    value: function equals(type) {
      return this.value === type;
    }
  }, {
    key: "typeEquals",
    value: function typeEquals(target) {
      return this.value === target.value;
    }
  }, {
    key: "matchType",
    value: function matchType(matcher) {
      return matcher[this.value];
    }
  }, {
    key: "matchCall",
    value: function matchCall(matcher) {
      return matcher[this.getValue()]();
    }
  }]);
}(BaseValue);

var FormState = /*#__PURE__*/function (_BaseType) {
  function FormState(value, errorMessage) {
    var _this;
    _classCallCheck(this, FormState);
    _this = _callSuper(this, FormState, [value]);
    _this.errorMessage = errorMessage;
    return _this;
  }
  /**
   * UIの状態を管理するStateを生成する
   *
   * @param isTouched
   * @param isValid
   * @param noValidate
   * @param disabled
   * @param errorMessage
   * @param readOnly
   * @returns
   */
  _inherits(FormState, _BaseType);
  return _createClass(FormState, [{
    key: "matchComponents",
    value: function matchComponents(matcher) {
      if (this.value === "readOnly") {
        return matcher.readOnly;
      }
      if (!this.errorMessage) {
        return matcher["default"];
      }
      return matcher[this.value];
    }
    /**
     * 状態が fail の場合 true 、それ以外の場合 false を返す
     */
  }, {
    key: "isFail",
    value: function isFail() {
      return this.matchType({
        "default": false,
        success: false,
        disabled: false,
        fail: true,
        readOnly: false
      });
    }
  }], [{
    key: "create",
    value: function create(isTouched, isValid, noValidate, disabled, errorMessage, readOnly) {
      if (readOnly) {
        return new FormState("readOnly", errorMessage);
      }
      if (disabled) {
        return new FormState("disabled", errorMessage);
      }
      if (!isTouched) {
        return new FormState("default", errorMessage);
      }
      if (noValidate) {
        return new FormState("default", errorMessage);
      }
      if (isValid) {
        return new FormState("success", errorMessage);
      }
      if (!isValid) {
        return new FormState("fail", errorMessage);
      }
      return new FormState("default", errorMessage);
    }
  }]);
}(BaseType);

function useFormState(_ref) {
  var value = _ref.value,
    validate = _ref.validate,
    noValidate = _ref.noValidate,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    onBlur = _ref.onBlur,
    readOnly = _ref.readOnly;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var formState = React.useMemo(function () {
    return FormState.create(touched, validate(value), noValidate, disabled, errorMessage, readOnly);
  }, [disabled, errorMessage, noValidate, touched, validate, value, readOnly]);
  var handleBlur = React.useCallback(function (event) {
    setTouched(true);
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [onBlur]);
  return {
    formState: formState,
    handleBlur: handleBlur
  };
}

var css_248z$P = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.base-text-input-module__GDK__wrap___FXo1K {\n  position: relative;\n  width: 100%;\n}\n\n.base-text-input-module__GDK__input___w3Sms {\n  width: 100%;\n  height: 56px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  padding: 12px 24px;\n  border: 1px solid #706d6c;\n  background-color: #fff;\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-text-input-module__GDK__input___w3Sms {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n/* width: 800px(SP幅)未満かつ、StateがreadOnlyの時に使用される想定のクラス。（iosの為に対応）*/\n\n.base-text-input-module__GDK__readOnlySpDivWrap___vvvIC {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  /* アイコンを表示する時のスペース確保のため、rightは広めに指定。*/\n  padding: 8px 52px 8px 16px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  color: #1d1c1a;\n  background-color: #faf9f7;\n  border: 1px solid #706d6c;\n  align-items: center;\n}\n\n/* width: 800px(SP幅)未満かつ、StateがreadOnlyの時に使用される想定のクラス。（iosの為に対応）*/\n\n.base-text-input-module__GDK__readOnlySpDivText___yfn9r {\n  display: flex;\n  width: 100%;\n  white-space: nowrap;\n  overflow: scroll;\n  /* スクロールバーの位置を下げる（文字から離す）ために指定。*/\n  height: 48px;\n  line-height: 48px;\n}\n\n/* width: 800px(SP幅)未満かつ、StateがreadOnlyの時に使用される想定のクラス。（iosの為に対応）*/\n\n.base-text-input-module__GDK__readOnlySpIcon___C5E-2 {\n  display: block;\n  line-height: 1;\n  margin-right: -44px;\n  margin-left: 8px;\n  cursor: not-allowed;\n}\n\n.base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__needStatusIcon___UPHXV.base-text-input-module__GDK__success___CVhLC,\n.base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__needStatusIcon___UPHXV.base-text-input-module__GDK__fail___i66KK,\n.base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__readOnly___Vw3pG {\n  /* アイコンを表示する時のスペース確保のため、rightは広めに指定。*/\n  padding: 12px 56px 12px 24px;\n}\n\n.base-text-input-module__GDK__input___w3Sms::-moz-placeholder {\n  color: #b8b5b4;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.base-text-input-module__GDK__input___w3Sms::placeholder {\n  color: #b8b5b4;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-text-input-module__GDK__input___w3Sms::-moz-placeholder {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  .base-text-input-module__GDK__input___w3Sms::placeholder {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.base-text-input-module__GDK__input___w3Sms:not(:disabled):hover {\n  background-color: #fff;\n  border: 1px solid #3d3b3a;\n}\n\n.base-text-input-module__GDK__disabled___wDxhl.base-text-input-module__GDK__input___w3Sms {\n  background-color: #faf9f7;\n  color: #706d6c;\n  cursor: not-allowed;\n  outline: 0;\n  box-shadow: none;\n  border: none;\n  /* safariのための対応 */\n  -webkit-text-fill-color: #706d6c;\n  opacity: 1;\n}\n\n.base-text-input-module__GDK__input___w3Sms:not(:disabled):focus {\n  background-color: #fff;\n  outline: 0;\n  border: 1px solid #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-text-input-module__GDK__fail___i66KK.base-text-input-module__GDK__input___w3Sms {\n  background-color: #fff7f8;\n  border: 1px solid #de3226;\n}\n\n.base-text-input-module__GDK__fail___i66KK.base-text-input-module__GDK__input___w3Sms:not(:disabled):hover {\n  background-color: #fff7f8;\n  border: 1px solid #f64c41;\n}\n\n.base-text-input-module__GDK__fail___i66KK.base-text-input-module__GDK__input___w3Sms:not(:disabled):focus {\n  background-color: #fff7f8;\n}\n\n.base-text-input-module__GDK__success___CVhLC.base-text-input-module__GDK__input___w3Sms {\n  background-color: #fff;\n  border: 1px solid #237f6d;\n}\n\n.base-text-input-module__GDK__success___CVhLC.base-text-input-module__GDK__input___w3Sms:not(:disabled):hover {\n  background-color: #fff;\n  border: 1px solid #3dac9a;\n}\n\n.base-text-input-module__GDK__success___CVhLC.base-text-input-module__GDK__input___w3Sms:not(:disabled):focus {\n  background-color: #fff;\n}\n\n.base-text-input-module__GDK__icon___R0xD2 {\n  position: absolute;\n  display: inline-block;\n  line-height: 1;\n  margin-top: 12px;\n  margin-left: -48px;\n}\n\n.base-text-input-module__GDK__readOnly___Vw3pG.base-text-input-module__GDK__input___w3Sms {\n  color: #1d1c1a;\n  background-color: #faf9f7;\n  border: 1px solid #706d6c;\n}\n\n.base-text-input-module__GDK__readOnly___Vw3pG.base-text-input-module__GDK__input___w3Sms:hover {\n  background-color: #faf9f7;\n  border: 1px solid #706d6c;\n  cursor: not-allowed;\n}\n\n.base-text-input-module__GDK__readOnlySpDivWrap___vvvIC:hover {\n  background-color: #faf9f7;\n  border: 1px solid #706d6c;\n  cursor: not-allowed;\n}\n\n.base-text-input-module__GDK__readOnly___Vw3pG.base-text-input-module__GDK__input___w3Sms:focus {\n  background-color: #faf9f7;\n  outline: 0;\n  border: 1px solid #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-text-input-module__GDK__readOnlySpDivWrap___vvvIC:focus {\n  background-color: #faf9f7;\n  outline: 0;\n  border: 1px solid #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-text-input-module__GDK__readOnlySpDivWrap___vvvIC:focus-visible {\n  background-color: #faf9f7;\n  outline: 0;\n  border: 1px solid #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-text-input-module__GDK__readOnlyIcon___HCmf-:hover {\n  cursor: not-allowed;\n}\n\n@media screen and (max-width: 800px) {\n  .base-text-input-module__GDK__input___w3Sms {\n    height: 48px;\n    padding: 8px 16px;\n  }\n  .base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__needStatusIcon___UPHXV.base-text-input-module__GDK__success___CVhLC,\n  .base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__needStatusIcon___UPHXV.base-text-input-module__GDK__fail___i66KK,\n  .base-text-input-module__GDK__input___w3Sms.base-text-input-module__GDK__readOnly___Vw3pG {\n    /* アイコンを表示する時のスペース確保のため、rightは広めに指定。*/\n    padding: 8px 52px 8px 16px;\n  }\n  .base-text-input-module__GDK__input___w3Sms::-moz-placeholder {\n    font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n  .base-text-input-module__GDK__input___w3Sms::placeholder {\n    font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n  .base-text-input-module__GDK__icon___R0xD2 {\n    margin-top: 8px;\n  }\n}\n";
var inputStyles = {"wrap":"base-text-input-module__GDK__wrap___FXo1K","input":"base-text-input-module__GDK__input___w3Sms","readOnlySpDivWrap":"base-text-input-module__GDK__readOnlySpDivWrap___vvvIC","readOnlySpDivText":"base-text-input-module__GDK__readOnlySpDivText___yfn9r","readOnlySpIcon":"base-text-input-module__GDK__readOnlySpIcon___C5E-2","needStatusIcon":"base-text-input-module__GDK__needStatusIcon___UPHXV","success":"base-text-input-module__GDK__success___CVhLC","fail":"base-text-input-module__GDK__fail___i66KK","readOnly":"base-text-input-module__GDK__readOnly___Vw3pG","disabled":"base-text-input-module__GDK__disabled___wDxhl","icon":"base-text-input-module__GDK__icon___R0xD2","readOnlyIcon":"base-text-input-module__GDK__readOnlyIcon___HCmf-"};
styleInject(css_248z$P);

/**
 * aria-describedby に設定する値を返却。
 */
var getAreaDescribedByValue = function getAreaDescribedByValue(ids) {
  var values = ids.filter(function (v) {
    return v !== undefined && v !== "";
  });
  // 1つもIdが指定されていない場合は、undefinedを返却。
  if (values.length < 1) {
    return undefined;
  }
  // 複数のIdがある場合にはスペースで結合して返却。
  return values.join(" ");
};
/**
 * labelに設定するidを返却。
 * (Sp幅readOnlyの際に<input type="text">のような見た目になるように実装した<div><div> に対して、labelを関連付ける際に使用。)
 */
var getLabelId = function getLabelId(id) {
  return id ? "label-".concat(id) : undefined;
};

var IconSizes = {
  extraSmall: 16,
  lessSmall: 20,
  small: 24,
  /** @deprecated use `spButtonMedium` */
  spButtonMidium: 28,
  spButtonMedium: 28,
  /** @deprecated use `medium` */
  midium: 32,
  medium: 32,
  large: 40
};
// 「--wh」 in variables.css
var BUTTON_WHITE_COLOR = "#fff";
/**
 * ボタンの種類ごとに、SVGの <path fill="◯◯◯">  ← ◯◯◯部分に指定する値（色）を定義。
 * 「inherit」は <svg fill="xxx"> ← xxx部分に指定された色を引き継ぐ。
 */
var buttonIconColors = {
  Primary: {
    inner: "inherit",
    outer: BUTTON_WHITE_COLOR
  },
  Secondary: {
    inner: BUTTON_WHITE_COLOR,
    outer: "inherit"
  },
  Danger: {
    inner: "inherit",
    outer: BUTTON_WHITE_COLOR
  },
  DangerSecondary: {
    inner: BUTTON_WHITE_COLOR,
    outer: "inherit"
  },
  Text: {
    inner: BUTTON_WHITE_COLOR,
    outer: "inherit"
  }
};
/**
 * SVGアイコンに設定する色セットを返却。
 * @param isReversible
 * @param defaultIconColor アイコンにデフォルトで指定する色セット。
 * @param buttonType
 * @returns
 */
var getIconcolorSet = function getIconcolorSet(isReversible, defaultIconColor, buttonType) {
  // isReversible が true の場合はデフォルトの色を反転した色セットを返却。
  if (isReversible) {
    return {
      inner: defaultIconColor.outer,
      outer: defaultIconColor.inner
    };
  }
  // ボタン内で使用されるアイコンの場合は、ボタンの種類に応じた色セットを返却。
  if (buttonType !== undefined) {
    return buttonIconColors[buttonType];
  }
  return defaultIconColor;
};
/**
 * 外枠が不要なSVGアイコンに指定する色を返却。
 * @param defaultSetIconColor アイコンにデフォルトで指定する色。
 * @param buttonType
 * @returns ボタン内で使用するアイコンの場合はボタンの種類に応じた色を、ボタン以外で使用するアイコンの場合は渡ってきた色(defaultSetIconColor)を返却。
 */
var getIconColor = function getIconColor(defaultSetIconColor, buttonType) {
  return buttonType !== undefined ? buttonIconColors[buttonType].outer : defaultSetIconColor;
};
var getIconSize = function getIconSize(isSmall, isPc) {
  if (isSmall) {
    return IconSizes.small;
  }
  // 大きいボタンの場合はPC端末かSP端末かに応じてアイコンの大きさを変える。
  return isPc ? IconSizes.midium : IconSizes.spButtonMidium;
};

var _excluded$D = ["size", "isReversible", "buttonType", "iconColor", "alt"];
var defaultIconColor$J = {
  inner: "white",
  outer: "#237F6D"
};
var SvgIcon$2 = function SvgIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible,
    buttonType = _ref.buttonType,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$J : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "完了" : _ref$alt,
    props = _objectWithoutProperties(_ref, _excluded$D);
  var iconColorSet = getIconcolorSet(isReversible, iconColor, buttonType);
  return React__namespace.default.createElement("svg", _objectSpread2({
    width: size,
    height: size,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, props), React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u5B8C\u4E86\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u5B8C\u4E86\u307E\u305F\u306F\u6210\u529F\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M20 40.78C31.0457 40.78 40 31.8257 40 20.78C40 9.73433 31.0457 0.780029 20 0.780029C8.9543 0.780029 0 9.73433 0 20.78C0 31.8257 8.9543 40.78 20 40.78Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17.6997 29.43L10.1797 21.53L12.3497 19.46L17.7197 25.09L28.5297 13.88L30.6897 15.96L17.6997 29.43Z",
    fill: iconColorSet.inner
  })));
};
var CheckIcon = function CheckIcon(props) {
  return React__namespace.default.createElement(SvgIcon$2, _objectSpread2({
    focusable: "false"
  }, props));
};

var _excluded$C = ["size", "isReversible", "buttonType", "iconColor", "alt"];
var defaultIconColor$I = {
  inner: "white",
  outer: "#D53B3A"
};
var SvgIcon$1 = function SvgIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible,
    buttonType = _ref.buttonType,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$I : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "エラー" : _ref$alt,
    props = _objectWithoutProperties(_ref, _excluded$C);
  var iconColorSet = getIconcolorSet(isReversible, iconColor, buttonType);
  return React__namespace.default.createElement("svg", _objectSpread2({
    width: size,
    height: size,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, props), React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30A8\u30E9\u30FC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30A8\u30E9\u30FC\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M20.5938 40.5C31.6394 40.5 40.5938 31.5457 40.5938 20.5C40.5938 9.4543 31.6394 0.5 20.5938 0.5C9.54805 0.5 0.59375 9.4543 0.59375 20.5C0.59375 31.5457 9.54805 40.5 20.5938 40.5Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17.5596 29.2575C17.5596 27.6375 18.7296 26.3775 20.2896 26.3775C21.8496 26.3775 23.0496 27.6375 23.0496 29.2575C23.0496 30.8775 21.8496 32.1375 20.2896 32.1375C18.7296 32.1375 17.5596 30.8775 17.5596 29.2575ZM18.2196 13.0875L18.0696 8.91748H22.5096L22.3596 13.0875L21.7296 24.1575H18.8496L18.2196 13.0875Z",
    fill: iconColorSet.inner
  })));
};
var AttentionIcon = function AttentionIcon(props) {
  return React__namespace.default.createElement(SvgIcon$1, _objectSpread2({
    focusable: "false"
  }, props));
};

var _excluded$B = ["size", "iconColor", "buttonType", "alt"];
var defaultIconColor$H = "#706D6C";
var SvgIcon = function SvgIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$H : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "編集不可" : _ref$alt,
    props = _objectWithoutProperties(_ref, _excluded$B);
  return React__namespace.default.createElement("svg", _objectSpread2({
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, props), React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u7DE8\u96C6\u4E0D\u53EF\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u7DE8\u96C6\u304C\u3067\u304D\u306A\u3044\u3053\u3068\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M3.20133 22.4144L3.12951 22.4863L2.28564 29.7143L9.52132 28.8703L9.58416 28.8075L3.20133 22.4144Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M23.3281 2.28562L5.10352 20.5137L11.4894 26.9009L29.714 8.67276L23.3281 2.28562Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0529 28.5714L3.42871 4.94721L4.94733 3.42859L28.5716 27.0528L27.0529 28.5714Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};
var NoEditIcon = function NoEditIcon(props) {
  return React__namespace.default.createElement(SvgIcon, _objectSpread2({
    focusable: "false"
  }, props));
};

var useDeviceType = function useDeviceType() {
  var getWindowDimensions = function getWindowDimensions() {
    var _window = window,
      width = _window.innerWidth;
    var isPc = width >= 800;
    return {
      isPc: isPc
    };
  };
  var _useState = React.useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    deviceType = _useState2[0],
    setDeviceType = _useState2[1];
  React.useEffect(function () {
    var onResize = function onResize() {
      setDeviceType(getWindowDimensions());
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("load", onResize);
    return function () {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("load", onResize);
    };
  }, []);
  return deviceType;
};

var _excluded$A = ["errorMessageId", "formState", "needStatusIcon", "descriptionId", "helperTextId"];
/**
 * input[type="text"] のコンポーネント（GDK内部でのみ使用)
 * エラーかどうか等の状態判定は呼び出し元コンポーネントで行う。Propsとして渡ってきた「formState」を元に状態に合ったスタイルを適用して返却。
 */
var BaseTextInput = React__namespace.forwardRef(function InputText(_ref, ref) {
  var errorMessageId = _ref.errorMessageId,
    formState = _ref.formState,
    _ref$needStatusIcon = _ref.needStatusIcon,
    needStatusIcon = _ref$needStatusIcon === void 0 ? false : _ref$needStatusIcon,
    descriptionId = _ref.descriptionId,
    helperTextId = _ref.helperTextId,
    props = _objectWithoutProperties(_ref, _excluded$A);
  var notFailAriaDescribedByValue = getAreaDescribedByValue([descriptionId, helperTextId]);
  // PRODUCTS-8794 数値コンポーネントに対してフォーカスが当たっている状態でスクロールして意図せず値を変更してしまう by chiharu-matsukura · Pull Request #1327 · graffer-inc/graffer-design-kit https://github.com/graffer-inc/graffer-design-kit/pull/1327
  var disableWheel = function disableWheel(e) {
    e.target && e.target.blur();
  };
  var handleWheel = React__namespace.useMemo(function () {
    return props.type === "number" ? disableWheel : undefined;
  }, [props.type]);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  var isReadOnlySp = formState.getValue() === "readOnly" && !isPc;
  if (isReadOnlySp) {
    return React__namespace.createElement("div", _objectSpread2(_objectSpread2({}, props), {}, {
      "aria-labelledby": getLabelId(props.id),
      "aria-describedby": notFailAriaDescribedByValue,
      "aria-readonly": true,
      role: "textbox",
      className: inputStyles.readOnlySpDivWrap,
      tabIndex: 0
    }), React__namespace.createElement("div", {
      className: inputStyles.readOnlySpDivText
    }, props.value), React__namespace.createElement(NoEditIcon, {
      size: 32,
      className: "".concat(inputStyles.readOnlySpIcon)
    }));
  }
  return React__namespace.createElement("div", {
    className: inputStyles.wrap
  }, React__namespace.createElement("input", _objectSpread2(_objectSpread2({}, props), {}, {
    onWheel: handleWheel,
    className: classNames__default.default(inputStyles.input, formState.matchType({
      "default": "",
      disabled: inputStyles.disabled,
      success: inputStyles.success,
      fail: inputStyles.fail,
      readOnly: inputStyles.readOnly
    }), needStatusIcon && inputStyles.needStatusIcon),
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true,
      readOnly: false
    }),
    "aria-describedby": formState.matchType({
      "default": notFailAriaDescribedByValue,
      disabled: notFailAriaDescribedByValue,
      success: notFailAriaDescribedByValue,
      fail: getAreaDescribedByValue([descriptionId, errorMessageId, helperTextId]),
      readOnly: notFailAriaDescribedByValue
    }),
    "aria-required": props.required,
    ref: ref
  })), formState.matchType({
    "default": null,
    disabled: null,
    success: needStatusIcon && React__namespace.createElement(CheckIcon, {
      size: 32,
      className: inputStyles.icon,
      role: "img",
      alt: "\u5165\u529B\u6210\u529F"
    }),
    fail: needStatusIcon && React__namespace.createElement(AttentionIcon, {
      size: 32,
      className: inputStyles.icon,
      role: "img",
      alt: "\u5165\u529B\u30A8\u30E9\u30FC"
    }),
    readOnly: React__namespace.createElement(NoEditIcon, {
      size: 32,
      className: "".concat(inputStyles.icon, " ").concat(inputStyles.readOnlyIcon),
      role: "img",
      alt: "\u7DE8\u96C6\u4E0D\u53EF"
    })
  }));
});

var _excluded$z = ["value", "noValidate", "validate", "errorMessage", "onChange", "onBlur", "id", "descriptionId", "errorMessageId", "needStatusIcon"];
/**
 * input[type="text"] のコンポーネント（GDK外部から呼び出し可能。)
 * エラーかどうか等の状態判定を行い、状態に合ったスタイルを適用して返却。
 */
var TextInput = function TextInput(_ref) {
  var value = _ref.value,
    noValidate = _ref.noValidate,
    validate = _ref.validate,
    errorMessage = _ref.errorMessage,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    id = _ref.id,
    descriptionId = _ref.descriptionId,
    errorMessageId = _ref.errorMessageId,
    _ref$needStatusIcon = _ref.needStatusIcon,
    needStatusIcon = _ref$needStatusIcon === void 0 ? true : _ref$needStatusIcon,
    props = _objectWithoutProperties(_ref, _excluded$z);
  var _useFormState = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: props.disabled,
      errorMessage: errorMessage,
      onBlur: onBlur,
      readOnly: !!props.readOnly
    }),
    formState = _useFormState.formState,
    handleBlur = _useFormState.handleBlur;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    id: id,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    formState: formState,
    needStatusIcon: needStatusIcon,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId
  })));
};

var css_248z$O = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/* common */\n\n.button-module__GDK__disabled___qiraW {\n  fill: #dcd9d8;\n  color: #dcd9d8;\n}\n\n.button-module__GDK__button___SnRm4 {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  padding: 8px 32px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .button-module__GDK__button___SnRm4 {\n  padding: 8px 24px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n\n  .button-module__GDK__button___SnRm4 {\n  font: bold 18px/30px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n/* primary */\n\n.button-module__GDK__primary___Z-PFP {\n  color: #fff;\n  background-color: #454ab8;\n  fill: #454ab8;\n}\n\n.button-module__GDK__primary___Z-PFP:hover {\n  background: #3739a2;\n  color: #fff;\n  fill: #3739a2;\n}\n\n.button-module__GDK__primary___Z-PFP:focus {\n  background: #3739a2;\n  color: #fff;\n  fill: #3739a2;\n}\n\n.button-module__GDK__primary___Z-PFP:focus {\n  outline: 1px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.button-module__GDK__primary___Z-PFP:active {\n  background: #1c1e78;\n  color: #fff;\n  fill: #1c1e78;\n}\n\n.button-module__GDK__primary___Z-PFP:disabled {\n  background: #dcd9d8;\n  border: 2px solid #dcd9d8;\n  color: #fff;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  fill: #dcd9d8;\n}\n\n/* secondary */\n\n.button-module__GDK__secondary___yZ3kv {\n  color: #454ab8;\n  background-color: #fff;\n  border: 2px solid #454ab8;\n  fill: #454ab8;\n}\n\n.button-module__GDK__secondary___yZ3kv:hover {\n  background: #fff;\n  color: #3739a2;\n  border: 2px solid #3739a2;\n  fill: #3739a2;\n}\n\n.button-module__GDK__secondary___yZ3kv:focus {\n  background: #fff;\n  color: #3739a2;\n  border: 2px solid #3739a2;\n  fill: #3739a2;\n}\n\n.button-module__GDK__secondary___yZ3kv:focus {\n  outline: 1px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.button-module__GDK__secondary___yZ3kv:active {\n  background: #fff;\n  border: 2px solid #1c1e78;\n  color: #1c1e78;\n  fill: #1c1e78;\n}\n\n.button-module__GDK__secondary___yZ3kv:disabled {\n  background: #fff;\n  border: 2px solid #dcd9d8;\n  color: #dcd9d8;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  fill: #dcd9d8;\n}\n\n/* danger */\n\n.button-module__GDK__danger___1YIjg {\n  color: #fff;\n  background-color: #d53b3a;\n  fill: #d53b3a;\n}\n\n.button-module__GDK__danger___1YIjg:hover {\n  background: #b42828;\n  color: #fff;\n  fill: #b42828;\n}\n\n.button-module__GDK__danger___1YIjg:focus {\n  background: #b42828;\n  color: #fff;\n  fill: #b42828;\n}\n\n.button-module__GDK__danger___1YIjg:focus {\n  outline: 2px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.button-module__GDK__danger___1YIjg:active {\n  background: #8e1b19;\n  color: #fff;\n  fill: #8e1b19;\n}\n\n.button-module__GDK__danger___1YIjg:disabled {\n  background-color: #dcd9d8;\n  border: 2px solid #dcd9d8;\n  color: #fff;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  fill: #dcd9d8;\n}\n\n/* dangerSecondary */\n\n.button-module__GDK__dangerSecondary___0g2AS {\n  color: #d53b3a;\n  background-color: #fff;\n  border: 2px solid #d53b3a;\n  fill: #d53b3a;\n}\n\n.button-module__GDK__dangerSecondary___0g2AS:hover {\n  background: #fff;\n  color: #b42828;\n  border: 2px solid #b42828;\n  fill: #b42828;\n}\n\n.button-module__GDK__dangerSecondary___0g2AS:focus {\n  background: #fff;\n  color: #b42828;\n  border: 2px solid #b42828;\n  fill: #b42828;\n}\n\n.button-module__GDK__dangerSecondary___0g2AS:focus {\n  outline: 2px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.button-module__GDK__dangerSecondary___0g2AS:active {\n  background: #fff;\n  color: #8e1b19;\n  border: 2px solid #8e1b19;\n  fill: #8e1b19;\n}\n\n.button-module__GDK__dangerSecondary___0g2AS:disabled {\n  background: #fff;\n  border: 2px solid #dcd9d8;\n  color: #dcd9d8;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  fill: #dcd9d8;\n}\n\n/* textButton */\n\n.button-module__GDK__textButton___lfgkM {\n  display: inline-flex;\n  text-align: left;\n  align-items: center;\n  border-radius: 8px;\n  padding: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  gap: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .button-module__GDK__textButton___lfgkM {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n/* clear */\n\n.button-module__GDK__clear___KtWRo {\n  color: #454ab8;\n  fill: #454ab8;\n  cursor: pointer;\n}\n\n.button-module__GDK__clear___KtWRo:focus {\n  color: #3739a2;\n  fill: #3739a2;\n  outline: 2px solid #454ab8;\n  outline-offset: -2px;\n}\n\n.button-module__GDK__clear___KtWRo:hover {\n  color: #3739a2;\n  fill: #3739a2;\n}\n\n.button-module__GDK__clear___KtWRo:active {\n  color: #3739a2;\n  fill: #3739a2;\n}\n\n.button-module__GDK__small___au8FJ {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  padding: 4px 24px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .button-module__GDK__small___au8FJ {\n  padding: 4px 16px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n\n  .button-module__GDK__small___au8FJ {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n/* icon */\n\n.button-module__GDK__icon___vytIO {\n  display: flex;\n  align-items: center;\n}\n\n.button-module__GDK__iconLeft___-i1AX {\n  display: flex;\n  align-items: center;\n  margin-right: 12px;\n}\n\n.button-module__GDK__small___au8FJ .button-module__GDK__iconLeft___-i1AX {\n  margin-right: 8px;\n}\n\n.button-module__GDK__iconRight___SOg-Y {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.button-module__GDK__button___SnRm4:disabled,\n.button-module__GDK__textButton___lfgkM:disabled {\n  cursor: not-allowed;\n}\n\n@media screen and (max-width: 800px) {\n  .button-module__GDK__button___SnRm4 {\n    width: 100%;\n    padding: 8px;\n  }\n  .button-module__GDK__small___au8FJ {\n    padding: calc(8px / 2);\n  }\n}\n";
var styles$N = {"disabled":"button-module__GDK__disabled___qiraW","button":"button-module__GDK__button___SnRm4","primary":"button-module__GDK__primary___Z-PFP","secondary":"button-module__GDK__secondary___yZ3kv","danger":"button-module__GDK__danger___1YIjg","dangerSecondary":"button-module__GDK__dangerSecondary___0g2AS","textButton":"button-module__GDK__textButton___lfgkM","clear":"button-module__GDK__clear___KtWRo","small":"button-module__GDK__small___au8FJ","icon":"button-module__GDK__icon___vytIO","iconLeft":"button-module__GDK__iconLeft___-i1AX","iconRight":"button-module__GDK__iconRight___SOg-Y"};
styleInject(css_248z$O);

var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "外部リンク" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u5916\u90E8\u30EA\u30F3\u30AF\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u5916\u90E8\u30EA\u30F3\u30AF\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3053\u3068\u3092\u793A\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M37 37H3V3H18.1661V6.09091H6.09091V33.9091H33.9091V21.8339H37V37Z",
    fill: "currentColor"
  }), React__namespace.default.createElement("path", {
    d: "M23.3176 3V6.09091H31.7249L19.6292 18.1867L21.8134 20.3709L33.9092 8.27515V16.6824H37.0001V3H23.3176Z",
    fill: "currentColor"
  })));
};

var defaultIconColor$G = "#3944B3";
var LeftArrowIcon = function LeftArrowIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$G : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "左矢印" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u5DE6\u77E2\u5370\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u5DE6\u5411\u304D\u306E\u77E2\u5370\u3092\u8868\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M5.17505 12.1463L14.5075 2.02499L15.675 3.00519L7.24547 12.1463L15.675 21.2874L14.5075 22.275L5.17505 12.1463Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};
var RightArrowIcon = function RightArrowIcon(_ref2) {
  var size = _ref2.size,
    _ref2$iconColor = _ref2.iconColor,
    iconColor = _ref2$iconColor === void 0 ? defaultIconColor$G : _ref2$iconColor,
    buttonType = _ref2.buttonType,
    _ref2$alt = _ref2.alt,
    alt = _ref2$alt === void 0 ? "右矢印" : _ref2$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u53F3\u77E2\u5370\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u53F3\u5411\u304D\u306E\u77E2\u5370\u3092\u8868\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M19.2749 12.1537L9.94243 22.275L8.7749 21.2948L17.2045 12.1537L8.7749 3.01262L9.94243 2.02499L19.2749 12.1537Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};
var UpArrowIcon = function UpArrowIcon(_ref3) {
  var size = _ref3.size,
    _ref3$iconColor = _ref3.iconColor,
    iconColor = _ref3$iconColor === void 0 ? defaultIconColor$G : _ref3$iconColor,
    buttonType = _ref3.buttonType,
    _ref3$alt = _ref3.alt,
    alt = _ref3$alt === void 0 ? "上矢印" : _ref3$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u4E0A\u77E2\u5370\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u4E0A\u5411\u304D\u306E\u77E2\u5370\u3092\u8868\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M20.5048 12L34 23.8321L32.0859 26L20.5048 15.8445L8.92374 26L7 23.8321L20.5048 12Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};
var DownArrowIcon = function DownArrowIcon(_ref4) {
  var size = _ref4.size,
    _ref4$iconColor = _ref4.iconColor,
    iconColor = _ref4$iconColor === void 0 ? defaultIconColor$G : _ref4$iconColor,
    buttonType = _ref4.buttonType,
    _ref4$alt = _ref4.alt,
    alt = _ref4$alt === void 0 ? "下矢印" : _ref4$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u4E0B\u77E2\u5370\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u4E0B\u5411\u304D\u306E\u77E2\u5370\u3092\u8868\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M20.21 29.53L6.25 17.25L8.23 15L20.21 25.54L32.19 15L34.18 17.25L20.21 29.53Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$F = "#3944B3";
var CalenderIcon = function CalenderIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$F : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "カレンダー" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30AB\u30EC\u30F3\u30C0\u30FC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30AB\u30EC\u30F3\u30C0\u30FC\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M34.5 8V36H5.5V8H34.5ZM37.5 5H2.5V39H37.5V5Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M37.5 5H2.5V12.8H37.5V5Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M34.5 8V9.8H5.5V8H34.5ZM37.5 5H2.5V12.8H37.5V5Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 16.62H9.5V19.62H12.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 16.62H9.5V19.62H12.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 16.62H15.5V19.62H18.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 16.62H15.5V19.62H18.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 16.62H21.5V19.62H24.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 16.62H21.5V19.62H24.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 16.62H27.5V19.62H30.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 16.62H27.5V19.62H30.5V16.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 22.62H9.5V25.62H12.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 22.62H9.5V25.62H12.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 22.62H15.5V25.62H18.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 22.62H15.5V25.62H18.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 22.62H21.5V25.62H24.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 22.62H21.5V25.62H24.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 22.62H27.5V25.62H30.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 22.62H27.5V25.62H30.5V22.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 28.62H9.5V31.62H12.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M12.5 28.62H9.5V31.62H12.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 28.62H15.5V31.62H18.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M18.5 28.62H15.5V31.62H18.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 28.62H21.5V31.62H24.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M24.5 28.62H21.5V31.62H24.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 28.62H27.5V31.62H30.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M30.5 28.62H27.5V31.62H30.5V28.62Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M11 1H8V5H11V1Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M32 1H29V5H32V1Z",
    fill: getIconColor(iconColor, buttonType)
  }));
};

var defaultIconColor$E = "#706D6C";
var CancelIcon = function CancelIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible,
    buttonType = _ref.buttonType,
    className = _ref.className,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$E : _ref$iconColor;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    className: className
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30AD\u30E3\u30F3\u30BB\u30EB\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u64CD\u4F5C\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M35 7.11155L32.8884 5L20 17.8884L7.11155 5L5 7.11155L17.8884 20L5 32.8884L7.11155 35L20 22.1116L32.8884 35L35 32.8884L22.1116 20L35 7.11155Z",
    fill: isReversible ? "#ffffff" : getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$D = {
  inner: "white",
  outer: "#454AB8"
};
var InfoIcon = function InfoIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible,
    buttonType = _ref.buttonType,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$D : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "情報" : _ref$alt;
  var iconColorSet = getIconcolorSet(isReversible, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u60C5\u5831\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u4F1D\u3048\u308B\u60C5\u5831\u304C\u3042\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M20 40.78C31.0457 40.78 40 31.8257 40 20.78C40 9.73433 31.0457 0.780029 20 0.780029C8.9543 0.780029 0 9.73433 0 20.78C0 31.8257 8.9543 40.78 20 40.78Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17.6396 10.46C17.6396 9.02003 18.7496 8.06003 20.2796 8.06003C21.7796 8.06003 22.8896 9.02003 22.8896 10.46C22.8896 11.84 21.7796 12.86 20.2796 12.86C18.7496 12.86 17.6396 11.83 17.6396 10.46ZM18.0696 15.55H22.4496V32.35H18.0696V15.55Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$C = {
  inner: "white",
  outer: "#E07E02"
};
var WarningIcon = function WarningIcon(_ref) {
  var size = _ref.size,
    _ref$isReversible = _ref.isReversible,
    isReversible = _ref$isReversible === void 0 ? false : _ref$isReversible,
    buttonType = _ref.buttonType,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$C : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "注意" : _ref$alt;
  var iconColorSet = getIconcolorSet(isReversible, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u6CE8\u610F\u559A\u8D77\u306E\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u6CE8\u610F\u559A\u8D77\u3092\u4FC3\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M34.8104 37.6H5.00043C2.71043 37.6 1.26043 35.13 2.38043 33.13L17.4404 6.31002C18.5904 4.26002 21.5504 4.27002 22.6804 6.33002L37.4304 33.15C38.5404 35.16 37.0904 37.6 34.8104 37.6Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17.79 30.44C17.79 29.14 18.73 28.14 19.97 28.14C21.21 28.14 22.18 29.15 22.18 30.44C22.18 31.74 21.22 32.74 19.97 32.74C18.72 32.74 17.79 31.74 17.79 30.44ZM18.31 17.5L18.19 14.16H21.74L21.62 17.5L21.12 26.36H18.82L18.31 17.5Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$B = "";
var EditIcon = function EditIcon(_ref) {
  var size = _ref.size,
    buttonType = _ref.buttonType,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$B : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "編集" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u7DE8\u96C6\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u7DE8\u96C6\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("path", {
    d: "M6.00153 25.0182L5.92297 25.0968L5 33.0025L12.914 32.0793L12.9828 32.0106L6.00153 25.0182Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M28.0154 3.00252L8.08228 22.9395L15.0669 29.9254L35 9.98845L28.0154 3.00252Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M38 35H2V38H38V35Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$A = {
  inner: "white",
  outer: "#454AB8"
};
var FileIcon = function FileIcon(_ref) {
  var buttonType = _ref.buttonType,
    size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$A : _ref$iconColor,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ファイルアップロード" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.createElement("g", null, React__namespace.createElement("title", null, "\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30A2\u30A4\u30B3\u30F3"), React__namespace.createElement("desc", null, "\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3067\u304D\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.createElement("path", {
    d: "M25.232 13.023C24.6 8.33499 20.592 4.71899 15.728 4.71899C10.424 4.71899 6.128 9.01499 6.128 14.319V15.175C2.68 15.559 0 18.479 0 22.023C0 25.663 2.832 28.639 6.408 28.887V28.911H6.888H16H24C28.416 28.911 32 25.327 32 20.911C32 16.919 29.064 13.615 25.232 13.023Z",
    fill: "currentColor"
  }), React__namespace.createElement("path", {
    d: "M22.7848 18.239L16.0008 12.367L9.2168 18.239L10.7848 20.055L14.8008 16.575V25.383H17.2008V16.575L21.2168 20.055L22.7848 18.239Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$z = {
  inner: "white",
  outer: "#454AB8"
};
var TrashIcon = function TrashIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$z : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ゴミ箱" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "trash-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    trashIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(trashIconId, ")")
  }, React__namespace.default.createElement("title", null, "\u30B4\u30DF\u7BB1\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u8AAD\u307F\u8FBC\u307E\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3067\u304D\u308B\u3053\u3068\u3092\u793A\u3057\u3066\u3044\u308B\u30A2\u30A4\u30B3\u30F3\u3067\u3059\u3002"), React__namespace.default.createElement("path", {
    d: "M18.8996 6.21899H5.09961V23.619H18.8996V6.21899Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M21 2.61899H3V4.41899H21V2.61899Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M16.2008 0.819H7.80078V2.619H16.2008V0.819Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M10.4992 9.21899H8.69922V20.619H10.4992V9.21899Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M15.3 9.21899H13.5V20.619H15.3V9.21899Z",
    fill: iconColorSet.inner
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: trashIconId
  }, React__namespace.default.createElement("rect", {
    width: size,
    height: size,
    fill: "white",
    transform: "translate(0 0.218994)"
  }))));
};

var css_248z$N = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.star-module__GDK__star___Ex3cT path {\n  stroke: #454ab8;\n  fill: #fff;\n}\n";
var styles$M = {"star":"star-module__GDK__star___Ex3cT"};
styleInject(css_248z$N);

var StarIcon = function StarIcon(_ref) {
  var size = _ref.size,
    className = _ref.className,
    reviewPoint = _ref.reviewPoint;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(styles$M.star),
    role: "img",
    "aria-label": "\u8A55\u4FA1 ".concat(reviewPoint, "\u70B9")
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u8A55\u4FA1"), React__namespace.default.createElement("desc", null, "".concat(reviewPoint, "\u70B9")), React__namespace.default.createElement("path", {
    d: "M16.1103 2.5442C16.4735 1.78824 17.5499 1.78824 17.9131 2.5442L21.427 9.85865C21.8644 10.769 22.7304 11.3982 23.7313 11.5328L31.7736 12.6144C32.6048 12.7262 32.9374 13.75 32.3307 14.329L26.4601 19.9312C25.7295 20.6284 25.3987 21.6465 25.58 22.64L27.0364 30.623C27.187 31.448 26.3161 32.0807 25.578 31.6826L18.4358 27.8305C17.5469 27.3511 16.4765 27.3511 15.5876 27.8305L8.44545 31.6826C7.7073 32.0807 6.83646 31.448 6.98699 30.623L8.44347 22.64C8.62474 21.6465 8.29396 20.6285 7.56333 19.9312L1.69275 14.329C1.08602 13.75 1.41865 12.7262 2.24983 12.6144L10.2922 11.5328C11.2931 11.3982 12.1591 10.769 12.5964 9.85865L16.1103 2.5442Z",
    strokeWidth: "2"
  })));
};

var defaultIconColor$y = "";
var CloseEyeIcon = function CloseEyeIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$y : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "閉じた目" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u9589\u3058\u305F\u76EE\u306E\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u9589\u3058\u305F\u76EE\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M39 16.1155L36.8822 14L35.8082 15.0428C34.7845 16.0459 33.3994 17.2775 31.7533 18.4593L31.673 18.36L30.579 19.2737C27.608 21.2104 23.9445 22.8392 20 22.8392C13.1648 22.8392 7.1627 17.9528 4.19176 15.0428L3.1178 14L1 16.1155L2.07396 17.1682C3.02747 18.1018 4.28209 19.2241 5.74749 20.3364L2.76651 23.8523L5.07501 25.7691L8.21659 22.0646C9.06973 22.6009 9.97306 23.1074 10.9266 23.5642L9.31062 27.9541L12.141 28.977L13.7068 24.7163C15.2224 25.2427 16.8283 25.6201 18.4945 25.7592V30H21.5055V25.7592C22.8806 25.64 24.2055 25.3619 25.4902 24.9845L26.9556 28.977L29.7861 27.9541L28.3006 23.9218C29.3143 23.4649 30.2678 22.9584 31.1812 22.4122L34.0217 25.7592L36.3302 23.8423L33.7005 20.7536C35.4168 19.5022 36.8621 18.221 37.926 17.1682L39 16.1155Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$x = {
  inner: "white",
  outer: ""
};
var OpenEyeIcon = function OpenEyeIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$x : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "開いた目" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u958B\u3044\u305F\u76EE\u306E\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u958B\u3044\u305F\u76EE\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M38.1113 17.88C39.2962 19.04 39.2962 20.95 38.1113 22.11C34.8676 25.31 27.9786 31 19.995 31C12.0114 31 5.1324 25.31 1.88874 22.12C0.703753 20.96 0.703753 19.05 1.88874 17.89C5.1324 14.69 12.0214 9 19.995 9C27.9686 9 34.8676 14.69 38.1113 17.88Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M19.9951 12.39C15.7773 12.39 12.3529 15.8 12.3529 20C12.3529 24.2 15.7773 27.61 19.9951 27.61C24.2128 27.61 27.6373 24.2 27.6373 20C27.6373 15.8 24.2229 12.39 19.9951 12.39ZM19.9951 22.87C18.4084 22.87 17.1129 21.59 17.1129 20C17.1129 18.41 18.3984 17.13 19.9951 17.13C21.5818 17.13 22.8772 18.41 22.8772 20C22.8772 21.59 21.5918 22.87 19.9951 22.87Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$w = "";
var KebabIcon = function KebabIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$w : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ケバブ" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30B1\u30D0\u30D6\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "3\u3064\u306E\u70B9\u304C\u7E26\u306B\u4E26\u3093\u3060\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("circle", {
    cx: "20",
    cy: "8",
    r: "3",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "3",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("circle", {
    cx: "20",
    cy: "32",
    r: "3",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$v = "";
var HamburgerIcon = function HamburgerIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$v : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ハンバーガーメニュー" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30CF\u30F3\u30D0\u30FC\u30AC\u30FC\u30E1\u30CB\u30E5\u30FC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30E1\u30CB\u30E5\u30FC\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M32 6H8V9H32V6Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M32 13.5H8V16.5H32V13.5Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M32 21H8V24H32V21Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M5.12891 39.9297H6.42383V34.6035H6.44727L8.23438 38.7051H9.3125L11.0996 34.6035H11.1289V39.9297H12.4238V31.3867H11.1992L8.79688 36.9531L6.34766 31.3867H5.12891V39.9297Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M14.2227 39.9297H19.6777V38.7051H15.5176V36.1973H19.0684V35.0488H15.5176V32.6113H19.6777V31.3867H14.2227V39.9297Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M20.9023 39.9297H22.1973V33.8594H22.2207L26.082 39.9297H27.3066V31.3867H26.0117V37.457H25.9883L22.1211 31.3867H20.9023V39.9297Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M28.959 37.0352C28.9668 37.9336 29.2637 38.6465 29.8496 39.1738C30.4238 39.7168 31.1387 39.9922 31.9941 40C32.8652 39.9922 33.5859 39.7168 34.1562 39.1738C34.7227 38.6465 35.0137 37.9336 35.0293 37.0352V31.3867H33.7344V36.8945C33.7266 37.4766 33.5625 37.9199 33.2422 38.2246C32.9141 38.5449 32.498 38.7051 31.9941 38.7051C31.4902 38.7051 31.0781 38.5449 30.7578 38.2246C30.4297 37.9199 30.2617 37.4766 30.2539 36.8945V31.3867H28.959V37.0352Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$u = {
  inner: "white",
  outer: ""
};
var ListIcon = function ListIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$u : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "リスト" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30EA\u30B9\u30C8\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30EA\u30B9\u30C8\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M25.72 7.0625V6.8125C25.72 3.6125 23.11 1.0025 19.91 1.0025C16.7 1.0025 14.1 3.6125 14.1 6.8125V7.0625H6V39.0625H34V7.0625H25.72ZM18.1 6.8125C18.1 5.8125 18.91 5.0025 19.91 5.0025C20.91 5.0025 21.72 5.8125 21.72 6.8125V7.0625H18.1V6.8125Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M28.87 14.0025H17.41V17.0025H28.87V14.0025Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M12.98 17.3425C11.96 17.3425 11.14 16.5225 11.14 15.5025C11.14 14.4825 11.96 13.6625 12.98 13.6625C14 13.6625 14.82 14.4825 14.82 15.5025C14.82 16.5125 14 17.3425 12.98 17.3425Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M28.87 21.5625H17.41V24.5625H28.87V21.5625Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M12.98 24.9025C11.96 24.9025 11.14 24.0825 11.14 23.0625C11.14 22.0425 11.96 21.2225 12.98 21.2225C14 21.2225 14.82 22.0425 14.82 23.0625C14.82 24.0725 14 24.9025 12.98 24.9025Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M28.87 29.1225H17.41V32.1225H28.87V29.1225Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M12.98 32.4625C11.96 32.4625 11.14 31.6425 11.14 30.6225C11.14 29.6025 11.96 28.7825 12.98 28.7825C14 28.7825 14.82 29.6025 14.82 30.6225C14.82 31.6325 14 32.4625 12.98 32.4625Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$t = "";
var List2Icon = function List2Icon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$t : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "リスト" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30EA\u30B9\u30C8\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30EA\u30B9\u30C8\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("rect", {
    x: "4.92114",
    y: "4.96594",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "15.9211",
    y: "4.966",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "26.9319",
    y: "4.96594",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "4.92114",
    y: "15.8978",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "15.9211",
    y: "15.8978",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "26.9319",
    y: "15.8978",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "4.92114",
    y: "26.9659",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "15.9211",
    y: "26.9659",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("rect", {
    x: "26.9319",
    y: "26.9659",
    width: "8.06813",
    height: "8.06813",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$s = {
  inner: "white",
  outer: ""
};
var SPIcon = function SPIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$s : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "スマートフォン" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M27.7917 2H12.2083C10.4392 2 9 3.44923 9 5.23077V34.7692C9 36.5508 10.4392 38 12.2083 38H27.7917C29.5608 38 31 36.5508 31 34.7692V5.23077C31 3.44923 29.5608 2 27.7917 2ZM11.75 7.53846H28.25V32.4615H11.75V7.53846Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M22.6126 3.84619H17.3967V5.69235H22.6126V3.84619Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M15.5633 3.84619H13.7208V5.69235H15.5633V3.84619Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M26.2793 3.84619H24.4368V5.69235H26.2793V3.84619Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M23.0617 34.3076H16.9292V36.1538H23.0617V34.3076Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$r = {
  inner: "white",
  outer: ""
};
var PCIcon = function PCIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$r : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "パソコン" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30D1\u30BD\u30B3\u30F3\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30D1\u30BD\u30B3\u30F3\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M34.7692 5H5.23077C3.44923 5 2 6.44923 2 8.23077V26.6923C2 28.4738 3.44923 29.9231 5.23077 29.9231H16.4738V31.8985H7.07692V34.6677H32.9231V31.8985H23.5262V29.9231H34.7692C36.5508 29.9231 38 28.4738 38 26.6923V8.23077C38 6.44923 36.5508 5 34.7692 5Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M35.2217 10.3631H4.78784V24.5692H35.2217V10.3631Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$q = {
  inner: "white",
  outer: ""
};
var SecurityIcon = function SecurityIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$q : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "セキュリティ" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u8868\u3059\u9375\u30DE\u30FC\u30AF\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M31.45 14.95V13.45C31.45 7.14 26.31 2 20 2C13.69 2 8.55 7.14 8.55 13.45V14.95H5V37.95H35V14.95H31.45ZM11.55 13.45C11.55 8.79 15.34 5 20 5C24.66 5 28.45 8.79 28.45 13.45V14.95H11.55V13.45Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M23.1799 23.73C23.1799 21.97 21.7599 20.55 19.9999 20.55C18.2399 20.55 16.8199 21.97 16.8199 23.73C16.8199 24.94 17.4999 25.98 18.4999 26.52V32.89H21.4999V26.52C22.4899 25.98 23.1799 24.94 23.1799 23.73Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$p = "";
var LogIcon = function LogIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$p : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ログ" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30ED\u30B0\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30ED\u30B0\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M21.9333 2.0025C13.2608 2.0025 6.01236 8.10587 4.26205 16.2174L2.34363 13.7662L0 15.5776L4.96415 21.927L11.9258 17.8417L10.4227 15.3019L7.08035 17.2609C8.37577 10.2716 14.5365 4.95574 21.9333 4.95574C30.2695 4.95574 37.0433 11.7088 37.0433 19.9976C37.0433 28.2863 30.2596 35.0493 21.9333 35.0493C18.0074 35.0493 14.2892 33.553 11.4611 30.8458L9.39431 32.9721C12.7763 36.2109 17.2262 38.0025 21.9234 38.0025C31.8912 38.0025 40 29.9303 40 20.0074C40 10.0845 31.9011 2.0025 21.9333 2.0025Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M31.4166 21.4939H20.45V10.6653H23.4166V18.5407H31.4166V21.4939Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$o = "";
var HomeIcon = function HomeIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$o : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ホーム" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30DB\u30FC\u30E0\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30DB\u30FC\u30E0\u3092\u8868\u3059\u3001\u5BB6\u306E\u30DE\u30FC\u30AF\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M19.973 4.0025L2 20.8914H7.7334V36.0025H16.2346V26.3581C16.2346 24.3047 17.9241 22.6336 20 22.6336C22.0759 22.6336 23.7654 24.3047 23.7654 26.3581V36.0025H32.2666V20.8914H38L19.973 4.0025Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$n = "";
var LogOutIcon = function LogOutIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$n : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ログアウト" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30ED\u30B0\u30A2\u30A6\u30C8\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30ED\u30B0\u30A2\u30A6\u30C8\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M31.411 11.46L29.191 13.48L33.271 17.97H18.671V20.97H33.271L29.191 25.46L31.411 27.48L38.701 19.47L31.411 11.46Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M29.791 37H6.45105V2H29.791V7.19H26.791V5H9.45105V34H26.791V31.01H29.791V37Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$m = {
  inner: "white",
  outer: ""
};
var CardIcon = function CardIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$m : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "カード" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30AB\u30FC\u30C9\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30AB\u30FC\u30C9\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M3 29.8313V10.182C3 8.97954 4.0115 8.0025 5.2695 8.0025H34.739C35.9885 8.0025 37 8.97954 37 10.182V29.8229C37 31.0254 35.9885 32.0025 34.7305 32.0025H5.2695C4.0115 32.0108 3 31.0338 3 29.8313Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M37 13.8165H3V18.432H37V13.8165Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M10.3101 29.3886H8.10015C7.16515 29.3886 6.40015 28.6236 6.40015 27.6886V25.4786C6.40015 24.5436 7.16515 23.7786 8.10015 23.7786H10.3101C11.2451 23.7786 12.0101 24.5436 12.0101 25.4786V27.6886C12.0101 28.6321 11.2536 29.3886 10.3101 29.3886Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$l = {
  inner: "white",
  outer: ""
};
var UserInfoIcon = function UserInfoIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$l : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ユーザー情報" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30E6\u30FC\u30B6\u30FC\u60C5\u5831\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M37 8H3V32H37V8Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M13.7523 19.7743C16.0855 19.7743 17.9768 17.9137 17.9768 15.6185C17.9768 13.3234 16.0855 11.4628 13.7523 11.4628C11.4192 11.4628 9.52783 13.3234 9.52783 15.6185C9.52783 17.9137 11.4192 19.7743 13.7523 19.7743Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M20.3996 28.5372H7.11414V26.9067C7.11414 24.139 9.40064 21.8898 12.2141 21.8898H15.2996C18.1131 21.8898 20.3996 24.139 20.3996 26.9067V28.5372Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M32.8861 11.6301H24.3011V14.1385H32.8861V11.6301Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M32.8861 25.6525H24.3011V28.161H32.8861V25.6525Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M32.8861 18.6371H24.3011V21.1456H32.8861V18.6371Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$k = "";
var SearchIcon = function SearchIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$k : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "検索" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u691C\u7D22\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u691C\u7D22\u3092\u8868\u3059\u866B\u773C\u93E1\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M37 34.8101L28.5668 26.3795C30.5517 23.912 31.755 20.7865 31.755 17.3731C31.755 9.43604 25.317 3 17.3775 3C9.43799 3 3 9.43604 3 17.3731C3 25.3103 9.43799 31.7463 17.3775 31.7463C20.7919 31.7463 23.9183 30.5537 26.3866 28.5694L34.8197 37L37 34.8101ZM6.0853 17.3731C6.0853 11.1427 11.1452 6.08437 17.3775 6.08437C23.6098 6.08437 28.6697 11.1427 28.6697 17.3731C28.6697 23.6036 23.6098 28.6619 17.3775 28.6619C11.1452 28.6619 6.0853 23.5933 6.0853 17.3731Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$j = {
  inner: "white",
  outer: ""
};
var NumberIcon = function NumberIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$j : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "数字" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "number-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    numberIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u6570\u5B57\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u6570\u3092\u8868\u3059\u3001\u6570\u5B57\u306E\uFF11\u306E\u30DE\u30FC\u30AF\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(numberIconId, ")")
  }, React__namespace.default.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "18.5",
    fill: iconColorSet.outer,
    stroke: iconColorSet.outer,
    strokeWidth: "3"
  }), React__namespace.default.createElement("path", {
    d: "M18.7012 13.0879V30H21.5586V10.0664H18.7012L15.8711 12.1309V15.166L18.7012 13.0879Z",
    fill: iconColorSet.inner
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: numberIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner
  })))));
};

var defaultIconColor$i = "";
var TextAreaIcon = function TextAreaIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$i : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "テキストエリア" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30C6\u30AD\u30B9\u30C8\u30A8\u30EA\u30A2\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30C6\u30AD\u30B9\u30C8\u30A8\u30EA\u30A2\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M34.9449 29.0098L29.0121 34.9426L31.065 36.9955L36.9978 31.0627L34.9449 29.0098Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M34.9472 21.0103L21.0082 34.9493L23.0611 37.0022L37 23.0632L34.9472 21.0103Z",
    fill: getIconColor(iconColor, buttonType)
  }), React__namespace.default.createElement("path", {
    d: "M34.9429 13.0038L12.9977 34.949L15.0506 37.0018L36.9957 15.0567L34.9429 13.0038Z",
    fill: getIconColor(iconColor, buttonType)
  })));
};

var defaultIconColor$h = {
  inner: "white",
  outer: ""
};
var PlusIcon = function PlusIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$h : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "プラス" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "plus-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    plusIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30D7\u30E9\u30B9\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30D7\u30E9\u30B9\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(plusIconId, ")")
  }, React__namespace.default.createElement("path", {
    d: "M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.9543 31.5457 0 20.5 0C9.4543 0 0.5 8.9543 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M30.5 18.5H22V10H19V18.5H10.5V21.5H19V30H22V21.5H30.5V18.5Z",
    fill: iconColorSet.inner
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: plusIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.5)"
  })))));
};

var defaultIconColor$g = {
  inner: "white",
  outer: ""
};
var PDFIcon = function PDFIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$g : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "PDF" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "PDF\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "PDF\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M26.77 2.19V9.99H34.35L26.77 2.19Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M24.46 12.37V1H5.5V39H35.5V12.37H24.46Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M10.8199 28.22V15.4H13.4999C13.9899 15.4 14.4199 15.47 14.7899 15.6C15.1599 15.73 15.4999 15.97 15.7999 16.3C16.0999 16.64 16.3099 17.03 16.4299 17.48C16.5499 17.93 16.6099 18.54 16.6099 19.31C16.6099 19.89 16.5799 20.37 16.5099 20.77C16.4499 21.17 16.3099 21.54 16.0999 21.89C15.8499 22.31 15.5299 22.64 15.1199 22.87C14.7099 23.1 14.1799 23.22 13.5099 23.22H12.5999V28.22H10.8199ZM12.5999 17.13V21.49H13.4599C13.8199 21.49 14.0999 21.44 14.2999 21.33C14.4999 21.22 14.6399 21.07 14.7399 20.88C14.8299 20.7 14.8899 20.48 14.9099 20.21C14.9299 19.94 14.9399 19.65 14.9399 19.33C14.9399 19.03 14.9299 18.75 14.9199 18.47C14.9099 18.2 14.8599 17.96 14.7599 17.76C14.6699 17.56 14.5299 17.4 14.3399 17.29C14.1499 17.18 13.8899 17.13 13.5399 17.13H12.5999Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M17.9399 28.22V15.4H20.5799C21.6099 15.4 22.3799 15.69 22.9099 16.26C23.4399 16.84 23.7099 17.65 23.7099 18.71V24.7C23.7099 25.9 23.4299 26.78 22.8599 27.35C22.2899 27.92 21.4799 28.21 20.4199 28.21H17.9399V28.22ZM19.7199 17.13V26.49H20.5399C21.0399 26.49 21.3999 26.36 21.6099 26.1C21.8199 25.84 21.9199 25.44 21.9199 24.89V18.72C21.9199 18.22 21.8199 17.83 21.6199 17.55C21.4199 17.27 21.0599 17.14 20.5399 17.14H19.7199V17.13Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M25.3899 28.22V15.4H30.7099V17.13H27.1799V21.02H30.2599V22.75H27.1799V28.22H25.3899Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$f = {
  inner: "white",
  outer: ""
};
var ImageIcon = function ImageIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$f : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "イメージ" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u753B\u50CF\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u753B\u50CF\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M26.77 2.19V9.99H34.35L26.77 2.19Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M24.46 1H5.5V39H35.5V12.37H24.46V1Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M9.43994 34.09H31.5799V20L20.7099 28.83V21.91L9.43994 30.49V34.09Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M13.13 22C14.8311 22 16.21 20.5807 16.21 18.83C16.21 17.0792 14.8311 15.66 13.13 15.66C11.429 15.66 10.05 17.0792 10.05 18.83C10.05 20.5807 11.429 22 13.13 22Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$e = {
  inner: "white",
  outer: ""
};
var NGIcon = function NGIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$e : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "NG" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "ng-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    ngIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "NG\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "NG\u3092\u8868\u3059\u30D0\u30C4\u5370\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(ngIconId, ")")
  }, React__namespace.default.createElement("path", {
    d: "M20.25 40C31.2957 40 40.25 31.0457 40.25 20C40.25 8.9543 31.2957 0 20.25 0C9.2043 0 0.25 8.9543 0.25 20C0.25 31.0457 9.2043 40 20.25 40Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M30.03 12.34L27.91 10.22L20.25 17.88L12.59 10.22L10.47 12.34L18.13 20L10.47 27.66L12.59 29.78L20.25 22.12L27.91 29.78L30.03 27.66L22.37 20L30.03 12.34Z",
    fill: iconColorSet.inner
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: ngIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.25)"
  })))));
};

var defaultIconColor$d = {
  inner: "white",
  outer: ""
};
var LoadingIcon = function LoadingIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$d : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ローディング" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "loading-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    loadingIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30ED\u30FC\u30C7\u30A3\u30F3\u30B0\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30ED\u30FC\u30C7\u30A3\u30F3\u30B0\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(loadingIconId, ")")
  }, React__namespace.default.createElement("path", {
    opacity: "0.1",
    d: "M20.5 40C9.46897 40 0.5 31.031 0.5 20C0.5 8.96897 9.46897 0 20.5 0C31.531 0 40.5 8.96897 40.5 20C40.5 31.031 31.531 40 20.5 40ZM20.5 3.003C11.1306 3.003 3.503 10.6306 3.503 20C3.503 29.3694 11.1306 36.997 20.5 36.997C29.8694 36.997 37.497 29.3694 37.497 20C37.497 10.6306 29.8694 3.003 20.5 3.003Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M20.5 40C9.46897 40 0.5 31.031 0.5 20C0.5 19.1692 1.17067 18.4985 2.0015 18.4985C2.83233 18.4985 3.503 19.1692 3.503 20C3.503 29.3694 11.1306 36.997 20.5 36.997C29.8694 36.997 37.497 29.3694 37.497 20C37.497 10.6306 29.8694 3.003 20.5 3.003C19.6692 3.003 18.9985 2.33233 18.9985 1.5015C18.9985 0.670671 19.6692 0 20.5 0C31.531 0 40.5 8.96897 40.5 20C40.5 31.031 31.531 40 20.5 40Z",
    fill: iconColorSet.outer
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: loadingIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.5)"
  })))));
};

var defaultIconColor$c = {
  inner: "white",
  outer: ""
};
var TimeIcon = function TimeIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$c : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "時計" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "time-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    timeIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u6642\u8A08\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u6642\u9593\u3092\u8868\u3059\u3001\u6642\u8A08\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(timeIconId, ")")
  }, React__namespace.default.createElement("path", {
    d: "M20.5 40C31.5457 40 40.5 31.0457 40.5 20C40.5 8.9543 31.5457 0 20.5 0C9.4543 0 0.5 8.9543 0.5 20C0.5 31.0457 9.4543 40 20.5 40Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M32.4999 21.32H19.1799V8.10999H22.1799V18.32H32.4999V21.32Z",
    fill: iconColorSet.inner
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: timeIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.5)"
  })))));
};

var defaultIconColor$b = {
  inner: "white",
  outer: ""
};
var QuestionIcon = function QuestionIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$b : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "クエスチョン" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "question-icon1-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    questionIcon1Id = _useId2[0];
  var _useId3 = nextId.useId(1, "question-icon2-id-"),
    _useId4 = _slicedToArray(_useId3, 1),
    questionIcon2Id = _useId4[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30AF\u30A8\u30B9\u30C1\u30E7\u30F3\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30AF\u30A8\u30B9\u30C1\u30E7\u30F3\u30DE\u30FC\u30AF\u306E\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(questionIcon1Id, ")")
  }, React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(questionIcon2Id, ")")
  }, React__namespace.default.createElement("path", {
    d: "M20.25 40C31.2957 40 40.25 31.0457 40.25 20C40.25 8.9543 31.2957 0 20.25 0C9.2043 0 0.25 8.9543 0.25 20C0.25 31.0457 9.2043 40 20.25 40Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M22.57 14.38C22.57 12.88 21.58 11.92 20.02 11.92C18.7 11.92 17.65 12.61 16.69 13.6L14.26 11.38C15.82 9.61 17.95 8.38 20.56 8.38C24.16 8.38 26.8 10.24 26.8 14.08C26.8 18.34 21.58 19.78 22.03 24.01H18.19C17.47 19.18 22.57 17.26 22.57 14.38ZM17.39 29.11C17.39 27.49 18.56 26.23 20.12 26.23C21.71 26.23 22.88 27.49 22.88 29.11C22.88 30.73 21.71 31.99 20.12 31.99C18.56 31.99 17.39 30.73 17.39 29.11Z",
    fill: iconColorSet.inner
  }))), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: questionIcon1Id
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.25)"
  })), React__namespace.default.createElement("clipPath", {
    id: questionIcon2Id
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner,
    transform: "translate(0.25)"
  })))));
};

var defaultIconColor$a = {
  inner: "white",
  outer: ""
};
var FaqIcon = function FaqIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$a : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "FAQ" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "FAQ\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "FAQ\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M38 0H2V30H20.75L29.19 39.85V30H38V0Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M21.43 10.94C21.444 10.7053 21.4071 10.4703 21.3217 10.2512C21.2364 10.0321 21.1046 9.83403 20.9355 9.67064C20.7665 9.50724 20.564 9.38237 20.3421 9.30458C20.1202 9.22679 19.8841 9.19793 19.65 9.21999C19.2017 9.24299 18.7632 9.35887 18.3621 9.56027C17.961 9.76168 17.6062 10.0442 17.32 10.39L15.62 8.84C16.1581 8.19031 16.8315 7.66581 17.5931 7.30312C18.3548 6.94042 19.1864 6.74825 20.03 6.73999C22.54 6.73999 24.39 8.03999 24.39 10.74C24.39 13.74 20.74 14.74 21.05 17.68H18.37C17.87 14.29 21.43 12.93 21.43 10.94ZM17.79 21.24C17.8057 20.8636 17.9317 20.5002 18.1525 20.195C18.3732 19.8897 18.6788 19.6561 19.0313 19.5233C19.3838 19.3905 19.7676 19.3643 20.1349 19.448C20.5022 19.5317 20.8367 19.7215 21.0969 19.994C21.357 20.2664 21.5313 20.6093 21.598 20.98C21.6647 21.3508 21.6208 21.7329 21.4719 22.0789C21.323 22.425 21.0756 22.7195 20.7606 22.926C20.4455 23.1324 20.0766 23.2416 19.7 23.24C19.4418 23.2389 19.1865 23.1857 18.9493 23.0836C18.7122 22.9816 18.4981 22.8328 18.3198 22.6461C18.1415 22.4593 18.0027 22.2386 17.9116 21.997C17.8206 21.7554 17.7792 21.4979 17.79 21.24Z",
    fill: iconColorSet.inner
  })));
};

var defaultIconColor$9 = {
  inner: "black",
  outer: "black"
};
var CopyIcon = function CopyIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$9 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "コピー" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30B3\u30D4\u30FC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30B3\u30D4\u30FC\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M26.5301 16.45V5.79999L9.93005 5.84999L10.0301 39.99L36.9901 39.91L36.9101 16.45H26.5301Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M29.53 7.34998V13.45H35.48L29.53 7.34998Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M7 26.5H4V0H26V3H7V26.5Z",
    fill: iconColorSet.inner
  })));
};

// 今のところGrafferのSchemas繰り返し項目でのみ使用予定
var CopyForRepeatableIcon = function CopyForRepeatableIcon(_ref) {
  var size = _ref.size,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 25",
    // fill="none"
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("title", null, "\u30B3\u30D4\u30FC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30B3\u30D4\u30FC\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2862 3.52521C17.3243 3.53244 17.3627 3.53601 17.4008 3.53601V3.53001C17.5508 3.53001 17.7008 3.47601 17.8148 3.36801C18.0548 3.14001 18.0668 2.76201 17.8388 2.52201L17.2328 1.88601C17.1366 1.78476 17.0062 1.72196 16.8705 1.7048C16.8632 1.70387 16.8558 1.70308 16.8484 1.70242C16.8407 1.70172 16.8329 1.70118 16.8251 1.70078C16.815 1.70027 16.8049 1.70001 16.7948 1.70001H15.9128C15.5828 1.70001 15.3128 1.97001 15.3128 2.30001C15.3128 2.63001 15.5828 2.90001 15.9128 2.90001H16.1948V3.18201C16.1948 3.51201 16.4648 3.78201 16.7948 3.78201C16.9974 3.78201 17.1774 3.6802 17.2862 3.52521ZM16.0988 22.676C16.9709 22.676 17.6944 22.0076 17.8196 21.134H18.1988C18.5288 21.134 18.7988 20.864 18.7988 20.534C18.7988 20.204 18.5288 19.934 18.1988 19.934H17.8388V10.3287C17.8427 10.301 17.8448 10.2727 17.8448 10.244C17.8448 10.0404 17.742 9.85957 17.5857 9.75098L12.8571 4.71495C12.7498 4.55093 12.5644 4.44201 12.3548 4.44201C12.3261 4.44201 12.2978 4.44406 12.2701 4.44801H7.35678V3.50601C7.35678 3.28401 7.47078 3.07401 7.65078 2.96601C7.93278 2.79801 8.02878 2.42601 7.85478 2.14401C7.68678 1.86201 7.31478 1.76601 7.03278 1.94001C6.49878 2.26401 6.16278 2.87001 6.16278 3.51201V4.44801H3.54078C2.58078 4.44801 1.80078 5.25801 1.80078 6.26001V20.864C1.80078 21.86 2.58078 22.676 3.54078 22.676H16.0988ZM3.54078 5.64801H11.7548V9.03801C11.7548 10.034 12.5348 10.85 13.4948 10.85H16.6448L16.6448 20.534L16.6448 20.864C16.6448 21.2 16.4048 21.476 16.1048 21.476H3.54078C3.24678 21.476 3.00078 21.2 3.00078 20.864V6.25401C3.00078 5.91801 3.24078 5.64201 3.54078 5.64201V5.64801ZM13.4948 9.64401H15.8491L12.9548 6.56665V9.03201C12.9548 9.36801 13.2008 9.64401 13.4948 9.64401ZM20.5688 21.134H19.9148C19.5848 21.134 19.3148 20.864 19.3148 20.534C19.3148 20.204 19.5848 19.934 19.9148 19.934H20.5688C20.7368 19.934 20.8868 19.85 20.9948 19.706C21.1928 19.436 21.5648 19.382 21.8348 19.58C22.0988 19.778 22.1588 20.15 21.9608 20.42C21.6248 20.876 21.1208 21.134 20.5688 21.134ZM21.7268 18.998C21.3968 18.998 21.1268 18.728 21.1268 18.398V16.682C21.1268 16.352 21.3968 16.082 21.7268 16.082C22.0568 16.082 22.3268 16.352 22.3268 16.682V18.398C22.3268 18.728 22.0568 18.998 21.7268 18.998ZM21.7268 15.56C21.3968 15.56 21.1268 15.29 21.1268 14.96V13.244C21.1268 12.914 21.3968 12.644 21.7268 12.644C22.0568 12.644 22.3268 12.914 22.3268 13.244V14.96C22.3268 15.29 22.0568 15.56 21.7268 15.56ZM21.7268 12.122C21.3968 12.122 21.1268 11.852 21.1268 11.522V9.80601C21.1268 9.47601 21.3968 9.20601 21.7268 9.20601C22.0568 9.20601 22.3268 9.47601 22.3268 9.80601V11.522C22.3268 11.852 22.0568 12.122 21.7268 12.122ZM22.1392 7.07321L21.3788 6.26601C21.1508 6.02601 20.7728 6.01401 20.5328 6.24201C20.3078 6.45573 20.2832 6.80123 20.4687 7.04134C20.3324 7.15157 20.2448 7.32006 20.2448 7.50801C20.2448 7.83801 20.5148 8.10801 20.8448 8.10801H21.1273C21.14 8.427 21.4048 8.68401 21.7268 8.68401L21.7208 8.69001C22.0508 8.69001 22.3208 8.42001 22.3208 8.09001V7.59267C22.3247 7.565 22.3268 7.53673 22.3268 7.50801C22.3268 7.33735 22.2546 7.18273 22.1392 7.07321ZM19.7618 6.032C19.6067 6.03124 19.446 5.97121 19.3268 5.84601L18.1448 4.59801C17.9168 4.35801 17.9288 3.98001 18.1688 3.75201C18.4088 3.52401 18.7868 3.53601 19.0148 3.77601L20.1968 5.02401C20.4248 5.26401 20.4128 5.64201 20.1728 5.87001C20.0595 5.97729 19.9108 6.03128 19.7618 6.032ZM19.7618 6.032L19.7648 6.03201H19.7588L19.7618 6.032ZM14.1848 2.90001H12.4688C12.1388 2.90001 11.8688 2.63001 11.8688 2.30001C11.8688 1.97001 12.1388 1.70001 12.4688 1.70001H14.1848C14.5148 1.70001 14.7848 1.97001 14.7848 2.30001C14.7848 2.63001 14.5148 2.90001 14.1848 2.90001ZM10.7468 2.90001H9.03078C8.70078 2.90001 8.43078 2.63001 8.43078 2.30001C8.43078 1.97001 8.70078 1.70001 9.03078 1.70001H10.7468C11.0768 1.70001 11.3468 1.97001 11.3468 2.30001C11.3468 2.63001 11.0768 2.90001 10.7468 2.90001ZM19.2668 8.10801H17.9408C17.8148 8.10801 17.6828 8.09601 17.5628 8.06601C17.2388 7.99401 17.0348 7.67001 17.1128 7.34601C17.1848 7.02201 17.5088 6.81801 17.8328 6.89601C17.8688 6.90201 17.9108 6.90801 17.9468 6.90801H19.2728C19.6028 6.90801 19.8728 7.17801 19.8728 7.50801C19.8728 7.83801 19.6028 8.10801 19.2728 8.10801H19.2668ZM16.7888 6.91401C16.4648 6.91401 16.2008 6.67401 16.1888 6.35001V4.76001C16.1888 4.43001 16.4588 4.16001 16.7888 4.16001C17.1188 4.16001 17.3888 4.43001 17.3888 4.76001V6.29601C17.3888 6.62601 17.1248 6.90801 16.7948 6.91401H16.7888Z",
    fill: "currentColor"
  })));
};

var defaultIconColor$8 = {
  inner: "white",
  outer: "#1D1C1A"
};
var PrintIcon = function PrintIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$8 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "印刷" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u5370\u5237\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u5370\u5237\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M30 20.93H10V36.93H30V20.93Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M35.79 18.98C36.6185 18.98 37.29 18.3084 37.29 17.48C37.29 16.6516 36.6185 15.98 35.79 15.98C34.9616 15.98 34.29 16.6516 34.29 17.48C34.29 18.3084 34.9616 18.98 35.79 18.98Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M3.58 13.51H36.42C37.3695 13.51 38.2801 13.8872 38.9514 14.5586C39.6228 15.2299 40 16.1405 40 17.09V29.51H0V17.09C0 16.1405 0.377178 15.2299 1.04856 14.5586C1.71994 13.8872 2.63052 13.51 3.58 13.51V13.51Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M31.97 21.44H7.96997V37.44H31.97V21.44Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M33.62 39.08H6.32996V19.8H33.62V39.08ZM9.61996 35.8H30.33V23.08H9.61996V35.8Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M34 21.52C35.1046 21.52 36 20.6246 36 19.52C36 18.4154 35.1046 17.52 34 17.52C32.8954 17.52 32 18.4154 32 19.52C32 20.6246 32.8954 21.52 34 21.52Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M31.9 2.5H7.90002V10.5H31.9V2.5Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M33.4 12H6.40002V1H33.4V12ZM9.40002 9H30.4V4H9.40002V9Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M27.97 25.43H11.97V28.45H27.97V25.43Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M27.97 30.43H11.97V33.45H27.97V30.43Z",
    fill: iconColorSet.outer
  }));
};

var defaultIconColor$7 = {
  inner: "",
  outer: "#1D1C1A"
};
var LinkIcon = function LinkIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$7 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "リンク" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30EA\u30F3\u30AF\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30EA\u30F3\u30AF\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M21.7901 18.24L21.9801 18.44L22.2601 18.73C22.6075 19.0773 22.8831 19.4897 23.0711 19.9435C23.2591 20.3973 23.3559 20.8838 23.3559 21.375C23.3559 21.8662 23.2591 22.3527 23.0711 22.8065C22.8831 23.2604 22.6075 23.6727 22.2601 24.02L12.3801 33.9C12.0327 34.2473 11.6203 34.5229 11.1665 34.7109C10.7127 34.8988 10.2263 34.9956 9.73506 34.9956C9.24384 34.9956 8.75743 34.8988 8.3036 34.7109C7.84977 34.5229 7.43739 34.2473 7.09004 33.9C6.74269 33.5526 6.46717 33.1403 6.27919 32.6865C6.09121 32.2326 5.99446 31.7462 5.99446 31.255C5.99446 30.7638 6.09121 30.2774 6.27919 29.8235C6.46717 29.3697 6.74269 28.9573 7.09004 28.61L12.1901 23.5C11.7357 22.3875 11.4883 21.2014 11.46 20L4.97005 26.49C3.74657 27.762 3.07082 29.4631 3.08796 31.2279C3.10511 32.9927 3.81382 34.6803 5.06178 35.9283C6.30974 37.1763 7.99736 37.8849 9.76216 37.9021C11.527 37.9192 13.2281 37.2435 14.5001 36.02L24.3801 26.14C25.6435 24.8761 26.3533 23.1621 26.3533 21.375C26.3533 19.5879 25.6435 17.8739 24.3801 16.61L24.16 16.38L23.91 16.12L21.7901 18.24Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M19.17 22.75L18.98 22.55C18.93 22.55 18.8901 22.46 18.7001 22.26C18.3527 21.9127 18.077 21.5003 17.889 21.0465C17.701 20.5927 17.6042 20.1062 17.6042 19.615C17.6042 19.1238 17.701 18.6373 17.889 18.1835C18.077 17.7296 18.3527 17.3173 18.7001 16.97L28.58 7.08999C29.2815 6.3885 30.233 5.9944 31.225 5.9944C32.2171 5.9944 33.1686 6.3885 33.8701 7.08999C34.5716 7.79149 34.9656 8.74293 34.9656 9.735C34.9656 10.7271 34.5716 11.6785 33.8701 12.38L28.7601 17.49C29.2223 18.6005 29.4732 19.7875 29.5001 20.99L35.9901 14.5C36.6359 13.8788 37.1514 13.135 37.5064 12.3122C37.8613 11.4893 38.0486 10.604 38.0573 9.70788C38.066 8.8118 37.896 7.92297 37.5571 7.0934C37.2182 6.26382 36.7172 5.51015 36.0836 4.87649C35.4499 4.24283 34.6962 3.74191 33.8666 3.403C33.0371 3.06409 32.1482 2.89402 31.2521 2.90272C30.3561 2.91143 29.4707 3.09874 28.6479 3.4537C27.8251 3.80867 27.0813 4.32415 26.46 4.97L16.5701 14.85C15.3115 16.1165 14.6051 17.8295 14.6051 19.615C14.6051 21.4005 15.3115 23.1135 16.5701 24.38L16.79 24.61L17.05 24.87L19.17 22.75Z",
    fill: iconColorSet.outer
  }));
};

var defaultIconColor$6 = {
  inner: "#1D1C1A",
  outer: ""
};
var BanIcon = function BanIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$6 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "BAN" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "BAN\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "BAN\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M19.58 1C15.9052 1 12.313 2.08971 9.25753 4.1313C6.20206 6.1729 3.82061 9.07469 2.41433 12.4697C1.00805 15.8648 0.640104 19.6006 1.35702 23.2048C2.07393 26.8089 3.84352 30.1196 6.44198 32.718C9.04044 35.3165 12.3511 37.0861 15.9552 37.803C19.5594 38.5199 23.2952 38.152 26.6903 36.7457C30.0853 35.3394 32.9871 32.958 35.0287 29.9025C37.0703 26.847 38.16 23.2548 38.16 19.58C38.1574 14.6531 36.199 9.92874 32.7151 6.44489C29.2313 2.96103 24.5069 1.00265 19.58 1V1ZM19.58 4.16C23.1489 4.15749 26.6072 5.39864 29.36 7.67L7.67001 29.36C5.81402 27.1039 4.63761 24.3667 4.27788 21.4675C3.91816 18.5683 4.38995 15.6266 5.63827 12.9853C6.88659 10.344 8.85999 8.112 11.3284 6.54945C13.7969 4.98691 16.6586 4.15822 19.58 4.16V4.16ZM19.58 35C16.0064 35.002 12.5441 33.7571 9.79 31.48L31.48 9.78999C33.3385 12.0453 34.5174 14.7825 34.8791 17.6824C35.2409 20.5823 34.7706 23.5253 33.5232 26.168C32.2757 28.8108 30.3025 31.0443 27.8337 32.6081C25.3649 34.1719 22.5024 35.0015 19.58 35Z",
    fill: iconColorSet.inner
  }));
};

var defaultIconColor$5 = {
  inner: "",
  outer: "#1D1C1A"
};
var FelicaIcon = function FelicaIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$5 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "Felica" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "Felica\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "Felica\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M22.22 32.37C20.55 32.27 20.58 32.2 20.99 31.91C22.0267 31.276 22.9185 30.4311 23.6076 29.4302C24.2967 28.4293 24.7677 27.2947 24.99 26.1C25.81 21.68 22.99 19.16 18.18 19.76C12.29 20.49 7.58 23.76 3.3 30.19C1.49 32.94 1.54001 34.57 4.03001 32C8.68001 27.18 14.03 22.74 19.1 21.59C21.44 21.05 23.1 21.86 22.61 24.14C22.06 26.98 19.96 29.14 16.92 31.35C15.8 32.17 15.13 32.67 15.49 33.25C15.85 33.83 17.29 34.05 18.85 34.25C23.0619 34.6068 27.2985 34.5532 31.5 34.09C34.7 33.66 36.5 31.9 37.19 28.46C38.3537 22.9344 38.3264 17.2242 37.11 11.71C36.43 9.07999 35.06 7.61001 31.59 6.83001C26.0155 5.90385 20.3357 5.79604 14.73 6.51C11.79 7.06 9.83 8.13001 8.58 10.8C7.59305 12.964 7.24605 15.3652 7.58 17.72C7.75 19.17 8.18 20.47 8.58 20.37C8.98 20.27 9.10001 20.13 9.04001 17.86C8.94869 15.8841 9.17146 13.9061 9.7 12C9.89601 11.1319 10.3559 10.3457 11.0166 9.7495C11.6773 9.15326 12.5064 8.77617 13.39 8.67C17.99 7.67 26.47 7.72 31.51 8.67C34 9.15 35.07 10.14 35.51 12.22C36.3774 17.3778 36.4617 22.637 35.76 27.82C35.39 30.43 33.95 31.77 31.34 32.16C28.3144 32.531 25.2595 32.6014 22.22 32.37V32.37Z",
    fill: iconColorSet.outer
  }));
};

var defaultIconColor$4 = {
  inner: "white",
  outer: "#1D1C1A"
};
var FolderIcon = function FolderIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$4 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "フォルダ" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  var _useId = nextId.useId(1, "folder-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    folderIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30D5\u30A9\u30EB\u30C0\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30D5\u30A9\u30EB\u30C0\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(folderIconId, ")")
  }, React__namespace.default.createElement("path", {
    d: "M38.15 11H20L14 5H2.00003C1.46959 5 0.960885 5.21071 0.585812 5.58578C0.210739 5.96086 2.70311e-05 6.46957 2.70311e-05 7V33.14C-0.00129075 33.3838 0.0455854 33.6254 0.137966 33.851C0.230348 34.0766 0.366407 34.2818 0.538327 34.4546C0.710246 34.6275 0.914638 34.7646 1.13974 34.8582C1.36485 34.9518 1.60624 35 1.85003 35H38.15C38.3938 35 38.6352 34.9518 38.8603 34.8582C39.0854 34.7646 39.2898 34.6275 39.4617 34.4546C39.6336 34.2818 39.7697 34.0766 39.8621 33.851C39.9545 33.6254 40.0013 33.3838 40 33.14V12.85C40 12.3593 39.8051 11.8888 39.4582 11.5419C39.1112 11.1949 38.6407 11 38.15 11Z",
    fill: iconColorSet.outer
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: folderIconId
  }, React__namespace.default.createElement("rect", {
    width: "40",
    height: "40",
    fill: iconColorSet.inner
  }))));
};

var defaultIconColor$3 = {
  inner: "",
  outer: "#1D1C1A"
};
var MailIcon = function MailIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$3 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "メール" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30E1\u30FC\u30EB\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30E1\u30FC\u30EB\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M0 6V33.67H40V6H0ZM34.1899 9L19.96 20.31L5.75 9H34.1899ZM3 30.67V10.61L20 24.11L37 10.6V30.67H3Z",
    fill: iconColorSet.outer
  }));
};

var defaultIconColor$2 = {
  inner: "",
  outer: "#1D1C1A"
};
var NFCIcon = function NFCIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$2 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "NFC" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "NFC\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "NFC\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M12.38 3.99998C9.75 3.99998 7.13001 3.99998 6.47001 4.05998C5.83128 4.07531 5.22312 4.33657 4.77228 4.78927C4.32144 5.24198 4.0627 5.85121 4.05 6.48999C3.99 7.78999 3.99 32.16 4.05 33.49C4.08184 34.1196 4.3476 34.7147 4.79524 35.1586C5.24287 35.6026 5.84013 35.8634 6.47001 35.89C7.93001 35.97 12.7 35.99 14.06 35.99C11.61 34.29 11.27 31.1 11.06 25.19C10.93 21.68 11.06 9.38999 11.06 8.86999L11.12 5.50999L24.02 18.42V22.42L13.71 12.18C13.71 14.18 13.66 16.85 13.66 19.27C13.66 21.69 13.66 23.76 13.76 24.89C14.14 31.33 14.76 34.36 18.1 35.54C19.2575 35.9172 20.4741 36.0799 21.69 36.02C23 36.02 32.19 36.02 33.5 35.96C34.1399 35.9424 34.7489 35.6811 35.2024 35.2294C35.656 34.7777 35.9198 34.1698 35.94 33.53C35.99 32.23 35.99 7.91999 35.94 6.58999C35.901 5.96037 35.6299 5.36756 35.1793 4.92613C34.7286 4.4847 34.1303 4.226 33.5 4.19999C32.05 4.11999 27.29 4.03999 25.91 4.03999C28.36 5.73999 28.68 8.92999 28.91 14.85C29.04 18.36 28.91 30.64 28.91 31.17L28.85 34.52L16.05 21.61V17.61L26.26 27.84C26.26 25.84 26.31 23.16 26.31 20.75C26.31 18.34 26.31 16.26 26.22 15.14C25.83 8.68998 25.22 5.65999 21.88 4.47999C20.7232 4.09969 19.506 3.93693 18.29 3.99998H12.38Z",
    fill: iconColorSet.outer
  }));
};

var defaultIconColor$1 = {
  inner: "white",
  outer: "black"
};
var ZoomInIcon = function ZoomInIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor$1 : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ズームイン" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30BA\u30FC\u30E0\u30A4\u30F3\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30BA\u30FC\u30E0\u30A4\u30F3\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M29.2201 27.1819L27.0988 29.3032L36.3194 38.5239L38.4407 36.4026L29.2201 27.1819Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17 33C25.8366 33 33 25.8366 33 17C33 8.16344 25.8366 1 17 1C8.16344 1 1 8.16344 1 17C1 25.8366 8.16344 33 17 33Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M18.5 9H15.5V25H18.5V9Z",
    fill: iconColorSet.inner
  }), React__namespace.default.createElement("path", {
    d: "M25 15.5H9V18.5H25V15.5Z",
    fill: iconColorSet.inner
  }));
};

var defaultIconColor = {
  inner: "white",
  outer: "black"
};
var ZoomOutIcon = function ZoomOutIcon(_ref) {
  var size = _ref.size,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultIconColor : _ref$iconColor,
    buttonType = _ref.buttonType,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ズームアウト" : _ref$alt;
  var iconColorSet = getIconcolorSet(false, iconColor, buttonType);
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("title", null, "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8\u30A2\u30A4\u30B3\u30F3"), React__namespace.default.createElement("desc", null, "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8\u3092\u8868\u3059\u30A2\u30A4\u30B3\u30F3\u3067\u3059"), React__namespace.default.createElement("path", {
    d: "M29.2254 27.1776L27.1041 29.2989L36.3248 38.5196L38.4461 36.3982L29.2254 27.1776Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M17 33C25.8366 33 33 25.8366 33 17C33 8.16344 25.8366 1 17 1C8.16344 1 1 8.16344 1 17C1 25.8366 8.16344 33 17 33Z",
    fill: iconColorSet.outer
  }), React__namespace.default.createElement("path", {
    d: "M25 15.5H9V18.5H25V15.5Z",
    fill: iconColorSet.inner
  }));
};

/**
 * HelperTextで使用するアイコン
 */
var InfoOutlineIcon = function InfoOutlineIcon(_ref) {
  var size = _ref.size,
    alt = _ref.alt;
  var _useId = nextId.useId(1, "folder-icon-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    folderIconId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("g", {
    clipPath: "url(#".concat(folderIconId, ")")
  }, React__namespace.default.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "none"
  }), React__namespace.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "currentColor"
  }), React__namespace.default.createElement("path", {
    d: "M8.82031 4.83989C8.82031 4.11989 9.37531 3.63989 10.1403 3.63989C10.8903 3.63989 11.4453 4.11989 11.4453 4.83989C11.4453 5.52989 10.8903 6.03989 10.1403 6.03989C9.37531 6.03989 8.82031 5.52489 8.82031 4.83989ZM9.03531 7.38489H11.2253V15.7849H9.03531V7.38489Z",
    fill: "currentColor"
  })), React__namespace.default.createElement("defs", null, React__namespace.default.createElement("clipPath", {
    id: folderIconId
  }, React__namespace.default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "none"
  }))));
};

var Icons = {
  LeftArrowIcon: LeftArrowIcon,
  RightArrowIcon: RightArrowIcon,
  AttentionIcon: AttentionIcon,
  CalenderIcon: CalenderIcon,
  CancelIcon: CancelIcon,
  CheckIcon: CheckIcon,
  EditIcon: EditIcon,
  FileIcon: FileIcon,
  InfoIcon: InfoIcon,
  InfoOutlineIcon: InfoOutlineIcon,
  ExternalLinkIcon: ExternalLinkIcon,
  TrashIcon: TrashIcon,
  WarningIcon: WarningIcon,
  StarIcon: StarIcon,
  CloseEyeIcon: CloseEyeIcon,
  OpenEyeIcon: OpenEyeIcon,
  KebabIcon: KebabIcon,
  HamburgerIcon: HamburgerIcon,
  List2Icon: List2Icon,
  ListIcon: ListIcon,
  SPIcon: SPIcon,
  PCIcon: PCIcon,
  SecurityIcon: SecurityIcon,
  LogIcon: LogIcon,
  HomeIcon: HomeIcon,
  LogOutIcon: LogOutIcon,
  CardIcon: CardIcon,
  UserInfoIcon: UserInfoIcon,
  SearchIcon: SearchIcon,
  NumberIcon: NumberIcon,
  TextAreaIcon: TextAreaIcon,
  PlusIcon: PlusIcon,
  PDFIcon: PDFIcon,
  ImageIcon: ImageIcon,
  UpArrowIcon: UpArrowIcon,
  DownArrowIcon: DownArrowIcon,
  NGIcon: NGIcon,
  NoEditIcon: NoEditIcon,
  LoadingIcon: LoadingIcon,
  TimeIcon: TimeIcon,
  QuestionIcon: QuestionIcon,
  FaqIcon: FaqIcon,
  CopyIcon: CopyIcon,
  CopyForRepeatableIcon: CopyForRepeatableIcon,
  ZoomInIcon: ZoomInIcon,
  ZoomOutIcon: ZoomOutIcon,
  BanIcon: BanIcon,
  NFCIcon: NFCIcon,
  FelicaIcon: FelicaIcon,
  FolderIcon: FolderIcon,
  PrintIcon: PrintIcon,
  LinkIcon: LinkIcon,
  MailIcon: MailIcon
};

var _excluded$y = ["children", "onClick"],
  _excluded2$h = ["text", "type", "className", "isSmall", "buttonType", "onClick"],
  _excluded3$a = ["text"],
  _excluded4 = ["text"],
  _excluded5 = ["text"],
  _excluded6 = ["text"],
  _excluded7 = ["text", "type", "icon", "iconPosition"];
var BaseButton = React__namespace.forwardRef(function BaseButton(_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded$y);
  // HTML上に不要な属性が表示されてしまうため削除
  if ("icon" in props) {
    delete props.icon;
  }
  if ("iconPosition" in props) {
    delete props.iconPosition;
  }
  return React__namespace.createElement("button", _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: !props.disabled && onClick ? onClick : undefined,
    ref: ref
  }), children);
});
var BaseSubmitButtonIcon = function BaseSubmitButtonIcon(_ref2) {
  var isSmall = _ref2.isSmall,
    icon = _ref2.icon,
    iconPosition = _ref2.iconPosition,
    buttonType = _ref2.buttonType,
    children = _ref2.children;
  var Icon = Icons[icon];
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  var IconSize = getIconSize(isSmall !== null && isSmall !== void 0 ? isSmall : false, isPc);
  if (!Icon) {
    return null;
  }
  if (iconPosition === "right") {
    return React__namespace.createElement(React__namespace.Fragment, null, children, React__namespace.createElement("span", {
      className: styles$N.iconRight,
      "aria-hidden": true
    }, React__namespace.createElement(Icon, {
      size: IconSize,
      buttonType: buttonType
    })));
  }
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("span", {
    className: styles$N.iconLeft,
    "aria-hidden": true
  }, React__namespace.createElement(Icon, {
    size: IconSize,
    buttonType: buttonType
  })), children);
};
// TODO type = "button" に変更する
var BaseSubmitButton = React__namespace.forwardRef(function BaseSubmitButton(_ref3, ref) {
  var text = _ref3.text,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? "submit" : _ref3$type,
    className = _ref3.className,
    isSmall = _ref3.isSmall,
    buttonType = _ref3.buttonType,
    onClick = _ref3.onClick,
    props = _objectWithoutProperties(_ref3, _excluded2$h);
  var handleOnClick = React__namespace.useCallback(function (e) {
    if (props.disabled || props.ignoreClick) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  }, [onClick, props.disabled, props.ignoreClick]);
  return React__namespace.createElement(BaseButton, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    className: "".concat(styles$N.button, "  ").concat(isSmall ? styles$N.small : "", " ").concat(className),
    ref: ref,
    onClick: handleOnClick
  }), "icon" in props ? React__namespace.createElement(BaseSubmitButtonIcon, _objectSpread2({
    isSmall: isSmall,
    buttonType: buttonType
  }, props), React__namespace.createElement("span", null, text)) : React__namespace.createElement("span", null, text));
});
/**
 * defaultをbuttonに変更する予定なのでtypeを明示的に設定してください。
 * デフォルトのtypeを使用するのは非推奨です。
 */
var PrimaryButton = React__namespace.forwardRef(function PrimaryButton(_ref4, ref) {
  var text = _ref4.text,
    props = _objectWithoutProperties(_ref4, _excluded3$a);
  return React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$N.primary,
    buttonType: "Primary",
    text: text,
    ref: ref
  }));
});
/**
 * defaultをbuttonに変更する予定なのでtypeを明示的に設定してください。
 * デフォルトのtypeを使用するのは非推奨です。
 */
var SecondaryButton = React__namespace.forwardRef(function SecondaryButton(_ref5, ref) {
  var text = _ref5.text,
    props = _objectWithoutProperties(_ref5, _excluded4);
  return React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$N.secondary,
    buttonType: "Secondary",
    text: text,
    ref: ref
  }));
});
/**
 * defaultをbuttonに変更する予定なのでtypeを明示的に設定してください。
 * デフォルトのtypeを使用するのは非推奨です。
 */
var DangerButton = React__namespace.forwardRef(function DangerButton(_ref6, ref) {
  var text = _ref6.text,
    props = _objectWithoutProperties(_ref6, _excluded5);
  return React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$N.danger,
    buttonType: "Danger",
    text: text,
    ref: ref
  }));
});
/**
 * defaultをbuttonに変更する予定なのでtypeを明示的に設定してください。
 * デフォルトのtypeを使用するのは非推奨です。
 */
var DangerSecondaryButton = React__namespace.forwardRef(function DangerSecondaryButton(_ref7, ref) {
  var text = _ref7.text,
    props = _objectWithoutProperties(_ref7, _excluded6);
  return React__namespace.createElement(BaseSubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$N.dangerSecondary,
    buttonType: "DangerSecondary",
    text: text,
    ref: ref
  }));
});
var TextButton = React__namespace.forwardRef(function TextButton(_ref8, ref) {
  var text = _ref8.text,
    _ref8$type = _ref8.type,
    type = _ref8$type === void 0 ? "button" : _ref8$type,
    icon = _ref8.icon,
    _ref8$iconPosition = _ref8.iconPosition,
    iconPosition = _ref8$iconPosition === void 0 ? "left" : _ref8$iconPosition,
    props = _objectWithoutProperties(_ref8, _excluded7);
  var Icon = Icons[icon];
  return React__namespace.createElement(BaseButton, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    className: "".concat(styles$N.textButton, " ").concat(props.disabled ? styles$N.disabled : styles$N.clear),
    ref: ref
  }), iconPosition === "right" && text, React__namespace.createElement("span", {
    className: styles$N.icon,
    "aria-hidden": "true"
  }, React__namespace.createElement(Icon, {
    size: IconSizes.small,
    buttonType: "Text"
  })), iconPosition === "left" && text);
});

var css_248z$M = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.graffer-schemas-button-module__GDK__button___CIttE {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  padding: 2px 22px;\n  border: 2px solid;\n}\n\n@media screen and (max-width: 800px) {\n\n  .graffer-schemas-button-module__GDK__button___CIttE {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n/* secondary */\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk {\n  color: #454ab8;\n  background-color: #fff;\n  border-color: #454ab8;\n  fill: #454ab8;\n}\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk:hover {\n  background: #fff;\n  color: #3739a2;\n  border: 2px solid #3739a2;\n  fill: #3739a2;\n}\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk:focus {\n  background: #fff;\n  color: #3739a2;\n  border: 2px solid #3739a2;\n  fill: #3739a2;\n}\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk:focus {\n  background: #fff;\n  outline: 1px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk:active {\n  background: #fff;\n  border: 2px solid #1c1e78;\n  color: #1c1e78;\n  fill: #1c1e78;\n}\n\n.graffer-schemas-button-module__GDK__secondary___vbUjk:disabled {\n  background: #fff;\n  border-color: #dcd9d8;\n  color: #dcd9d8;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  fill: #dcd9d8;\n}\n\n/* icon */\n\n.graffer-schemas-button-module__GDK__iconLeft___BjRFg {\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n}\n\n.graffer-schemas-button-module__GDK__iconRight___y86FT {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.graffer-schemas-button-module__GDK__button___CIttE:disabled,\n.graffer-schemas-button-module__GDK__textButton___0wtO-:disabled {\n  cursor: not-allowed;\n}\n\n.graffer-schemas-button-module__GDK__fullWidth___B2lQh {\n  width: 100%;\n}\n";
var styles$L = {"button":"graffer-schemas-button-module__GDK__button___CIttE","secondary":"graffer-schemas-button-module__GDK__secondary___vbUjk","iconLeft":"graffer-schemas-button-module__GDK__iconLeft___BjRFg","iconRight":"graffer-schemas-button-module__GDK__iconRight___y86FT","textButton":"graffer-schemas-button-module__GDK__textButton___0wtO-","fullWidth":"graffer-schemas-button-module__GDK__fullWidth___B2lQh"};
styleInject(css_248z$M);

var _excluded$x = ["children", "onClick"],
  _excluded2$g = ["text", "type", "className", "isFullWidth", "buttonType"],
  _excluded3$9 = ["text"];
/**
 * GrafferSchemas以外で使用しないでください。
 */
var GrafferSchemasBaseButton = React__namespace.forwardRef(function BaseButton(_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded$x);
  // HTML上に不要な属性が表示されてしまうため削除
  if ("icon" in props) {
    delete props.icon;
  }
  if ("iconPosition" in props) {
    delete props.iconPosition;
  }
  return React__namespace.createElement("button", _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: !props.disabled && onClick ? onClick : undefined,
    ref: ref
  }), children);
});
/**
 * GrafferSchemas以外で使用しないでください。
 */
var GrafferSchemasBaseButtonIcon = function GrafferSchemasBaseButtonIcon(_ref2) {
  var icon = _ref2.icon,
    iconPosition = _ref2.iconPosition,
    buttonType = _ref2.buttonType,
    children = _ref2.children;
  var Icon = Icons[icon];
  if (!Icon) {
    return null;
  }
  if (iconPosition === "right") {
    return React__namespace.createElement(React__namespace.Fragment, null, children, React__namespace.createElement("span", {
      className: styles$L.iconRight
    }, React__namespace.createElement(Icon, {
      size: 16,
      buttonType: buttonType
    })));
  }
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("span", {
    className: styles$L.iconLeft
  }, React__namespace.createElement(Icon, {
    size: 24,
    buttonType: buttonType
  })), children);
};
/**
 * GrafferSchemas以外で使用しないでください。
 */
var GrafferSchemasBaseButtonWithIcon = React__namespace.forwardRef(function BaseSubmitButton(_ref3, ref) {
  var text = _ref3.text,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? "button" : _ref3$type,
    className = _ref3.className,
    isFullWidth = _ref3.isFullWidth,
    buttonType = _ref3.buttonType,
    props = _objectWithoutProperties(_ref3, _excluded2$g);
  return React__namespace.createElement(GrafferSchemasBaseButton, _objectSpread2(_objectSpread2({}, props), {}, {
    type: type,
    className: "".concat(styles$L.button, " ").concat(className, " ").concat(isFullWidth ? styles$L.fullWidth : ""),
    ref: ref
  }), "icon" in props ? React__namespace.createElement(GrafferSchemasBaseButtonIcon, _objectSpread2({
    buttonType: buttonType
  }, props), React__namespace.createElement("span", null, text)) : React__namespace.createElement("span", null, text));
});
/**
 * GrafferSchemasの繰り返し項目の「追加する」系ボタンとしての使用を想定したボタンです。
 * https://github.com/graffer-inc/graffer-schemas 以外での使用は禁止します。
 */
var GrafferSchemasSecondaryButton = React__namespace.forwardRef(function SecondaryButton(_ref4, ref) {
  var text = _ref4.text,
    props = _objectWithoutProperties(_ref4, _excluded3$9);
  return React__namespace.createElement(GrafferSchemasBaseButtonWithIcon, _objectSpread2(_objectSpread2({}, props), {}, {
    className: styles$L.secondary,
    buttonType: "Secondary",
    text: text,
    ref: ref
  }));
});

var css_248z$L = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.cancel-button-module__GDK__background___3zuZd {\n  display: none;\n  position: absolute;\n  bottom: 25%;\n  right: 50%;\n  transform: translate(50%, 50%);\n  margin: auto;\n}\n\n.cancel-button-module__GDK__button___2yvWY {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.cancel-button-module__GDK__button___2yvWY:hover {\n  background-color: #dcd9d8;\n}\n\n.cancel-button-module__GDK__button___2yvWY:focus {\n  outline: 2px solid #454ab8;\n}\n";
var styles$K = {"background":"cancel-button-module__GDK__background___3zuZd","button":"cancel-button-module__GDK__button___2yvWY"};
styleInject(css_248z$L);

var CancelButton = function CancelButton(_ref) {
  var iconSize = _ref.iconSize,
    onCancel = _ref.onCancel,
    className = _ref.className,
    isReversible = _ref.isReversible,
    ariaLabel = _ref.ariaLabel;
  return React__namespace.default.createElement("button", {
    className: "".concat(styles$K.button, " ").concat(className),
    onClick: onCancel,
    "aria-label": ariaLabel
  }, React__namespace.default.createElement(CancelIcon, {
    size: iconSize,
    isReversible: isReversible,
    className: styles$K.cancelIcon
  }));
};

var css_248z$K = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.graffer-ui-reactDatePicker > .react-datepicker__month-container {\n  width: 100%;\n  float: none;\n}\n\n.react-datepicker__input-container {\n  display: flex;\n}\n\n.react-datepicker-popper {\n  z-index: 100;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__header--custom {\n  background-color: #fff;\n  border: none;\n  padding: 0;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__header--custom\n  .react-datepicker__day-names {\n  display: flex;\n  margin-top: 16px;\n  justify-content: space-around;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__header--custom\n  .react-datepicker__day-name {\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  text-align: center;\n  margin: 0;\n}\n\n@media screen and (max-width: 800px) {\n\n  .graffer-ui-reactDatePicker\n  .react-datepicker__header--custom\n  .react-datepicker__day-name {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__month {\n  margin: 8px 0 0;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__week:not(:first-child) {\n  margin-top: 2px;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__week {\n  margin: 0;\n  display: flex;\n  justify-content: space-around;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--outside-month {\n  pointer-events: none;\n  color: #dcd9d8;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--keyboard-selected {\n  background-color: transparent;\n  border-radius: 0;\n  color: #1d1c1a;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day .cell {\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day:hover .cell {\n  background-color: #f7f3f0;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day.react-datepicker__day--selected:hover\n  .cell {\n  background-color: #454ab8;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--selected,\n.graffer-ui-reactDatePicker .react-datepicker__day:hover {\n  background-color: transparent;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-range,\n.graffer-ui-reactDatePicker .react-datepicker__day--in-selecting-range {\n  border-radius: 0;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__week\n  .react-datepicker__day:first-child,\n.graffer-ui-reactDatePicker .react-datepicker__day--range-start,\n.graffer-ui-reactDatePicker .react-datepicker__day--selecting-range-start {\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__week\n  .react-datepicker__day:last-child,\n.graffer-ui-reactDatePicker .react-datepicker__day--range-end,\n.graffer-ui-reactDatePicker .react-datepicker__day--in-selecting-range:hover,\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--range-end.react-datepicker__day--in-range.lastDayOfMonth,\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--in-selecting-range.lastDayOfMonth {\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n}\n\n.graffer-ui-reactDatePicker\n  .lastDayOfMonth.react-datepicker__day--outside-month,\n.graffer-ui-reactDatePicker .lastDayOfMonth.react-datepicker__day--in-range {\n  border-radius: 0;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-selecting-range {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-selecting-range:hover {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-range {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-range:hover {\n  background-color: #e8e9f7;\n  color: #1d1c1a;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day--selected .cell {\n  color: #fffefc;\n  background-color: #454ab8;\n}\n\n/* TODO:正式な色を決める */\n\n.graffer-ui-reactDatePicker .react-datepicker__day--in-range .cell:hover,\n.graffer-ui-reactDatePicker .react-datepicker__day--in-range .cell:hover {\n  background-color: #bec3ff;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--in-selecting-range:hover\n  .cell {\n  background: transparent;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--range-end.react-datepicker__day--in-range\n  .cell {\n  background-color: #454ab8;\n  color: #fff;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--range-end.react-datepicker__day--outside-month\n  .cell {\n  background-color: #454ab8;\n  color: #fff;\n}\n\n.graffer-ui-reactDatePicker .cell {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start\n  .cell {\n  background-color: #454ab8;\n  color: #fff;\n}\n\n.graffer-ui-reactDatePicker\n  .react-datepicker__day--range-start.react-datepicker__day--selected\n  .cell {\n  background-color: #454ab8;\n  color: #fff;\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__month-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.year-month-wrapper .react-datepicker__month-text--keyboard-selected {\n  background-color: #454ab8;\n  color: #fff;\n}\n\n.year-month-wrapper\n  .react-datepicker__month-text--keyboard-selected:focus-visible {\n  outline: 1px solid #454ab8;\n  outline-offset: 1px;\n  z-index: 10;\n}\n\n.year-month-wrapper .react-datepicker__month-text {\n  cursor: pointer;\n}\n\n.graffer-ui-reactDatePicker .customDay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: inherit;\n}\n\n@media screen and (max-width: 800px) {\n\n  .graffer-ui-reactDatePicker .customDay {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.graffer-ui-reactDatePicker .react-datepicker__day:focus-visible .cell {\n  outline: 1px solid #454ab8;\n  outline-offset: 1px;\n  z-index: 10;\n}\n\n@media screen and (max-width: 800px) {\n  .graffer-ui-reactDatePicker\n    .react-datepicker__header--custom\n    .react-datepicker__day-names {\n    margin-top: 16px;\n  }\n  .graffer-ui-reactDatePicker .react-datepicker__week {\n    display: flex;\n    justify-content: space-around;\n  }\n  .graffer-ui-reactDatePicker .react-datepicker__day {\n    height: auto;\n    flex: 1 1 auto;\n    position: relative;\n  }\n\n  .graffer-ui-reactDatePicker .react-datepicker__day:before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n  }\n\n  .react-datepicker__portal {\n    align-items: start !important;\n    overflow: auto;\n    height: 100dvh;\n  }\n\n  .graffer-ui-reactDatePicker .customDay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    justify-content: center;\n  }\n}\n";
styleInject(css_248z$K);

// プラグインを有効化
dayjs__default.default.extend(utc__default.default);
dayjs__default.default.extend(timezone__default.default);
dayjs__default.default.extend(isBetween__default.default);
var getSeparator = function getSeparator(format) {
  switch (format) {
    case "YYYY/MM/DD":
      return "/";
    case "YYYY/MM":
      return "/";
    case "YYYY-MM-DD":
      return "-";
  }
};
/*
 * 西暦 -> 和暦(年)
 */
var convertYearToWareki = function convertYearToWareki(date) {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  if (!year) {
    return "";
  }
  if (year >= 2019) {
    var isYear = year === 2019;
    var isMonth = month <= 4;
    var warekiYear = year - (isYear && isMonth ? 2019 : 2018);
    return warekiYear === 0 ? "\u5E73\u6210".concat(year - 1988, "\u5E74") : warekiYear === 1 ? "令和元年" : "\u4EE4\u548C".concat(warekiYear, "\u5E74");
  }
  if (year >= 1989) {
    var _warekiYear = year - 1988;
    return _warekiYear === 0 ? "\u662D\u548C".concat(year - 1925, "\u5E74") : _warekiYear === 1 ? "平成元年" : "\u5E73\u6210".concat(_warekiYear, "\u5E74");
  }
  if (year >= 1926) {
    var _warekiYear2 = year - 1925;
    return _warekiYear2 === 1 ? "昭和元年" : "\u662D\u548C".concat(_warekiYear2, "\u5E74");
  }
  if (year >= 1912) {
    var _warekiYear3 = year - 1911;
    return _warekiYear3 === 1 ? "大正元年" : "\u5927\u6B63".concat(_warekiYear3, "\u5E74");
  }
  if (year >= 1868) {
    var _warekiYear4 = year - 1867;
    return _warekiYear4 === 1 ? "明治元年" : "\u660E\u6CBB".concat(_warekiYear4, "\u5E74");
  }
  return "";
};
/***
 * 西暦 -> 和暦(年)
 * 年でのみ変換するため、年号の切り替え年は両方表示する
 */
var convertYearToWarekiOnlyYear = function convertYearToWarekiOnlyYear(year) {
  if (!year) {
    return "";
  }
  if (year >= 2019) {
    var warekiYear = year - 2019;
    return warekiYear === 0 ? "\u5E73\u6210".concat(year - 1988, "\u5E74 | \u4EE4\u548C\u5143\u5E74") : "\u4EE4\u548C".concat(warekiYear + 1, "\u5E74");
  }
  if (year >= 1989) {
    var _warekiYear5 = year - 1988;
    return _warekiYear5 === 0 ? "\u662D\u548C".concat(year - 1925, "\u5E74") : _warekiYear5 === 1 ? "\u662D\u548C".concat(year - 1925, "\u5E74 | \u5E73\u6210\u5143\u5E74") : "\u5E73\u6210".concat(_warekiYear5, "\u5E74");
  }
  if (year >= 1926) {
    var _warekiYear6 = year - 1925;
    return _warekiYear6 === 1 ? "\u5927\u6B63".concat(year - 1911, "\u5E74 | \u662D\u548C\u5143\u5E74") : "\u662D\u548C".concat(_warekiYear6, "\u5E74");
  }
  if (year >= 1912) {
    var _warekiYear7 = year - 1911;
    return _warekiYear7 === 1 ? "\u660E\u6CBB".concat(year - 1867, "\u5E74 | \u5927\u6B63\u5143\u5E74") : "\u5927\u6B63".concat(_warekiYear7, "\u5E74");
  }
  if (year >= 1868) {
    var _warekiYear8 = year - 1867;
    return _warekiYear8 === 1 ? "明治元年" : "\u660E\u6CBB".concat(_warekiYear8, "\u5E74");
  }
  return "";
};
var isLastDayOfMonth = function isLastDayOfMonth(date) {
  return date.getDate() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};
var dateToValue = function dateToValue(date, format) {
  if (!date || isNaN(date.getTime())) {
    return null;
  }
  var _year$month$day$hours = {
      year: date.getFullYear().toString(),
      month: ("0" + (date.getMonth() + 1).toString()).slice(-2),
      day: ("0" + date.getDate().toString()).slice(-2),
      hours: ("0" + date.getHours().toString()).slice(-2),
      minutes: ("0" + date.getMinutes().toString()).slice(-2)
    },
    year = _year$month$day$hours.year,
    month = _year$month$day$hours.month,
    day = _year$month$day$hours.day,
    hours = _year$month$day$hours.hours,
    minutes = _year$month$day$hours.minutes;
  if (format === "HH:mm") {
    return "".concat(hours, ":").concat(minutes);
  }
  return [year, month, day].join(getSeparator(format));
};
var valueToDate$1 = function valueToDate(dateString) {
  if (dateString === "" || !dateString) {
    return null;
  }
  return new Date(dateString);
};
var timeValueToDate = function timeValueToDate(timeString) {
  var timeSplited = timeString.split(":");
  //「:」で分割できない場合
  if (timeSplited.length === 1) {
    return null;
  }
  if (isNaN(Number(timeSplited[0])) || isNaN(Number(timeSplited[1]))) {
    return null;
  }
  if (!validateHours(timeSplited[0]) || !validateMinutes(timeSplited[1])) {
    return null;
  }
  var time = new Date();
  time.setHours(Number(timeSplited[0]));
  time.setMinutes(Number(timeSplited[1]));
  return time;
};
var validateHours = function validateHours(hours) {
  if (hours === "" || !hours) {
    return false;
  }
  return parseInt(hours) >= 0 && parseInt(hours) < 24;
};
var validateMinutes = function validateMinutes(minutes) {
  if (minutes === "" || !minutes) {
    return false;
  }
  return parseInt(minutes) >= 0 && parseInt(minutes) < 60;
};
var isValidDate = function isValidDate(date) {
  return date.toString() !== "Invalid Date" && date instanceof Date;
};
var getRegExp = function getRegExp(format) {
  switch (format) {
    case "YYYY/MM":
      return /^\d{4}\/\d{1,2}/;
    case "YYYY/MM/DD":
      return /^\d{4}\/\d{1,2}\/\d{1,2}$/;
    case "YYYY-MM-DD":
      return /^\d{4}-\d{1,2}-\d{1,2}$/;
  }
};
/**
 * 有効な日付と日付文字列のチェック
 * 厳密にチェックでためisValidDateStringの使用を推奨
 * @param value
 * @param format
 * @deprecated
 * @returns
 */
var isValidDateAndDateString = function isValidDateAndDateString(value, format) {
  if (!value) return true;
  if (typeof value === "string") {
    return value === dayjs__default.default(value, undefined).format(format);
  }
  return value.toString() !== "Invalid Date" && value instanceof Date;
};
/**
 * 有効な日付と日付文字列のチェック
 * @param value
 * @param format
 * @returns
 */
var isValidDateString = function isValidDateString(value, format) {
  if (!value) return true;
  if (typeof value === "string") {
    if (!value.match(getRegExp(format))) {
      return false;
    }
    var y = Number(value.split(getSeparator(format))[0]);
    var m = Number(value.split(getSeparator(format))[1]) - 1;
    var d = format !== "YYYY/MM" ? Number(value.split(getSeparator(format))[2]) : 1;
    var date = new Date(y, m, d);
    if (date.getFullYear() !== y || date.getMonth() !== m || date.getDate() !== d) {
      return false;
    }
    return true;
  }
  return value.toString() !== "Invalid Date" && value instanceof Date;
};
var formatValue = function formatValue(dateString, format) {
  var v = format === "YYYY/MM" ? dateString.replace(/\D/g, "").match(/^(\d{0,4})(\d{1,2})?$/) : dateString.replace(/\D/g, "").match(/^(\d{0,4})(\d{1,2})?(\d{1,2})?$/);
  var ymd = v || [];
  ymd.shift();
  return ymd.filter(function (_) {
    return _;
  }).join(getSeparator(format));
};
var convertToDate = function convertToDate(dateString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY/MM/DD";
  if (dateString) {
    var _ = dayjs__default.default(dateString).toDate();
    return isValidDateString(dateString, format) ? _ : null;
  }
  return null;
};
var splitTimeInputString = function splitTimeInputString(timeString) {
  var _a, _b;
  if (!timeString) {
    return {
      hour: "",
      minutes: ""
    };
  }
  var timeSplited = timeString.split(":");
  //「:」で分割できない場合
  if (timeSplited.length === 1) {
    return {
      hour: "",
      minutes: ""
    };
  }
  return {
    hour: (_a = timeSplited[0]) !== null && _a !== void 0 ? _a : "",
    minutes: (_b = timeSplited[1]) !== null && _b !== void 0 ? _b : ""
  };
};
var createMergedDateTime = function createMergedDateTime(date, hour, minutes) {
  var newTimeString = "".concat(hour, ":").concat(minutes);
  var newTime = timeValueToDate(newTimeString);
  if (!date || !newTime) {
    return null;
  }
  if (!isValidDate(date) || !isValidDate(newTime)) {
    return null;
  }
  var dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), newTime.getHours(), newTime.getMinutes(), 0);
  return dateTime;
};
/**
 * YYYY/M or MM/D or DD形式のstringを受け取り、splitしてそれぞれ返す
 * @param dateString
 * @returns [year,month,day]
 */
var splitDateString$1 = function splitDateString(dateString) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  var _a, _b, _c;
  if (!dateString) {
    return ["", "", ""];
  }
  var dateSplited = dateString.split(separator);
  return [(_a = dateSplited[0]) !== null && _a !== void 0 ? _a : "", (_b = dateSplited[1]) !== null && _b !== void 0 ? _b : "", (_c = dateSplited[2]) !== null && _c !== void 0 ? _c : ""];
};
/**
 * YYYY/M or MM/D or DD形式のstring | Dateを受け取り、splitしてそれぞれ返す
 * @param date
 * @param format
 * @returns [year,month,day]
 */
var splitDate = function splitDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY/MM/DD";
  if (!date) {
    return ["", "", ""];
  }
  if (typeof date === "string") {
    var converted = dayjs__default.default(date, format);
    return ["".concat(converted.year()), "".concat(converted.month() + 1), "".concat(converted.date())];
  }
  return ["".concat(date.getFullYear()), "".concat(date.getMonth() + 1), "".concat(date.getDate())];
};
/**
 * year , month , dayを受け取り、format形式のstring | Dateを返す
 * @param {
 * year: string;
 * month: string;
 * day: string;
 * format: DATE_FORMAT;
 * type: "string" | "date";
 * }
 * @returns [year,month,day]
 */
var mergeYearMonthDay = function mergeYearMonthDay(_ref) {
  var year = _ref.year,
    month = _ref.month,
    day = _ref.day,
    format = _ref.format,
    type = _ref.type;
  var separator = getSeparator(format);
  var dateString = "".concat(year).concat(separator).concat((month === null || month === void 0 ? void 0 : month.length) === 1 ? "0".concat(month) : month).concat(format === "YYYY/MM" ? "" : (day === null || day === void 0 ? void 0 : day.length) === 1 ? "".concat(separator, "0").concat(day) : "".concat(separator).concat(day));
  var date = convertToDate(dateString, format);
  if (type === "string") {
    if (!year && !month && !day) return "";
    return dateString;
  }
  return date;
};
/**
 * 日付で使用できない文字を弾く
 * @param value
 * @returns
 */
var removeInvalidDateString = function removeInvalidDateString(value) {
  if (!value) return "";
  var v = value.trim();
  if (v && v.length === 1 && v.match(/[０0]/g)) return "";
  if (!v.match(/[０-９-0-9]/g)) return "";
  return value;
};
/**
 * 全角数字を半角数字に変換する
 * @param value
 * @returns
 */
var convertFullToHalfWidth = function convertFullToHalfWidth(value) {
  var v = removeInvalidDateString(value);
  return v.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
};
/**
 *
 * Date型の日付と時間を受け取りフォーマットされた日付時間を返却する
 *
 * @param dateValue
 * @param timeValue
 * @param format YYYY/MM/DD HH:mm | YYYY-MM-DD HH:mm
 * @returns
 */
var formatDateTimeFromDateAndTime = function formatDateTimeFromDateAndTime(dateValue, timeValue, format) {
  if (!dateValue || !timeValue) return "";
  var dateString = dayjs__default.default(dateValue).format("YYYY/MM/DD");
  var timeString = dayjs__default.default(timeValue).format("HH:mm");
  var dateTime = new Date("".concat(dateString, " ").concat(timeString));
  return dayjs__default.default(dateTime).format(format);
};
/**
 * Date型をフォーマットされた文字列に変換する
 * @param dateValue
 * @param format
 * @returns
 */
var formatDateTime = function formatDateTime(dateValue, format) {
  if (!dateValue) return "";
  return dayjs__default.default(dateValue).format(format);
};
/**
 * 日付と時間をマージする
 * @param dateValue Date | null
 * @param timeValue Date | null
 * @returns
 */
var mergeDateTime = function mergeDateTime(dateValue, timeValue) {
  if (!dateValue || !timeValue) return null;
  return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), timeValue.getHours(), timeValue.getMinutes(), timeValue.getSeconds());
};

var css_248z$J = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.date-picker-common-module__GDK__wrapper___45EEF {\n  display: flex;\n  margin-bottom: 2px;\n}\n\n.date-picker-common-module__GDK__calenderIcon___aKE75 {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.date-picker-common-module__GDK__calenderIcon___aKE75:focus::after {\n  content: \"\";\n  position: absolute;\n  width: 48px;\n  height: 48px;\n  background-color: #e8e9f7;\n  border-radius: 8px;\n  top: -11%;\n  left: -10%;\n  z-index: -1;\n}\n\n.date-picker-common-module__GDK__calenderIcon___aKE75:hover path {\n  fill: #7b82ce;\n}\n\n.date-picker-common-module__GDK__calenderIcon___aKE75:disabled {\n  cursor: not-allowed;\n}\n\n.date-picker-common-module__GDK__calenderIcon___aKE75:disabled path {\n  fill: #dcd9d8;\n}\n\n.date-picker-common-module__GDK__container___Xsusk {\n  width: 400px;\n  background-color: #fff;\n  border: 1px solid #dcd9d8;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  padding: 32px;\n}\n\n.date-picker-common-module__GDK__header___FfB5w {\n  border: none;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-picker-common-module__GDK__header___FfB5w {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-picker-common-module__GDK__changeMonthButton___uZJMO {\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border: 1px solid #706d6c;\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  outline: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.date-picker-common-module__GDK__changeMonthButton___uZJMO:focus {\n  outline: 1px solid #454ab8;\n  outline-offset: 4px;\n}\n\n.date-picker-common-module__GDK__changeMonthButton___uZJMO:hover {\n  border-color: #3d3b3a;\n}\n\n.date-picker-common-module__GDK__changeMonthButton___uZJMO path {\n  fill: #706d6c;\n}\n\n.date-picker-common-module__GDK__transitionContainer___Klpar {\n  margin-top: 6px;\n}\n\n.date-picker-common-module__GDK__spaceLeft___QnCoR {\n  margin-left: 1rem;\n}\n\n.date-picker-common-module__GDK__day___qbvaK {\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: stretch;\n  justify-content: center;\n  margin: 0;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-picker-common-module__GDK__day___qbvaK {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-picker-common-module__GDK__day___qbvaK:focus {\n  outline: none;\n}\n\n.date-picker-common-module__GDK__mobileLabel___BHjC1 {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  background-color: #f4f2f0;\n  border-bottom: 1px solid #dcd9d8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% + 28px);\n  height: 60px;\n  transform: translateX(-14px);\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-picker-common-module__GDK__mobileLabel___BHjC1 {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-picker-common-module__GDK__footer___SKtdz {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .date-picker-common-module__GDK__wrapper___45EEF {\n    margin-bottom: 1px;\n  }\n  .date-picker-common-module__GDK__calenderIcon___aKE75 {\n    width: 40px;\n    height: 40px;\n  }\n  .date-picker-common-module__GDK__calenderIcon___aKE75 svg {\n    width: 24px;\n    height: 24px;\n  }\n  .date-picker-common-module__GDK__container___Xsusk {\n    position: relative;\n    z-index: 100;\n    top: 20px;\n    width: calc(100vw - 32px);\n    padding: 0 14px 15px;\n  }\n  .date-picker-common-module__GDK__header___FfB5w {\n    margin-top: 16px;\n  }\n  .date-picker-common-module__GDK__mobileLabel___BHjC1 {\n    padding-right: 16px;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n  }\n  .date-picker-common-module__GDK__mobileLabelText___qDet0 {\n    grid-column-start: 2;\n    display: flex;\n    align-items: center;\n  }\n  .date-picker-common-module__GDK__cancel___aH7Gq {\n    margin-left: auto;\n  }\n}\n";
var styles$J = {"wrapper":"date-picker-common-module__GDK__wrapper___45EEF","calenderIcon":"date-picker-common-module__GDK__calenderIcon___aKE75","container":"date-picker-common-module__GDK__container___Xsusk","header":"date-picker-common-module__GDK__header___FfB5w","changeMonthButton":"date-picker-common-module__GDK__changeMonthButton___uZJMO","transitionContainer":"date-picker-common-module__GDK__transitionContainer___Klpar","spaceLeft":"date-picker-common-module__GDK__spaceLeft___QnCoR","day":"date-picker-common-module__GDK__day___qbvaK","mobileLabel":"date-picker-common-module__GDK__mobileLabel___BHjC1","footer":"date-picker-common-module__GDK__footer___SKtdz","mobileLabelText":"date-picker-common-module__GDK__mobileLabelText___qDet0","cancel":"date-picker-common-module__GDK__cancel___aH7Gq"};
styleInject(css_248z$J);

var css_248z$I = ".use-fixed-scroll-module__GDK__fixScroll___sZJ3A {\n  overflow: hidden;\n}\n";
var styles$I = {"fixScroll":"use-fixed-scroll-module__GDK__fixScroll___sZJ3A"};
styleInject(css_248z$I);

/**
 * スクロールを固定する。（Modal・Dialog等を開いた際に、背景スクロールを止める為に使用される想定。）
 * @param testClassName jestでテストする際にのみ使用（クラス着脱確認用）。通常は使用しない。
 * @returns
 */
function useFixedScroll() {
  var fixSclollClassName = styles$I.fixScroll;
  var ua = window.navigator.userAgent.toLowerCase();
  var isSafari = ua.includes("safari");
  var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1 || ua.indexOf("macintosh") > -1 && "ontouchend" in document;
  var isTargetBrowser = React.useMemo(function () {
    return isSafari && isiOS;
  }, [isSafari, isiOS]);
  // scrollを固定する
  var applyFixedScroll = React__namespace.default.useCallback(function (scrollPosition) {
    var body = document.body;
    var html = document.documentElement;
    if (isTargetBrowser) {
      body.style.position = "fixed";
      body.style.width = "100%";
      body.style.top = "-".concat(scrollPosition, "px");
    } else {
      body.classList.add(fixSclollClassName);
      html.classList.add(fixSclollClassName);
    }
  }, [fixSclollClassName, isTargetBrowser]);
  // scroll固定を削除する
  var removeFixedScroll = React__namespace.default.useCallback(function (scrollPosition) {
    var body = document.body;
    var html = document.documentElement;
    if (isTargetBrowser) {
      body.style.removeProperty("position");
      body.style.removeProperty("width");
      body.style.removeProperty("top");
      window.scrollTo(0, scrollPosition);
    } else {
      body.classList.remove(fixSclollClassName);
      html.classList.remove(fixSclollClassName);
    }
  }, [fixSclollClassName, isTargetBrowser]);
  return {
    applyFixedScroll: applyFixedScroll,
    removeFixedScroll: removeFixedScroll,
    isTargetBrowser: isTargetBrowser
  };
}

/**
 * スマホでは、背景のスクロールを固定する。
 * PCでは、モーダルを開いた際に、指定したセレクタの要素にフォーカスを当てる。
 * @param selectors モーダルを開いた際にフォーカスを当てるセレクタ
 * @returns
 */
function useMobileModalOpen(selectors) {
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  //モーダルを開いた際のscroll位置を保持
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var _useFixedScroll = useFixedScroll(),
    applyFixedScroll = _useFixedScroll.applyFixedScroll,
    removeFixedScroll = _useFixedScroll.removeFixedScroll;
  var onOpen = React__namespace.default.useCallback(function () {
    var _a;
    var focusElm = document.querySelectorAll(selectors);
    (_a = focusElm === null || focusElm === void 0 ? void 0 : focusElm[0]) === null || _a === void 0 ? void 0 : _a.focus();
    if (!isPc) {
      var _scrollPosition = window.pageYOffset;
      setScrollPosition(_scrollPosition);
      applyFixedScroll(_scrollPosition);
    }
  }, [isPc, selectors, applyFixedScroll]);
  var onClose = React__namespace.default.useCallback(function () {
    if (!isPc) {
      removeFixedScroll(scrollPosition);
    }
  }, [removeFixedScroll, scrollPosition, isPc]);
  return {
    onOpen: onOpen,
    onClose: onClose
  };
}

ReactDatePicker.registerLocale("ja", ja__default.default);
/** DatePickerに渡すpropsの1つ。カスタマイズしたカレンダーアイコン。ReactDatePickerから渡されるonClickを発火させる必要があるためrefを受け取る
 * @link https://github.com/Hacker0x01/react-datepicker/issues/2165
 */
var CustomIcon = React__namespace.default.forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled,
    _ref$iconTitle = _ref.iconTitle,
    iconTitle = _ref$iconTitle === void 0 ? "カレンダーを表示する" : _ref$iconTitle;
  return React__namespace.default.createElement("button", {
    className: styles$J.calenderIcon,
    onClick: onClick,
    ref: ref,
    type: "button",
    "aria-label": iconTitle,
    disabled: disabled
  }, React__namespace.default.createElement(CalenderIcon, {
    size: 32
  }));
});
CustomIcon.displayName = "CustomIcon";
/** DatePickerに渡すpropsの1つ。カレンダーの月の最終日にスタイル調節のためのクラスをつける */
var dayClassName = function dayClassName(date) {
  return "".concat(styles$J.day, " ").concat(isLastDayOfMonth(date) ? "lastDayOfMonth" : "");
};
/** DatePickerに渡すpropsの1つ。カレンダーのヘッダーをカスタムした要素を返す関数*/
var RenderCustomHeader = function RenderCustomHeader(_ref2) {
  var date = _ref2.date,
    decreaseMonth = _ref2.decreaseMonth,
    increaseMonth = _ref2.increaseMonth;
  var wareki = convertYearToWareki(date);
  return React__namespace.default.createElement("div", {
    className: styles$J.header
  }, React__namespace.default.createElement("button", {
    className: styles$J.changeMonthButton,
    onClick: decreaseMonth,
    "aria-label": "\u524D\u306E\u6708\u3092\u8868\u793A\u3059\u308B",
    type: "button"
  }, React__namespace.default.createElement(LeftArrowIcon, {
    size: 24
  })), React__namespace.default.createElement("div", {
    className: styles$J.transitionContainer
  }, "".concat(date.getFullYear(), "\u5E74"), "\uFF08".concat(wareki && wareki, "\uFF09"), React__namespace.default.createElement("span", {
    className: styles$J.spaceLeft
  }, "".concat(date.getMonth() + 1, "\u6708"))), React__namespace.default.createElement("button", {
    className: styles$J.changeMonthButton,
    onClick: increaseMonth,
    "aria-label": "\u6B21\u306E\u6708\u3092\u8868\u793A\u3059\u308B",
    type: "button"
  }, React__namespace.default.createElement(RightArrowIcon, {
    size: 24
  })));
};
/** DatePickerに渡すpropsの1つ。カレンダーの日にちをカスタムした要素を返す関数*/
var RenderDayOfMonth = function RenderDayOfMonth(dayOfMonth) {
  return React__namespace.default.createElement("div", {
    className: "cell"
  }, React__namespace.default.createElement("span", {
    className: "customDay"
  }, dayOfMonth));
};
/** 共通のpropsを渡したReactDatePickerをラップしたコンポーネント。
 * refを使用してカレンダーの開閉を操作するためrefを受け取る(stateでは操作できない)
 * @link https://github.com/Hacker0x01/react-datepicker/issues/685
 */
var DatePickerCore = React__namespace.default.forwardRef(function (props, ref) {
  var _useMobileModalOpen = useMobileModalOpen(".".concat(styles$J.changeMonthButton)),
    onCalendarOpen = _useMobileModalOpen.onOpen,
    onCalendarClose = _useMobileModalOpen.onClose;
  return React__namespace.default.createElement(ReactDatePicker__default.default, _objectSpread2(_objectSpread2({
    ref: ref,
    locale: "ja",
    customInput: React__namespace.default.createElement(CustomIcon, {
      disabled: props.disabled,
      iconTitle: props.iconTitle
    }),
    dayClassName: dayClassName,
    renderCustomHeader: RenderCustomHeader,
    wrapperClassName: styles$J.wrapper,
    fixedHeight: true,
    popperModifiers: [{
      name: "flip",
      options: {
        fallbackPlacements: ["top", "right"]
      }
    }],
    renderDayContents: RenderDayOfMonth
  }, props), {}, {
    onCalendarOpen: onCalendarOpen,
    onCalendarClose: onCalendarClose
  }));
});
DatePickerCore.displayName = "DatePickerCore";
/**DatePickerに渡すpropsの1つ。カレンダーを囲うカスタム要素を追加する。pcとmobileで要素が異なるため、それぞれの定義ファイルでimportして使用する */
var CalendarContainer = function CalendarContainer(_ref3) {
  var isMobile = _ref3.isMobile,
    handleCancel = _ref3.handleCancel,
    handleReflect = _ref3.handleReflect,
    showMonthYearPicker = _ref3.showMonthYearPicker;
  return (
    // eslint-disable-next-line react/display-name
    function (_ref4) {
      var children = _ref4.children;
      return React__namespace.default.createElement("div", {
        className: classNames__default.default("graffer-ui-reactDatePicker", styles$J.container, showMonthYearPicker && "year-month-wrapper")
      }, React__namespace.default.createElement(React__namespace.default.Fragment, null, isMobile && React__namespace.default.createElement("div", {
        className: styles$J.mobileLabel
      }, React__namespace.default.createElement("span", {
        className: styles$J.mobileLabelText
      }, showMonthYearPicker ? "年月を選択" : "日にちを選択"), React__namespace.default.createElement(CancelButton, {
        className: styles$J.cancel,
        iconSize: 24,
        onCancel: handleCancel || function () {
          return null;
        },
        ariaLabel: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3092\u9589\u3058\u308B"
      })), children, isMobile && handleCancel && handleReflect && React__namespace.default.createElement("div", {
        className: styles$J.footer
      }, React__namespace.default.createElement(PrimaryButton, {
        text: "".concat(showMonthYearPicker ? "年月を決定" : "日にちを決定"),
        onClick: handleReflect,
        isSmall: true,
        title: "\u9078\u629E\u3057\u305F\u5024\u3092\u53CD\u6620\u3057\u3066\u30AB\u30EC\u30F3\u30C0\u30FC\u3092\u9589\u3058\u308B",
        disabled: false
      }))));
    }
  );
};

/**
 * 主にモバイル用の日付操作の関数と値を返すhooks
 * PCと違いモバイルでは日付選択をしてもすぐに元の値が変更されるのではなく、日付選択後、反映の操作をして初めて値が変更される。そのため、元の値とは別に、内部で一時的な日付の値を持つ必要がある(temporaryDate)。
 * @returns pickerRef モーダルの開閉に必要なref。react-DatePickerではモーダルの開閉がstateで操作できず、refでの操作を推奨(強制)
 * @returns temporaryDate モバイルで日付選択をする際に必要な一時的な値。ReactDatePickerに渡されて日付選択ののUI表示に使用される。
 * @returns handleCancel temporaryDateを元の値に戻す関数
 * @returns handleReflect 元の値をtemporaryDateで上書きする関数
 * @returns handlePickerMobileChange temporaryDateを変更する関数
 */
var useMobileDate = function useMobileDate(_ref) {
  var date = _ref.date,
    setValue = _ref.setValue,
    showMonthYearPicker = _ref.showMonthYearPicker,
    isOpen = _ref.isOpen;
  var pickerRef = React.useRef(null);
  //mobileのカレンダー入力の場合、反映ボタンで値を反映させるために一時的な値としてkeepする。
  var _useState = React.useState(date),
    _useState2 = _slicedToArray(_useState, 2),
    temporaryDate = _useState2[0],
    setTemporaryDate = _useState2[1];
  //外部（inputフォーム）からの入力に対応する
  React.useEffect(function () {
    setTemporaryDate(date);
  }, [date]);
  React.useEffect(function () {
    var _a;
    if (isOpen !== undefined) {
      (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(isOpen);
    }
  }, [isOpen]);
  var setNewValue = React.useCallback(function (date) {
    var dateString = date ? dateFns.format(date, "".concat(showMonthYearPicker ? "yyyy/MM" : "yyyy/MM/dd")) : "";
    setValue(dateString);
  }, [setValue, showMonthYearPicker]);
  var handleCancel = React.useCallback(function () {
    var _a;
    setTemporaryDate(date);
    (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
  }, [setTemporaryDate, date]);
  var handleReflect = React.useCallback(function () {
    var _a;
    setNewValue(temporaryDate);
    (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
  }, [temporaryDate, setNewValue]);
  var handlePickerMobileChange = React.useCallback(function (date) {
    setTemporaryDate(date);
  }, [setTemporaryDate]);
  return {
    pickerRef: pickerRef,
    temporaryDate: temporaryDate,
    handleCancel: handleCancel,
    handleReflect: handleReflect,
    handlePickerMobileChange: handlePickerMobileChange
  };
};

var _excluded$w = ["date", "onChange"],
  _excluded2$f = ["date", "setValue"],
  _excluded3$8 = ["onChange", "setValue"];
var PcDatePicker = function PcDatePicker(_ref) {
  var date = _ref.date,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded$w);
  return React__namespace.default.createElement(DatePickerCore, _objectSpread2({
    selected: date,
    onChange: onChange,
    calendarContainer: CalendarContainer({
      isMobile: false,
      showMonthYearPicker: !!props.showMonthYearPicker
    })
  }, props));
};
var MobileDatePicker = function MobileDatePicker(_ref2) {
  var date = _ref2.date,
    setValue = _ref2.setValue,
    props = _objectWithoutProperties(_ref2, _excluded2$f);
  var _useMobileDate = useMobileDate({
      date: date,
      setValue: setValue,
      showMonthYearPicker: !!props.showMonthYearPicker,
      isOpen: props.open
    }),
    pickerRef = _useMobileDate.pickerRef,
    temporaryDate = _useMobileDate.temporaryDate,
    handleCancel = _useMobileDate.handleCancel,
    handleReflect = _useMobileDate.handleReflect,
    handlePickerMobileChange = _useMobileDate.handlePickerMobileChange;
  return React__namespace.default.createElement(DatePickerCore, _objectSpread2(_objectSpread2({
    ref: pickerRef,
    selected: temporaryDate,
    withPortal: true,
    shouldCloseOnSelect: false,
    portalId: "root-portal",
    calendarContainer: CalendarContainer({
      isMobile: true,
      handleCancel: handleCancel,
      handleReflect: handleReflect,
      showMonthYearPicker: !!props.showMonthYearPicker
    })
  }, props), {}, {
    onChange: handlePickerMobileChange
  }));
};
var DatePicker = function DatePicker(_ref3) {
  var onChange = _ref3.onChange,
    setValue = _ref3.setValue,
    props = _objectWithoutProperties(_ref3, _excluded3$8);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return isPc ? React__namespace.default.createElement(PcDatePicker, _objectSpread2({
    onChange: onChange
  }, props)) : React__namespace.default.createElement(MobileDatePicker, _objectSpread2({
    setValue: setValue
  }, props));
};

var css_248z$H = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.error-message-module__GDK__failText___Bt897 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  padding-top: 8px;\n  color: #8e1b19;\n}\n\n@media screen and (max-width: 800px) {\n\n  .error-message-module__GDK__failText___Bt897 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$H = {"failText":"error-message-module__GDK__failText___Bt897"};
styleInject(css_248z$H);

var ErrorMessages = function ErrorMessages(_ref) {
  var messages = _ref.messages,
    id = _ref.id,
    _ref$ariaLive = _ref.ariaLive,
    ariaLive = _ref$ariaLive === void 0 ? "assertive" : _ref$ariaLive;
  if (!messages || !messages.length) {
    return null;
  }
  return React__namespace.createElement(React__namespace.Fragment, null, Array.isArray(messages) ? React__namespace.createElement("div", {
    id: id,
    "aria-live": ariaLive
  }, messages.map(function (e, index) {
    return React__namespace.createElement("p", {
      className: styles$H.failText,
      key: index
    }, e);
  })) : React__namespace.createElement("p", {
    id: id,
    "aria-live": ariaLive,
    className: styles$H.failText
  }, messages));
};

var css_248z$G = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.date-input-module__GDK__wrapper___IeQ0P {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 24px;\n}\n\n.date-input-module__GDK__legend___Idh7I {\n  margin-bottom: 8px;\n}\n\n.date-input-module__GDK__description___qQ6zR {\n  margin-bottom: 8px;\n}\n\n.date-input-module__GDK__label___u4z9y {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  vertical-align: middle;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-input-module__GDK__label___u4z9y {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-input-module__GDK__description___qQ6zR {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-input-module__GDK__description___qQ6zR {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-input-module__GDK__year___xg26T {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.date-input-module__GDK__month___ujA43 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.date-input-module__GDK__day___SDCaF {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.date-input-module__GDK__year___xg26T input {\n  width: 100px;\n  text-align: center;\n}\n\n.date-input-module__GDK__month___ujA43 input,\n.date-input-module__GDK__day___SDCaF input {\n  width: 80px;\n  text-align: center;\n}\n\n.date-input-module__GDK__unit___1--4D {\n  max-width: 66px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  line-height: 28px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-input-module__GDK__unit___1--4D {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-input-module__GDK__picker___Ldzjp {\n  width: 40px;\n}\n\n@media screen and (max-width: 800px) {\n  .date-input-module__GDK__wrapper___IeQ0P {\n    gap: 8px;\n  }\n\n  .date-input-module__GDK__year___xg26T {\n    gap: 8px;\n  }\n\n  .date-input-module__GDK__month___ujA43 {\n    gap: 8px;\n  }\n\n  .date-input-module__GDK__day___SDCaF {\n    gap: 8px;\n  }\n\n  .date-input-module__GDK__year___xg26T input {\n    width: 80px;\n    text-align: center;\n  }\n\n  .date-input-module__GDK__picker___Ldzjp {\n    width: 24px;\n  }\n\n  .date-input-module__GDK__month___ujA43 input,\n  .date-input-module__GDK__day___SDCaF input {\n    width: 58px;\n    text-align: center;\n  }\n}\n";
var styles$G = {"wrapper":"date-input-module__GDK__wrapper___IeQ0P","legend":"date-input-module__GDK__legend___Idh7I","description":"date-input-module__GDK__description___qQ6zR","label":"date-input-module__GDK__label___u4z9y","year":"date-input-module__GDK__year___xg26T","month":"date-input-module__GDK__month___ujA43","day":"date-input-module__GDK__day___SDCaF","unit":"date-input-module__GDK__unit___1--4D","picker":"date-input-module__GDK__picker___Ldzjp"};
styleInject(css_248z$G);

/**
 * 呼び出し元プロジェクトの「validate」に優先してGDK内で行うバリデーションチェック。
 */
var DateInputDefaultErrorType = /*#__PURE__*/function (_BaseType) {
  function DateInputDefaultErrorType() {
    _classCallCheck(this, DateInputDefaultErrorType);
    return _callSuper(this, DateInputDefaultErrorType, arguments);
  }
  _inherits(DateInputDefaultErrorType, _BaseType);
  return _createClass(DateInputDefaultErrorType, null, [{
    key: "create",
    value: function create(innerValue, innerValueStr, date, required) {
      var year = innerValue.year;
      var _getIsEmpty = getIsEmpty$1(innerValue),
        isYearEmpty = _getIsEmpty.isYearEmpty,
        isMonthEmpty = _getIsEmpty.isMonthEmpty,
        isDayEmpty = _getIsEmpty.isDayEmpty,
        isAllEmpty = _getIsEmpty.isAllEmpty;
      // 「必須」ではなく、年・月・日が全て空の場合
      if (isAllEmpty && !required) {
        return new DateInputDefaultErrorType("SUCCESS_WITH_NO_REQUIRED");
      }
      // 「必須」かつ、年・月・日が全て空の場合
      if (isAllEmpty && required) {
        return new DateInputDefaultErrorType("REQUIRED");
      }
      // 年・月・日のどれか1つでも空の場合
      if (!isAllEmpty && (isYearEmpty || isMonthEmpty || isDayEmpty)) {
        return new DateInputDefaultErrorType("EMPTY_INPUT");
      }
      // 年が、4桁以外の場合
      if (year.length !== 4) {
        return new DateInputDefaultErrorType("YEAR_DIGIT_COUNT");
      }
      var format = "YYYY/MM/DD";
      if (!(dayjs__default.default(innerValueStr, format).format(format) === innerValueStr)) {
        return new DateInputDefaultErrorType("INVALID_DATE");
      }
      if (!isValidDate(date)) {
        return new DateInputDefaultErrorType("INVALID_DATE");
      }
      return new DateInputDefaultErrorType("SUCCESS");
    }
  }]);
}(BaseType);
/**
 * 入力値が、空かどうかを判定。
 */
var getIsEmpty$1 = function getIsEmpty(value) {
  var year = value.year,
    month = value.month,
    day = value.day;
  var isYearEmpty = year === "";
  var isMonthEmpty = month === "" || month === "00";
  var isDayEmpty = day === "" || day === "00";
  var isAllEmpty = isYearEmpty && isMonthEmpty && isDayEmpty;
  return {
    isYearEmpty: isYearEmpty,
    isMonthEmpty: isMonthEmpty,
    isDayEmpty: isDayEmpty,
    isAllEmpty: isAllEmpty
  };
};

var useDateInput = function useDateInput(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    validate = _ref.validate,
    required = _ref.required;
  // 年・月・日のinput、どれか1つでも「onBlur」イベントを呼び出した場合、DatePickerで値を決定した場合に「isTouched」の状態は「true」になる。
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTouched = _useState2[0],
    setIsTouched = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  // GDK内で設定されたバリデーションのエラーメッセージ
  var _useState5 = React.useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    innerErrorMsg = _useState6[0],
    setInnerErrorMsg = _useState6[1];
  // datePickerに渡す値として使用されている
  var _useState7 = React.useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    date = _useState8[0],
    setDate = _useState8[1];
  // inputの値として使用されている
  var _useState9 = React.useState(splitDateString(dateToValue(value, "YYYY/MM/DD"))),
    _useState10 = _slicedToArray(_useState9, 2),
    innerValue = _useState10[0],
    setInnerValue = _useState10[1];
  // Propsから渡ってきたvalueの値を保存。
  var _useState11 = React.useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    statePropValue = _useState12[0],
    setStatePropValue = _useState12[1];
  // onBlurのタイミング / datePickerで日付確定時 / Propsのvalueが変わった時に呼び出される。
  var setNewValue = React.useCallback(function (innerValue) {
    var isPropsValueChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var innerValueStr = "".concat(innerValue.year, "/").concat(innerValue.month, "/").concat(innerValue.day);
    var date = new Date(innerValueStr);
    var defaultErrorState = DateInputDefaultErrorType.create(innerValue, innerValueStr, date, required);
    var setInnerError = function setInnerError(message) {
      setInnerErrorMsg(message);
      setIsValid(false);
      setDate(null);
    };
    defaultErrorState.matchCall({
      SUCCESS_WITH_NO_REQUIRED: function SUCCESS_WITH_NO_REQUIRED() {
        setInnerErrorMsg(undefined);
        setDate(null);
        if (!isPropsValueChanged) {
          setValue(null);
        }
        setIsValid(true);
      },
      REQUIRED: function REQUIRED() {
        return setInnerError("入力必須の項目です");
      },
      EMPTY_INPUT: function EMPTY_INPUT() {
        return setInnerError("年・月・日の全てに値を入力してください。");
      },
      YEAR_DIGIT_COUNT: function YEAR_DIGIT_COUNT() {
        return setInnerError("年には、西暦4桁を入力してください。");
      },
      INVALID_DATE: function INVALID_DATE() {
        return setInnerError("日付の値が不正です。");
      },
      SUCCESS: function SUCCESS() {
        setInnerErrorMsg(undefined);
        setDate(date);
        if (!isPropsValueChanged) {
          setValue(date);
        }
        setIsValid(validate(innerValueStr));
      }
    });
  }, [required, setValue, validate]);
  var handleBlur = React.useCallback(function () {
    setIsTouched(true);
    setNewValue(innerValue);
  }, [innerValue, setNewValue]);
  var setNewInnerValue = function setNewInnerValue(value) {
    var parsedDate = splitDateString(value);
    setInnerValue({
      year: parsedDate.year,
      month: parsedDate.month,
      day: parsedDate.day
    });
  };
  // PC/SPの共通処理部分。PCの場合は、この関数をhandlePickerChange()内で呼び出している。
  var handlePickerChangeCommon = React.useCallback(function (value) {
    setIsTouched(true);
    setNewInnerValue(value);
    setNewValue(splitDateString(value));
  }, [setNewValue]);
  //  Propsのvalue自体が変わった時の処理。
  React.useEffect(function () {
    var _a;
    if (statePropValue === value) {
      return;
    }
    setStatePropValue(value);
    var convertedValue = (_a = dateToValue(value, "YYYY/MM/DD")) !== null && _a !== void 0 ? _a : "";
    setNewInnerValue(convertedValue);
    setNewValue(splitDateString(convertedValue), true);
  }, [setNewValue, statePropValue, value]);
  var _useDateValue = useDateValue$1({
      innerValue: innerValue,
      setNewInnerValue: setNewInnerValue,
      handlePickerChangeCommon: handlePickerChangeCommon
    }),
    handleYearChange = _useDateValue.handleYearChange,
    handleMonthChange = _useDateValue.handleMonthChange,
    handleDayChange = _useDateValue.handleDayChange,
    handlePickerChange = _useDateValue.handlePickerChange;
  return _objectSpread2(_objectSpread2({
    handleYearChange: handleYearChange,
    handleMonthChange: handleMonthChange,
    handleDayChange: handleDayChange,
    handleBlur: handleBlur,
    handlePickerChange: handlePickerChange,
    isTouched: isTouched,
    isValid: isValid,
    date: date
  }, innerValue), {}, {
    setNewInnerValue: setNewInnerValue,
    innerErrorMsg: innerErrorMsg,
    handlePickerChangeCommon: handlePickerChangeCommon
  });
};
var useDateValue$1 = function useDateValue(_ref2) {
  var innerValue = _ref2.innerValue,
    setNewInnerValue = _ref2.setNewInnerValue,
    handlePickerChangeCommon = _ref2.handlePickerChangeCommon;
  var handleYearChange = React.useCallback(function (e) {
    var v = e.target.value;
    if (!v.match(/^\d{0,4}$/)) {
      return;
    }
    setNewInnerValue("".concat(v, "/").concat(innerValue.month, "/").concat(innerValue.day));
  }, [setNewInnerValue, innerValue.month, innerValue.day]);
  var handleMonthChange = React.useCallback(function (e) {
    var v = e.target.value;
    if (!v.match(/^\d{0,2}$/)) {
      return;
    }
    setNewInnerValue("".concat(innerValue.year, "/").concat(v.padStart(2, "0"), "/").concat(innerValue.day));
  }, [setNewInnerValue, innerValue.year, innerValue.day]);
  var handleDayChange = React.useCallback(function (e) {
    var v = e.target.value;
    if (!v.match(/^\d{0,2}$/)) {
      return;
    }
    setNewInnerValue("".concat(innerValue.year, "/").concat(innerValue.month, "/").concat(v.padStart(2, "0")));
  }, [setNewInnerValue, innerValue.year, innerValue.month]);
  // PCで呼び出される。
  var handlePickerChange = React.useCallback(function (d) {
    if (!d) {
      return;
    }
    var date = dateToValue(d, "YYYY/MM/DD");
    if (date) {
      handlePickerChangeCommon(date);
    }
  }, [handlePickerChangeCommon]);
  return {
    handleYearChange: handleYearChange,
    handleMonthChange: handleMonthChange,
    handleDayChange: handleDayChange,
    handlePickerChange: handlePickerChange
  };
};
/**
 * YYYY/M or MM/D or DD形式のstringを受け取り、splitしてそれぞれ返す
 * @param dateString
 * @returns year,month,day
 */
var splitDateString = function splitDateString(dateString) {
  var _a, _b, _c;
  if (!dateString) {
    return {
      year: "",
      month: "",
      day: ""
    };
  }
  var dateSplited = dateString.split("/");
  var parsed = [(_a = dateSplited[0]) !== null && _a !== void 0 ? _a : "", (_b = dateSplited[1]) !== null && _b !== void 0 ? _b : "", (_c = dateSplited[2]) !== null && _c !== void 0 ? _c : ""];
  return {
    year: parsed[0],
    month: parsed[1],
    day: parsed[2]
  };
};

var css_248z$F = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.optional-tag-module__GDK__tag___G1aSr {\n  display: inline-block;\n  height: 18px;\n  background-color: #dcd9d8;\n  color: #5c5959;\n  font: 10px/16px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 4px;\n  display: inline-block;\n  letter-spacing: 1px;\n  padding: 1px 4px;\n  margin-left: 16px;\n  font-weight: 600;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n";
var styles$F = {"tag":"optional-tag-module__GDK__tag___G1aSr"};
styleInject(css_248z$F);

var OptionalTag = function OptionalTag() {
  return React__namespace.createElement("span", {
    className: styles$F.tag
  }, "\u4EFB\u610F");
};

var css_248z$E = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.required-tag-module__GDK__tag___SkPQA {\n  display: inline-block;\n  height: 18px;\n  background-color: #d53b3a4b;\n  /* cloud-govのnotification sassの影響を受けるので!importantを付与 */\n  color: #8e1b19 !important;\n  font: 10px/16px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 4px;\n  display: inline-block;\n  letter-spacing: 1px;\n  padding: 1px 4px;\n  margin-left: 16px;\n  font-weight: 600;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n";
var styles$E = {"tag":"required-tag-module__GDK__tag___SkPQA"};
styleInject(css_248z$E);

/**
 * https://github.com/search?q=org%3Agraffer-inc+RequiredTag&type=code
 * 現在booth-reserveから参照されていますが、タグ単体の使用は非推奨です。
 * TitleWrapもしくはFieldSetWrapを使用するようにしてください。
 * exportからも削除する予定です。
 * @deprecated
 * @returns
 */
var RequiredTag = function RequiredTag() {
  return React__namespace.createElement("strong", {
    className: styles$E.tag
  }, "\u5FC5\u9808");
};

var css_248z$D = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.fieldset-wrap-module__GDK__fieldset___b3YU5 {\n  display: inline-block;\n  width: 0;\n  min-width: 100%;\n  box-sizing: border-box;\n  border: none;\n  word-break: break-all;\n}\n\n.fieldset-wrap-module__GDK__legend___z4-1N {\n  margin-bottom: 8px;\n  color: #1d1c1a;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  width: 100%;\n}\n\n@media screen and (max-width: 800px) {\n\n  .fieldset-wrap-module__GDK__legend___z4-1N {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.fieldset-wrap-module__GDK__title___GT1WG {\n  display: inline;\n}\n\n.fieldset-wrap-module__GDK__description___OFgSn {\n  margin-bottom: 8px;\n}\n";
var styles$D = {"fieldset":"fieldset-wrap-module__GDK__fieldset___b3YU5","legend":"fieldset-wrap-module__GDK__legend___z4-1N","title":"fieldset-wrap-module__GDK__title___GT1WG","description":"fieldset-wrap-module__GDK__description___OFgSn"};
styleInject(css_248z$D);

var css_248z$C = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.breaking-line-description-module__GDK__description___UFACF {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n@media screen and (max-width: 800px) {\n\n  .breaking-line-description-module__GDK__description___UFACF {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$C = {"description":"breaking-line-description-module__GDK__description___UFACF"};
styleInject(css_248z$C);

var BaseBreakingLineDescription = function BaseBreakingLineDescription(_ref) {
  var descriptionId = _ref.descriptionId,
    description = _ref.description,
    className = _ref.className;
  return React__namespace.createElement("p", {
    id: descriptionId,
    className: classNames__default.default(className, styles$C.description)
  }, description);
};
var DefaultBreakingLineDescription = function DefaultBreakingLineDescription(_ref2) {
  var descriptionId = _ref2.descriptionId,
    description = _ref2.description,
    className = _ref2.className;
  return React__namespace.createElement(BaseBreakingLineDescription, {
    descriptionId: descriptionId,
    description: description,
    className: className
  });
};

var FieldsetWrap = function FieldsetWrap(_ref) {
  var title = _ref.title,
    description = _ref.description,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    descriptionId = _ref.descriptionId,
    children = _ref.children;
  return React__namespace.createElement("fieldset", {
    className: styles$D.fieldset
  }, React__namespace.createElement("legend", {
    className: styles$D.legend
  }, React__namespace.createElement("span", {
    className: styles$D.title
  }, title), required ? React__namespace.createElement(RequiredTag, null) : React__namespace.createElement(OptionalTag, null)), description && React__namespace.createElement(DefaultBreakingLineDescription, {
    descriptionId: descriptionId,
    description: description,
    className: styles$D.description
  }), children);
};

var MultipleFormState = /*#__PURE__*/function (_BaseType) {
  function MultipleFormState(value, errorMessage) {
    var _this;
    _classCallCheck(this, MultipleFormState);
    _this = _callSuper(this, MultipleFormState, [value]);
    _this.errorMessage = errorMessage;
    return _this;
  }
  /**
   * UIの状態を管理する複合コンポーネント（DateRangeInput  , TimeRangeInput ,  ...etc）用のStateを生成する
   *
   * @param isTouched
   * @param isValid
   * @param noValidate
   * @param disabled
   * @param errorMessage
   * @returns
   */
  _inherits(MultipleFormState, _BaseType);
  return _createClass(MultipleFormState, [{
    key: "matchComponents",
    value: function matchComponents(matcher) {
      if (!this.errorMessage) {
        return matcher["default"];
      }
      return matcher[this.value];
    }
    /**
     * 状態が fail の場合 true 、それ以外の場合 false を返す
     */
  }, {
    key: "isFail",
    value: function isFail() {
      return this.matchType({
        "default": false,
        success: false,
        disabled: false,
        fail: true
      });
    }
  }], [{
    key: "create",
    value: function create(isTouched, isValid, noValidate, disabled, errorMessage) {
      if (disabled) {
        return new MultipleFormState("disabled", errorMessage);
      }
      if (!isTouched) {
        return new MultipleFormState("default", errorMessage);
      }
      if (noValidate) {
        return new MultipleFormState("default", errorMessage);
      }
      if (isValid || !errorMessage || !errorMessage.length) {
        return new MultipleFormState("success", errorMessage);
      }
      if (errorMessage) {
        return new MultipleFormState("fail", errorMessage);
      }
      return new MultipleFormState("default", errorMessage);
    }
  }]);
}(BaseType);

/**
 * 単一の入力（選択）Elementからなるコンポーネントのtouchedを管理する
 * @param defaultValue
 * @returns
 */
var useTouched = function useTouched(defaultValue) {
  var _useState = React.useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    isTouched = _useState2[0],
    setIsTouched = _useState2[1];
  var changeTouchedTrue = React.useCallback(function () {
    return setIsTouched(true);
  }, []);
  return {
    isTouched: isTouched,
    changeTouchedTrue: changeTouchedTrue
  };
};
/**
 * 複数の入力（選択）Elementからなるコンポーネントのtouchedを管理する
 * @param defaultValues
 * @param onBlur
 * @returns
 */
function useMultipleTouched(defaultValues, onBlur) {
  var _useState3 = React.useState(defaultValues),
    _useState4 = _slicedToArray(_useState3, 2),
    touched = _useState4[0],
    setTouched = _useState4[1];
  var onBlurHandlers = React.useMemo(function () {
    return touched.map(function (_, index) {
      return function (e) {
        setTouched(function (oldValues) {
          var newValues = _toConsumableArray(oldValues);
          newValues[index] = true;
          if (newValues.every(function (value) {
            return !!value;
          })) {
            if (onBlur) {
              if (Array.isArray(onBlur)) {
                onBlur[index](e);
              } else {
                onBlur(e);
              }
            }
          }
          return newValues;
        });
      };
    });
  }, [onBlur, touched]);
  var isTouched = React.useMemo(function () {
    return touched.every(function (value) {
      return value;
    });
  }, [touched]);
  return {
    touched: touched,
    isTouched: isTouched,
    onBlurHandlers: onBlurHandlers
  };
}

var _excluded$v = ["dataTestId"],
  _excluded2$e = ["dataTestId"],
  _excluded3$7 = ["dataTestId"];
var BaseDateInput = function BaseDateInput(_ref) {
  var _ref$yearInputProps = _ref.yearInputProps,
    yearDataTestId = _ref$yearInputProps.dataTestId,
    yearInputProps = _objectWithoutProperties(_ref$yearInputProps, _excluded$v),
    _ref$monthInputProps = _ref.monthInputProps,
    monthDataTestId = _ref$monthInputProps.dataTestId,
    monthInputProps = _objectWithoutProperties(_ref$monthInputProps, _excluded2$e),
    _ref$dayInputProps = _ref.dayInputProps,
    dayDataTestId = _ref$dayInputProps.dataTestId,
    dayInputProps = _objectWithoutProperties(_ref$dayInputProps, _excluded3$7),
    onBlur = _ref.onBlur,
    datePicker = _ref.datePicker;
  var _useMultipleTouched = useMultipleTouched([!!yearInputProps.value, !!monthInputProps.value, !!dayInputProps.value], onBlur),
    _useMultipleTouched$o = _slicedToArray(_useMultipleTouched.onBlurHandlers, 3),
    handleYearTouchedTrue = _useMultipleTouched$o[0],
    handleMonthTouchedTrue = _useMultipleTouched$o[1],
    handleDayTouchedTrue = _useMultipleTouched$o[2];
  var _useId = nextId.useId(1, "errorMessage-DateInput-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    errorMessageId = _useId2[0];
  return React__namespace.default.createElement("div", {
    className: styles$G.wrapper
  }, React__namespace.default.createElement("div", {
    className: styles$G.year
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({
    "aria-label": "\u5E74"
  }, yearInputProps), {}, {
    "data-testid": yearDataTestId,
    errorMessageId: errorMessageId,
    onBlur: function onBlur(e) {
      handleYearTouchedTrue(e);
      yearInputProps.onBlur && yearInputProps.onBlur(e);
    },
    maxLength: 4,
    inputMode: "numeric"
  })), React__namespace.default.createElement("p", {
    className: "".concat(styles$G.unit, " ").concat(styles$G.yearUnit)
  }, "\u5E74")), React__namespace.default.createElement("div", {
    className: styles$G.month
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({
    "aria-label": "\u6708"
  }, monthInputProps), {}, {
    "data-testid": monthDataTestId,
    errorMessageId: errorMessageId,
    onBlur: function onBlur(e) {
      handleMonthTouchedTrue(e);
      monthInputProps.onBlur && monthInputProps.onBlur(e);
    },
    maxLength: 2,
    inputMode: "numeric"
  })), React__namespace.default.createElement("p", {
    className: "".concat(styles$G.unit, " ").concat(styles$G.monthUnit)
  }, "\u6708")), React__namespace.default.createElement("div", {
    className: styles$G.day
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({
    "aria-label": "\u65E5"
  }, dayInputProps), {}, {
    "data-testid": dayDataTestId,
    errorMessageId: errorMessageId,
    onBlur: function onBlur(e) {
      handleDayTouchedTrue(e);
      dayInputProps.onBlur && dayInputProps.onBlur(e);
    },
    maxLength: 2,
    inputMode: "numeric"
  })), React__namespace.default.createElement("p", {
    className: "".concat(styles$G.unit, " ").concat(styles$G.dayUnit)
  }, "\u65E5")), !!datePicker && React__namespace.default.createElement("div", {
    className: styles$G.picker
  }, datePicker));
};
var GrafferSchemasDateInputComponent = function GrafferSchemasDateInputComponent(_ref2) {
  var yearInputProps = _ref2.yearInputProps,
    monthInputProps = _ref2.monthInputProps,
    dayInputProps = _ref2.dayInputProps,
    onSetDate = _ref2.onSetDate,
    onChangeDate = _ref2.onChangeDate,
    onBlur = _ref2.onBlur,
    _ref2$noValidate = _ref2.noValidate,
    noValidate = _ref2$noValidate === void 0 ? false : _ref2$noValidate,
    _ref2$touched = _ref2.touched,
    touched = _ref2$touched === void 0 ? false : _ref2$touched,
    errorMessage = _ref2.errorMessage;
  var date = React.useMemo(function () {
    var values = [yearInputProps.value, monthInputProps.value, dayInputProps.value];
    var date = valueToDate$1(values.join("/"));
    return date && isValidDate(date) ? date : null;
  }, [dayInputProps.value, monthInputProps.value, yearInputProps.value]);
  var formState = React.useMemo(function () {
    return MultipleFormState.create(touched, !errorMessage && touched, noValidate, false, errorMessage);
  }, [errorMessage, touched, noValidate]);
  return React__namespace.default.createElement(BaseDateInput, {
    datePicker: React__namespace.default.createElement(DatePicker, {
      date: date,
      setValue: onSetDate,
      onChange: onChangeDate,
      iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u65E5\u4ED8\u3092\u9078\u629E\u3059\u308B"
    }),
    yearInputProps: _objectSpread2({}, _objectSpread2(_objectSpread2({}, yearInputProps), {}, {
      formState: formState
    })),
    monthInputProps: _objectSpread2({}, _objectSpread2(_objectSpread2({}, monthInputProps), {}, {
      formState: formState
    })),
    dayInputProps: _objectSpread2({}, _objectSpread2(_objectSpread2({}, dayInputProps), {}, {
      formState: formState
    })),
    onBlur: onBlur
  });
};
var defaultValidate$2 = function defaultValidate() {
  return true;
};
var DateInput = function DateInput(_ref3) {
  var value = _ref3.value,
    setValue = _ref3.setValue,
    label = _ref3.label,
    noValidate = _ref3.noValidate,
    _ref3$validate = _ref3.validate,
    validate = _ref3$validate === void 0 ? defaultValidate$2 : _ref3$validate,
    errorMessage = _ref3.errorMessage,
    description = _ref3.description,
    yearPlaceholder = _ref3.yearPlaceholder,
    monthPlaceholder = _ref3.monthPlaceholder,
    dayPlaceholder = _ref3.dayPlaceholder,
    required = _ref3.required,
    onErrorStateChange = _ref3.onErrorStateChange;
  var _useDateInput = useDateInput({
      value: value,
      setValue: setValue,
      validate: validate,
      required: required
    }),
    handleYearChange = _useDateInput.handleYearChange,
    handleMonthChange = _useDateInput.handleMonthChange,
    handleDayChange = _useDateInput.handleDayChange,
    handleBlur = _useDateInput.handleBlur,
    handlePickerChange = _useDateInput.handlePickerChange,
    isTouched = _useDateInput.isTouched,
    isValid = _useDateInput.isValid,
    date = _useDateInput.date,
    year = _useDateInput.year,
    month = _useDateInput.month,
    day = _useDateInput.day,
    innerErrorMsg = _useDateInput.innerErrorMsg,
    handlePickerChangeCommon = _useDateInput.handlePickerChangeCommon;
  var styleState = React.useMemo(function () {
    return MultipleFormState.create(isTouched, isValid, noValidate, false, innerErrorMsg !== null && innerErrorMsg !== void 0 ? innerErrorMsg : errorMessage);
  }, [errorMessage, innerErrorMsg, isTouched, isValid, noValidate]);
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(styleState.isFail());
  }, [onErrorStateChange, styleState]);
  var _useId3 = nextId.useId(1, "errorMessage-DateInput-id-"),
    _useId4 = _slicedToArray(_useId3, 1),
    errorMessageId = _useId4[0];
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement(FieldsetWrap, {
    title: label,
    description: description,
    required: required
  }, React__namespace.default.createElement(BaseDateInput, {
    datePicker: React__namespace.default.createElement(DatePicker, {
      date: date,
      setValue: handlePickerChangeCommon,
      onChange: handlePickerChange,
      iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u65E5\u4ED8\u3092\u9078\u629E\u3059\u308B"
    }),
    yearInputProps: {
      value: year,
      placeholder: yearPlaceholder,
      onChange: handleYearChange,
      formState: styleState
    },
    monthInputProps: {
      value: month.replace(/^0+/, ""),
      placeholder: monthPlaceholder,
      onChange: handleMonthChange,
      formState: styleState
    },
    dayInputProps: {
      value: day.replace(/^0+/, ""),
      placeholder: dayPlaceholder,
      onChange: handleDayChange,
      formState: styleState
    },
    onBlur: handleBlur
  })), styleState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.default.createElement(ErrorMessages, {
      messages: innerErrorMsg !== null && innerErrorMsg !== void 0 ? innerErrorMsg : errorMessage,
      id: errorMessageId
    })
  }));
};

/**
 * 主にモバイル用の日付範囲操作の関数と値を返すhooks
 * PCと違いモバイルでは日付範囲選択をしてもすぐに元の値が変更されるのではなく、日付範囲選択後、反映の操作をして初めて値が変更される。そのため、元の値とは別に、内部で一時的な日付範囲の値を持つ必要がある(temporaryDate)。
 * @returns pickerRef モーダルの開閉に必要なref。react-DatePickerではモーダルの開閉がstateで操作できず、refでの操作を推奨(強制)
 * @returns temporaryDate モバイルで日付選択をする際に必要な一時的な値。ReactDatePickerに渡されて日付選択の範囲のUI表示に使用される。
 * @returns handleCancel temporaryDateを元の値に戻す関数
 * @returns handleReflect 元の値をtemporaryDateで上書きする関数
 * @returns handlePickerMobileChange temporaryDateを変更する関数
 */
var useMobileDateRange = function useMobileDateRange(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    setValue = _ref.setValue;
  var pickerRef = React.useRef(null);
  //mobileのカレンダー入力の場合、反映ボタンで値を反映させるために一時的な値としてkeepする。
  var _useState = React.useState({
      startDate: startDate,
      endDate: endDate
    }),
    _useState2 = _slicedToArray(_useState, 2),
    temporaryDate = _useState2[0],
    setTemporaryDate = _useState2[1];
  //外部（inputフォーム）からの入力に対応する
  React.useEffect(function () {
    setTemporaryDate({
      startDate: startDate,
      endDate: endDate
    });
  }, [startDate, endDate]);
  var setNewValue = React.useCallback(function (_ref2) {
    var startDate = _ref2.startDate,
      endDate = _ref2.endDate;
    if (startDate && endDate) {
      setValue(startDate, endDate);
    }
  }, [setValue]);
  var handleCancel = React.useCallback(function () {
    var _a;
    setTemporaryDate({
      startDate: startDate,
      endDate: endDate
    });
    (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
  }, [setTemporaryDate, startDate, endDate]);
  var handleReflect = React.useCallback(function () {
    var _a;
    setNewValue(_objectSpread2(_objectSpread2({}, temporaryDate), {}, {
      startDate: temporaryDate.startDate,
      endDate: temporaryDate.endDate
    }));
    (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
  }, [temporaryDate, setNewValue]);
  var handlePickerMobileChange = React.useCallback(function (date) {
    setTemporaryDate(_objectSpread2(_objectSpread2({}, temporaryDate), {}, {
      startDate: date[0],
      endDate: date[1]
    }));
  }, [temporaryDate, setTemporaryDate]);
  return {
    pickerRef: pickerRef,
    temporaryDate: temporaryDate,
    handleCancel: handleCancel,
    handleReflect: handleReflect,
    handlePickerMobileChange: handlePickerMobileChange
  };
};

var _excluded$u = ["startDate", "endDate", "iconTitle"],
  _excluded2$d = ["setValue", "startDate", "endDate", "iconTitle"],
  _excluded3$6 = ["onChange", "setValue"];
ReactDatePicker.registerLocale("ja", ja__default.default);
var PcDateRangePicker = function PcDateRangePicker(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    iconTitle = _ref.iconTitle,
    props = _objectWithoutProperties(_ref, _excluded$u);
  var shouldCloseOnSelect = React.useMemo(function () {
    return !!startDate && !endDate;
  }, [startDate, endDate]);
  return React__namespace.default.createElement(DatePickerCore, _objectSpread2({
    selectsRange: true,
    shouldCloseOnSelect: shouldCloseOnSelect,
    selected: startDate,
    startDate: startDate,
    endDate: endDate,
    calendarContainer: CalendarContainer({
      isMobile: false,
      showMonthYearPicker: !!props.showMonthYearPicker
    }),
    iconTitle: iconTitle
  }, props));
};
var MobileDaterRangePicker = function MobileDaterRangePicker(_ref2) {
  var setValue = _ref2.setValue,
    startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    iconTitle = _ref2.iconTitle,
    props = _objectWithoutProperties(_ref2, _excluded2$d);
  var _useMobileDateRange = useMobileDateRange({
      startDate: startDate,
      endDate: endDate,
      setValue: setValue
    }),
    pickerRef = _useMobileDateRange.pickerRef,
    temporaryDate = _useMobileDateRange.temporaryDate,
    handleCancel = _useMobileDateRange.handleCancel,
    handleReflect = _useMobileDateRange.handleReflect,
    handlePickerMobileChange = _useMobileDateRange.handlePickerMobileChange;
  return React__namespace.default.createElement(DatePickerCore, _objectSpread2({
    ref: pickerRef,
    selectsRange: true,
    withPortal: true,
    shouldCloseOnSelect: false,
    selected: temporaryDate.startDate,
    startDate: temporaryDate.startDate,
    endDate: temporaryDate.endDate,
    onChange: handlePickerMobileChange,
    iconTitle: iconTitle,
    calendarContainer: CalendarContainer({
      isMobile: true,
      handleCancel: handleCancel,
      handleReflect: handleReflect,
      showMonthYearPicker: !!props.showMonthYearPicker
    })
  }, props));
};
var DateRangePicker = function DateRangePicker(_ref3) {
  var onChange = _ref3.onChange,
    setValue = _ref3.setValue,
    props = _objectWithoutProperties(_ref3, _excluded3$6);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return isPc ? React__namespace.default.createElement(PcDateRangePicker, _objectSpread2({
    onChange: onChange
  }, props)) : React__namespace.default.createElement(MobileDaterRangePicker, _objectSpread2({
    setValue: setValue
  }, props));
};

var css_248z$B = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.date-multiple-range-module__GDK__wrapper___7AQZK {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-bottom: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-multiple-range-module__GDK__wrapper___7AQZK {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-multiple-range-module__GDK__input___-VtxV {\n  display: inline-flex;\n  align-items: center;\n}\n\n.date-multiple-range-module__GDK__start___jr1RD {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-multiple-range-module__GDK__start___jr1RD {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-multiple-range-module__GDK__end___TAfm9 {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-multiple-range-module__GDK__end___TAfm9 {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-multiple-range-module__GDK__legend___hPPXZ {\n  margin-bottom: 8px;\n  margin-top: calc(8px * -1);\n}\n\n.date-multiple-range-module__GDK__description___167ib {\n  margin-bottom: 8px;\n}\n\n.date-multiple-range-module__GDK__label___02i0i {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  vertical-align: middle;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-multiple-range-module__GDK__label___02i0i {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-multiple-range-module__GDK__description___167ib {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-multiple-range-module__GDK__description___167ib {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-multiple-range-module__GDK__to___75k17 {\n  padding: 0 calc(32px - 1px);\n}\n\n.date-multiple-range-module__GDK__input___-VtxV input {\n  max-width: 240px;\n}\n\n@media screen and (max-width: 800px) {\n  .date-multiple-range-module__GDK__to___75k17 {\n    padding: 0 calc(16px - 4px);\n  }\n}\n";
var styles$B = {"wrapper":"date-multiple-range-module__GDK__wrapper___7AQZK","input":"date-multiple-range-module__GDK__input___-VtxV","start":"date-multiple-range-module__GDK__start___jr1RD","end":"date-multiple-range-module__GDK__end___TAfm9","legend":"date-multiple-range-module__GDK__legend___hPPXZ","description":"date-multiple-range-module__GDK__description___167ib","label":"date-multiple-range-module__GDK__label___02i0i","to":"date-multiple-range-module__GDK__to___75k17"};
styleInject(css_248z$B);

function useInnerSplitDateState(value, separator) {
  var splitDate = React.useMemo(function () {
    return splitDateString$1(value, separator);
  }, [separator, value]);
  var _useState = React.useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    year = _useState2[0],
    setYear = _useState2[1];
  var _useState3 = React.useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = React.useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    day = _useState6[0],
    setDay = _useState6[1];
  React.useEffect(function () {
    setYear(splitDate[0]);
    setMonth(splitDate[1]);
    setDay(splitDate[2]);
  }, [splitDate]);
  return {
    date: splitDate,
    year: year,
    month: month,
    day: day,
    setYear: setYear,
    setMonth: setMonth,
    setDay: setDay
  };
}
function useStringDateBlurHandler(values, setValue, separator) {
  return React.useMemo(function () {
    return _toConsumableArray(new Array(3)).map(function () {
      return function () {
        var _a;
        var month = values[1].length === 1 && Number(values[1]) > 0 && Number(values[1]) < 10 ? "0".concat(values[1]) : values[1];
        var day = values[2].length === 1 && Number(values[2]) > 0 && Number(values[2]) < 10 ? "0".concat(values[2]) : values[2];
        var newValues = [(_a = values[0]) !== null && _a !== void 0 ? _a : "", month !== null && month !== void 0 ? month : "", day !== null && day !== void 0 ? day : ""];
        newValues.some(function (_) {
          return !!_;
        }) ? setValue(newValues.join(separator)) : setValue(undefined);
      };
    });
  }, [separator, setValue, values]);
}
function useStringDateChangeHandler(setValues) {
  return React.useMemo(function () {
    return _toConsumableArray(new Array(3)).map(function (_, index) {
      return function (e) {
        var value = e.target.value;
        var v = convertFullToHalfWidth(value);
        // year
        if (index === 0) {
          if (v.length > 4) {
            return;
          }
          setValues[0](v);
        }
        // month
        else if (index === 1) {
          if (v.length > 2) {
            return;
          }
          setValues[1](v);
        }
        // day
        else {
          if (v.length > 2) {
            return;
          }
          setValues[2](v);
        }
      };
    });
  }, [setValues]);
}
function useDateRangeCalender(startValue, endValue, setValue, format) {
  var onPickerChange = function onPickerChange(date) {
    var _a, _b;
    setValue((_a = dateToValue(date[0], format)) !== null && _a !== void 0 ? _a : "", (_b = dateToValue(date[1], format)) !== null && _b !== void 0 ? _b : "");
  };
  var onSetDate = React.useCallback(function (startValue, endValue) {
    var _a, _b;
    var start = (_a = dateToValue(startValue, format)) !== null && _a !== void 0 ? _a : undefined;
    var end = (_b = dateToValue(endValue, format)) !== null && _b !== void 0 ? _b : undefined;
    setValue(start, end);
  }, [format, setValue]);
  var startDate = React.useMemo(function () {
    var startDate = new Date(startValue);
    return isValidDate(startDate) ? startDate : null;
  }, [startValue]);
  var endDate = React.useMemo(function () {
    var endDate = new Date(endValue);
    return isValidDate(endDate) ? endDate : null;
  }, [endValue]);
  return {
    startDate: startDate,
    endDate: endDate,
    onPickerChange: onPickerChange,
    onSetDate: onSetDate
  };
}

/**
 * 日付範囲のUIコンポーネント
 * @param param0
 * @returns
 */
var BaseMultipleDateRangeInput = function BaseMultipleDateRangeInput(_ref) {
  var startProps = _ref.startProps,
    endProps = _ref.endProps,
    onBlur = _ref.onBlur,
    formState = _ref.formState,
    dateRangePickerProps = _ref.dateRangePickerProps;
  var _useMultipleTouched = useMultipleTouched([!!startProps.value, !!endProps.value], onBlur),
    _useMultipleTouched$o = _slicedToArray(_useMultipleTouched.onBlurHandlers, 2),
    handleStartBlur = _useMultipleTouched$o[0],
    handleEndBlur = _useMultipleTouched$o[1];
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement("div", {
    className: styles$B.start
  }, "\u958B\u59CB\u65E5"), React__namespace.default.createElement("div", {
    className: styles$B.wrapper
  }, React__namespace.default.createElement("div", {
    className: styles$B.input
  }, React__namespace.default.createElement(BaseDateInput, _objectSpread2({}, {
    onBlur: handleStartBlur,
    yearInputProps: _objectSpread2(_objectSpread2({}, startProps.yearInputProps), {}, {
      value: startProps.yearInputProps.value,
      formState: formState,
      "aria-label": "開始 年"
    }),
    monthInputProps: _objectSpread2(_objectSpread2({}, startProps.monthInputProps), {}, {
      value: startProps.monthInputProps.value,
      formState: formState,
      "aria-label": "開始 月"
    }),
    dayInputProps: _objectSpread2(_objectSpread2({}, startProps.dayInputProps), {}, {
      value: startProps.dayInputProps.value,
      formState: formState,
      "aria-label": "開始 日"
    }),
    datePicker: React__namespace.default.createElement(DateRangePicker, _objectSpread2(_objectSpread2({}, dateRangePickerProps), {}, {
      iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u958B\u59CB\u65E5\u3092\u9078\u629E\u3059\u308B"
    }))
  })))), React__namespace.default.createElement("div", {
    className: styles$B.end
  }, "\u7D42\u4E86\u65E5"), React__namespace.default.createElement("div", {
    className: styles$B.wrapper
  }, React__namespace.default.createElement("div", {
    className: styles$B.input
  }, React__namespace.default.createElement(BaseDateInput, _objectSpread2({}, {
    onBlur: handleEndBlur,
    yearInputProps: _objectSpread2(_objectSpread2({}, endProps.yearInputProps), {}, {
      value: endProps.yearInputProps.value,
      formState: formState,
      "aria-label": "終了 年"
    }),
    monthInputProps: _objectSpread2(_objectSpread2({}, endProps.monthInputProps), {}, {
      value: endProps.monthInputProps.value,
      formState: formState,
      "aria-label": "終了 月"
    }),
    dayInputProps: _objectSpread2(_objectSpread2({}, endProps.dayInputProps), {}, {
      value: endProps.dayInputProps.value,
      formState: formState,
      "aria-label": "終了 日"
    }),
    datePicker: React__namespace.default.createElement(DateRangePicker, _objectSpread2(_objectSpread2({}, dateRangePickerProps), {}, {
      iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u7D42\u4E86\u65E5\u3092\u9078\u629E\u3059\u308B"
    }))
  })))));
};
/**
 * form-generator用のコンポーネント touched, isValidを引数で受け取る
 * @param param0
 * @returns
 */
var GrafferSchemasMultipleDateRangeInputComponent = function GrafferSchemasMultipleDateRangeInputComponent(_ref2) {
  var _ref2$startValue = _ref2.startValue,
    startValue = _ref2$startValue === void 0 ? "" : _ref2$startValue,
    _ref2$endValue = _ref2.endValue,
    endValue = _ref2$endValue === void 0 ? "" : _ref2$endValue,
    touched = _ref2.touched,
    onStartChange = _ref2.onStartChange,
    onEndChange = _ref2.onEndChange,
    setValue = _ref2.setValue,
    noValidate = _ref2.noValidate,
    errorMessage = _ref2.errorMessage,
    onBlur = _ref2.onBlur,
    required = _ref2.required,
    _ref2$separator = _ref2.separator,
    separator = _ref2$separator === void 0 ? "-" : _ref2$separator;
  var _useId = nextId.useId(1, "errorMessage-DateRange-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    errorMessageId = _useId2[0];
  var formState = MultipleFormState.create(!!touched, !errorMessage, noValidate, false, errorMessage);
  var startState = useInnerSplitDateState(startValue, separator);
  var endState = useInnerSplitDateState(endValue, separator);
  var _useStringDateChangeH = useStringDateChangeHandler([startState.setYear, startState.setMonth, startState.setDay]),
    _useStringDateChangeH2 = _slicedToArray(_useStringDateChangeH, 3),
    onStartYearChange = _useStringDateChangeH2[0],
    onStartMonthChange = _useStringDateChangeH2[1],
    onStartDayChange = _useStringDateChangeH2[2];
  var _useStringDateBlurHan = useStringDateBlurHandler([startState.year, startState.month, startState.day], onStartChange, separator),
    _useStringDateBlurHan2 = _slicedToArray(_useStringDateBlurHan, 3),
    onStartYearBlur = _useStringDateBlurHan2[0],
    onStartMonthBlur = _useStringDateBlurHan2[1],
    onStartDayBlur = _useStringDateBlurHan2[2];
  var _useStringDateChangeH3 = useStringDateChangeHandler([endState.setYear, endState.setMonth, endState.setDay]),
    _useStringDateChangeH4 = _slicedToArray(_useStringDateChangeH3, 3),
    onEndYearChange = _useStringDateChangeH4[0],
    onEndMonthChange = _useStringDateChangeH4[1],
    onEndDayChange = _useStringDateChangeH4[2];
  var _useStringDateBlurHan3 = useStringDateBlurHandler([endState.year, endState.month, endState.day], onEndChange, separator),
    _useStringDateBlurHan4 = _slicedToArray(_useStringDateBlurHan3, 3),
    onEndYearBlur = _useStringDateBlurHan4[0],
    onEndMonthBlur = _useStringDateBlurHan4[1],
    onEndDayBlur = _useStringDateBlurHan4[2];
  var _useDateRangeCalender = useDateRangeCalender(startValue, endValue, setValue, "YYYY-MM-DD"),
    startDate = _useDateRangeCalender.startDate,
    endDate = _useDateRangeCalender.endDate,
    onPickerChange = _useDateRangeCalender.onPickerChange,
    onSetDate = _useDateRangeCalender.onSetDate;
  return React__namespace.default.createElement(BaseMultipleDateRangeInput, {
    formState: formState,
    onBlur: onBlur,
    startProps: {
      value: startValue,
      yearInputProps: {
        value: startState.year,
        onChange: onStartYearChange,
        errorMessageId: errorMessageId,
        onBlur: onStartYearBlur,
        required: required,
        "aria-required": required
      },
      monthInputProps: {
        value: startState.month,
        onChange: onStartMonthChange,
        errorMessageId: errorMessageId,
        onBlur: onStartMonthBlur,
        required: required,
        "aria-required": required
      },
      dayInputProps: {
        value: startState.day,
        onChange: onStartDayChange,
        errorMessageId: errorMessageId,
        onBlur: onStartDayBlur,
        required: required,
        "aria-required": required
      }
    },
    endProps: {
      value: endValue,
      yearInputProps: {
        value: endState.year,
        onChange: onEndYearChange,
        errorMessageId: errorMessageId,
        onBlur: onEndYearBlur,
        required: required,
        "aria-required": required
      },
      monthInputProps: {
        value: endState.month,
        onChange: onEndMonthChange,
        errorMessageId: errorMessageId,
        onBlur: onEndMonthBlur,
        required: required,
        "aria-required": required
      },
      dayInputProps: {
        value: endState.day,
        onChange: onEndDayChange,
        errorMessageId: errorMessageId,
        onBlur: onEndDayBlur,
        required: required,
        "aria-required": required
      }
    },
    dateRangePickerProps: {
      setValue: onSetDate,
      onChange: onPickerChange,
      startDate: startDate,
      endDate: endDate
    }
  });
};

var useDateRangeInner = function useDateRangeInner(_ref) {
  var startValue = _ref.startValue,
    endValue = _ref.endValue,
    setValue = _ref.setValue;
  var formattedValue = startValue && endValue ? "".concat(startValue, "~").concat(endValue) : "";
  var _splitDateRangeString = splitDateRangeString(formattedValue),
    start = _splitDateRangeString.start,
    end = _splitDateRangeString.end;
  var _useState = React.useState({
      start: start,
      end: end
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var setNewValue = React.useCallback(function (newValue) {
    setCurrentValue({
      start: newValue.start,
      end: newValue.end
    });
    setValue(newValue);
  }, [setValue]);
  var _useDateValue = useDateValue({
      currentValue: currentValue,
      setNewValue: setNewValue
    }),
    startDateString = _useDateValue.startDateString,
    endDateString = _useDateValue.endDateString,
    startDate = _useDateValue.startDate,
    endDate = _useDateValue.endDate,
    handleStartChange = _useDateValue.handleStartChange,
    handleEndChange = _useDateValue.handleEndChange,
    handlePickerChange = _useDateValue.handlePickerChange,
    handleCalenderOpen = _useDateValue.handleCalenderOpen;
  return {
    formattedValue: formattedValue,
    startDateString: startDateString,
    endDateString: endDateString,
    startDate: startDate,
    endDate: endDate,
    handleStartChange: handleStartChange,
    handleEndChange: handleEndChange,
    handlePickerChange: handlePickerChange,
    handleCalenderOpen: handleCalenderOpen,
    setNewValue: setNewValue
  };
};
var useDateRangeFromString = function useDateRangeFromString(_ref2) {
  var startValue = _ref2.startValue,
    endValue = _ref2.endValue,
    setValue = _ref2.setValue;
  var setNewValue = React.useCallback(function (newValue) {
    var startDate = new Date(newValue.start);
    var endDate = new Date(newValue.end);
    if (isValidDate(startDate) && isValidDate(endDate)) {
      setValue(newValue.start, newValue.end);
    }
  }, [setValue]);
  return useDateRangeInner({
    startValue: startValue,
    endValue: endValue,
    setValue: setNewValue
  });
};
var useDateRangeFromDate = function useDateRangeFromDate(_ref3) {
  var startValue = _ref3.startValue,
    endValue = _ref3.endValue,
    setValue = _ref3.setValue;
  var convertedStartValue = dateToValue(startValue, "YYYY/MM/DD");
  var convertedEndValue = dateToValue(endValue, "YYYY/MM/DD");
  var setNewValue = React.useCallback(function (newValue) {
    var startDate = new Date(newValue.start);
    var endDate = new Date(newValue.end);
    if (isValidDate(startDate) && isValidDate(endDate)) {
      setValue(startDate, endDate);
    }
  }, [setValue]);
  return useDateRangeInner({
    startValue: convertedStartValue,
    endValue: convertedEndValue,
    setValue: setNewValue
  });
};
var useDateValue = function useDateValue(_ref4) {
  var currentValue = _ref4.currentValue,
    setNewValue = _ref4.setNewValue;
  var handleStartChange = React.useCallback(function (e) {
    var v = e.target.value.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      start: formatValue(v, "YYYY/MM/DD")
    }));
  }, [currentValue, setNewValue]);
  var handleEndChange = React.useCallback(function (e) {
    var v = e.target.value.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      end: formatValue(v, "YYYY/MM/DD")
    }));
  }, [currentValue, setNewValue]);
  var handlePickerChange = React.useCallback(function (date) {
    var _a, _b;
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      start: (_a = dateToValue(date[0], "YYYY/MM/DD")) !== null && _a !== void 0 ? _a : "",
      //カレンダーは初めと終わりのどちらの選択時も発火するため、終わりdate[1]がnullになる場合がある
      end: (_b = dateToValue(date[1], "YYYY/MM/DD")) !== null && _b !== void 0 ? _b : ""
    }));
  }, [currentValue, setNewValue]);
  //範囲選択の際、endにのみ値がある状態だとDatePickerのonChangeが発火しないため、両方入力されている場合をのぞきリセットする
  var handleCalenderOpen = React.useCallback(function (_ref5) {
    var start = _ref5.start,
      end = _ref5.end;
    if (!(start && end)) {
      setNewValue({
        start: "",
        end: ""
      });
    }
  }, [setNewValue]);
  return {
    startDateString: currentValue.start,
    endDateString: currentValue.end,
    startDate: valueToDate(currentValue.start),
    endDate: valueToDate(currentValue.end),
    handlePickerChange: handlePickerChange,
    handleStartChange: handleStartChange,
    handleEndChange: handleEndChange,
    handleCalenderOpen: handleCalenderOpen
  };
};
var useValid = function useValid(_ref6) {
  var formattedValue = _ref6.formattedValue,
    validate = _ref6.validate;
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  React.useEffect(function () {
    setIsValid(validate(formattedValue));
  }, [formattedValue, validate]);
  return {
    isValid: isValid
  };
};
/**
 * X~Yの形式のstringを~でsplitして{X,Y}で返す
 * @param dateString
 * @returns start,end
 */
var splitDateRangeString = function splitDateRangeString(dateRangeString) {
  var _a, _b;
  var dateSplited = dateRangeString.split("~");
  return {
    start: (_a = dateSplited[0]) !== null && _a !== void 0 ? _a : "",
    end: (_b = dateSplited[1]) !== null && _b !== void 0 ? _b : ""
  };
};
var valueToDate = function valueToDate(value) {
  var date = new Date(value);
  var isValidDate = date.toString() !== "Invalid Date" && date instanceof Date;
  return isValidDate ? date : null;
};

var css_248z$A = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.date-range-module__GDK__wrapper___pMfsJ {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-bottom: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-range-module__GDK__wrapper___pMfsJ {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-range-module__GDK__start___rSsYM {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-range-module__GDK__start___rSsYM {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-range-module__GDK__end___FKcnh {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-range-module__GDK__end___FKcnh {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-range-module__GDK__legend___j1BXv {\n  margin-bottom: 8px;\n  margin-top: calc(8px * -1);\n}\n\n.date-range-module__GDK__description___gA2Tf {\n  margin-bottom: 8px;\n}\n\n.date-range-module__GDK__label___1h7-s {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  vertical-align: middle;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-range-module__GDK__label___1h7-s {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-range-module__GDK__description___gA2Tf {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .date-range-module__GDK__description___gA2Tf {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.date-range-module__GDK__to___wQc1g {\n  padding: 0 calc(32px - 1px);\n}\n\n.date-range-module__GDK__icon___yEEYq {\n  margin-left: 16px;\n}\n\n.date-range-module__GDK__input___EQfny input {\n  max-width: 240px;\n}\n\n@media screen and (max-width: 800px) {\n  .date-range-module__GDK__to___wQc1g {\n    padding: 0 calc(16px - 4px);\n  }\n  .date-range-module__GDK__icon___yEEYq {\n    margin-left: calc(16px - 1px);\n  }\n}\n";
var styles$A = {"wrapper":"date-range-module__GDK__wrapper___pMfsJ","start":"date-range-module__GDK__start___rSsYM","end":"date-range-module__GDK__end___FKcnh","legend":"date-range-module__GDK__legend___j1BXv","description":"date-range-module__GDK__description___gA2Tf","label":"date-range-module__GDK__label___1h7-s","to":"date-range-module__GDK__to___wQc1g","icon":"date-range-module__GDK__icon___yEEYq","input":"date-range-module__GDK__input___EQfny"};
styleInject(css_248z$A);

var defaultValidate$1 = function defaultValidate() {
  return true;
};
/**
 * 日付範囲のUIコンポーネント 単一入力(年月日入力はDateRangeMultipleInput)
 * @param param0
 * @returns
 */
var BaseDateRangeInput = function BaseDateRangeInput(_ref) {
  var formState = _ref.formState,
    startProps = _ref.startProps,
    endProps = _ref.endProps,
    dateRangePickerProps = _ref.dateRangePickerProps,
    onBlur = _ref.onBlur;
  var _useMultipleTouched = useMultipleTouched([!!startProps.value, !!endProps.value], onBlur),
    _useMultipleTouched$o = _slicedToArray(_useMultipleTouched.onBlurHandlers, 2),
    handleStartBlur = _useMultipleTouched$o[0],
    handleEndBlur = _useMultipleTouched$o[1];
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement("div", {
    className: styles$A.start
  }, "\u958B\u59CB\u65E5"), React__namespace.default.createElement("div", {
    className: styles$A.wrapper
  }, React__namespace.default.createElement("span", {
    className: styles$A.input
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, startProps), {}, {
    type: "text",
    formState: formState,
    onBlur: handleStartBlur,
    inputMode: "numeric",
    needStatusIcon: true
  }))), React__namespace.default.createElement("div", {
    className: styles$A.icon
  }, React__namespace.default.createElement(DateRangePicker, _objectSpread2(_objectSpread2({}, dateRangePickerProps), {}, {
    iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u958B\u59CB\u65E5\u3092\u9078\u629E\u3059\u308B"
  })))), React__namespace.default.createElement("div", {
    className: styles$A.end
  }, "\u7D42\u4E86\u65E5"), React__namespace.default.createElement("div", {
    className: styles$A.wrapper
  }, React__namespace.default.createElement("span", {
    className: styles$A.input
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, endProps), {}, {
    type: "text",
    formState: formState,
    onBlur: handleEndBlur,
    inputMode: "numeric",
    needStatusIcon: true
  }))), React__namespace.default.createElement("div", {
    className: styles$A.icon
  }, React__namespace.default.createElement(DateRangePicker, _objectSpread2(_objectSpread2({}, dateRangePickerProps), {}, {
    iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u7D42\u4E86\u65E5\u3092\u9078\u629E\u3059\u308B"
  })))));
};
/**
 * form-generator用のコンポーネント touched, isValidを引数で受け取る
 * （ガイドラインに即していないコンポーネントのため、DateRangeMultiInputComponentの使用を推奨）
 * @param param0
 * @returns
 * @deprecated
 */
var GrafferSchemasDateRangeInputComponent = function GrafferSchemasDateRangeInputComponent(_ref2) {
  var startValue = _ref2.startValue,
    endValue = _ref2.endValue,
    startPlaceholder = _ref2.startPlaceholder,
    endPlaceholder = _ref2.endPlaceholder,
    setValue = _ref2.setValue,
    noValidate = _ref2.noValidate,
    errorMessage = _ref2.errorMessage,
    touched = _ref2.touched,
    isValid = _ref2.isValid,
    onBlur = _ref2.onBlur;
  var _useDateRangeFromStri = useDateRangeFromString({
      startValue: startValue,
      endValue: endValue,
      setValue: setValue
    }),
    startDateString = _useDateRangeFromStri.startDateString,
    endDateString = _useDateRangeFromStri.endDateString,
    startDate = _useDateRangeFromStri.startDate,
    endDate = _useDateRangeFromStri.endDate,
    handleStartChange = _useDateRangeFromStri.handleStartChange,
    handleEndChange = _useDateRangeFromStri.handleEndChange,
    handlePickerChange = _useDateRangeFromStri.handlePickerChange,
    handleCalenderOpen = _useDateRangeFromStri.handleCalenderOpen;
  var _useId = nextId.useId(1, "errorMessage-DateRange-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    errorMessageId = _useId2[0];
  var formState = MultipleFormState.create(!!touched, !!isValid, noValidate, false, errorMessage);
  var onSetDate = React.useCallback(function (startValue, endValue) {
    var _a, _b;
    var start = (_a = dateToValue(startValue, "YYYY/MM/DD")) !== null && _a !== void 0 ? _a : undefined;
    var end = (_b = dateToValue(endValue, "YYYY/MM/DD")) !== null && _b !== void 0 ? _b : undefined;
    setValue(start, end);
  }, [setValue]);
  return React__namespace.default.createElement(BaseDateRangeInput, {
    formState: formState,
    onBlur: onBlur,
    startProps: {
      value: startDateString,
      placeholder: startPlaceholder,
      errorMessageId: errorMessageId,
      onChange: handleStartChange
    },
    endProps: {
      value: endDateString,
      placeholder: endPlaceholder,
      errorMessageId: errorMessageId,
      onChange: handleEndChange
    },
    dateRangePickerProps: {
      setValue: onSetDate,
      onChange: handlePickerChange,
      startDate: startDate,
      endDate: endDate,
      onCalendarOpen: function onCalendarOpen() {
        return handleCalenderOpen({
          start: startDate,
          end: endDate
        });
      }
    }
  });
};
/**
 * 日付範囲コンポーネント （ガイドラインに即していないコンポーネントのため、DateRangeMultiInputの使用を推奨）
 * @param param0
 * @returns
 * @deprecated
 */
var DateRangeInput = function DateRangeInput(_ref3) {
  var label = _ref3.label,
    startValue = _ref3.startValue,
    endValue = _ref3.endValue,
    startPlaceholder = _ref3.startPlaceholder,
    endPlaceholder = _ref3.endPlaceholder,
    setValue = _ref3.setValue,
    noValidate = _ref3.noValidate,
    _ref3$validate = _ref3.validate,
    validate = _ref3$validate === void 0 ? defaultValidate$1 : _ref3$validate,
    errorMessage = _ref3.errorMessage,
    description = _ref3.description,
    required = _ref3.required;
  var _useDateRangeFromDate = useDateRangeFromDate({
      startValue: startValue,
      endValue: endValue,
      setValue: setValue
    }),
    formattedValue = _useDateRangeFromDate.formattedValue,
    startDateString = _useDateRangeFromDate.startDateString,
    endDateString = _useDateRangeFromDate.endDateString,
    startDate = _useDateRangeFromDate.startDate,
    endDate = _useDateRangeFromDate.endDate,
    handleStartChange = _useDateRangeFromDate.handleStartChange,
    handleEndChange = _useDateRangeFromDate.handleEndChange,
    handlePickerChange = _useDateRangeFromDate.handlePickerChange,
    handleCalenderOpen = _useDateRangeFromDate.handleCalenderOpen;
  var _useId3 = nextId.useId(1, "errorMessage-DateRange-id-"),
    _useId4 = _slicedToArray(_useId3, 1),
    errorMessageId = _useId4[0];
  var _useValid = useValid({
      formattedValue: formattedValue,
      validate: validate
    }),
    isValid = _useValid.isValid;
  var _useTouched = useTouched(!!startValue && !!endValue),
    isTouched = _useTouched.isTouched,
    changeTouchedTrue = _useTouched.changeTouchedTrue;
  var formState = MultipleFormState.create(isTouched, isValid, noValidate, false, errorMessage);
  var handleOnBlur = React.useCallback(function () {
    changeTouchedTrue();
  }, [changeTouchedTrue]);
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement(FieldsetWrap, {
    title: label,
    description: description,
    required: required
  }, React__namespace.default.createElement(BaseDateRangeInput, {
    formState: formState,
    onBlur: handleOnBlur,
    startProps: {
      value: startDateString,
      placeholder: startPlaceholder,
      errorMessageId: errorMessageId,
      onChange: handleStartChange
    },
    endProps: {
      value: endDateString,
      placeholder: endPlaceholder,
      errorMessageId: errorMessageId,
      onChange: handleEndChange
    },
    dateRangePickerProps: {
      setValue: setValue,
      onChange: handlePickerChange,
      startDate: startDate,
      endDate: endDate,
      onCalendarOpen: function onCalendarOpen() {
        return handleCalenderOpen({
          start: startDate,
          end: endDate
        });
      }
    }
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.default.createElement(ErrorMessages, {
      messages: errorMessage,
      id: errorMessageId
    })
  }));
};

var css_248z$z = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.message-module__GDK__message___1Jq1s {\n  border-radius: 8px;\n  padding: 24px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .message-module__GDK__message___1Jq1s {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.message-module__GDK__default___MuUdQ {\n  background-color: #e8e9f7;\n  color: #3739a2;\n}\n\n.message-module__GDK__success___bOPT3 {\n  background-color: #e1f3f1;\n  color: #175243;\n}\n\n.message-module__GDK__warning___QA1k0 {\n  background-color: #fcf3e0;\n  color: #90440d;\n}\n\n.message-module__GDK__error___UV9-J {\n  background-color: #fff7f8;\n  color: #8e1b19;\n}\n\n.message-module__GDK__header___GRP7a {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.message-module__GDK__titleWrapper___NuOH2 {\n  display: flex;\n  align-items: center;\n}\n\n.message-module__GDK__iconWrapper___sr0ty {\n  display: flex;\n  align-items: center;\n}\n\n.message-module__GDK__description___HNOQp {\n  margin-bottom: 16px;\n}\n\n.message-module__GDK__title___nHn94 {\n  font: bold 24px/42px Meiryo, Arial, system-ui, sans-serif;\n  margin-left: 16px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .message-module__GDK__title___nHn94 {\n  font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .message-module__GDK__message___1Jq1s {\n    padding: 16px;\n  }\n  .message-module__GDK__header___GRP7a {\n    margin-bottom: 8px;\n  }\n  .message-module__GDK__title___nHn94 {\n    font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n    margin-left: 8px;\n  }\n  @media screen and (max-width: 800px) {\n\n    .message-module__GDK__title___nHn94 {\n    font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n}\n";
var styles$z = {"message":"message-module__GDK__message___1Jq1s","default":"message-module__GDK__default___MuUdQ","success":"message-module__GDK__success___bOPT3","warning":"message-module__GDK__warning___QA1k0","error":"message-module__GDK__error___UV9-J","header":"message-module__GDK__header___GRP7a","titleWrapper":"message-module__GDK__titleWrapper___NuOH2","iconWrapper":"message-module__GDK__iconWrapper___sr0ty","description":"message-module__GDK__description___HNOQp","title":"message-module__GDK__title___nHn94"};
styleInject(css_248z$z);

var _excluded$t = ["title", "className", "icon", "children", "onCancel"];
var BaseMessage = function BaseMessage(_ref) {
  var title = _ref.title,
    className = _ref.className,
    icon = _ref.icon,
    children = _ref.children,
    onCancel = _ref.onCancel,
    props = _objectWithoutProperties(_ref, _excluded$t);
  var Icon = Icons[icon];
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return React__namespace.createElement("article", _objectSpread2({
    className: "".concat(styles$z.message, " ").concat(className)
  }, props), React__namespace.createElement("div", {
    className: classNames__default.default(styles$z.header, !!children && styles$z.description)
  }, React__namespace.createElement("div", {
    className: styles$z.titleWrapper
  }, React__namespace.createElement("div", {
    className: styles$z.iconWrapper,
    "aria-hidden": true
  }, React__namespace.createElement(Icon, {
    size: isPc ? IconSizes.large : IconSizes.medium
  })), React__namespace.createElement("div", {
    className: styles$z.title
  }, title)), !!onCancel && React__namespace.createElement(CancelButton, {
    className: styles$z.cancel,
    onCancel: onCancel,
    iconSize: isPc ? IconSizes.midium : IconSizes.small,
    ariaLabel: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9589\u3058\u308B"
  })), children);
};
var DefaultMessage = function DefaultMessage(_ref2) {
  var title = _ref2.title,
    onCancel = _ref2.onCancel,
    children = _ref2.children;
  return React__namespace.createElement(BaseMessage, {
    className: styles$z["default"],
    title: title,
    icon: "InfoIcon",
    onCancel: onCancel
  }, children);
};
var SuccessMessage = function SuccessMessage(_ref3) {
  var title = _ref3.title,
    onCancel = _ref3.onCancel,
    children = _ref3.children;
  return React__namespace.createElement(BaseMessage, {
    className: styles$z.success,
    title: title,
    icon: "CheckIcon",
    onCancel: onCancel,
    "aria-live": "polite"
  }, children);
};
var WarningMessage = function WarningMessage(_ref4) {
  var title = _ref4.title,
    onCancel = _ref4.onCancel,
    children = _ref4.children;
  return React__namespace.createElement(BaseMessage, {
    className: styles$z.warning,
    title: title,
    icon: "WarningIcon",
    onCancel: onCancel
  }, children);
};
var ErrorMessage = function ErrorMessage(_ref5) {
  var title = _ref5.title,
    onCancel = _ref5.onCancel,
    children = _ref5.children;
  return React__namespace.createElement(BaseMessage, {
    className: styles$z.error,
    title: title,
    icon: "AttentionIcon",
    onCancel: onCancel
  }, children);
};

var css_248z$y = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.snackbar-module__GDK__snackbarContainer___4EqQn {\n  position: fixed;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.snackbar-module__GDK__snackbarContainer___4EqQn > * {\n  margin-top: 16px;\n}\n\n.snackbar-module__GDK__snackbarContainer___4EqQn > *:first-child {\n  margin-top: 0;\n}\n\n.snackbar-module__GDK__snackbarWrapper___JFh9a {\n  display: inline-block;\n}\n\n.snackbar-module__GDK__snackbar___hYXHp {\n  border-radius: 8px;\n  padding: 16px 24px;\n  display: flex;\n  justify-content: space-between;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border: 2px solid #237f6d;\n}\n\n.snackbar-module__GDK__iconTextWrapper___ehofZ {\n  display: flex;\n  align-items: center;\n  margin-right: 80px;\n  font-size: 18px;\n}\n\n.snackbar-module__GDK__text___rPO-j {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n}\n\n@media screen and (max-width: 800px) {\n\n  .snackbar-module__GDK__text___rPO-j {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .snackbar-module__GDK__snackbarContainer___4EqQn {\n    top: 8px;\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .snackbar-module__GDK__snackbarWrapper___JFh9a {\n    display: block;\n  }\n\n  .snackbar-module__GDK__snackbar___hYXHp {\n    padding: 16px;\n  }\n\n  .snackbar-module__GDK__iconTextWrapper___ehofZ {\n    margin-right: 0;\n    font-size: 16px;\n  }\n}\n";
var styles$y = {"snackbarContainer":"snackbar-module__GDK__snackbarContainer___4EqQn","snackbarWrapper":"snackbar-module__GDK__snackbarWrapper___JFh9a","snackbar":"snackbar-module__GDK__snackbar___hYXHp","iconTextWrapper":"snackbar-module__GDK__iconTextWrapper___ehofZ","text":"snackbar-module__GDK__text___rPO-j"};
styleInject(css_248z$y);

var snackbarMessageIdMapper = function snackbarMessageIdMapper(item) {
  return {
    message: item,
    id: uuid.v4()
  };
};
var useSnackbar = function useSnackbar(_ref) {
  var snackbarMessages = _ref.snackbarMessages,
    setSnackbarMessages = _ref.setSnackbarMessages;
  var messagesWithId = React.useMemo(function () {
    return snackbarMessages.map(snackbarMessageIdMapper);
  }, [snackbarMessages]);
  var closeSnackbar = React.useCallback(function (id) {
    setSnackbarMessages(messagesWithId.filter(function (item) {
      return item.id !== id;
    }).map(function (item) {
      return item.message;
    }));
  }, [messagesWithId, setSnackbarMessages]);
  return {
    messagesWithId: messagesWithId,
    closeSnackbar: closeSnackbar
  };
};

var SnackbarContent = function SnackbarContent(_ref) {
  var children = _ref.children,
    onCancel = _ref.onCancel;
  return React__namespace.createElement("div", {
    className: styles$y.snackbarWrapper
  }, React__namespace.createElement("div", {
    className: styles$y.snackbar,
    role: "status"
  }, React__namespace.createElement("div", {
    className: styles$y.iconTextWrapper
  }, React__namespace.createElement(CheckIcon, {
    size: 24,
    "aria-hidden": true
  }), React__namespace.createElement("div", {
    className: styles$y.text
  }, children)), React__namespace.createElement(CancelButton, {
    onCancel: onCancel,
    iconSize: 24,
    ariaLabel: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9589\u3058\u308B"
  })));
};
var Snackbar = function Snackbar(_ref2) {
  var messages = _ref2.messages,
    close = _ref2.close;
  return ReactDOM__default.default.createPortal(React__namespace.createElement("div", {
    className: styles$y.snackbarContainer
  }, messages.filter(function (_item, i) {
    return i < 2;
  }).map(function (item) {
    return React__namespace.createElement(SnackbarContent, {
      onCancel: function onCancel() {
        return close(item.id);
      },
      key: item.id
    }, item.message);
  })), document.body);
};
var SnackbarContainer = function SnackbarContainer(_ref3) {
  var snackbarMessages = _ref3.snackbarMessages,
    setSnackbarMessages = _ref3.setSnackbarMessages,
    children = _ref3.children;
  var _useSnackbar = useSnackbar({
      snackbarMessages: snackbarMessages,
      setSnackbarMessages: setSnackbarMessages
    }),
    messagesWithId = _useSnackbar.messagesWithId,
    closeSnackbar = _useSnackbar.closeSnackbar;
  return React__namespace.createElement(Snackbar, {
    messages: messagesWithId,
    close: closeSnackbar
  }, children);
};

var css_248z$x = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.review-stars-module__GDK__label___vYUwo {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .review-stars-module__GDK__label___vYUwo {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.review-stars-module__GDK__starContainer___qMBIX {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 16px;\n}\n\n.review-stars-module__GDK__input___GBo3v,\n.review-stars-module__GDK__star___0piK6,\n.review-stars-module__GDK__disabledStar___KXkEj,\n.review-stars-module__GDK__starWrapper___H9ghN {\n  display: block;\n}\n\n.review-stars-module__GDK__star___0piK6,\n.review-stars-module__GDK__disabledStar___KXkEj,\n.review-stars-module__GDK__starWrapper___H9ghN {\n  height: 40px;\n  width: 40px;\n}\n\n.review-stars-module__GDK__input___GBo3v,\n.review-stars-module__GDK__hiddenAltText___CsU9t {\n  /* 要素を見えないようにするが、domツリー上には残しスクリーンリーダーでは読めるようにする */\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n}\n\n.review-stars-module__GDK__starWrapper___H9ghN {\n  position: relative;\n}\n\n.review-stars-module__GDK__star___0piK6 {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  margin: auto;\n  z-index: 1;\n}\n\n.review-stars-module__GDK__input___GBo3v:hover + .review-stars-module__GDK__starWrapper___H9ghN > .review-stars-module__GDK__star___0piK6 path {\n  stroke: #1c1e78;\n  fill: #fff;\n}\n\n.review-stars-module__GDK__input___GBo3v.review-stars-module__GDK__selected___Kx33H + .review-stars-module__GDK__starWrapper___H9ghN > .review-stars-module__GDK__star___0piK6 path {\n  stroke: #454ab8;\n  fill: #454ab8;\n}\n\n.review-stars-module__GDK__starContainer___qMBIX .review-stars-module__GDK__disabledStar___KXkEj path {\n  stroke: #dcd9d8;\n  fill: #fff;\n}\n\n.review-stars-module__GDK__starWrapper___H9ghN::before {\n  content: \"\";\n  display: block;\n  height: 60px;\n  width: 60px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  margin: auto;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.review-stars-module__GDK__input___GBo3v:focus-visible + .review-stars-module__GDK__starWrapper___H9ghN {\n  box-shadow:\n    #fff 0px 0px 0px 8px,\n    #454ab8 0px 0px 0px 10px;\n  background-color: #fff;\n  border-radius: 50%;\n}\n\n.review-stars-module__GDK__scale___5MFZ8 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .review-stars-module__GDK__scale___5MFZ8 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n@media screen and (max-width: 374px) {\n  .review-stars-module__GDK__starContainer___qMBIX {\n    gap: 8px;\n  }\n}\n";
var styles$x = {"label":"review-stars-module__GDK__label___vYUwo","starContainer":"review-stars-module__GDK__starContainer___qMBIX","input":"review-stars-module__GDK__input___GBo3v","star":"review-stars-module__GDK__star___0piK6","disabledStar":"review-stars-module__GDK__disabledStar___KXkEj","starWrapper":"review-stars-module__GDK__starWrapper___H9ghN","hiddenAltText":"review-stars-module__GDK__hiddenAltText___CsU9t","selected":"review-stars-module__GDK__selected___Kx33H","scale":"review-stars-module__GDK__scale___5MFZ8"};
styleInject(css_248z$x);

var numberOfStars = 1;
var ReviewStars = function ReviewStars(_ref) {
  var label = _ref.label,
    reviewValues = _ref.reviewValues,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useState = React.useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputName = _useState2[0],
    setInputName = _useState2[1];
  React.useEffect(function () {
    var uniqueName = uuid.v4();
    setInputName(uniqueName);
  }, []);
  return React__namespace.default.createElement("fieldset", null, React__namespace.default.createElement("legend", {
    className: styles$x.label
  }, label), React__namespace.default.createElement("div", {
    className: styles$x.starContainer
  }, React__namespace.default.createElement("div", {
    className: styles$x.scale
  }, "\u4E0D\u6E80"), _toConsumableArray(reviewValues).map(function (reviewValue, index) {
    var virtualIndex = numberOfStars + index;
    var starId = "".concat(inputName, "-star-").concat(virtualIndex);
    return React__namespace.default.createElement(React__namespace.default.Fragment, {
      key: starId
    }, React__namespace.default.createElement("input", {
      type: "radio",
      id: starId,
      name: inputName,
      value: reviewValue.value,
      checked: value === reviewValue.value,
      className: classNames__default.default(styles$x.input, parseInt(value) >= parseInt(reviewValue.value) && styles$x.selected),
      disabled: disabled,
      onChange: onChange,
      "aria-label": "\u8A55\u4FA1".concat(virtualIndex, "\u70B9"),
      "data-testid": "test-star-".concat(virtualIndex)
    }), React__namespace.default.createElement("label", {
      htmlFor: starId,
      "aria-hidden": "true",
      className: styles$x.starWrapper
    }, React__namespace.default.createElement(StarIcon, {
      size: 40,
      className: disabled ? styles$x.disabledStar : styles$x.star,
      reviewPoint: virtualIndex
    })));
  }), React__namespace.default.createElement("div", {
    className: styles$x.scale
  }, "\u6E80\u8DB3")));
};

var css_248z$w = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.spinner-module__GDK__wrapper___jYcaZ {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* 背景だけ透過させたい時にはrgbaを使用する => https://qiita.com/ritukiii/items/6568875a3eaaf0c0bde9*/\n  background-color: rgba(255, 255, 255, 0.3);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner-module__GDK__box___bTSpX {\n  background-color: #5c5959;\n  min-width: 192px;\n  max-width: 300px;\n  min-height: 223px;\n  opacity: 0.8;\n\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n}\n\n.spinner-module__GDK__spinnerWrapper___0tEhr {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.spinner-module__GDK__text___4ims- {\n  color: #fff;\n  padding: 0 10px 10px;\n  word-break: break-all;\n}\n\n.spinner-module__GDK__spinner___kzfda {\n  margin-top: 40px;\n  margin-bottom: 10px;\n  width: 88px;\n  height: 88px;\n  border: 4px #5c5959 solid;\n  border-top: 4px #fff solid;\n  border-right: 4px #fff solid;\n  border-bottom: 4px #fff solid;\n  border-radius: 50%;\n  animation: spinner-module__GDK__spinner-animation___EVuBN 1s infinite linear;\n}\n\n@keyframes spinner-module__GDK__spinner-animation___EVuBN {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n";
var styles$w = {"wrapper":"spinner-module__GDK__wrapper___jYcaZ","box":"spinner-module__GDK__box___bTSpX","spinnerWrapper":"spinner-module__GDK__spinnerWrapper___0tEhr","text":"spinner-module__GDK__text___4ims-","spinner":"spinner-module__GDK__spinner___kzfda","spinner-animation":"spinner-module__GDK__spinner-animation___EVuBN"};
styleInject(css_248z$w);

var SpinnerState = /*#__PURE__*/function (_BaseType) {
  function SpinnerState(value, startTime) {
    var _this;
    _classCallCheck(this, SpinnerState);
    _this = _callSuper(this, SpinnerState, [value]);
    _this.startTime = startTime;
    return _this;
  }
  _inherits(SpinnerState, _BaseType);
  return _createClass(SpinnerState, [{
    key: "matchNewState",
    value: function matchNewState(loading, matcher) {
      var newState = loading ? this.getOpenState() : this.getCloseState();
      if (newState === this || this.typeEquals(newState)) {
        return matcher.noChange({
          state: this
        });
      }
      var time = newState.getTimeout();
      if (time) {
        return matcher.newStateWithTime({
          state: newState,
          time: time
        });
      }
      return matcher.newStateWithoutTime({
        state: newState
      });
    }
  }, {
    key: "getOpenState",
    value: function getOpenState() {
      var _this2 = this;
      return this.matchCall({
        hidden: function hidden() {
          return new SpinnerState("first200ms", Date.now());
        },
        first200ms: function first200ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2.newState("show600ms"),
            after600ms: _this2.newState("show")
          });
        },
        show600ms: function show600ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2,
            after600ms: _this2.newState("show")
          });
        },
        hide600ms: function hide600ms() {
          return _this2.matchTime({
            before200ms: _this2,
            before600ms: _this2.newState("show600ms"),
            after600ms: _this2.newState("show")
          });
        },
        show: function show() {
          return _this2;
        }
      });
    }
  }, {
    key: "getCloseState",
    value: function getCloseState() {
      var _this3 = this;
      var closeState = this.matchTime({
        before200ms: this.newHiddenState(),
        before600ms: this.newState("hide600ms"),
        after600ms: this.newHiddenState()
      });
      return this.matchCall({
        hidden: function hidden() {
          return _this3;
        },
        first200ms: function first200ms() {
          return closeState;
        },
        show600ms: function show600ms() {
          return closeState;
        },
        hide600ms: function hide600ms() {
          return closeState;
        },
        show: function show() {
          return _this3.newHiddenState();
        }
      });
    }
  }, {
    key: "newState",
    value: function newState(value) {
      return new SpinnerState(value, this.startTime);
    }
  }, {
    key: "newHiddenState",
    value: function newHiddenState() {
      return new SpinnerState("hidden", 0);
    }
  }, {
    key: "matchTime",
    value: function matchTime(matcher) {
      if (this.getPassedTime() < 200) {
        return matcher.before200ms;
      }
      if (this.getPassedTime() < 200 + 600) {
        return matcher.before600ms;
      }
      return matcher.after600ms;
    }
  }, {
    key: "getTimeout",
    value: function getTimeout() {
      var passed800ms = 200 + 600 - this.getPassedTime();
      var before600ms = this.matchTime({
        before200ms: passed800ms,
        before600ms: passed800ms,
        after600ms: 0
      });
      return this.matchType({
        hidden: 0,
        first200ms: this.matchTime({
          before200ms: 200 - this.getPassedTime(),
          before600ms: passed800ms,
          after600ms: 0
        }),
        show600ms: before600ms,
        hide600ms: before600ms,
        show: 0
      });
    }
  }, {
    key: "getPassedTime",
    value: function getPassedTime() {
      return Date.now() - this.startTime;
    }
  }], [{
    key: "hidden",
    value: function hidden() {
      return new this("hidden", 0);
    }
  }]);
}(BaseType);

var useSpinner = function useSpinner(loading) {
  var _useState = React.useState(SpinnerState.hidden()),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var timeoutCount = React.useRef(0);
  React.useEffect(function () {
    setState(function (state) {
      return state.matchNewState(loading, {
        noChange: function noChange(_ref) {
          var state = _ref.state;
          return state;
        },
        newStateWithTime: function newStateWithTime(_ref2) {
          var state = _ref2.state,
            time = _ref2.time;
          timeoutCount.current = setTimeout(function () {
            setState(function (state) {
              return state.matchNewState(loading, {
                noChange: function noChange(_ref3) {
                  var state = _ref3.state;
                  return state;
                },
                newStateWithTime: function newStateWithTime(_ref4) {
                  var state = _ref4.state;
                  return state;
                },
                newStateWithoutTime: function newStateWithoutTime(_ref5) {
                  var state = _ref5.state;
                  return state;
                }
              });
            });
          }, time);
          return state;
        },
        newStateWithoutTime: function newStateWithoutTime(_ref6) {
          var state = _ref6.state;
          clearTimeout(timeoutCount.current);
          timeoutCount.current = 0;
          return state;
        }
      });
    });
  }, [loading]);
  return {
    isHidden: state.matchType({
      hidden: true,
      first200ms: true,
      show600ms: false,
      hide600ms: false,
      show: false
    })
  };
};

var Spinner = function Spinner(_ref) {
  var loading = _ref.loading,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? "通信中..." : _ref$text;
  var _useSpinner = useSpinner(loading),
    isHidden = _useSpinner.isHidden;
  if (isHidden) {
    return null;
  }
  return React__namespace.createElement(SpinnerInner, {
    text: text
  });
};
// ReactDOM.createPortalを使用して、div="app"の外にコンポーネントを差し込む => https://ja.reactjs.org/docs/portals.html
// 上位のDOMからスタイルを渡されてしまうとDOMが壊れてしまうので、上位のDOM外に差し込む。
var SpinnerInner = function SpinnerInner(_ref2) {
  var text = _ref2.text;
  var dialogRef = React.useRef(null);
  var focusRef = React.useRef(null);
  React.useEffect(function () {
    if (dialogRef.current) {
      dialogPolyfill__default.default.registerDialog(dialogRef.current);
    }
  }, [dialogRef]);
  return ReactDOM__default.default.createPortal(React__namespace.createElement("dialog", {
    ref: dialogRef,
    className: styles$w.wrapper
  }, React__namespace.createElement("div", {
    id: "dialog",
    className: styles$w.box
  }, React__namespace.createElement("div", {
    className: styles$w.spinnerWrapper
  }, React__namespace.createElement("div", {
    className: styles$w.spinner
  }), React__namespace.createElement("p", {
    ref: focusRef,
    className: styles$w.text,
    "aria-live": "polite"
  }, text)))), document.body);
};
var ForTestSpinnerInner = SpinnerInner;

var css_248z$v = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/** bulmaのclass「notification」内でLinkコンポーネントを使用すると、\n    colorが上書きされて効かなくなってしまうため「!important」を指定。 **/\n\n.link-module__GDK__link___Sad6x {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #454ab8 !important;\n  -webkit-text-decoration: underline #454ab8;\n          text-decoration: underline #454ab8;\n  fill: #454ab8;\n  padding: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .link-module__GDK__link___Sad6x {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.link-module__GDK__link___Sad6x:active {\n  color: #1c1e78 !important;\n  -webkit-text-decoration: underline #1c1e78;\n          text-decoration: underline #1c1e78;\n  fill: #1c1e78;\n}\n\n.link-module__GDK__link___Sad6x:hover {\n  color: #3739a2 !important;\n  -webkit-text-decoration: underline #3739a2;\n          text-decoration: underline #3739a2;\n  fill: #3739a2;\n}\n\n.link-module__GDK__link___Sad6x:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n}\n\n.link-module__GDK__externalLinkDisabled___-0czX:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n}\n\n.link-module__GDK__faqLinkDisabled___7K71D:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n}\n\n.link-module__GDK__faqLink___hP5tS:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n}\n\n.link-module__GDK__externalLink___ZcdZ8:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n}\n\n.link-module__GDK__link___Sad6x:visited {\n  color: #7b319a !important;\n  -webkit-text-decoration: underline #7b319a;\n          text-decoration: underline #7b319a;\n  fill: #7b319a;\n}\n\n.link-module__GDK__disabled___bUn9b {\n  pointer-events: none;\n  color: #dcd9d8 !important;\n  -webkit-text-decoration: underline #dcd9d8;\n          text-decoration: underline #dcd9d8;\n  fill: #dcd9d8;\n}\n\n.link-module__GDK__externalLink___ZcdZ8 {\n  padding: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #454ab8 !important;\n  -webkit-text-decoration: underline #454ab8;\n          text-decoration: underline #454ab8;\n  fill: #454ab8;\n}\n\n@media screen and (max-width: 800px) {\n\n  .link-module__GDK__externalLink___ZcdZ8 {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.link-module__GDK__faqLink___hP5tS {\n  padding: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #454ab8 !important;\n  -webkit-text-decoration: underline #454ab8;\n          text-decoration: underline #454ab8;\n  fill: #454ab8;\n}\n\n@media screen and (max-width: 800px) {\n\n  .link-module__GDK__faqLink___hP5tS {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.link-module__GDK__externalLink___ZcdZ8:active {\n  color: #1c1e78 !important;\n  -webkit-text-decoration: underline #1c1e78;\n          text-decoration: underline #1c1e78;\n  fill: #1c1e78;\n}\n\n.link-module__GDK__faqLink___hP5tS:active {\n  color: #1c1e78 !important;\n  -webkit-text-decoration: underline #1c1e78;\n          text-decoration: underline #1c1e78;\n  fill: #1c1e78;\n}\n\n.link-module__GDK__externalLink___ZcdZ8:hover {\n  color: #3739a2 !important;\n  -webkit-text-decoration: underline #3739a2;\n          text-decoration: underline #3739a2;\n  fill: #3739a2;\n}\n\n.link-module__GDK__faqLink___hP5tS:hover {\n  color: #3739a2 !important;\n  -webkit-text-decoration: underline #3739a2;\n          text-decoration: underline #3739a2;\n  fill: #3739a2;\n}\n\n.link-module__GDK__externalLink___ZcdZ8:visited {\n  color: #7b319a !important;\n  -webkit-text-decoration: underline #7b319a;\n          text-decoration: underline #7b319a;\n  fill: #7b319a;\n}\n\n.link-module__GDK__faqLink___hP5tS:visited {\n  color: #7b319a !important;\n  -webkit-text-decoration: underline #7b319a;\n          text-decoration: underline #7b319a;\n  fill: #7b319a;\n}\n\n.link-module__GDK__externalLinkDisabled___-0czX {\n  padding: 8px;\n  pointer-events: none;\n  color: #dcd9d8 !important;\n  -webkit-text-decoration: underline #dcd9d8;\n          text-decoration: underline #dcd9d8;\n  fill: #dcd9d8;\n}\n\n.link-module__GDK__faqLinkDisabled___7K71D {\n  padding: 8px;\n  pointer-events: none;\n  color: #dcd9d8 !important;\n  -webkit-text-decoration: underline #dcd9d8;\n          text-decoration: underline #dcd9d8;\n  fill: #dcd9d8;\n}\n\n.link-module__GDK__externalIcon___0CV9w {\n  display: inline-block;\n  margin-top: 4px;\n  margin-right: 8px;\n  vertical-align: middle;\n  margin-left: 8px;\n}\n\n.link-module__GDK__faqIcon___40FhB {\n  margin-top: 3px;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n.link-module__GDK__faqLink___hP5tS,\n.link-module__GDK__faqLinkDisabled___7K71D {\n  display: flex;\n  padding: 4px 6px 0px;\n}\n";
var styles$v = {"link":"link-module__GDK__link___Sad6x","externalLinkDisabled":"link-module__GDK__externalLinkDisabled___-0czX","faqLinkDisabled":"link-module__GDK__faqLinkDisabled___7K71D","faqLink":"link-module__GDK__faqLink___hP5tS","externalLink":"link-module__GDK__externalLink___ZcdZ8","disabled":"link-module__GDK__disabled___bUn9b","externalIcon":"link-module__GDK__externalIcon___0CV9w","faqIcon":"link-module__GDK__faqIcon___40FhB"};
styleInject(css_248z$v);

var _excluded$s = ["anchor", "children"];
/**
 * AnchorPropsがある場合はAnchorPropsを、ない場合は<></>を使ってchildrenをrenderします。
 *
 * @param AnchorProps
 * @param children
 * @constructor
 */
function Anchor(_ref) {
  var AnchorProps = _ref.anchor,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$s);
  if (AnchorProps) {
    return React__namespace.default.createElement(AnchorProps, _objectSpread2({}, props), children);
  }
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, children);
}

var _excluded$r = ["children", "anchor"],
  _excluded2$c = ["children"],
  _excluded3$5 = ["children"];
/**
 * プレースホルダーリンク
 *
 * 通常リンクとならないですが、リンクと認識する支援技術に対して「使用不能」とラベルに追加することで対応します
 *
 * @see https://www.scottohara.me/note/2019/07/17/placeholder-link.html
 */
var PlaceholderLink = function PlaceholderLink(_ref) {
  var labelWhenDisabled = _ref.labelWhenDisabled,
    children = _ref.children;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    React__namespace.createElement("a", {
      "aria-label": "".concat(labelWhenDisabled, " \u4F7F\u7528\u4E0D\u80FD"),
      className: "".concat(styles$v.disabled, " ").concat(styles$v.link)
    }, children)
  );
};
var Link = function Link(_ref2) {
  var children = _ref2.children,
    anchor = _ref2.anchor,
    props = _objectWithoutProperties(_ref2, _excluded$r);
  if (props.disabled) {
    return React__namespace.createElement(PlaceholderLink, {
      labelWhenDisabled: props.labelWhenDisabled
    }, children);
  }
  return React__namespace.createElement(Anchor, {
    anchor: anchor,
    className: styles$v.link,
    "aria-disabled": props.disabled
  }, children);
};
var ExternalLink = function ExternalLink(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded2$c);
  if (props.disabled) {
    return React__namespace.createElement("a", _objectSpread2(_objectSpread2({}, props), {}, {
      className: "".concat(props.disabled ? styles$v.disabled : "", " ").concat(styles$v.externalLinkDisabled, " "),
      target: "_blank",
      rel: "noreferrer noopener"
    }), children, React__namespace.createElement("span", {
      className: styles$v.externalIcon
    }, React__namespace.createElement(ExternalLinkIcon, {
      alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
      size: 24
    })));
  }
  return React__namespace.createElement("a", _objectSpread2(_objectSpread2({}, props), {}, {
    className: "".concat(props.disabled ? styles$v.disabled : "", " ").concat(styles$v.externalLink, " "),
    target: "_blank",
    rel: "noreferrer noopener"
  }), children, React__namespace.createElement("span", {
    className: styles$v.externalIcon
  }, React__namespace.createElement(ExternalLinkIcon, {
    alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
    size: 24
  })));
};
var FaqLink = function FaqLink(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded3$5);
  if (props.disabled) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      React__namespace.createElement("a", {
        "aria-label": "".concat(props.labelWhenDisabled, " \u4F7F\u7528\u4E0D\u80FD"),
        className: styles$v.faqLinkDisabled
      }, React__namespace.createElement("span", {
        className: styles$v.faqIcon
      }, React__namespace.createElement(FaqIcon, {
        alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
        size: 24
      })), React__namespace.createElement("div", null, children))
    );
  }
  return React__namespace.createElement("a", {
    href: props.href,
    className: styles$v.faqLink,
    target: "_blank",
    rel: "noreferrer noopener"
  }, React__namespace.createElement("span", {
    className: styles$v.faqIcon
  }, React__namespace.createElement(FaqIcon, {
    alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
    size: 24
  })), React__namespace.createElement("div", null, children));
};

var css_248z$u = ".image-encode__GDK__check-background-image___rkviR {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z%22%20fill%3D%22%23237F6D%22%2F%3E%3Cpath%20d%3D%22M14.1605%2022.92L8.14453%2016.6L9.88053%2014.944L14.1765%2019.448L22.8245%2010.48L24.5525%2012.144L14.1605%2022.92Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E\");\n}.image-encode__GDK__fail-background-image___vs8q7 {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z%22%20fill%3D%22%23D53B3A%22%2F%3E%3Cpath%20d%3D%22M14.0488%2023.1599C14.0488%2021.8639%2014.9848%2020.8559%2016.2328%2020.8559C17.4808%2020.8559%2018.4408%2021.8639%2018.4408%2023.1599C18.4408%2024.4559%2017.4808%2025.4639%2016.2328%2025.4639C14.9848%2025.4639%2014.0488%2024.4559%2014.0488%2023.1599ZM14.5768%2010.2239L14.4568%206.88794H18.0088L17.8888%2010.2239L17.3848%2019.0799H15.0808L14.5768%2010.2239Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E\");\n}.image-encode__GDK__down-arrow-background-image___brdJ8 {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFJSURBVHgB7ZK/TsNADMbtJIWVkbG8AZVolBH6BBVTNwpTFVAJvABhY+Ok/lEWBDwFYqF0QSEdYISJjmzASpMcX1NUoRDKbTDkGxyfz/bvYpkoV65c/0KcDjhOo0iRcUqjcFN43pAUhJrxZwl1J6jbStdp3yqiwi7sKhX0ntMAUAUgxwD9Csc1mjPq6Rw9HfCD4NIyTSbmKulctVbKfX8weM4E2DYexSVi/QZDWQTsULTa7q+QT9D1FKRxDf4jYg9fc/aa28Qa12EucJynWO6LTucoq18mZAoql98SEFPNskzyb4N+8gfNHVh2SfIxnBei2BbtrvdTL41mCC8TFMUlDH2IUbhofpBcMJpLgi+fcF8Rre7ZrD5MCppsnN5DehEV9wAsJ4BRVFHZQCVIBuiO3sN11RVXhkxAzgKH4YY0jHMhxCvlyvXn+gDQ0XlO1uNvHgAAAABJRU5ErkJggg==);\n}\n\n:root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.base-select-module__GDK__select___Nu78a {\n  height: 56px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #1d1c1a;\n  padding-left: 16px;\n  padding-right: 16px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 1px solid #706d6c;\n  border-radius: 8px;\n  outline: none;\n  width: 100%;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: right 18.25px bottom 50%;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-select-module__GDK__select___Nu78a {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.base-select-module__GDK__select___Nu78a.base-select-module__GDK__half___iaCCJ {\n  width: 50%;\n}\n\n.base-select-module__GDK__default___m6nq0 {\n  color: #b8b5b4;\n}\n\n.base-select-module__GDK__default___m6nq0.base-select-module__GDK__hasValue___gMixZ {\n  color: #1d1c1a;\n}\n\n.base-select-module__GDK__default___m6nq0:hover {\n  border-color: #3d3b3a;\n}\n\n.base-select-module__GDK__success___-QZBo:hover {\n  border-color: #3d3b3a;\n}\n\n.base-select-module__GDK__default___m6nq0:focus {\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-select-module__GDK__success___-QZBo:focus {\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-select-module__GDK__success___-QZBo.base-select-module__GDK__enabledSuccessState___CGrNV {\n  border-color: #237f6d;\n}\n\n.base-select-module__GDK__success___-QZBo.base-select-module__GDK__enabledSuccessState___CGrNV:hover {\n  border-color: #3dac9a;\n}\n\n.base-select-module__GDK__success___-QZBo.base-select-module__GDK__enabledSuccessState___CGrNV:focus {\n  outline: 0;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-select-module__GDK__fail___3F3OY {\n  background-color: #fff7f8;\n  border-color: #de3226;\n}\n\n.base-select-module__GDK__fail___3F3OY:hover {\n  background-color: #fff7f8;\n  border-color: #f64c41;\n}\n\n.base-select-module__GDK__fail___3F3OY:focus {\n  outline: 0;\n  background-color: #fff7f8;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.base-select-module__GDK__select___Nu78a:disabled {\n  border-color: #faf9f7;\n  background-color: #faf9f7;\n  color: #706d6c;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n/* WiondowのChromeの場合、文字がホワイトアウトしてしまうので明示的に色を指定する */\n\n.base-select-module__GDK__option___Ve7k3 {\n  color: #1d1c1a;\n}\n\n.base-select-module__GDK__empty___u96ch {\n  color: #b8b5b4;\n}\n\n@media screen and (max-width: 800px) {\n  .base-select-module__GDK__select___Nu78a.base-select-module__GDK__half___iaCCJ {\n    width: 100%;\n  }\n}\n";
var styles$u = {"select":"base-select-module__GDK__select___Nu78a image-encode__GDK__down-arrow-background-image___brdJ8","half":"base-select-module__GDK__half___iaCCJ","default":"base-select-module__GDK__default___m6nq0","hasValue":"base-select-module__GDK__hasValue___gMixZ","success":"base-select-module__GDK__success___-QZBo","enabledSuccessState":"base-select-module__GDK__enabledSuccessState___CGrNV","fail":"base-select-module__GDK__fail___3F3OY","option":"base-select-module__GDK__option___Ve7k3","empty":"base-select-module__GDK__empty___u96ch"};
styleInject(css_248z$u);

var _excluded$q = ["value", "formState", "placeholder", "id", "name", "half", "options", "ariaLabel", "descriptionId", "errorMessageId", "blank", "enabledSuccessState", "autoComplete"];
/**
 * セレクトボックスのUIコンポーネント
 */
var BaseSelect = React__namespace.forwardRef(function BaseSelect(_ref, ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    formState = _ref.formState,
    placeholder = _ref.placeholder,
    id = _ref.id,
    name = _ref.name,
    half = _ref.half,
    options = _ref.options,
    ariaLabel = _ref.ariaLabel,
    descriptionId = _ref.descriptionId,
    errorMessageId = _ref.errorMessageId,
    _ref$blank = _ref.blank,
    blank = _ref$blank === void 0 ? false : _ref$blank,
    _ref$enabledSuccessSt = _ref.enabledSuccessState,
    enabledSuccessState = _ref$enabledSuccessSt === void 0 ? false : _ref$enabledSuccessSt,
    autoComplete = _ref.autoComplete,
    props = _objectWithoutProperties(_ref, _excluded$q);
  var _useId = nextId.useId(1, "SelectInput-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var notFailAriaDescribedByValue = getAreaDescribedByValue([descriptionId]);
  var hasSelected = options.some(function (o) {
    return o.selected;
  });
  var successClass = React__namespace.useMemo(function () {
    if (enabledSuccessState) {
      return styles$u.success;
    }
    return !value ? styles$u["default"] : styles$u.success;
  }, [enabledSuccessState, value]);
  return React__namespace.createElement("select", _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    value: value,
    id: htmlId,
    name: name,
    autoComplete: autoComplete,
    className: classNames__default.default(styles$u.select, half ? styles$u.half : "", formState.matchType({
      "default": styles$u["default"],
      disabled: "",
      success: successClass,
      fail: styles$u.fail,
      readOnly: ""
    }), !!value && styles$u.hasValue, enabledSuccessState && styles$u.enabledSuccessState, formState.isFail() && !value ? styles$u.empty : ""),
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true,
      readOnly: false
    }),
    "aria-describedby": formState.matchType({
      "default": notFailAriaDescribedByValue,
      disabled: notFailAriaDescribedByValue,
      success: notFailAriaDescribedByValue,
      fail: getAreaDescribedByValue([descriptionId, errorMessageId]),
      readOnly: notFailAriaDescribedByValue
    }),
    "aria-required": props.required,
    "aria-label": ariaLabel
  }), blank ? React__namespace.createElement("option", {
    value: ""
  }, placeholder) : React__namespace.createElement(React__namespace.Fragment, null, !hasSelected && React__namespace.createElement("option", {
    disabled: true,
    hidden: true,
    value: ""
  }, placeholder)), options.map(function (o) {
    return React__namespace.createElement("option", {
      key: o.value,
      value: o.value,
      className: styles$u.option,
      "aria-label": o["aria-label"]
    }, o.text);
  }));
});

var GrafferSchemasContext = React.createContext({
  id: "",
  descriptionId: "",
  errorMessageId: ""
});
var useGrafferSchemasContext = function useGrafferSchemasContext() {
  var context = React.useContext(GrafferSchemasContext);
  if (context === null) {
    // eslint-disable-next-line no-console
    console.error("GrafferSchemasContextProvider がありません。");
    return {
      id: "",
      descriptionId: "",
      errorMessageId: ""
    };
  }
  return context;
};
/**
 * graffer-schemas関連のコンポーネントで使用するid・descriptionId・errorMessageIdを返却する。
 * @param propsIds propsを通して渡されたid
 */
var useGrafferSchemasIds = function useGrafferSchemasIds(propsIds) {
  var _useGrafferSchemasCon = useGrafferSchemasContext(),
    id = _useGrafferSchemasCon.id,
    descriptionId = _useGrafferSchemasCon.descriptionId,
    errorMessageId = _useGrafferSchemasCon.errorMessageId;
  // GrafferSchemasContextProviderを通じて各idが渡ってきた場合は、そちらを優先する。
  return {
    id: id ? id : propsIds.id,
    descriptionId: descriptionId ? descriptionId : propsIds.descriptionId,
    errorMessageId: errorMessageId ? errorMessageId : propsIds.errorMessageId
  };
};
var GrafferSchemasContextProvider = function GrafferSchemasContextProvider(_ref) {
  var children = _ref.children,
    id = _ref.id,
    descriptionId = _ref.descriptionId,
    errorMessageId = _ref.errorMessageId;
  return React__namespace.createElement(GrafferSchemasContext.Provider, {
    value: {
      id: id,
      descriptionId: descriptionId,
      errorMessageId: errorMessageId
    }
  }, children);
};

var _excluded$p = ["touched", "isValid", "disabled", "placeholder", "noValidate", "blank"];
/**
 *
 * graffer-generator用のセレクトボックスコンポーネント（isValid,touched）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasSelectComponent = React__namespace.forwardRef(function SelectComponent(_ref, ref) {
  var touched = _ref.touched,
    isValid = _ref.isValid,
    disabled = _ref.disabled,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    _ref$noValidate = _ref.noValidate,
    noValidate = _ref$noValidate === void 0 ? false : _ref$noValidate,
    _ref$blank = _ref.blank,
    blank = _ref$blank === void 0 ? true : _ref$blank,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: props.id,
      descriptionId: props.descriptionId,
      errorMessageId: props.errorMessageId
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  var formState = FormState.create(touched, isValid, noValidate, disabled, undefined, undefined);
  return React__namespace.createElement(BaseSelect, _objectSpread2(_objectSpread2({
    placeholder: placeholder,
    disabled: disabled,
    formState: formState,
    ref: ref,
    blank: blank
  }, props), {}, {
    id: id,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId
  }));
});
/**
 * セレクトコンポーネント
 * @param param0
 * @returns
 */
var Select = function Select(_ref2) {
  var name = _ref2.name,
    _ref2$half = _ref2.half,
    half = _ref2$half === void 0 ? false : _ref2$half,
    options = _ref2.options,
    onChange = _ref2.onChange,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? "" : _ref2$value,
    onFocus = _ref2.onFocus,
    onBlur = _ref2.onBlur,
    disabled = _ref2.disabled,
    formState = _ref2.formState,
    id = _ref2.id,
    placeholder = _ref2.placeholder,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    descriptionId = _ref2.descriptionId,
    errorMessageId = _ref2.errorMessageId,
    ariaLabel = _ref2.ariaLabel,
    autoComplete = _ref2.autoComplete;
  var selectRef = React.useRef(null);
  var handleChange = React.useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  return React__namespace.createElement(BaseSelect, {
    id: id,
    half: half,
    name: name,
    ref: selectRef,
    placeholder: placeholder,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    formState: formState,
    value: value,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled,
    required: required,
    options: options,
    ariaLabel: ariaLabel,
    autoComplete: autoComplete
  });
};

var css_248z$t = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.file-upload-module__GDK__singleNormalFile___Yw4Rn {\n  align-items: stretch;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  align-items: center;\n  border: 1px solid transparent;\n  box-shadow: none;\n  display: inline-flex;\n  height: 2.5em;\n  justify-content: flex-start;\n  line-height: 1.5;\n  padding-bottom: calc(0.5em - 1px);\n  padding-top: calc(0.5em - 1px);\n  position: relative;\n  vertical-align: top;\n  border-color: #dbdbdb;\n  border-radius: 4px;\n  font-size: 1em;\n  padding-left: 1em;\n  padding-right: 1em;\n  white-space: nowrap;\n  color: #4a4a4a;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__default___tevTR {\n  background-color: #fff;\n  border: 1px solid #706d6c;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__success___qnIkG {\n  background-color: #fff;\n  border: 1px solid #706d6c;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__loading___Wy3Om {\n  background-color: #fff;\n  border: 1px solid #706d6c;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__default___tevTR:hover {\n  background-color: #fff;\n  border: 1px solid #3d3b3a;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__success___qnIkG:hover {\n  background-color: #fff;\n  border: 1px solid #3d3b3a;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__loading___Wy3Om:hover {\n  background-color: #fff;\n  border: 1px solid #3d3b3a;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__default___tevTR:active {\n  border: 1px solid #454ab8;\n  background-color: #dcd9d8;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__success___qnIkG:active {\n  border: 1px solid #454ab8;\n  background-color: #dcd9d8;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__fail___nQPXR {\n  border: 1px solid #d53b3a;\n  background-color: #fff7f8;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__fail___nQPXR:hover {\n  border: 1px solid #b42828;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  background-color: #fff7f8;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__fail___nQPXR:active {\n  border: 1px solid #d53b3a;\n  background-color: #fff7f8;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__disabled___weZkP {\n  color: #b8b5b4;\n  background: #faf9f7;\n  border: none;\n  pointer-events: none;\n}\n\n.file-upload-module__GDK__link___2crD8 {\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  align-items: center;\n  color: #454ab8;\n  fill: #454ab8;\n  margin-right: 16px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .file-upload-module__GDK__link___2crD8 {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.file-upload-module__GDK__link___2crD8:focus {\n  outline: 1px solid #454ab8;\n}\n\n.file-upload-module__GDK__link___2crD8:hover {\n  color: #3739a2;\n}\n\n.file-upload-module__GDK__linkText___UpTib {\n  text-align: left;\n  word-break: break-all;\n}\n\n.file-upload-module__GDK__failLinkText___7wKoA {\n  margin-left: 8px;\n  margin-right: 16px;\n  text-align: left;\n}\n\n.file-upload-module__GDK__defaultLink___3xoVX {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  text-decoration: underline;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.file-upload-module__GDK__loadingLink___YVWox {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  pointer-events: none;\n  margin-left: 5px;\n  margin-right: 20px;\n}\n\n.file-upload-module__GDK__failLink___DgNeo {\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  text-decoration: none;\n  color: #8e1b19;\n  text-align: left;\n}\n\n@media screen and (max-width: 800px) {\n\n  .file-upload-module__GDK__failLink___DgNeo {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.file-upload-module__GDK__spinner___jyCSN {\n  width: 24px;\n  height: 24px;\n  border: 2px #454ab8 solid;\n  border-top: 2px rgba(61, 67, 202, 0.1) solid;\n  border-radius: 50%;\n  animation: file-upload-module__GDK__spinner-animation___zNfWO 1s infinite linear;\n  flex-shrink: 0;\n}\n\n.file-upload-module__GDK__fileWrapper___H9E6U {\n  margin-top: 16px;\n}\n\n.file-upload-module__GDK__file___dOMPq {\n  margin-top: 0px;\n  align-items: center;\n  display: flex;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG {\n  border-radius: 8px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .file-upload-module__GDK__fileCta___mP1XG {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.file-upload-module__GDK__fileIcon___Li-Po {\n  width: 32px;\n  margin-right: 16px;\n  vertical-align: middle;\n  color: #454ab8;\n  align-items: center;\n  display: flex;\n  height: 1em;\n  justify-content: center;\n  font-style: inherit;\n  font-weight: inherit;\n}\n\n.file-upload-module__GDK__fileLabel___kU-Or {\n  align-items: stretch;\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  overflow: hidden;\n  position: relative;\n}\n\n.file-upload-module__GDK__fileInput___E2mUC {\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  outline: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  font-family:\n    BlinkMacSystemFont,\n    -apple-system,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    \"Helvetica\",\n    \"Arial\",\n    sans-serif;\n}\n\n.file-upload-module__GDK__fileCta___mP1XG.file-upload-module__GDK__fail___nQPXR .file-upload-module__GDK__fileIcon___Li-Po {\n  color: #d53b3a;\n}\n\n.file-upload-module__GDK__disabled___weZkP .file-upload-module__GDK__fileIcon___Li-Po {\n  color: #b8b5b4;\n}\n\n.file-upload-module__GDK__disabledText___MErqG {\n  color: #706d6c;\n}\n\n.file-upload-module__GDK__externalLinkIcon___uyVr8 {\n  margin-left: 8px;\n  vertical-align: middle;\n  display: inline-flex;\n  align-items: center;\n}\n\n.file-upload-module__GDK__errorIcon___p13Sn {\n  padding-top: 8px;\n}\n\n.file-upload-module__GDK__trashArea___IwnDv {\n  align-self: center;\n  white-space: nowrap;\n}\n\n.file-upload-module__GDK__fileText___5TBwD {\n  padding-left: 8px;\n}\n\n@keyframes file-upload-module__GDK__spinner-animation___zNfWO {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .file-upload-module__GDK__defaultLink___3xoVX {\n    margin-right: 0px;\n  }\n  .file-upload-module__GDK__failLinkText___7wKoA {\n    margin-right: 0px;\n  }\n  .file-upload-module__GDK__file___dOMPq {\n    margin-top: 8px;\n  }\n  .file-upload-module__GDK__fileLabel___kU-Or {\n    width: 100%;\n  }\n  .file-upload-module__GDK__fileCta___mP1XG {\n    width: 100%;\n    height: 48px;\n  }\n  .file-upload-module__GDK__errorIcon___p13Sn {\n    padding-top: 3px;\n    align-self: start;\n  }\n}\n\n.file-upload-module__GDK__fileLabel___kU-Or:focus-within {\n  border-radius: 8px;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.file-upload-module__GDK__fileLabel___kU-Or:focus-within .file-upload-module__GDK__fileCta___mP1XG {\n  border: 1px solid #454ab8;\n}\n";
var styles$t = {"singleNormalFile":"file-upload-module__GDK__singleNormalFile___Yw4Rn","fileCta":"file-upload-module__GDK__fileCta___mP1XG","default":"file-upload-module__GDK__default___tevTR","success":"file-upload-module__GDK__success___qnIkG","loading":"file-upload-module__GDK__loading___Wy3Om","fail":"file-upload-module__GDK__fail___nQPXR","disabled":"file-upload-module__GDK__disabled___weZkP","link":"file-upload-module__GDK__link___2crD8","linkText":"file-upload-module__GDK__linkText___UpTib","failLinkText":"file-upload-module__GDK__failLinkText___7wKoA","defaultLink":"file-upload-module__GDK__defaultLink___3xoVX","loadingLink":"file-upload-module__GDK__loadingLink___YVWox","failLink":"file-upload-module__GDK__failLink___DgNeo","spinner":"file-upload-module__GDK__spinner___jyCSN","spinner-animation":"file-upload-module__GDK__spinner-animation___zNfWO","fileWrapper":"file-upload-module__GDK__fileWrapper___H9E6U","file":"file-upload-module__GDK__file___dOMPq","fileIcon":"file-upload-module__GDK__fileIcon___Li-Po","fileLabel":"file-upload-module__GDK__fileLabel___kU-Or","fileInput":"file-upload-module__GDK__fileInput___E2mUC","disabledText":"file-upload-module__GDK__disabledText___MErqG","externalLinkIcon":"file-upload-module__GDK__externalLinkIcon___uyVr8","errorIcon":"file-upload-module__GDK__errorIcon___p13Sn","trashArea":"file-upload-module__GDK__trashArea___IwnDv","fileText":"file-upload-module__GDK__fileText___5TBwD"};
styleInject(css_248z$t);

var css_248z$s = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.dialog-module__GDK__dialog___Vl4Hl {\n  top: 0;\n  /* 背景だけ透過させたい時にはrgbaを使用する => https://qiita.com/ritukiii/items/6568875a3eaaf0c0bde9*/\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  border: none;\n  border-radius: 6px;\n  padding: 0px;\n  background-color: #fff;\n  border: 1px solid #dcd9d8;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);\n  border-radius: 6px;\n  width: 640px;\n\n  /* For Polyfill */\n  position: fixed;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n/* For Native */\n\n.dialog-module__GDK__dialog___Vl4Hl::backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n/* For Polyfill */\n\n.dialog-module__GDK__dialog___Vl4Hl + .dialog-module__GDK__backdrop___O3foI {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.dialog-module__GDK__header___8l-dh {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font: bold 24px/42px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 24px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .dialog-module__GDK__header___8l-dh {\n  font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.dialog-module__GDK__title___M2VLa {\n  font-weight: bold;\n  word-break: break-all;\n  font: bold 24px/42px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .dialog-module__GDK__title___M2VLa {\n  font: bold 20px/35px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.dialog-module__GDK__titleWrapper___TK7ni {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 16px;\n}\n\n.dialog-module__GDK__box___EP2pZ {\n  width: 100%;\n  padding: 32px;\n}\n\n.dialog-module__GDK__icon___Y9Tit {\n  margin-right: 8px;\n  display: flex;\n  align-content: center;\n}\n\n.dialog-module__GDK__contents___itsQ1 {\n  margin-bottom: 24px;\n}\n\n.dialog-module__GDK__dialogButtons___mlz30 {\n  display: flex;\n  justify-content: center;\n}\n\n.dialog-module__GDK__button___T9ldT:not(:last-child) {\n  margin-right: 40px;\n}\n\n@media screen and (max-width: 800px) {\n  .dialog-module__GDK__dialog___Vl4Hl {\n    width: auto;\n  }\n  .dialog-module__GDK__dialogButtons___mlz30 {\n    flex-direction: column-reverse;\n  }\n  .dialog-module__GDK__button___T9ldT {\n    margin: 0 0 16px 0;\n  }\n  .dialog-module__GDK__box___EP2pZ {\n    padding: 16px;\n  }\n  .dialog-module__GDK__button___T9ldT:not(:last-child) {\n    margin-right: 0px;\n  }\n}\n";
var styles$s = {"dialog":"dialog-module__GDK__dialog___Vl4Hl","backdrop":"dialog-module__GDK__backdrop___O3foI","header":"dialog-module__GDK__header___8l-dh","title":"dialog-module__GDK__title___M2VLa","titleWrapper":"dialog-module__GDK__titleWrapper___TK7ni","box":"dialog-module__GDK__box___EP2pZ","icon":"dialog-module__GDK__icon___Y9Tit","contents":"dialog-module__GDK__contents___itsQ1","dialogButtons":"dialog-module__GDK__dialogButtons___mlz30","button":"dialog-module__GDK__button___T9ldT"};
styleInject(css_248z$s);

var useDialog = function useDialog(onClose) {
  var dialogRef = React.useRef(null);
  //モーダルを開いた際のscroll位置を保持
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var _useFixedScroll = useFixedScroll(),
    applyFixedScroll = _useFixedScroll.applyFixedScroll,
    removeFixedScroll = _useFixedScroll.removeFixedScroll;
  var handleKeyPress = React.useCallback(function (e) {
    if (e.key === "Escape") {
      onClose();
    }
  }, [onClose]);
  React.useEffect(function () {
    var scrollPosition = window.pageYOffset;
    setScrollPosition(scrollPosition);
    // scrollを固定
    applyFixedScroll(scrollPosition);
    return function () {
      // scrollを削除
      removeFixedScroll(scrollPosition);
    };
  }, [applyFixedScroll, removeFixedScroll]);
  React.useEffect(function () {
    if (dialogRef.current) {
      dialogRef.current.removeAttribute("open");
      dialogPolyfill__default.default.registerDialog(dialogRef.current);
      dialogRef.current.showModal();
    }
  }, [dialogRef]);
  React.useEffect(function () {
    if (dialogRef.current) {
      document.addEventListener("keyup", handleKeyPress);
    }
    return function cleanup() {
      document.removeEventListener("keyup", handleKeyPress);
    };
  }, [dialogRef, handleKeyPress]);
  var closeDialog = React.useCallback(function () {
    if (dialogRef.current) {
      dialogRef.current.close();
      onClose();
      // scroll固定を削除
      removeFixedScroll(scrollPosition);
    }
  }, [onClose, removeFixedScroll, scrollPosition]);
  return {
    dialogRef: dialogRef,
    closeDialog: closeDialog
  };
};

var css_248z$r = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.button-group-module__GDK__ButtonGroupPc___ldnNA {\n  display: flex;\n  justify-content: center;\n}\n\n.button-group-module__GDK__secondaryButtonPc___winoV {\n  margin-right: 40px;\n}\n\n.button-group-module__GDK__primaryButtonSp___ufPU6 {\n  margin-bottom: 16px;\n}\n";
var styles$r = {"ButtonGroupPc":"button-group-module__GDK__ButtonGroupPc___ldnNA","secondaryButtonPc":"button-group-module__GDK__secondaryButtonPc___winoV","primaryButtonSp":"button-group-module__GDK__primaryButtonSp___ufPU6"};
styleInject(css_248z$r);

var buttons = {
  Primary: PrimaryButton,
  Secondary: SecondaryButton,
  Danger: DangerButton,
  DangerSecondary: DangerSecondaryButton
};
/**
 * primaryに渡したボタンはPCでは右側、SPでは上側に表示されます。
 * 画面の上部からからフォーカスを移動すると、PCでは左（secondary）→ 右（primary）、SPでは上（primary）→ 下（secondary）、のボタン順にフォーカスが当たります。
 */
var ButtonGroup = function ButtonGroup(props) {
  var primary = props.primary,
    secondary = props.secondary;
  var primaryButtonType = primary.buttonType,
    primaryButtonProps = primary.buttonProps;
  var secondaryButtonType = secondary.buttonType,
    secondaryButtonProps = secondary.buttonProps;
  var PrimaryButton = buttons[primaryButtonType];
  var SecondaryButton = buttons[secondaryButtonType];
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return isPc ? React__namespace.createElement("div", {
    className: styles$r.ButtonGroupPc
  }, React__namespace.createElement("div", {
    className: styles$r.secondaryButtonPc
  }, React__namespace.createElement(SecondaryButton, _objectSpread2({}, secondaryButtonProps))), React__namespace.createElement("div", null, React__namespace.createElement(PrimaryButton, _objectSpread2({}, primaryButtonProps)))) : React__namespace.createElement("div", null, React__namespace.createElement("div", {
    className: styles$r.primaryButtonSp
  }, React__namespace.createElement(PrimaryButton, _objectSpread2({}, primaryButtonProps))), React__namespace.createElement("div", null, React__namespace.createElement(SecondaryButton, _objectSpread2({}, secondaryButtonProps))));
};

var _excluded$o = ["proceedDisabled", "onProceed"],
  _excluded2$b = ["proceedDisabled", "onProceed"],
  _excluded3$4 = ["proceedDisabled", "onProceed"];
var BaseDialog = React__namespace.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    contents = _ref.contents,
    title = _ref.title,
    children = _ref.children,
    onCancel = _ref.onCancel;
  var _useId = nextId.useId(1, "dialog-header-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    dialogHeaderId = _useId2[0];
  var stopPropagation = React.useCallback(function (e) {
    e.stopPropagation();
  }, []);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return ReactDOM__default.default.createPortal(
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
  React__namespace.createElement("dialog", {
    className: styles$s.dialog,
    ref: ref,
    "aria-modal": "true",
    "aria-labelledby": dialogHeaderId,
    onClick: onCancel
  }, React__namespace.createElement("div", {
    id: "dialog",
    className: styles$s.box,
    tabIndex: -1,
    onClick: stopPropagation
  }, React__namespace.createElement("div", {
    className: styles$s.header
  }, React__namespace.createElement("div", {
    className: styles$s.titleWrapper
  }, icon && React__namespace.createElement("span", {
    "aria-hidden": true,
    className: styles$s.icon
  }, icon), React__namespace.createElement("h1", {
    className: styles$s.title,
    id: dialogHeaderId
  }, title)), React__namespace.createElement(CancelButton, {
    onCancel: onCancel,
    iconSize: isPc ? 40 : 24,
    className: styles$s.cancelIcon,
    ariaLabel: "\u30C0\u30A4\u30A2\u30ED\u30B0\u3092\u9589\u3058\u308B"
  })), React__namespace.createElement("div", {
    className: styles$s.contents
  }, contents), children)), document.body);
});
BaseDialog.displayName = "BaseDialog";
var DefaultDialog = function DefaultDialog(_ref2) {
  var _ref2$proceedDisabled = _ref2.proceedDisabled,
    proceedDisabled = _ref2$proceedDisabled === void 0 ? false : _ref2$proceedDisabled,
    onProceed = _ref2.onProceed,
    props = _objectWithoutProperties(_ref2, _excluded$o);
  var _useDialog = useDialog(props.onCancel),
    dialogRef = _useDialog.dialogRef,
    closeDialog = _useDialog.closeDialog;
  var handleOnProceed = React.useCallback(function () {
    onProceed();
    closeDialog();
  }, [closeDialog, onProceed]);
  return React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    onCancel: closeDialog,
    ref: dialogRef
  }), React__namespace.createElement(ButtonGroup, {
    primary: {
      buttonType: "Primary",
      buttonProps: {
        text: props.proceedText,
        onClick: handleOnProceed,
        disabled: proceedDisabled
      }
    },
    secondary: {
      buttonType: "Secondary",
      buttonProps: {
        type: "button",
        text: props.cancelText,
        onClick: closeDialog
      }
    }
  }));
};
var MessageDialog = function MessageDialog(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  var _useDialog2 = useDialog(props.onCancel),
    dialogRef = _useDialog2.dialogRef,
    closeDialog = _useDialog2.closeDialog;
  return React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: dialogRef,
    onCancel: closeDialog
  }), React__namespace.createElement("div", {
    className: styles$s.dialogButtons
  }, React__namespace.createElement(SecondaryButton, {
    text: props.cancelText,
    onClick: closeDialog
  })));
};
var WarningDialog = function WarningDialog(_ref4) {
  var _ref4$proceedDisabled = _ref4.proceedDisabled,
    proceedDisabled = _ref4$proceedDisabled === void 0 ? false : _ref4$proceedDisabled,
    onProceed = _ref4.onProceed,
    props = _objectWithoutProperties(_ref4, _excluded2$b);
  var _useDialog3 = useDialog(props.onCancel),
    dialogRef = _useDialog3.dialogRef,
    closeDialog = _useDialog3.closeDialog;
  var handleOnProceed = React.useCallback(function () {
    onProceed();
    closeDialog();
  }, [closeDialog, onProceed]);
  return React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    onCancel: closeDialog,
    icon: React__namespace.createElement(WarningIcon, {
      size: 40
    }),
    ref: dialogRef
  }), React__namespace.createElement(ButtonGroup, {
    primary: {
      buttonType: "Primary",
      buttonProps: {
        text: props.proceedText,
        onClick: handleOnProceed,
        disabled: proceedDisabled
      }
    },
    secondary: {
      buttonType: "Secondary",
      buttonProps: {
        text: props.cancelText,
        onClick: closeDialog
      }
    }
  }));
};
var ErrorDialog = function ErrorDialog(_ref5) {
  var _ref5$proceedDisabled = _ref5.proceedDisabled,
    proceedDisabled = _ref5$proceedDisabled === void 0 ? false : _ref5$proceedDisabled,
    onProceed = _ref5.onProceed,
    props = _objectWithoutProperties(_ref5, _excluded3$4);
  var _useDialog4 = useDialog(props.onCancel),
    dialogRef = _useDialog4.dialogRef,
    closeDialog = _useDialog4.closeDialog;
  var handleOnProceed = React.useCallback(function () {
    onProceed();
    closeDialog();
  }, [closeDialog, onProceed]);
  return React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    onCancel: closeDialog,
    icon: React__namespace.createElement(AttentionIcon, {
      size: 40
    }),
    ref: dialogRef
  }), React__namespace.createElement(ButtonGroup, {
    primary: {
      buttonType: "Danger",
      buttonProps: {
        text: props.proceedText,
        onClick: handleOnProceed,
        disabled: proceedDisabled
      }
    },
    secondary: {
      buttonType: "DangerSecondary",
      buttonProps: {
        text: props.cancelText,
        onClick: closeDialog
      }
    }
  }));
};
/*
 * graffer-uiのModalからの移行用Dialogコンポーネント。
 * graffer-uiのModalからの移行のために使用するため、新規での使用は行わない
 *
 * @deprecated
 */
var GrafferUiModalDialog = function GrafferUiModalDialog(_ref6) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref6), _ref6));
  var _useDialog5 = useDialog(props.onCancel),
    dialogRef = _useDialog5.dialogRef,
    closeDialog = _useDialog5.closeDialog;
  return React__namespace.createElement(BaseDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: dialogRef,
    onCancel: closeDialog
  }));
};

var css_248z$q = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.preview-module__GDK__previewWrapper___cp69f {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.preview-module__GDK__buttons___OZCki {\n  display: inline-flex;\n  align-items: center;\n}\n\n.preview-module__GDK__trashArea___3p22T {\n  align-self: center;\n  white-space: nowrap;\n}\n\n.preview-module__GDK__previewText___plocb {\n  padding: 8px;\n  display: inline-flex;\n  align-items: center;\n  word-break: break-all;\n}\n\n.preview-module__GDK__previewImage___Dka7S {\n  -o-object-fit: contain;\n     object-fit: contain;\n  width: 311px;\n  height: 355px;\n}\n";
var styles$q = {"previewWrapper":"preview-module__GDK__previewWrapper___cp69f","buttons":"preview-module__GDK__buttons___OZCki","trashArea":"preview-module__GDK__trashArea___3p22T","previewText":"preview-module__GDK__previewText___plocb","previewImage":"preview-module__GDK__previewImage___Dka7S"};
styleInject(css_248z$q);

var useModal = function useModal() {
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var open = React.useCallback(function () {
    return setIsOpen(true);
  }, []);
  var close = React.useCallback(function () {
    return setIsOpen(false);
  }, []);
  return [isOpen, open, close];
};

var css_248z$p = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/* 見た目は見えないが、スクリーンリーダーでは読み上げられる。 */\n\n.file-uploaded-text-module__GDK__visuallyHidden___bUjV6 {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  border: 0;\n  padding: 0;\n  white-space: nowrap;\n  clip-path: inset(100%);\n  clip: rect(0 0 0 0);\n  overflow: hidden;\n}\n";
var styles$p = {"visuallyHidden":"file-uploaded-text-module__GDK__visuallyHidden___bUjV6"};
styleInject(css_248z$p);

var FileUploadedText = function FileUploadedText() {
  return React__namespace.createElement("span", {
    className: styles$p.visuallyHidden
  }, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u6E08\u307F");
};

var Preview = function Preview(_ref) {
  var _ref$previewUrl = _ref.previewUrl,
    previewUrl = _ref$previewUrl === void 0 ? "" : _ref$previewUrl,
    _ref$fileName = _ref.fileName,
    fileName = _ref$fileName === void 0 ? "" : _ref$fileName,
    mimeType = _ref.mimeType,
    onDeleteModalOpen = _ref.onDeleteModalOpen,
    uploadedTextRef = _ref.uploadedTextRef;
  var _useModal = useModal(),
    _useModal2 = _slicedToArray(_useModal, 3),
    openPreview = _useModal2[0],
    open = _useModal2[1],
    close = _useModal2[2];
  var isImage = React.useMemo(function () {
    if (!mimeType) return false;
    return mimeType.match(/^image/);
  }, [mimeType]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
    className: styles$q.previewWrapper
  }, React__namespace.createElement("p", {
    className: styles$q.previewText,
    ref: uploadedTextRef,
    tabIndex: -1
  }, React__namespace.createElement(FileUploadedText, null), React__namespace.createElement("span", null, fileName)), React__namespace.createElement("p", {
    className: styles$q.buttons
  }, isImage && React__namespace.createElement("span", {
    className: styles$q.previewIcon
  }, React__namespace.createElement(TextButton, {
    text: "",
    icon: "OpenEyeIcon",
    onClick: open,
    disabled: !previewUrl && !fileName,
    "aria-label": "\u30D7\u30EC\u30D3\u30E5\u30FC"
  })), React__namespace.createElement("span", {
    className: styles$q.trashArea
  }, React__namespace.createElement(TextButton, {
    text: "",
    icon: "TrashIcon",
    onClick: onDeleteModalOpen,
    "aria-label": "\u524A\u9664"
  })))), openPreview && React__namespace.createElement(MessageDialog, {
    title: fileName,
    cancelText: "閉じる",
    onCancel: close,
    contents: React__namespace.createElement("img", {
      className: styles$q.previewImage,
      alt: fileName,
      decoding: "async",
      width: 311,
      height: 351,
      src: previewUrl
    })
  }));
};

var FileWrapper = function FileWrapper(_ref) {
  var children = _ref.children;
  return React__namespace.createElement("div", {
    className: styles$t.fileWrapper
  }, React__namespace.createElement("div", {
    className: styles$t.file
  }, children));
};
var BaseFileUploadedItemComponent = function BaseFileUploadedItemComponent(_ref2) {
  var onClickFile = _ref2.onClickFile,
    fileName = _ref2.fileName,
    fileState = _ref2.fileState,
    onClear = _ref2.onClear,
    previewUrl = _ref2.previewUrl,
    mimeType = _ref2.mimeType,
    touched = _ref2.touched;
  var buttonRef = React.useRef(null);
  var uploadedTextRef = React.useRef(null);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  React.useEffect(function () {
    var _a, _b;
    // アクセシビリティ対応：ファイルがアップロードされた際に読み上げられるようにフォーカスを当てる
    if (touched && fileState.equals("success")) {
      isPc ? (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus() : (_b = uploadedTextRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
  }, [touched, fileState, isPc]);
  var _useModal = useModal(),
    _useModal2 = _slicedToArray(_useModal, 3),
    showDeleteDialog = _useModal2[0],
    open = _useModal2[1],
    close = _useModal2[2];
  var handleOnDelete = React__namespace.useCallback(function () {
    close();
    onClear();
  }, [close, onClear]);
  if (!fileName) {
    return !!fileState && fileState.equals("loading") ? React__namespace.createElement(FileWrapper, null, React__namespace.createElement("div", {
      className: styles$t.spinner
    })) : null;
  }
  return React__namespace.createElement(FileWrapper, null, fileState.matchType({
    "default": null,
    disabled: React__namespace.createElement(React__namespace.Fragment, null, isPc ? React__namespace.createElement("button", {
      className: "".concat(styles$t.defaultLink, " ").concat(styles$t.link),
      onClick: onClickFile,
      "aria-live": "polite"
    }, React__namespace.createElement("span", {
      className: styles$t.linkText
    }, fileName, React__namespace.createElement("span", {
      className: styles$t.externalLinkIcon
    }, React__namespace.createElement(ExternalLinkIcon, {
      alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
      size: 24
    })))) : React__namespace.createElement(Preview, {
      fileName: fileName,
      previewUrl: previewUrl,
      onDeleteModalOpen: open,
      mimeType: mimeType
    })),
    success: React__namespace.createElement(React__namespace.Fragment, null, isPc ? React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("button", {
      className: "".concat(styles$t.defaultLink, " ").concat(styles$t.link),
      onClick: onClickFile,
      disabled: !isPc,
      ref: buttonRef
    }, React__namespace.createElement(FileUploadedText, null), React__namespace.createElement("span", {
      className: styles$t.linkText
    }, fileName, React__namespace.createElement("span", {
      className: styles$t.externalLinkIcon
    }, React__namespace.createElement(ExternalLinkIcon, {
      alt: "\u5225\u30BF\u30D6\u3067\u958B\u304F",
      size: 24
    })))), React__namespace.createElement("span", {
      className: styles$t.trashArea
    }, React__namespace.createElement(TextButton, {
      text: "削除",
      icon: "TrashIcon",
      onClick: open
    }))) : React__namespace.createElement(Preview, {
      fileName: fileName,
      previewUrl: previewUrl,
      onDeleteModalOpen: open,
      mimeType: mimeType,
      uploadedTextRef: uploadedTextRef
    })),
    fail: React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("button", {
      className: "".concat(styles$t.defaultLink, " ").concat(styles$t.failLink),
      "aria-live": "polite"
    }, React__namespace.createElement("span", {
      className: styles$t.errorIcon
    }, React__namespace.createElement(AttentionIcon, {
      size: 24
    })), React__namespace.createElement("span", {
      className: styles$t.failLinkText
    }, fileName)), React__namespace.createElement("span", {
      className: styles$t.trashArea
    }, React__namespace.createElement(TextButton, {
      text: "削除",
      icon: "TrashIcon",
      onClick: open
    }))),
    loading: React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
      className: styles$t.spinner
    }), React__namespace.createElement("span", {
      className: styles$t.linkText
    }, fileName))
  }), showDeleteDialog && React__namespace.createElement(ErrorDialog, {
    title: "削除しますか？",
    onCancel: close,
    contents: "この添付ファイルを削除しますか？",
    onProceed: handleOnDelete,
    cancelText: "削除しない",
    proceedText: "削除する"
  }));
};
var FileUploadedItem = function FileUploadedItem(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  var _a, _b;
  var _useState = React.useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    previewUrl = _useState2[0],
    setPreviewUrl = _useState2[1];
  var onClickFile = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$props$file$ope, _yield$props$file$ope2, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (props.file) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.next = 4;
          return props.file.openDataURIContent();
        case 4:
          _yield$props$file$ope = _context.sent;
          _yield$props$file$ope2 = _slicedToArray(_yield$props$file$ope, 1);
          error = _yield$props$file$ope2[0];
          if (error) {
            alert("ファイルの表示に失敗しました。ファイルを削除して、再度ファイルをアップロードしてください。");
          }
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [props.file]);
  React.useEffect(function () {
    var set = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (props.file) {
                _context2.next = 3;
                break;
              }
              setPreviewUrl("");
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return props.file.getUrl();
            case 5:
              result = _context2.sent;
              result && setPreviewUrl(result.objURL);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function set() {
        return _ref5.apply(this, arguments);
      };
    }();
    set();
  }, [props.file]);
  return React__namespace.createElement(BaseFileUploadedItemComponent, _objectSpread2({
    fileName: (_a = props === null || props === void 0 ? void 0 : props.file) === null || _a === void 0 ? void 0 : _a.getName(),
    onClickFile: onClickFile,
    previewUrl: previewUrl,
    mimeType: (_b = props.file) === null || _b === void 0 ? void 0 : _b.getMimeType()
  }, props));
};

var FileUploadState = /*#__PURE__*/function (_BaseType) {
  function FileUploadState() {
    _classCallCheck(this, FileUploadState);
    return _callSuper(this, FileUploadState, arguments);
  }
  _inherits(FileUploadState, _BaseType);
  return _createClass(FileUploadState, [{
    key: "matchType",
    value: function matchType(matcher) {
      return matcher[this.value];
    }
  }], [{
    key: "create",
    value: function create(isFileRead, state, errorMessage) {
      if (state === "disabled") {
        return new FileUploadState("disabled");
      }
      if (state === "loading") {
        return new FileUploadState("loading");
      }
      if (errorMessage || state === "apiError") {
        return new FileUploadState("fail");
      }
      if (state === "apiError" && isFileRead) {
        return new FileUploadState("fail");
      }
      if (!state && isFileRead) {
        return new FileUploadState("success");
      }
      return new FileUploadState("default");
    }
  }]);
}(BaseType);

var HandleFile = /*#__PURE__*/function (_BaseType) {
  function HandleFile() {
    _classCallCheck(this, HandleFile);
    return _callSuper(this, HandleFile, arguments);
  }
  _inherits(HandleFile, _BaseType);
  return _createClass(HandleFile, null, [{
    key: "create",
    value: function create(event, acceptMimeTypes, maxFileSize) {
      if (!event.target.files || !event.target.files.length) {
        return new HandleFile("readError");
      }
      var file = event.target.files[0];
      if (file.size / 1024 / 1024 > maxFileSize) {
        return new HandleFile("invalidSize");
      }
      var isValidType = acceptMimeTypes.includes(file.type);
      if (!isValidType) {
        return new HandleFile("invalidType");
      }
      return new HandleFile("success");
    }
  }]);
}(BaseType);

var SelectedFile = /*#__PURE__*/function () {
  function SelectedFile(file) {
    _classCallCheck(this, SelectedFile);
    this.file = file;
  }
  return _createClass(SelectedFile, [{
    key: "getName",
    value: function getName() {
      return this.file.name;
    }
  }, {
    key: "getFile",
    value: function getFile() {
      return this.file;
    }
  }, {
    key: "getMimeType",
    value: function getMimeType() {
      return this.file.type;
    }
    // import from https://github.com/graffer-inc/graffer-schemas/blob/master/libs/packages/form-generator/lib/utils/blob-utils.ts
  }, {
    key: "dataURItoBlob",
    value: function dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mimeString
      });
    }
  }, {
    key: "createDataURI",
    value: function () {
      var _createDataURI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function () {
                  if (!reader.result) {
                    return reject();
                  }
                  if (reader.result instanceof ArrayBuffer) {
                    return reject();
                  }
                  resolve(reader.result);
                };
                reader.onerror = function (error) {
                  return reject(error);
                };
                reader.readAsDataURL(_this.file);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function createDataURI() {
        return _createDataURI.apply(this, arguments);
      }
      return createDataURI;
    }()
  }, {
    key: "getUrl",
    value: function () {
      var _getUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var dataURI, blob, objURL;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.createDataURI();
            case 2:
              dataURI = _context2.sent;
              if (dataURI) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", null);
            case 5:
              blob = this.dataURItoBlob(dataURI);
              objURL = URL.createObjectURL(blob);
              return _context2.abrupt("return", {
                objURL: objURL,
                blob: blob
              });
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getUrl() {
        return _getUrl.apply(this, arguments);
      }
      return getUrl;
    }()
  }, {
    key: "openDataURIContent",
    value: function () {
      var _openDataURIContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getUrl();
            case 2:
              result = _context3.sent;
              if (result) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", ["fail to create dataURI", null]);
            case 5:
              open(result.objURL, "_blank");
              return _context3.abrupt("return", [null, global.setTimeout(function () {
                return URL.revokeObjectURL(result.objURL);
              }, 2500)]);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function openDataURIContent() {
        return _openDataURIContent.apply(this, arguments);
      }
      return openDataURIContent;
    }()
  }]);
}();

var useHandleFile = function useHandleFile(_ref) {
  var file = _ref.file,
    errorMessage = _ref.errorMessage,
    maxFileSize = _ref.maxFileSize,
    acceptMimeTypes = _ref.acceptMimeTypes,
    onRead = _ref.onRead,
    state = _ref.state;
  var _useState = React.useState(file ? new SelectedFile(file) : undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFile = _useState2[0],
    setSelectedFile = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = React.useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMsg = _useState6[0],
    setErrorMsg = _useState6[1];
  var _useState7 = React.useState(FileUploadState.create(!!file, state, errorMsg)),
    _useState8 = _slicedToArray(_useState7, 2),
    fileState = _useState8[0],
    setFileState = _useState8[1];
  React.useEffect(function () {
    if (!file) {
      setSelectedFile(undefined);
    }
    setFileState(FileUploadState.create(!!file, isLoading ? "loading" : state, errorMsg));
  }, [errorMsg, file, isLoading, state]);
  var onFileHandle = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
      var handleFile;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setErrorMsg("");
            setIsLoading(true);
            handleFile = HandleFile.create(e, acceptMimeTypes, maxFileSize);
            handleFile.matchCall({
              readError: function () {
                var _readError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        setErrorMsg("ファイルの読み込みに失敗しました。");
                        setIsLoading(false);
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                function readError() {
                  return _readError.apply(this, arguments);
                }
                return readError;
              }(),
              invalidSize: function () {
                var _invalidSize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        setErrorMsg("".concat(maxFileSize, "MB\u4EE5\u4E0A\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u767B\u9332\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002"));
                        setIsLoading(false);
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                function invalidSize() {
                  return _invalidSize.apply(this, arguments);
                }
                return invalidSize;
              }(),
              invalidType: function () {
                var _invalidType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        setErrorMsg("\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u7A2E\u5225\u306E\u305F\u3081\u3001\u6DFB\u4ED8\u3067\u304D\u307E\u305B\u3093\u3002");
                        setIsLoading(false);
                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                function invalidType() {
                  return _invalidType.apply(this, arguments);
                }
                return invalidType;
              }(),
              success: function () {
                var _success = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var _a, file, selectedFile;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) {
                          _context4.next = 2;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 2:
                        file = e.target.files[0];
                        selectedFile = new SelectedFile(file);
                        setSelectedFile(selectedFile);
                        _context4.next = 7;
                        return onRead(selectedFile.getFile());
                      case 7:
                        e.target.value = "";
                        setIsLoading(false);
                      case 9:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                function success() {
                  return _success.apply(this, arguments);
                }
                return success;
              }()
            });
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [acceptMimeTypes, maxFileSize, onRead]);
  return {
    selectedFile: selectedFile,
    errorMessage: errorMsg ? errorMsg : errorMessage,
    fileState: fileState,
    onFileHandle: onFileHandle
  };
};

/**
 *  GrafferSchemasSingleFileUploadComponentで使用する値を返す
 * @returns
 */
function useGrafferSchemasSingleFileUpload(propsIds, state) {
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: propsIds.id,
      descriptionId: propsIds.descriptionId,
      errorMessageId: propsIds.errorMessageId
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  var notFailAriaDescribedByValue = getAreaDescribedByValue([descriptionId]);
  var ariaDescribedby = React.useMemo(function () {
    return state.matchType({
      "default": notFailAriaDescribedByValue,
      disabled: notFailAriaDescribedByValue,
      success: notFailAriaDescribedByValue,
      fail: getAreaDescribedByValue([descriptionId, errorMessageId]),
      loading: notFailAriaDescribedByValue
    });
  }, [state, notFailAriaDescribedByValue, descriptionId, errorMessageId]);
  return {
    id: id,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    ariaDescribedby: ariaDescribedby
  };
}

var _excluded$n = ["inputRef", "fileState", "id", "uploadedItem", "error"],
  _excluded2$a = ["file", "state", "onClear", "onClickFile", "previewUrl", "error", "touched"],
  _excluded3$3 = ["onClear", "id", "descriptionId", "acceptMimeTypes", "onBlur"];
/**
 *
 * DisableのSingleFileUploadコンポーネント
 *
 * @param param0
 * @returns
 */
var DisabledSingleFileUpload = function DisabledSingleFileUpload(_ref) {
  var uploadedItem = _ref.uploadedItem;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", null, React__namespace.createElement("span", {
    className: classNames__default.default(styles$t.fileCta, styles$t.disabled)
  }, React__namespace.createElement("span", {
    className: classNames__default.default(styles$t.fileIcon),
    "aria-hidden": true
  }, React__namespace.createElement(FileIcon, {
    size: 32
  })), React__namespace.createElement("span", {
    className: styles$t.disabledText
  }, "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u2026"))), uploadedItem);
};
/**
 *
 * SingleFileUploadのUIコンポーネント（fileStateが、disabled/fail 以外の場合。）
 *
 * @param param0
 * @returns
 */
var NormalSingleFileUpload = function NormalSingleFileUpload(_ref2) {
  var inputRef = _ref2.inputRef,
    fileState = _ref2.fileState,
    id = _ref2.id,
    uploadedItem = _ref2.uploadedItem,
    error = _ref2.error,
    props = _objectWithoutProperties(_ref2, _excluded$n);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
    className: styles$t.singleNormalFile
  }, React__namespace.createElement("label", {
    className: classNames__default.default(styles$t.fileLabel, fileState.matchType({
      "default": "",
      disabled: "",
      success: "",
      fail: styles$t.fail,
      loading: ""
    }))
  }, React__namespace.createElement("input", _objectSpread2(_objectSpread2({
    ref: inputRef
  }, props), {}, {
    "aria-required": props.required,
    id: id,
    className: styles$t.fileInput,
    type: "file",
    "aria-invalid": fileState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true,
      loading: false
    })
  })), React__namespace.createElement("span", {
    className: "".concat(styles$t.fileCta, " ").concat(fileState.matchType({
      "default": styles$t["default"],
      disabled: "",
      success: styles$t.success,
      fail: styles$t.fail,
      loading: styles$t.loading
    }))
  }, React__namespace.createElement("span", {
    className: styles$t.fileIcon,
    "aria-hidden": true
  }, React__namespace.createElement(FileIcon, {
    size: 32
  })), React__namespace.createElement("span", {
    className: styles$t.fileLabel
  }, "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u2026")))), uploadedItem, !!error && React__namespace.createElement(ErrorMessages, {
    id: error.messageId,
    messages: error.messages,
    ariaLive: "polite"
  }));
};
/**
 *
 * form-generatorで使用するSingleFileUploadComponent（state , onClickFile）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasSingleFileUploadComponent = function GrafferSchemasSingleFileUploadComponent(_ref3) {
  var file = _ref3.file,
    state = _ref3.state,
    onClear = _ref3.onClear,
    onClickFile = _ref3.onClickFile,
    previewUrl = _ref3.previewUrl,
    error = _ref3.error,
    touched = _ref3.touched,
    props = _objectWithoutProperties(_ref3, _excluded2$a);
  var inputRef = React__namespace.useRef(null);
  var fileState = React__namespace.useMemo(function () {
    return FileUploadState.create(!!file, state, error === null || error === void 0 ? void 0 : error.messages);
  }, [file, state, error === null || error === void 0 ? void 0 : error.messages]);
  var handleClear = React__namespace.useCallback(function () {
    var _a, _b;
    onClear();
    if ((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
      inputRef.current.value = "";
    }
  }, [onClear, inputRef]);
  var _useGrafferSchemasSin = useGrafferSchemasSingleFileUpload({
      id: props.id
    }, fileState),
    id = _useGrafferSchemasSin.id,
    ariaDescribedby = _useGrafferSchemasSin.ariaDescribedby;
  var uploadedItem = React__namespace.createElement(BaseFileUploadedItemComponent, {
    onClickFile: onClickFile,
    fileState: fileState,
    onClear: handleClear,
    fileName: file === null || file === void 0 ? void 0 : file.name,
    previewUrl: previewUrl,
    mimeType: file === null || file === void 0 ? void 0 : file.type,
    touched: touched
  });
  return React__namespace.createElement(React__namespace.Fragment, null, fileState.matchType({
    "default": React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      fileState: fileState,
      uploadedItem: uploadedItem,
      inputRef: inputRef,
      id: id,
      "aria-describedby": ariaDescribedby
    })),
    disabled: React__namespace.createElement(DisabledSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      fileState: fileState,
      uploadedItem: uploadedItem
    })),
    loading: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      fileState: fileState,
      uploadedItem: uploadedItem,
      inputRef: inputRef,
      id: id,
      "aria-describedby": ariaDescribedby
    })),
    success: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      fileState: fileState,
      uploadedItem: uploadedItem,
      inputRef: inputRef,
      id: id,
      "aria-describedby": ariaDescribedby
    })),
    fail: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      fileState: fileState,
      uploadedItem: uploadedItem,
      error: error,
      inputRef: inputRef,
      id: id,
      "aria-describedby": ariaDescribedby
    }))
  }));
};
/**
 *
 * SingleFileUploadコンポーネント
 *
 * @param param0
 * @returns
 */
var SingleFileUpload = function SingleFileUpload(_ref4) {
  var onClear = _ref4.onClear,
    id = _ref4.id,
    descriptionId = _ref4.descriptionId,
    acceptMimeTypes = _ref4.acceptMimeTypes,
    onBlur = _ref4.onBlur,
    props = _objectWithoutProperties(_ref4, _excluded3$3);
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFileInputTouched = _React$useState2[0],
    setIsFileInputTouched = _React$useState2[1];
  var _useHandleFile = useHandleFile(_objectSpread2(_objectSpread2({}, props), {}, {
      acceptMimeTypes: acceptMimeTypes
    })),
    selectedFile = _useHandleFile.selectedFile,
    errorMessage = _useHandleFile.errorMessage,
    fileState = _useHandleFile.fileState,
    onFileHandle = _useHandleFile.onFileHandle;
  var inputRef = React__namespace.useRef(null);
  var handleClear = React__namespace.useCallback(function () {
    var _a, _b;
    onClear();
    if ((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
      inputRef.current.value = "";
    }
  }, [onClear, inputRef]);
  var disabled = fileState.equals("disabled");
  var _useId = nextId.useId(1, "SingleFileUpload-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var errorMessageId = "errorMessage-".concat(htmlId);
  var uploadedItem = React__namespace.createElement(FileUploadedItem, {
    file: selectedFile,
    fileState: fileState,
    onClear: handleClear,
    touched: isFileInputTouched
  });
  var handleOnBlur = React__namespace.useCallback(function (e) {
    setIsFileInputTouched(true);
    if (onBlur) {
      onBlur(e);
    }
  }, [onBlur]);
  return React__namespace.createElement(React__namespace.Fragment, null, fileState.matchType({
    "default": React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      id: htmlId,
      fileState: fileState,
      onChange: onFileHandle,
      uploadedItem: uploadedItem,
      disabled: disabled,
      "aria-invalid": false,
      "aria-describedby": getAreaDescribedByValue([descriptionId]),
      onBlur: handleOnBlur
    })),
    disabled: React__namespace.createElement(DisabledSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      id: htmlId,
      fileState: fileState,
      uploadedItem: uploadedItem,
      disabled: disabled,
      onBlur: handleOnBlur
    })),
    loading: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      id: htmlId,
      fileState: fileState,
      onChange: onFileHandle,
      uploadedItem: uploadedItem,
      disabled: disabled,
      "aria-invalid": false,
      "aria-describedby": getAreaDescribedByValue([descriptionId]),
      onBlur: handleOnBlur
    })),
    success: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      id: htmlId,
      fileState: fileState,
      onChange: onFileHandle,
      uploadedItem: uploadedItem,
      disabled: disabled,
      "aria-invalid": false,
      "aria-describedby": getAreaDescribedByValue([descriptionId]),
      onBlur: handleOnBlur
    })),
    fail: React__namespace.createElement(NormalSingleFileUpload, _objectSpread2(_objectSpread2({}, props), {}, {
      id: htmlId,
      fileState: fileState,
      onChange: onFileHandle,
      uploadedItem: uploadedItem,
      "aria-invalid": true,
      "aria-describedby": getAreaDescribedByValue([descriptionId, errorMessageId]),
      onBlur: handleOnBlur,
      error: {
        messageId: errorMessageId,
        messages: errorMessage
      }
    }))
  }));
};

var css_248z$o = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.footer-module__GDK__company___-IY80 {\n  padding: 40px 0px;\n  display: flex;\n  justify-content: center;\n}\n\n.footer-module__GDK__companyLabel___2861z {\n  max-width: 608px;\n  color: #5c5959;\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  text-align: center;\n}\n\n@media screen and (max-width: 800px) {\n\n  .footer-module__GDK__companyLabel___2861z {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.footer-module__GDK__security___u30Sq {\n  padding: 64px 96px;\n  background-color: #fff;\n  border-top: 1px solid #dcd9d8;\n}\n\n.footer-module__GDK__descriptionArea___45O6i {\n  display: flex;\n  justify-content: center;\n}\n\n.footer-module__GDK__description___vnFtJ {\n  max-width: 608px;\n  margin-bottom: 64px;\n  color: #1d1c1a;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .footer-module__GDK__description___vnFtJ {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.footer-module__GDK__marks___Jh16Z {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n}\n\n.footer-module__GDK__privacyMark___oWU-1 {\n  flex: 0 0 120px;\n  height: 122px;\n  margin-right: 64px;\n}\n\n.footer-module__GDK__privacyMarkImage___7PvJU {\n  height: 120px;\n}\n\n.footer-module__GDK__isms___R8IK1 {\n  display: flex;\n  flex: 0 0 200px;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: 122px;\n}\n\n.footer-module__GDK__ismsImage___7pu0U {\n  height: 75px;\n  margin-bottom: 4px;\n}\n\n.footer-module__GDK__ismsCaption___RbVzF {\n  color: #1d1c1a;\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  white-space: pre-wrap;\n}\n\n@media screen and (max-width: 800px) {\n\n  .footer-module__GDK__ismsCaption___RbVzF {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.footer-module__GDK__legal___BcIbe {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  background-color: #fff;\n  border-top: 1px solid #dcd9d8;\n}\n\n.footer-module__GDK__legalItem___XkyWN {\n  list-style: none;\n  flex: 0 0 auto;\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n\n  .footer-module__GDK__legalItem___XkyWN {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.footer-module__GDK__legal___BcIbe > .footer-module__GDK__legalItem___XkyWN:not(:last-child) {\n  margin-right: 2em;\n}\n\n.footer-module__GDK__link___o58gJ {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #454ab8;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .footer-module__GDK__link___o58gJ {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.footer-module__GDK__link___o58gJ:active {\n  color: #1c1e78;\n  -webkit-text-decoration: underline #1c1e78;\n          text-decoration: underline #1c1e78;\n}\n\n.footer-module__GDK__link___o58gJ:focus-visible {\n  outline: 2px #454ab8 solid;\n  outline-offset: 8px;\n}\n\n.footer-module__GDK__link___o58gJ:visited {\n  color: #7b319a;\n}\n\n.footer-module__GDK__copy___wHfGb {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  background-color: #1d1c1a;\n  color: #fffefc;\n}\n\n@media screen and (max-width: 800px) {\n  .footer-module__GDK__company___-IY80 {\n    padding: 32px 16px;\n  }\n\n  .footer-module__GDK__security___u30Sq {\n    padding: 32px 16px;\n  }\n\n  .footer-module__GDK__description___vnFtJ {\n    margin-bottom: 24px;\n  }\n\n  .footer-module__GDK__marks___Jh16Z {\n    display: inline;\n  }\n\n  .footer-module__GDK__privacyMark___oWU-1 {\n    height: auto;\n    margin-right: 0px;\n    margin-bottom: 24px;\n  }\n\n  .footer-module__GDK__isms___R8IK1 {\n    height: auto;\n  }\n\n  .footer-module__GDK__ismsImage___7pu0U {\n    margin-bottom: 8px;\n  }\n\n  .footer-module__GDK__legal___BcIbe {\n    width: 100%;\n    padding: 0px;\n    justify-content: left;\n  }\n  .footer-module__GDK__legalItem___XkyWN {\n    font: bold 24px/42px Meiryo, Arial, system-ui, sans-serif;\n  }\n  @media screen and (max-width: 800px) {\n\n    .footer-module__GDK__legalItem___XkyWN {\n    font: bold 24px/42px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n  .footer-module__GDK__legal___BcIbe > .footer-module__GDK__legalItem___XkyWN:not(:last-child) {\n    margin-right: 0em;\n  }\n  .footer-module__GDK__legal___BcIbe > .footer-module__GDK__legalItem___XkyWN {\n    width: 50%;\n    text-align: center;\n  }\n  .footer-module__GDK__link___o58gJ {\n    font: 12px/21px Meiryo, Arial, system-ui, sans-serif;\n  }\n  @media screen and (max-width: 800px) {\n\n    .footer-module__GDK__link___o58gJ {\n    font: 12px/21px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n}\n\n@media (hover: hover) {\n  .footer-module__GDK__link___o58gJ:hover {\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n    color: #3739a2;\n  }\n  @media screen and (max-width: 800px) {\n\n    .footer-module__GDK__link___o58gJ:hover {\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n}\n";
var styles$o = {"company":"footer-module__GDK__company___-IY80","companyLabel":"footer-module__GDK__companyLabel___2861z","security":"footer-module__GDK__security___u30Sq","descriptionArea":"footer-module__GDK__descriptionArea___45O6i","description":"footer-module__GDK__description___vnFtJ","marks":"footer-module__GDK__marks___Jh16Z","privacyMark":"footer-module__GDK__privacyMark___oWU-1","privacyMarkImage":"footer-module__GDK__privacyMarkImage___7PvJU","isms":"footer-module__GDK__isms___R8IK1","ismsImage":"footer-module__GDK__ismsImage___7pu0U","ismsCaption":"footer-module__GDK__ismsCaption___RbVzF","legal":"footer-module__GDK__legal___BcIbe","legalItem":"footer-module__GDK__legalItem___XkyWN","link":"footer-module__GDK__link___o58gJ","copy":"footer-module__GDK__copy___wHfGb"};
styleInject(css_248z$o);

var IsmsImage = function IsmsImage(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "ISMS" : _ref$alt;
  return React__namespace.default.createElement("svg", {
    width: "200",
    height: "75",
    viewBox: "0 0 200 75",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined
  }, React__namespace.default.createElement("path", {
    d: "M200 74.3169H0V0H200V74.3169ZM1.01063 73.3155H198.989V1.00144H1.01063V73.3155Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M190.236 12.5371H152.6V49.831H190.236V12.5371Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M168.458 18.3697C168.45 19.0106 168.635 19.6392 168.988 20.1758C169.342 20.7124 169.849 21.1327 170.444 21.3832C171.039 21.6338 171.696 21.7034 172.332 21.5831C172.967 21.4627 173.552 21.158 174.012 20.7076C174.472 20.2571 174.786 19.6813 174.915 19.0533C175.045 18.4253 174.982 17.7735 174.737 17.1806C174.491 16.5878 174.073 16.0807 173.536 15.7238C172.998 15.3669 172.366 15.1764 171.72 15.1763C170.86 15.1717 170.033 15.5055 169.422 16.1043C168.81 16.703 168.463 17.5178 168.458 18.3697V18.3697Z",
    fill: "white"
  }), React__namespace.default.createElement("path", {
    d: "M169.816 23.5747C168.337 25.2208 167.951 29.2179 168.671 35.4673C169.105 39.1549 169.994 42.9114 171.581 47.6478C171.591 47.6765 171.61 47.7015 171.635 47.7192C171.66 47.7369 171.689 47.7465 171.72 47.7467C171.75 47.7453 171.78 47.7353 171.804 47.7177C171.829 47.7002 171.848 47.6759 171.859 47.6478C173.446 42.92 174.344 39.1549 174.769 35.4673C175.489 29.2179 175.103 25.2208 173.62 23.5747C173.382 23.3075 173.089 23.0935 172.761 22.947C172.433 22.8004 172.078 22.7246 171.718 22.7246C171.358 22.7246 171.003 22.8004 170.675 22.947C170.347 23.0935 170.054 23.3075 169.816 23.5747V23.5747Z",
    fill: "white"
  }), React__namespace.default.createElement("path", {
    d: "M156.149 25.1391C155.858 25.3671 155.619 25.6534 155.448 25.9794C155.277 26.3053 155.177 26.6634 155.155 27.0302C155.155 27.8211 155.65 28.6893 156.543 29.4672C158.139 30.8598 163.427 33.9028 177.97 32.046C178.005 32.0381 178.035 32.0183 178.056 31.9902C178.077 31.9621 178.087 31.9276 178.084 31.8928C178.081 31.8581 178.066 31.8254 178.041 31.8007C178.017 31.776 177.984 31.7609 177.949 31.7581C171.473 31.8913 165.752 30.6535 163.709 28.6721C163.462 28.4606 163.262 28.2012 163.121 27.9099C162.98 27.6185 162.901 27.3016 162.889 26.9787C162.889 23.9443 168.15 22.311 173.099 22.311C173.137 22.31 173.174 22.2949 173.201 22.2686C173.228 22.2423 173.245 22.2069 173.247 22.1692C173.248 22.1502 173.245 22.1312 173.239 22.1133C173.233 22.0953 173.223 22.0789 173.21 22.0648C173.197 22.0508 173.181 22.0395 173.164 22.0316C173.146 22.0237 173.127 22.0193 173.108 22.0188C164.542 21.3483 158.317 23.1663 156.149 25.1391Z",
    fill: "white"
  }), React__namespace.default.createElement("path", {
    d: "M171.242 23.7078C171.205 23.7077 171.17 23.7213 171.142 23.746C171.115 23.7707 171.098 23.8046 171.095 23.8411C171.091 23.8761 171.1 23.9114 171.121 23.94C171.142 23.9687 171.173 23.9885 171.208 23.9958C176.165 25.0918 180.75 26.6864 180.75 30.9371C180.731 31.51 180.592 32.0728 180.344 32.5904C180.095 33.108 179.742 33.5694 179.306 33.9457C176.269 36.8598 169.022 38.334 159.47 37.9901C159.433 37.9877 159.396 37.9999 159.368 38.024C159.34 38.0481 159.322 38.0822 159.319 38.1191C159.315 38.1559 159.325 38.1928 159.348 38.2223C159.37 38.2518 159.403 38.2718 159.44 38.2781C176.534 41.2609 183.5 37.2724 185.716 35.4285C187.343 34.0703 188.202 32.4715 188.202 30.7953C188.195 30.1985 188.065 29.6094 187.82 29.064C187.576 28.5186 187.221 28.0284 186.779 27.6233C183.747 24.6534 176.534 23.6391 171.242 23.7078Z",
    fill: "white"
  }), React__namespace.default.createElement("path", {
    d: "M176.504 62.6825H175.936V59.9575H176.504V62.6825Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M177.836 61.8396C177.844 61.9405 177.88 62.0372 177.94 62.1189C178.004 62.1805 178.081 62.2274 178.166 62.2563C178.251 62.2853 178.341 62.2956 178.43 62.2866C178.544 62.2906 178.659 62.2761 178.768 62.2436C178.84 62.2268 178.904 62.186 178.949 62.1281C178.994 62.0702 179.017 61.9986 179.015 61.9255C179.015 61.8836 179.004 61.8423 178.983 61.8061C178.962 61.7698 178.931 61.7398 178.894 61.7192C178.774 61.6584 178.645 61.615 178.512 61.5903L178.213 61.5258C178.002 61.4897 177.799 61.4201 177.61 61.3195C177.518 61.2525 177.444 61.1633 177.395 61.0604C177.347 60.9575 177.325 60.8441 177.333 60.7307C177.33 60.6153 177.353 60.5009 177.401 60.3954C177.448 60.2899 177.518 60.196 177.606 60.1204C177.833 59.9458 178.117 59.8601 178.404 59.8797C178.672 59.8728 178.936 59.9528 179.154 60.1075C179.258 60.1842 179.341 60.2842 179.398 60.3994C179.454 60.5145 179.482 60.6413 179.48 60.7694H178.929C178.927 60.6969 178.906 60.6263 178.867 60.5649C178.828 60.5036 178.773 60.4539 178.707 60.4212C178.6 60.3721 178.483 60.3485 178.365 60.3525C178.237 60.3462 178.11 60.3776 178 60.4427C177.958 60.4676 177.923 60.5036 177.899 60.5467C177.875 60.5899 177.864 60.6386 177.866 60.6877C177.864 60.7333 177.876 60.7784 177.9 60.8174C177.924 60.8564 177.959 60.8875 178 60.9069C178.117 60.9573 178.24 60.9948 178.365 61.0187L178.846 61.1304C179.017 61.164 179.179 61.2312 179.323 61.3281C179.406 61.3961 179.472 61.4825 179.515 61.5804C179.558 61.6782 179.577 61.7846 179.571 61.8911C179.573 62.0095 179.548 62.1268 179.498 62.2341C179.448 62.3414 179.373 62.4358 179.28 62.5101C179.044 62.6869 178.751 62.7738 178.456 62.755C178.147 62.7757 177.841 62.6907 177.588 62.5143C177.486 62.4352 177.405 62.3331 177.35 62.2165C177.296 62.0999 177.271 61.9722 177.276 61.8439L177.836 61.8396Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M182.112 60.0304C182.212 60.0714 182.3 60.1363 182.368 60.2195C182.426 60.2875 182.473 60.3644 182.507 60.4473C182.543 60.539 182.56 60.6368 182.559 60.7352C182.557 60.8688 182.523 61.0001 182.459 61.1178C182.425 61.1807 182.379 61.2363 182.323 61.2813C182.267 61.3263 182.203 61.3598 182.134 61.3799C182.245 61.4197 182.34 61.4954 182.403 61.5948C182.463 61.7298 182.49 61.8772 182.481 62.0246V62.2095C182.471 62.2937 182.471 62.3788 182.481 62.463C182.486 62.4948 182.497 62.5251 182.515 62.5519C182.533 62.5786 182.557 62.6011 182.585 62.6178V62.6865H181.952C181.952 62.6264 181.921 62.5748 181.913 62.5404C181.899 62.4623 181.891 62.3833 181.891 62.304V62.0504C181.902 61.9288 181.87 61.8072 181.8 61.7066C181.754 61.6707 181.702 61.6443 181.646 61.6288C181.59 61.6133 181.532 61.609 181.474 61.6163H180.911V62.6865H180.351V59.9573H181.652C181.809 59.9518 181.965 59.9766 182.112 60.0304ZM180.924 60.4301V61.165H181.544C181.639 61.1691 181.733 61.153 181.821 61.1178C181.876 61.0888 181.921 61.0442 181.949 60.9897C181.978 60.9353 181.989 60.8736 181.982 60.8126C181.99 60.7485 181.98 60.6834 181.952 60.6249C181.924 60.5663 181.881 60.5167 181.826 60.4816C181.743 60.4425 181.652 60.4247 181.561 60.4301H180.924Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M184.975 60.344C185.112 60.6678 185.183 61.0156 185.183 61.3669C185.183 61.7182 185.112 62.066 184.975 62.3898C184.89 62.5003 184.78 62.5898 184.655 62.6515C184.529 62.7131 184.391 62.7452 184.25 62.7452C184.11 62.7452 183.972 62.7131 183.846 62.6515C183.721 62.5898 183.611 62.5003 183.526 62.3898C183.389 62.066 183.318 61.7182 183.318 61.3669C183.318 61.0156 183.389 60.6678 183.526 60.344C183.61 60.2319 183.719 60.1409 183.845 60.0783C183.971 60.0156 184.11 59.9829 184.25 59.9829C184.391 59.9829 184.53 60.0156 184.656 60.0783C184.782 60.1409 184.891 60.2319 184.975 60.344V60.344ZM183.938 62.0632C183.955 62.1328 183.995 62.1949 184.051 62.2392C184.108 62.2836 184.178 62.3078 184.25 62.3078C184.323 62.3078 184.393 62.2836 184.449 62.2392C184.506 62.1949 184.546 62.1328 184.563 62.0632C184.619 61.8311 184.644 61.5926 184.636 61.354C184.645 61.1139 184.62 60.8738 184.563 60.6405C184.543 60.5736 184.502 60.5147 184.446 60.4729C184.389 60.431 184.321 60.4084 184.25 60.4084C184.18 60.4084 184.112 60.431 184.055 60.4729C183.999 60.5147 183.958 60.5736 183.938 60.6405C183.876 60.8732 183.85 61.1136 183.86 61.354C183.85 61.5972 183.877 61.8405 183.938 62.0761V62.0632Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M187.482 60.3443C187.754 60.9997 187.754 61.7349 187.482 62.3902C187.407 62.5109 187.3 62.6084 187.172 62.6715C187.044 62.7345 186.9 62.7607 186.758 62.7469C186.615 62.7617 186.472 62.736 186.343 62.6729C186.215 62.6097 186.108 62.5117 186.033 62.3902C185.896 62.0664 185.825 61.7186 185.825 61.3673C185.825 61.016 185.896 60.6682 186.033 60.3443C186.107 60.2221 186.214 60.1232 186.343 60.0593C186.471 59.9953 186.615 59.969 186.758 59.9833C186.901 59.97 187.044 59.9968 187.172 60.0607C187.3 60.1245 187.408 60.2228 187.482 60.3443V60.3443ZM186.441 62.0636C186.456 62.1348 186.497 62.1984 186.554 62.2432C186.612 62.288 186.684 62.3111 186.758 62.3085C186.83 62.3117 186.902 62.2886 186.958 62.2435C187.015 62.1984 187.053 62.1345 187.066 62.0636C187.122 61.8315 187.147 61.593 187.14 61.3544C187.148 61.1143 187.123 60.8742 187.066 60.6409C187.051 60.5716 187.012 60.5096 186.956 60.4663C186.899 60.4229 186.829 60.401 186.758 60.4045C186.685 60.4007 186.614 60.4223 186.556 60.4655C186.498 60.5088 186.457 60.5709 186.441 60.6409C186.384 60.8742 186.359 61.1143 186.367 61.3544C186.359 61.5973 186.384 61.8402 186.441 62.0764V62.0636Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M190.206 62.1065H189.902V62.6824H189.382V62.1065H188.311V61.6466L189.304 60.022H189.902V61.6939H190.206V62.1065ZM189.382 61.6767V60.5248L188.705 61.6767H189.382Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.596 63.3999V59.1362H154.274V63.3999H152.596Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M157.987 60.374C157.975 60.3095 157.946 60.2492 157.903 60.1989C157.861 60.1485 157.806 60.1097 157.744 60.086C157.607 60.0296 157.459 60.0032 157.311 60.0087C156.942 60.0087 156.777 60.0946 156.777 60.2493C156.777 60.8897 159.722 60.4943 159.722 62.0459C159.722 63.0345 158.733 63.5158 157.324 63.5158C155.914 63.5158 155.09 62.8582 155.055 62.0846H156.664C156.682 62.1584 156.716 62.2273 156.764 62.2861C156.812 62.3449 156.873 62.3922 156.942 62.4241C157.09 62.4975 157.254 62.5344 157.419 62.5316C157.853 62.5316 158.113 62.4198 158.113 62.2178C158.113 61.5731 155.168 62.0158 155.168 60.3869C155.168 59.48 156.109 59.0244 157.389 59.0244C158.811 59.0244 159.458 59.6304 159.579 60.374H157.987Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M160.386 63.3999V59.1362H162.411L163.314 61.7967L164.22 59.1362H166.246V63.3999H164.741V62.1105V61.4486L164.827 60.6792L163.895 63.4128H162.728L161.787 60.6663L161.856 61.2938L161.891 61.9557V63.3999H160.386Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M169.842 60.374C169.829 60.3095 169.8 60.2492 169.758 60.1989C169.715 60.1485 169.661 60.1097 169.599 60.086C169.462 60.0296 169.314 60.0032 169.165 60.0087C168.796 60.0087 168.632 60.0946 168.632 60.2493C168.632 60.8897 171.577 60.4943 171.577 62.0459C171.577 63.0345 170.588 63.5158 169.178 63.5158C167.768 63.5158 166.944 62.8582 166.91 62.0846H168.519C168.536 62.1584 168.57 62.2273 168.618 62.2861C168.666 62.3449 168.727 62.3922 168.796 62.4241C168.943 62.497 169.105 62.5338 169.269 62.5316C169.703 62.5316 169.968 62.4198 169.968 62.2178C169.968 61.5731 167.022 62.0158 167.022 60.3869C167.022 59.48 167.964 59.0244 169.243 59.0244C170.666 59.0244 171.312 59.6304 171.434 60.374H169.842Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M158.564 53.8416H157.35C157.033 53.8416 156.756 53.7083 156.756 53.4118C156.756 53.1023 157.033 52.982 157.35 52.982H159.679C159.703 52.9809 159.725 52.9711 159.742 52.9544C159.759 52.9377 159.769 52.9153 159.77 52.8917V51.8903C159.769 51.8671 159.759 51.8452 159.742 51.8292C159.725 51.8132 159.703 51.8043 159.679 51.8043H157.35C157.123 51.7842 156.895 51.8111 156.679 51.8833C156.463 51.9556 156.265 52.0715 156.097 52.2237C155.929 52.3759 155.795 52.5611 155.704 52.7675C155.612 52.9739 155.564 53.197 155.564 53.4225C155.564 53.648 155.612 53.8711 155.704 54.0775C155.795 54.2839 155.929 54.4691 156.097 54.6213C156.265 54.7736 156.463 54.8895 156.679 54.9617C156.895 55.0339 157.123 55.0608 157.35 55.0407H158.564C158.885 55.0407 159.159 55.1654 159.159 55.4705C159.159 55.7757 158.885 55.9003 158.564 55.9003H157.233C156.756 55.9003 156.699 55.7929 156.699 55.6038V55.4447C156.699 55.4219 156.69 55.4001 156.674 55.3839C156.658 55.3678 156.636 55.3588 156.613 55.3588H155.602C155.579 55.3588 155.557 55.3678 155.541 55.3839C155.524 55.4001 155.515 55.4219 155.515 55.4447V55.9003C155.515 56.5837 155.949 57.078 157.293 57.078H158.564C158.792 57.0981 159.022 57.071 159.239 56.9984C159.455 56.9258 159.654 56.8093 159.823 56.6562C159.992 56.5032 160.127 56.317 160.219 56.1096C160.311 55.9021 160.359 55.6779 160.359 55.4512C160.359 55.2245 160.311 55.0003 160.219 54.7928C160.127 54.5853 159.992 54.3992 159.823 54.2461C159.654 54.0931 159.455 53.9766 159.239 53.904C159.022 53.8314 158.792 53.8043 158.564 53.8244V53.8416Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M171.386 53.8416H170.172C169.855 53.8416 169.577 53.7083 169.577 53.4118C169.577 53.1023 169.855 52.982 170.172 52.982H172.501C172.524 52.9809 172.546 52.9709 172.562 52.954C172.579 52.9372 172.588 52.9149 172.588 52.8917V51.8903C172.588 51.8675 172.578 51.8456 172.562 51.8295C172.546 51.8134 172.524 51.8043 172.501 51.8043H170.172C169.945 51.7842 169.716 51.8111 169.501 51.8833C169.285 51.9556 169.087 52.0715 168.919 52.2237C168.751 52.3759 168.617 52.5611 168.525 52.7675C168.434 52.9739 168.386 53.197 168.386 53.4225C168.386 53.648 168.434 53.8711 168.525 54.0775C168.617 54.2839 168.751 54.4691 168.919 54.6213C169.087 54.7736 169.285 54.8895 169.501 54.9617C169.716 55.0339 169.945 55.0608 170.172 55.0407H171.386C171.707 55.0407 171.98 55.1654 171.98 55.4705C171.98 55.7757 171.707 55.9003 171.386 55.9003H170.055C169.577 55.9003 169.521 55.7929 169.521 55.6038V55.4447C169.521 55.4331 169.519 55.4215 169.514 55.4108C169.509 55.4001 169.503 55.3904 169.494 55.3824C169.486 55.3743 169.475 55.3681 169.464 55.364C169.453 55.36 169.442 55.3582 169.43 55.3588H168.424C168.412 55.3582 168.4 55.36 168.389 55.364C168.378 55.3681 168.368 55.3743 168.359 55.3824C168.351 55.3904 168.344 55.4001 168.34 55.4108C168.335 55.4215 168.333 55.4331 168.333 55.4447V55.9003C168.333 56.5837 168.766 57.078 170.115 57.078H171.386C171.614 57.0981 171.844 57.071 172.06 56.9984C172.277 56.9258 172.476 56.8093 172.645 56.6562C172.814 56.5032 172.949 56.317 173.041 56.1096C173.133 55.9021 173.181 55.6779 173.181 55.4512C173.181 55.2245 173.133 55.0003 173.041 54.7928C172.949 54.5853 172.814 54.3992 172.645 54.2461C172.476 54.0931 172.277 53.9766 172.06 53.904C171.844 53.8314 171.614 53.8043 171.386 53.8244V53.8416Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M186.667 53.0461H190.137C190.16 53.0461 190.183 53.0372 190.2 53.0212C190.217 53.0052 190.227 52.9833 190.228 52.9601V51.8684C190.227 51.8452 190.217 51.8234 190.2 51.8074C190.183 51.7914 190.16 51.7824 190.137 51.7825H186.541C186.09 51.7694 185.652 51.9308 185.319 52.2325C184.986 52.5341 184.785 52.9524 184.758 53.3985V55.4659C184.782 55.9143 184.982 56.3358 185.315 56.6402C185.648 56.9446 186.088 57.1078 186.541 57.0948H190.137C190.161 57.0948 190.184 57.0853 190.201 57.0684C190.218 57.0515 190.228 57.0285 190.228 57.0046V55.9172C190.227 55.8936 190.217 55.8712 190.2 55.8545C190.183 55.8378 190.161 55.828 190.137 55.8269H186.667C186.346 55.8269 186.073 55.6249 186.073 55.3971V53.506C186.077 53.2524 186.35 53.0461 186.667 53.0461Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M174.122 53.7593H177.402C177.425 53.7593 177.447 53.7683 177.463 53.7845C177.479 53.8006 177.488 53.8224 177.488 53.8452V54.8467C177.488 54.8706 177.479 54.8936 177.462 54.9105C177.445 54.9274 177.421 54.9369 177.397 54.9369H174.131C174.107 54.9369 174.084 54.9274 174.067 54.9105C174.05 54.8936 174.04 54.8706 174.04 54.8467V53.8452C174.041 53.8235 174.05 53.8028 174.065 53.787C174.08 53.7712 174.101 53.7613 174.122 53.7593V53.7593Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M165.903 51.8037H165.431C165.045 51.8069 164.675 51.9507 164.39 52.2077C164.106 51.9506 163.737 51.8067 163.353 51.8037H162.876C162.426 51.8303 162.003 52.0297 161.699 52.3594C161.395 52.6892 161.232 53.1235 161.245 53.5702V57.0774C161.245 57.089 161.247 57.1006 161.252 57.1113C161.257 57.122 161.263 57.1317 161.272 57.1397C161.28 57.1478 161.29 57.154 161.301 57.1581C161.312 57.1621 161.324 57.1639 161.336 57.1633H162.637C162.66 57.1633 162.682 57.1543 162.699 57.1382C162.715 57.1221 162.724 57.1002 162.724 57.0774V53.5702C162.724 53.2564 162.932 52.9814 163.158 52.9814H163.336C163.57 52.9814 163.769 53.2564 163.769 53.5702V57.0774C163.77 57.1006 163.781 57.1224 163.797 57.1384C163.814 57.1545 163.837 57.1634 163.86 57.1633H164.871C164.894 57.1633 164.916 57.1543 164.932 57.1382C164.949 57.1221 164.958 57.1002 164.958 57.0774V53.5702C164.958 53.2564 165.166 52.9814 165.392 52.9814H165.569C165.804 52.9814 166.003 53.2564 166.003 53.5702V57.0774C166.003 57.089 166.005 57.1006 166.01 57.1113C166.015 57.122 166.022 57.1317 166.03 57.1397C166.039 57.1478 166.049 57.154 166.06 57.1581C166.071 57.1621 166.082 57.1639 166.094 57.1633H167.395C167.418 57.1633 167.441 57.1543 167.457 57.1382C167.473 57.1221 167.482 57.1002 167.482 57.0774V53.5702C167.496 53.1317 167.34 52.7046 167.047 52.3762C166.753 52.0478 166.344 51.843 165.903 51.8037V51.8037Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M182.095 51.8037H180.005C179.098 51.8037 178.478 52.5988 178.478 53.5702V57.0774C178.479 57.1006 178.489 57.1224 178.506 57.1384C178.523 57.1545 178.546 57.1634 178.569 57.1633H179.697C179.72 57.1634 179.743 57.1545 179.76 57.1384C179.777 57.1224 179.787 57.1006 179.788 57.0774V55.3109H182.299V57.0774C182.299 57.1002 182.308 57.1221 182.325 57.1382C182.341 57.1543 182.363 57.1633 182.386 57.1633H183.475C183.487 57.1639 183.498 57.1621 183.509 57.1581C183.52 57.154 183.53 57.1478 183.539 57.1397C183.547 57.1317 183.554 57.122 183.559 57.1113C183.563 57.1006 183.566 57.089 183.566 57.0774V53.5702C183.579 52.5988 182.993 51.8037 182.095 51.8037ZM182.304 54.1332H179.792V53.5702C179.783 53.4301 179.828 53.2917 179.917 53.1825C180.006 53.0734 180.133 53.0016 180.274 52.9814H181.827C181.965 53.0044 182.09 53.0771 182.178 53.1857C182.266 53.2943 182.311 53.4311 182.304 53.5702V54.1332Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.678 53.6094H154.283C154.307 53.6094 154.33 53.6189 154.347 53.6358C154.364 53.6527 154.374 53.6757 154.374 53.6996V57.0779C154.374 57.0897 154.372 57.1014 154.367 57.1124C154.363 57.1233 154.356 57.1333 154.347 57.1417C154.339 57.1501 154.329 57.1567 154.318 57.1612C154.307 57.1658 154.295 57.1681 154.283 57.1681H152.678C152.655 57.1681 152.633 57.159 152.617 57.1429C152.6 57.1268 152.591 57.1049 152.591 57.0821V53.7039C152.59 53.6919 152.591 53.6798 152.595 53.6684C152.599 53.6569 152.605 53.6464 152.613 53.6375C152.622 53.6286 152.632 53.6215 152.643 53.6166C152.654 53.6118 152.666 53.6093 152.678 53.6094V53.6094Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.678 51.6919H154.283C154.307 51.6919 154.33 51.7014 154.347 51.7183C154.365 51.7353 154.374 51.7582 154.374 51.7822V51.9369C154.374 51.9597 154.365 51.9815 154.349 51.9977C154.332 52.0138 154.31 52.0228 154.287 52.0228H152.678C152.655 52.0228 152.633 52.0138 152.617 51.9977C152.601 51.9815 152.591 51.9597 152.591 51.9369V51.7822C152.591 51.7705 152.593 51.7589 152.597 51.7479C152.601 51.737 152.607 51.727 152.615 51.7186C152.623 51.7101 152.633 51.7034 152.644 51.6988C152.655 51.6942 152.666 51.6919 152.678 51.6919V51.6919Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.678 52.1738H154.279C154.303 52.1738 154.326 52.1833 154.343 52.2003C154.36 52.2172 154.37 52.2402 154.37 52.2641V52.436C154.37 52.46 154.36 52.4829 154.343 52.4998C154.326 52.5168 154.303 52.5263 154.279 52.5263H152.678C152.655 52.5263 152.633 52.5172 152.617 52.5011C152.601 52.485 152.591 52.4631 152.591 52.4403V52.2856C152.588 52.2724 152.588 52.2587 152.591 52.2455C152.594 52.2322 152.599 52.2198 152.608 52.209C152.616 52.1983 152.627 52.1896 152.639 52.1835C152.651 52.1774 152.665 52.1741 152.678 52.1738V52.1738Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.678 52.6509H154.283C154.307 52.6509 154.33 52.6604 154.347 52.6773C154.364 52.6942 154.374 52.7172 154.374 52.7411V52.8959C154.374 52.9198 154.364 52.9428 154.347 52.9597C154.33 52.9766 154.307 52.9861 154.283 52.9861H152.678C152.655 52.9861 152.633 52.9771 152.617 52.9609C152.6 52.9448 152.591 52.923 152.591 52.9002V52.7454C152.59 52.7334 152.591 52.7213 152.595 52.7099C152.599 52.6985 152.605 52.6879 152.613 52.679C152.622 52.6701 152.632 52.663 152.643 52.6581C152.654 52.6533 152.666 52.6508 152.678 52.6509V52.6509Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M152.679 53.1274H154.283C154.308 53.1274 154.331 53.137 154.348 53.1539C154.365 53.1708 154.375 53.1938 154.375 53.2177V53.3724C154.375 53.3964 154.365 53.4193 154.348 53.4362C154.331 53.4532 154.308 53.4627 154.283 53.4627H152.679C152.656 53.4627 152.633 53.4536 152.617 53.4375C152.601 53.4214 152.592 53.3995 152.592 53.3767V53.222C152.592 53.1992 152.601 53.1773 152.617 53.1612C152.633 53.1451 152.656 53.136 152.679 53.136V53.1274Z",
    fill: "#004EA2"
  }), React__namespace.default.createElement("path", {
    d: "M115.073 33.4086C115.154 31.9277 115.805 30.5341 116.892 29.5143C117.979 28.4945 119.418 27.9262 120.915 27.9262C122.412 27.9262 123.852 28.4945 124.938 29.5143C126.025 30.5341 126.676 31.9277 126.758 33.4086H115.073ZM120 47.1623C119.172 44.7468 117.207 43.4746 115.55 42.4087C113.715 41.2181 112.947 40.6035 112.908 39.4645C112.905 38.7215 113.197 38.007 113.721 37.476C114.246 36.945 114.96 36.6403 115.71 36.6278H125.916L120 47.1623ZM112.101 56.3299C112.556 56.4062 113.016 56.4479 113.476 56.4546C113.936 56.4545 114.395 56.4128 114.847 56.3299L113.476 58.7669L112.101 56.3299ZM110.436 36.6278C109.991 37.4801 109.752 38.4233 109.738 39.3829V39.3829C109.738 39.4129 109.738 39.4473 109.738 39.4774C109.785 42.486 112.041 43.9516 113.854 45.125C116.023 46.5176 117.228 47.4158 117.228 49.7067C117.228 51.9975 115.42 53.2955 113.208 53.2955C111.785 53.2955 109.985 52.5391 109.265 51.2883L108.627 50.1924L100.963 36.6235L110.436 36.6278ZM106.172 27.8943C107.671 27.9082 109.108 28.486 110.193 29.5107C111.278 30.5353 111.929 31.9303 112.015 33.4129H100.334C100.419 31.9306 101.069 30.5358 102.153 29.511C103.237 28.4862 104.674 27.9083 106.172 27.8943V27.8943ZM120.919 24.8212C119.451 24.8181 118.005 25.1823 116.716 25.8803C115.427 26.5783 114.336 27.5874 113.546 28.814C112.755 27.5871 111.665 26.5778 110.376 25.8798C109.087 25.1818 107.641 24.8177 106.172 24.8212C103.778 24.8337 101.486 25.7846 99.7975 27.4661C98.1086 29.1476 97.16 31.4231 97.1589 33.7954V34.7066C97.1328 35.7047 97.4077 36.6879 97.9483 37.5304L113.498 64.105C113.498 64.105 128.245 38.8671 128.978 37.5304C129.712 36.1937 129.824 35.6178 129.824 34.7066V33.7954C129.844 31.438 128.919 29.1689 127.253 27.4859C125.587 25.8028 123.316 24.843 120.937 24.8169",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M107.877 11.9183C106.938 11.9218 106.02 12.195 105.235 12.7048V7.14746H103.027V22.1905H104.329L104.684 21.3825C105.601 22.0775 106.727 22.4455 107.881 22.4269C110.757 22.4269 111.824 20.4627 111.824 17.1704C111.824 13.8781 110.757 11.9183 107.881 11.9183H107.877ZM107.365 13.8223C109.299 13.8223 109.594 15.3266 109.594 17.1704C109.594 19.0143 109.299 20.5272 107.365 20.5272C106.615 20.5282 105.88 20.3245 105.239 19.9383V14.4068C105.88 14.0224 106.616 13.8201 107.365 13.8223V13.8223ZM114.613 15.0429C114.613 14.1403 115.341 13.8008 116.508 13.8008C117.54 13.7917 118.565 13.9829 119.523 14.3638V12.4168C118.55 12.0406 117.508 11.8708 116.465 11.9183C113.567 11.9183 112.461 13.3796 112.461 15.1074C112.461 16.8352 113.194 17.7721 116.17 18.0386C117.493 18.1547 117.805 18.5329 117.805 19.2765C117.805 20.1618 117.037 20.5272 115.463 20.5272C114.457 20.5128 113.461 20.3222 112.522 19.9641V21.8853C113.566 22.26 114.67 22.4435 115.779 22.4269C118.933 22.4269 119.978 20.9226 119.978 19.1991C119.978 17.3338 119.21 16.4269 116.252 16.169C114.951 16.0486 114.613 15.7392 114.613 15.0472V15.0429ZM123.478 22.3495C123.624 22.3493 123.769 22.3349 123.912 22.3066V20.4627C123.279 20.4627 123.084 20.2607 123.084 19.6977V12.1589H120.876V19.7191C120.876 21.4384 121.687 22.328 123.478 22.328V22.3495ZM120.542 9.18902C120.549 9.46986 120.639 9.74245 120.802 9.97263C120.964 10.2028 121.192 10.3803 121.456 10.483C121.72 10.5856 122.008 10.6087 122.285 10.5495C122.562 10.4903 122.816 10.3513 123.013 10.15C123.211 9.94872 123.345 9.69406 123.397 9.41796C123.449 9.14187 123.418 8.85661 123.308 8.59795C123.197 8.33928 123.012 8.11872 122.775 7.96391C122.539 7.8091 122.261 7.72693 121.978 7.72769C121.592 7.73448 121.225 7.89184 120.956 8.16553C120.687 8.43922 120.539 8.80707 120.542 9.18902",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M113.468 67.1694C107.44 67.1692 101.58 65.2096 96.7844 61.5911C91.9892 57.9726 88.5244 52.8952 86.9217 47.1377C85.3189 41.3802 85.6666 35.2606 87.9115 29.7178C90.1564 24.175 94.1745 19.5151 99.3493 16.4529C99.4269 16.3986 99.5149 16.3608 99.6079 16.3418C99.7008 16.3227 99.7968 16.3229 99.8897 16.3424C99.9825 16.3618 100.07 16.4 100.148 16.4546C100.225 16.5092 100.29 16.579 100.339 16.6597C100.388 16.7404 100.419 16.8302 100.431 16.9235C100.443 17.0168 100.436 17.1116 100.409 17.2019C100.383 17.2923 100.338 17.3762 100.277 17.4485C100.216 17.5207 100.141 17.5798 100.056 17.6219C95.141 20.531 91.3245 24.9577 89.1923 30.223C87.0602 35.4882 86.7302 41.3012 88.2529 46.7702C89.7756 52.2392 93.067 57.0621 97.6222 60.4991C102.177 63.9362 107.745 65.7974 113.47 65.7974C119.195 65.7974 124.763 63.9362 129.318 60.4991C133.873 57.0621 137.164 52.2392 138.687 46.7702C140.21 41.3012 139.88 35.4882 137.748 30.223C135.615 24.9577 131.799 20.531 126.883 17.6219C126.804 17.5767 126.735 17.5163 126.679 17.4442C126.624 17.3722 126.583 17.2899 126.56 17.2021C126.537 17.1144 126.532 17.023 126.545 16.9332C126.558 16.8435 126.588 16.7572 126.635 16.6793C126.682 16.6015 126.744 16.5337 126.818 16.4798C126.892 16.426 126.975 16.3872 127.064 16.3657C127.153 16.3442 127.245 16.3405 127.336 16.3547C127.426 16.369 127.513 16.4009 127.59 16.4486C132.766 19.511 136.784 24.1713 139.029 29.7145C141.274 35.2578 141.621 41.3777 140.018 47.1355C138.414 52.8932 134.949 57.9706 130.153 61.5888C125.357 65.2069 119.495 67.1659 113.468 67.1651V67.1694Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M39.8478 16.9088C37.8873 13.0922 41.5221 13.7541 42.1597 11.7512C42.6281 14.2182 39.7047 13.5263 39.8478 16.9088ZM45.2046 13.9002C45.2046 13.9002 45.4908 15.5377 43.9857 16.2039C44.4889 14.532 43.4956 13.9518 43.3958 13.7541C44.5192 12.7182 46.2802 11.0506 43.8816 5.41162C43.8816 5.41162 44.6147 8.97897 42.9447 10.4747C41.2748 11.9704 37.4102 12.8644 37.4102 15.8558C37.5273 19.0449 39.3924 19.075 40.4464 19.1094C41.0753 19.1094 42.2985 19.161 42.7799 19.1094C43.2521 19.1054 43.7185 19.0059 44.1506 18.8171C45.8118 17.8501 45.8855 15.628 45.2046 13.9217V13.9002Z",
    fill: "#DF3929"
  }), React__namespace.default.createElement("path", {
    d: "M45.2049 18.4817C45.1636 18.4208 45.1355 18.352 45.1225 18.2797C45.1225 18.125 45.1225 17.8886 45.1225 17.8886C45.0513 17.9929 44.9746 18.0933 44.8926 18.1895C44.8305 18.2457 44.7621 18.2947 44.6888 18.3356C44.5369 18.2969 44.3895 18.2625 44.255 18.2324C44.2096 18.1739 44.1771 18.1065 44.1596 18.0347C44.1378 17.9067 44.1234 17.7776 44.1162 17.6479C44.0551 17.7567 43.987 17.8615 43.9124 17.9617C43.8563 18.0255 43.7922 18.0818 43.7215 18.1293L43.2878 18.0562C43.2377 18.0037 43.2006 17.9405 43.1793 17.8714C43.1471 17.7455 43.1225 17.6177 43.1056 17.4889C43.0545 17.6019 42.995 17.7111 42.9278 17.8155C42.8778 17.8841 42.8178 17.9449 42.7499 17.9961L42.3162 17.9617C42.2613 17.9114 42.2184 17.8498 42.1904 17.7812C42.1493 17.6583 42.1146 17.5335 42.0863 17.4072C42.0447 17.5255 41.9939 17.6405 41.9345 17.7511C41.8882 17.8211 41.8344 17.886 41.774 17.9445H41.2448C41.1873 17.8988 41.14 17.8417 41.106 17.7769C41.0453 17.635 40.9759 17.4072 40.9759 17.4072C40.9414 17.5286 40.8994 17.6477 40.8501 17.764C40.8111 17.838 40.7614 17.9061 40.7026 17.966L40.2689 18.0047C40.2067 17.9638 40.1548 17.9094 40.1171 17.8456C40.0433 17.7081 39.9566 17.4932 39.9566 17.4932C39.9318 17.6152 39.8999 17.7358 39.8612 17.8542C39.8256 17.9302 39.782 18.0022 39.731 18.0691C39.5792 18.0691 39.4274 18.1121 39.2973 18.1422C39.2335 18.1043 39.1776 18.0547 39.1325 17.9961C39.0501 17.8671 38.946 17.6565 38.946 17.6565C38.9312 17.7797 38.908 17.9018 38.8766 18.0218C38.8514 18.1019 38.8133 18.1774 38.7638 18.2453L38.33 18.3571C38.2618 18.3259 38.2011 18.2805 38.1522 18.2239C38.0758 18.1186 38.0049 18.0096 37.9397 17.8972C37.9347 18.0225 37.9216 18.1474 37.9006 18.2711C37.8553 18.3482 37.7999 18.4191 37.7358 18.4817L37.3628 18.6021C37.532 19.0878 37.7011 19.5734 37.8659 20.0591C40.231 19.3245 42.7662 19.3245 45.1312 20.0591C45.3003 19.5734 45.4695 19.0878 45.6343 18.6021L45.2006 18.4602L45.2049 18.4817Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M67.07 32.4072H67.1134C67.1654 32.4072 67.2088 32.4072 67.2088 32.3471C67.2088 32.2869 67.1828 32.2869 67.1221 32.2869H67.07V32.4029V32.4072ZM67.07 32.6393H66.9746V32.2353C67.0279 32.2298 67.0817 32.2298 67.1351 32.2353C67.1847 32.2316 67.2344 32.242 67.2782 32.2654C67.2908 32.2769 67.3007 32.2909 67.3074 32.3064C67.3142 32.322 67.3175 32.3387 67.3173 32.3557C67.3149 32.3785 67.3052 32.4001 67.2896 32.4171C67.274 32.4341 67.2533 32.4457 67.2305 32.4502V32.4502C67.2512 32.4584 67.2693 32.4718 67.283 32.4892C67.2967 32.5066 67.3056 32.5272 67.3086 32.5491C67.3115 32.5851 67.3219 32.6202 67.3389 32.6522H67.2305C67.2141 32.6211 67.2024 32.5878 67.1958 32.5534C67.1958 32.5061 67.1654 32.4889 67.1134 32.4889H67.0657V32.6522L67.07 32.6393ZM66.8185 32.4244C66.8173 32.4669 66.8247 32.5092 66.8403 32.5488C66.856 32.5884 66.8794 32.6245 66.9093 32.6549C66.9393 32.6854 66.975 32.7096 67.0146 32.7261C67.0541 32.7426 67.0965 32.7511 67.1394 32.7511C67.1815 32.7511 67.2233 32.7427 67.262 32.7264C67.3008 32.71 67.3358 32.686 67.365 32.6559C67.3942 32.6258 67.4169 32.5902 67.4318 32.5511C67.4467 32.5121 67.4535 32.4704 67.4517 32.4287C67.4517 32.3455 67.4184 32.2657 67.359 32.2069C67.2996 32.148 67.2191 32.115 67.1351 32.115C67.0511 32.115 66.9706 32.148 66.9112 32.2069C66.8518 32.2657 66.8185 32.3455 66.8185 32.4287V32.4244ZM67.5558 32.4244C67.5323 32.5174 67.4781 32.5999 67.4019 32.6588C67.3257 32.7177 67.2318 32.7497 67.1351 32.7497C67.0384 32.7497 66.9445 32.7177 66.8683 32.6588C66.792 32.5999 66.7379 32.5174 66.7144 32.4244C66.7379 32.3315 66.792 32.249 66.8683 32.1901C66.9445 32.1311 67.0384 32.0991 67.1351 32.0991C67.2318 32.0991 67.3257 32.1311 67.4019 32.1901C67.4781 32.249 67.5323 32.3315 67.5558 32.4244Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M65.5868 26.7464C66.1949 26.6524 66.7523 26.3552 67.1665 25.9041C67.5807 25.453 67.8268 24.8752 67.864 24.2664V24.1289C67.864 22.1948 66.3285 21.0472 63.7954 21.0472H56.4825V32.1103L52.1884 21.0601H47.5387L43.3747 31.9384L44.0297 21.9197C44.9839 21.7048 45.5998 21.3696 45.5998 20.9956C45.5998 20.3466 43.7651 19.8223 41.5053 19.8223C39.2454 19.8223 37.4107 20.3466 37.4107 20.9956C37.4107 21.4254 38.1481 21.7693 39.2671 21.9799L39.7009 25.904L39.8006 26.9355L39.3669 26.4455L38.6425 25.5558L34.9167 21.0601H31.2515V32.1103L26.9618 21.0601H22.312L17.9355 32.4455H21.7135L22.4075 30.563H26.168L26.7839 32.4455H35.2246V27.0773L35.9663 27.9842L39.7269 32.4326H46.9444L47.6384 30.5501H51.399L52.0106 32.4326H63.9386C66.4716 32.4326 67.9897 31.2851 67.9897 29.351V29.1662C67.9897 28.1346 67.183 27.0386 65.5868 26.7464ZM23.2966 28.0831L24.4114 24.8638L25.396 28.0831H23.2966ZM41.0325 31.4957C41.0377 31.5449 41.0242 31.5943 40.9944 31.6341C40.9647 31.6739 40.921 31.7012 40.872 31.7106C40.8479 31.7101 40.8241 31.7047 40.8021 31.6948C40.7802 31.6849 40.7605 31.6706 40.7443 31.6529C40.728 31.6352 40.7156 31.6145 40.7077 31.5919C40.6999 31.5693 40.6967 31.5453 40.6985 31.5215V31.5215C40.6725 31.3753 40.3385 22.0143 40.3385 22.0143C40.3385 22.0143 40.898 28.4054 41.0498 31.4957H41.0325ZM41.6354 31.4957C41.6392 31.5443 41.6244 31.5926 41.5938 31.6309C41.5633 31.6691 41.5192 31.6945 41.4706 31.702C41.4223 31.6966 41.3779 31.6731 41.3464 31.6364C41.315 31.5996 41.2989 31.5524 41.3014 31.5043V31.5043C41.3014 31.3452 41.3318 21.0171 41.3491 21.0171C41.3665 21.0171 41.5616 28.4097 41.6397 31.5043L41.6354 31.4957ZM42.2383 31.4957C42.2408 31.5438 42.2247 31.591 42.1933 31.6278C42.1618 31.6645 42.1174 31.688 42.0691 31.6934C42.0201 31.686 41.9756 31.6607 41.9443 31.6226C41.9131 31.5845 41.8972 31.5362 41.9 31.4871V31.4871C41.9 31.3281 42.1646 21.0042 42.1862 21.0085C42.2079 21.0128 42.2426 28.4183 42.2383 31.5129V31.4957ZM42.8369 31.4957C42.8386 31.5195 42.8355 31.5435 42.8276 31.5661C42.8197 31.5887 42.8073 31.6095 42.7911 31.6271C42.7749 31.6448 42.7552 31.6591 42.7332 31.669C42.7112 31.6789 42.6875 31.6843 42.6634 31.6848C42.6143 31.6754 42.5706 31.6481 42.5409 31.6083C42.5112 31.5685 42.4976 31.5191 42.5029 31.4699V31.4699C42.5029 31.3109 43.1014 21.9885 43.1014 21.9885C43.1014 21.9885 42.941 28.4269 42.8369 31.5172V31.4957ZM48.5233 28.0573L49.638 24.8381L50.6226 28.0573H48.5233ZM63.6653 28.5859C63.6653 29.1705 63.327 29.4455 62.5029 29.4455H60.8069V27.5673H62.5029C63.327 27.5673 63.6653 27.8424 63.6653 28.4269V28.5859ZM63.6653 25.0787C63.6653 25.659 63.327 25.9383 62.5029 25.9383H60.8069V24.0687H62.5029C63.327 24.0687 63.6653 24.3438 63.6653 24.9283V25.0787Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M10.2493 36.2925H11.03L11.1949 39.4171H10.5356V38.7595H9.6941L9.40783 39.4171H8.74854L10.2493 36.2925ZM9.91531 38.2524H10.5312V36.8383L9.91531 38.2524Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M13.1471 36.2925L13.4551 38.4415L13.9105 36.2925H14.4918L13.8238 39.4171H13.1124L12.8045 37.2294L12.336 39.4171H11.7505L12.4185 36.2925H13.1471Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M15.3244 38.4414V38.5359C15.2594 38.8282 15.3244 39.0173 15.6367 39.0173C15.7476 39.017 15.8548 38.978 15.9396 38.9073C16.0244 38.8366 16.0815 38.7386 16.1008 38.6305C16.1616 38.3468 16.0358 38.2394 15.6671 38.0975C15.1466 37.9041 14.9341 37.6677 15.0468 37.152C15.09 36.8883 15.2289 36.6493 15.4373 36.4799C15.6458 36.3105 15.9095 36.2224 16.1789 36.2322C16.7428 36.2322 17.1028 36.4729 16.9727 37.0918V37.1777H16.3654C16.4261 36.8855 16.3654 36.7136 16.1225 36.7136C16.0179 36.7124 15.9164 36.7487 15.8367 36.8158C15.757 36.883 15.7045 36.9764 15.6888 37.0789C15.6454 37.268 15.6888 37.3883 15.923 37.5087L16.3567 37.7193C16.4418 37.7431 16.521 37.7839 16.5895 37.8392C16.6579 37.8946 16.7143 37.9632 16.7549 38.041C16.7956 38.1187 16.8197 38.2039 16.8258 38.2912C16.8319 38.3786 16.8199 38.4663 16.7905 38.5488C16.7393 38.8436 16.5756 39.1075 16.3333 39.2859C16.0911 39.4644 15.7888 39.5436 15.4892 39.5073C14.7736 39.5073 14.5654 39.172 14.6868 38.5961L14.7128 38.4671L15.3244 38.4414Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M17.2544 39.4171L17.9224 36.2925H18.5556L17.8877 39.4171H17.2544Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M20.7853 36.2925H21.2884L21.7655 38.9014L22.3251 36.2925H22.7111L22.0431 39.4171H21.5183L21.0542 36.8899L20.512 39.4171H20.126L20.7853 36.2925Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M23.1747 37.7837C23.1855 37.6702 23.219 37.5599 23.2732 37.4594C23.3275 37.3588 23.4013 37.27 23.4905 37.198C23.5797 37.126 23.6825 37.0723 23.7929 37.04C23.9032 37.0078 24.0189 36.9976 24.1333 37.01C24.849 37.01 24.7579 37.4398 24.7058 37.6848L24.4239 38.9742C24.4022 39.0688 24.3849 39.1591 24.4976 39.1591C24.5288 39.1679 24.5619 39.1679 24.5931 39.1591L24.5367 39.4212C24.463 39.4265 24.3891 39.4265 24.3155 39.4212C24.1723 39.4212 23.9988 39.4212 24.0465 39.1204C23.9707 39.2197 23.8741 39.3014 23.7632 39.3601C23.6524 39.4187 23.53 39.4528 23.4046 39.4599C22.9709 39.4599 22.819 39.1977 22.9101 38.7765C22.9326 38.624 22.9996 38.4813 23.1029 38.366C23.2062 38.2507 23.3412 38.1678 23.4913 38.1275L24.0205 37.9771C24.3068 37.8954 24.3241 37.8224 24.3675 37.6247C24.4109 37.427 24.3068 37.2808 24.0596 37.2808C23.9347 37.285 23.8154 37.3332 23.7232 37.4167C23.631 37.5002 23.5718 37.6136 23.5564 37.7364V37.7622L23.1747 37.7837ZM24.2374 38.1404C24.0726 38.2866 23.7386 38.3166 23.5477 38.4155C23.4777 38.4526 23.4178 38.506 23.3732 38.5712C23.3287 38.6363 23.3007 38.7112 23.2918 38.7894C23.2398 39.0258 23.2918 39.1891 23.5391 39.1891C23.6669 39.1843 23.7902 39.1405 23.8919 39.0635C23.9937 38.9866 24.0689 38.8803 24.1073 38.7593L24.2374 38.1404Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M25.9728 36.3911H26.3414L26.194 37.0745H26.6017L26.541 37.3625H26.1332L25.8123 38.8668C25.7689 39.0559 25.8123 39.1289 25.9988 39.1289C26.0537 39.1325 26.1087 39.1325 26.1636 39.1289L26.0985 39.4298C25.9983 39.4474 25.8967 39.456 25.7949 39.4556C25.4089 39.4556 25.3612 39.3009 25.4176 38.9957L25.7646 37.3754H25.4219L25.4826 37.0874H25.8253L25.9728 36.3911Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M27.2088 37.0747H27.5774L27.0786 39.4171H26.71L27.2088 37.0747ZM27.3779 36.2925H27.7596L27.6685 36.7223H27.2998L27.3779 36.2925Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M29.165 37.0103C29.8504 37.0103 29.8937 37.5862 29.7506 38.2481C29.6075 38.91 29.3169 39.4816 28.6402 39.4816C27.9636 39.4816 27.9115 38.9057 28.0546 38.2524C28.1978 37.5991 28.4884 37.0103 29.165 37.0103ZM29.3646 38.2524C29.473 37.7409 29.4904 37.3068 29.0956 37.3068C28.7009 37.3068 28.5491 37.7366 28.4407 38.2524C28.3322 38.7681 28.3149 39.1936 28.6923 39.1936C29.0696 39.1936 29.2561 38.7552 29.3646 38.2524Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M30.7045 37.0747H31.0559L30.9995 37.3498C31.0746 37.2447 31.174 37.1589 31.2895 37.0998C31.405 37.0407 31.5331 37.01 31.6631 37.0103C32.2834 37.0103 32.1836 37.4787 32.1272 37.7538L31.7716 39.4171H31.3985L31.7455 37.8011C31.7846 37.6206 31.8366 37.3283 31.4983 37.3283C31.3638 37.3309 31.2343 37.3794 31.1316 37.4655C31.029 37.5516 30.9593 37.6701 30.9344 37.8011L30.5874 39.4171H30.2188L30.7045 37.0747Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M32.8695 37.7842C32.8803 37.6711 32.9137 37.5613 32.9676 37.461C33.0216 37.3608 33.095 37.2721 33.1838 37.2002C33.2725 37.1282 33.3747 37.0744 33.4846 37.0419C33.5944 37.0093 33.7097 36.9987 33.8237 37.0106C34.5394 37.0106 34.4483 37.4404 34.3963 37.6854L34.1187 38.9748C34.1187 39.0693 34.0753 39.1596 34.1924 39.1596C34.2221 39.1685 34.2538 39.1685 34.2835 39.1596L34.2271 39.4217C34.1535 39.4275 34.0795 39.4275 34.0059 39.4217C33.8671 39.4217 33.6893 39.4217 33.737 39.1209C33.6616 39.2196 33.5657 39.3011 33.4556 39.3597C33.3456 39.4183 33.224 39.4527 33.0994 39.4604C32.6656 39.4604 32.5138 39.1983 32.6006 38.777C32.6239 38.6242 32.6917 38.4814 32.7957 38.3661C32.8997 38.2508 33.0354 38.1681 33.1861 38.128L33.7153 37.9776C34.0016 37.896 34.0146 37.8229 34.0579 37.6252C34.1013 37.4275 34.0015 37.2813 33.7543 37.2813C33.6292 37.2846 33.5094 37.3325 33.417 37.4162C33.3246 37.4999 33.2657 37.6137 33.2512 37.7369V37.7627L32.8695 37.7842ZM33.9322 38.1409C33.763 38.2871 33.429 38.3172 33.2425 38.416C33.1719 38.4529 33.1113 38.5062 33.066 38.5713C33.0207 38.6364 32.9919 38.7114 32.9822 38.7899C32.9302 39.0263 32.9822 39.1897 33.2295 39.1897C33.3578 39.1845 33.4814 39.1405 33.5838 39.0637C33.6861 38.9869 33.7623 38.8808 33.802 38.7599L33.9322 38.1409Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M35.5674 36.2925H35.9404L35.2724 39.4171H34.8994L35.5674 36.2925Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M38.603 36.2925H39.1235L39.297 39.4171H38.9066L38.8676 38.5575H37.8656L37.4319 39.4171H37.0415L38.603 36.2925ZM38.0088 38.2524H38.8762L38.7982 36.7395L38.0088 38.2524Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M41.3227 37.7878C41.3705 37.56 41.3227 37.3021 41.0538 37.3021C40.7849 37.3021 40.568 37.4139 40.3859 38.2735C40.3165 38.5787 40.1907 39.189 40.6374 39.189C40.9541 39.189 41.0712 38.858 41.1492 38.6045H41.5179C41.4814 38.8355 41.3657 39.047 41.1904 39.2036C41.0151 39.3601 40.7907 39.4521 40.555 39.4641C39.9825 39.4641 39.822 39.0643 39.9955 38.2606C40.1213 37.6718 40.3815 36.9712 41.1059 36.9712C41.7478 36.9712 41.7521 37.4741 41.6914 37.7491L41.3227 37.7878Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M43.5309 37.7878C43.5786 37.56 43.5309 37.3021 43.2619 37.3021C42.993 37.3021 42.7762 37.4139 42.5897 38.2735C42.5246 38.5787 42.3988 39.189 42.8456 39.189C43.1622 39.189 43.2793 38.858 43.3574 38.6045H43.726C43.6895 38.8355 43.5739 39.047 43.3985 39.2036C43.2232 39.3601 42.9988 39.4521 42.7631 39.4641C42.1863 39.4641 42.0301 39.0643 42.2036 38.2606C42.3294 37.6718 42.5897 36.9712 43.314 36.9712C43.9559 36.9712 43.9603 37.4741 43.8995 37.7491L43.5309 37.7878Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M44.7706 37.0747H45.1393L45.0656 37.4228C45.1194 37.3069 45.2022 37.2065 45.3062 37.1313C45.4103 37.0561 45.532 37.0084 45.6598 36.993C45.7146 36.9893 45.7695 36.9982 45.8203 37.0188L45.7422 37.3798C45.6773 37.3732 45.6119 37.3732 45.547 37.3798C45.3998 37.3958 45.2616 37.4584 45.153 37.5582C45.0444 37.6581 44.9712 37.7899 44.9441 37.9343L44.6275 39.4171H44.2588L44.7706 37.0747Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M46.4548 38.2906C46.3767 38.6473 46.2596 39.1889 46.715 39.1889C47.0663 39.1889 47.1921 38.8236 47.2312 38.6473H47.5998C47.5562 38.8744 47.4365 39.0802 47.2602 39.2315C47.0839 39.3828 46.8613 39.4707 46.6283 39.4812C46.0557 39.4812 45.8952 39.0814 46.0687 38.2777C46.1945 37.6889 46.4548 36.9883 47.1791 36.9883C47.9035 36.9883 47.8341 37.6158 47.7256 38.1187L47.6953 38.2691L46.4548 38.2906ZM47.37 37.9983L47.396 37.8737C47.4524 37.6115 47.435 37.302 47.1097 37.302C46.7844 37.302 46.5762 37.7748 46.5458 37.9124V37.9983H47.37Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M49.7419 39.4168H49.3905L49.4469 39.1116C49.3888 39.2158 49.3041 39.3032 49.2014 39.365C49.0987 39.4268 48.9815 39.461 48.8614 39.4641C48.3062 39.4641 48.1977 38.9698 48.3582 38.2305C48.4623 37.7362 48.7009 36.9927 49.3645 36.9927C49.4642 36.99 49.5617 37.0215 49.6407 37.0818C49.7197 37.1421 49.7754 37.2275 49.7982 37.3236V37.3236L50.0195 36.2749H50.3881L49.7419 39.4168ZM48.9741 39.1632C49.3819 39.1632 49.5337 38.7807 49.6464 38.2477C49.7419 37.7921 49.7636 37.3279 49.3688 37.3279C48.9741 37.3279 48.8614 37.6847 48.7399 38.2477C48.6185 38.8107 48.6315 39.1632 48.9741 39.1632V39.1632Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M51.0823 37.0747H51.4553L50.9522 39.4171H50.5835L51.0823 37.0747ZM51.2515 36.2925H51.6158L51.5247 36.7223H51.1821L51.2515 36.2925Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M52.5483 36.3911H52.917L52.7739 37.0745H53.1816L53.1209 37.3625H52.7132L52.3878 38.8668C52.3488 39.0559 52.3878 39.1289 52.5744 39.1289C52.6292 39.1327 52.6843 39.1327 52.7392 39.1289L52.6741 39.4298C52.574 39.4479 52.4723 39.4565 52.3705 39.4556C51.9888 39.4556 51.9367 39.3009 51.9975 38.9957L52.3401 37.3754H51.9975L52.0625 37.0874H52.4052L52.5483 36.3911Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M53.559 37.7842C53.5698 37.6711 53.6032 37.5613 53.6571 37.461C53.7111 37.3608 53.7845 37.2721 53.8733 37.2002C53.962 37.1282 54.0643 37.0744 54.1741 37.0419C54.284 37.0093 54.3992 36.9987 54.5133 37.0106C55.2333 37.0106 55.1379 37.4404 55.0858 37.6854L54.8082 38.9748C54.8082 39.0693 54.7692 39.1596 54.8819 39.1596C54.9115 39.1691 54.9434 39.1691 54.973 39.1596L54.9166 39.4217C54.8445 39.4273 54.772 39.4273 54.6998 39.4217C54.5566 39.4217 54.3831 39.4217 54.4265 39.1209C54.3512 39.2196 54.2552 39.3011 54.1451 39.3597C54.0351 39.4183 53.9136 39.4527 53.7889 39.4604C53.3551 39.4604 53.2033 39.1983 53.2944 38.777C53.3158 38.6241 53.3825 38.4809 53.4859 38.3654C53.5893 38.2499 53.7249 38.1673 53.8756 38.128L54.4048 37.9776C54.6911 37.896 54.7041 37.8229 54.7475 37.6252C54.7909 37.4275 54.6911 37.2813 54.4439 37.2813C54.3187 37.2846 54.199 37.3325 54.1066 37.4162C54.0141 37.4999 53.9553 37.6137 53.9407 37.7369V37.7627L53.559 37.7842ZM54.6217 38.1409C54.4525 38.2871 54.1229 38.3172 53.932 38.416C53.8614 38.4529 53.8009 38.5062 53.7555 38.5713C53.7102 38.6364 53.6815 38.7114 53.6718 38.7899C53.6241 39.0263 53.6718 39.1897 53.919 39.1897C54.0473 39.1845 54.171 39.1405 54.2733 39.0637C54.3757 38.9869 54.4518 38.8808 54.4916 38.7599L54.6217 38.1409Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M56.352 36.3911H56.7207L56.5776 37.0745H56.9853L56.9246 37.3625H56.5169L56.1916 38.8668C56.1525 39.0559 56.1915 39.1289 56.3781 39.1289C56.4329 39.1327 56.488 39.1327 56.5429 39.1289L56.4778 39.4298C56.3777 39.4479 56.276 39.4565 56.1742 39.4556C55.7925 39.4556 55.7405 39.3009 55.8012 38.9957L56.1438 37.3754H55.8012L55.8619 37.0874H56.2089L56.352 36.3911Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M57.593 37.0747H57.9617L57.4629 39.4171H57.0898L57.593 37.0747ZM57.7578 36.2925H58.1222L58.0311 36.7223H57.6884L57.7578 36.2925Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M59.5494 37.0103C60.2304 37.0103 60.2781 37.5862 60.135 38.2481C59.9919 38.91 59.7013 39.4816 59.0203 39.4816C58.3393 39.4816 58.2959 38.9057 58.439 38.2481C58.5822 37.5905 58.8728 37.0103 59.5494 37.0103ZM59.749 38.2481C59.8574 37.7366 59.8747 37.3025 59.48 37.3025C59.0853 37.3025 58.9335 37.7323 58.8251 38.2481C58.7166 38.7638 58.695 39.1893 59.0767 39.1893C59.4584 39.1893 59.6405 38.7552 59.749 38.2524V38.2481Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M61.0889 37.0747H61.4403L61.3795 37.3498C61.4517 37.2468 61.5476 37.1623 61.6592 37.1033C61.7708 37.0443 61.895 37.0124 62.0215 37.0103C62.6417 37.0103 62.542 37.4787 62.4813 37.7538L62.1256 39.4171H61.7569L62.1039 37.8011C62.1429 37.6206 62.1906 37.3283 61.8567 37.3283C61.7214 37.33 61.5909 37.378 61.4873 37.4641C61.3838 37.5503 61.3135 37.6694 61.2884 37.8011L60.9458 39.4171H60.5728L61.0889 37.0747Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M65.0272 36.2925H65.9902C66.4239 36.2925 66.7536 36.4859 66.6234 37.0962C66.5922 37.2472 66.5206 37.3872 66.416 37.5014C66.3115 37.6156 66.1779 37.6998 66.0292 37.7452V37.7452C66.3979 37.8398 66.5063 38.132 66.4239 38.5188C66.381 38.7943 66.2305 39.042 66.0049 39.2084C65.7793 39.3749 65.4967 39.4468 65.2181 39.4085H64.3506L65.0272 36.2925ZM64.8147 39.112H65.3439C65.508 39.1153 65.6675 39.0583 65.7917 38.952C65.9159 38.8456 65.9958 38.6974 66.0162 38.536C66.1073 38.1062 65.8644 37.9386 65.5261 37.9386H65.0619L64.8147 39.112ZM65.127 37.6506H65.5607C65.7148 37.6608 65.8671 37.6129 65.987 37.5164C66.1069 37.4199 66.1855 37.2821 66.207 37.1306C66.2764 36.8082 66.155 36.6191 65.7733 36.6191H65.3395L65.127 37.6506Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M68.2109 37.0103C68.8962 37.0103 68.9396 37.5862 68.7965 38.2481C68.6534 38.91 68.3627 39.4816 67.6861 39.4816C67.0095 39.4816 66.9574 38.9057 67.1005 38.2481C67.2437 37.5905 67.5343 37.0103 68.2109 37.0103ZM68.4105 38.2481C68.5189 37.7366 68.5362 37.3025 68.1415 37.3025C67.7468 37.3025 67.595 37.7323 67.4866 38.2481C67.3781 38.7638 67.3608 39.1893 67.7381 39.1893C68.1155 39.1893 68.302 38.7552 68.4105 38.2524V38.2481Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M69.5424 37.7837C69.5532 37.6702 69.5867 37.5599 69.6409 37.4594C69.6951 37.3588 69.769 37.27 69.8582 37.198C69.9474 37.126 70.0502 37.0723 70.1605 37.04C70.2709 37.0078 70.3866 36.9976 70.501 37.01C71.2166 37.01 71.1255 37.4398 71.0735 37.6848L70.7916 38.9742C70.7699 39.0688 70.7525 39.1591 70.8653 39.1591C70.8965 39.1679 70.9295 39.1679 70.9607 39.1591L70.9043 39.4212C70.8307 39.4265 70.7568 39.4265 70.6831 39.4212C70.54 39.4212 70.3665 39.4212 70.4142 39.1204C70.3384 39.2197 70.2417 39.3014 70.1309 39.3601C70.0201 39.4187 69.8977 39.4528 69.7723 39.4599C69.3385 39.4599 69.1867 39.1977 69.2778 38.7765C69.3021 38.631 69.367 38.4952 69.4651 38.3843C69.5632 38.2734 69.6906 38.1919 69.833 38.149L70.3622 37.9986C70.6484 37.9169 70.6658 37.8439 70.7048 37.6462C70.7439 37.4484 70.6484 37.3023 70.4012 37.3023C70.2761 37.3056 70.1563 37.3535 70.0639 37.4371C69.9715 37.5208 69.9126 37.6347 69.8981 37.7579V37.7837H69.5424ZM70.6051 38.1404C70.4359 38.2866 70.1063 38.3166 69.9154 38.4155C69.8454 38.4526 69.7855 38.506 69.7409 38.5712C69.6963 38.6363 69.6684 38.7112 69.6595 38.7894C69.6075 39.0258 69.6595 39.1891 69.9067 39.1891C70.0346 39.1843 70.1579 39.1405 70.2596 39.0635C70.3613 38.9866 70.4365 38.8803 70.4749 38.7593L70.6051 38.1404Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M72.0368 37.0744H72.4098L72.3317 37.4225C72.3866 37.3065 72.4703 37.2062 72.575 37.1311C72.6797 37.0559 72.8019 37.0083 72.9303 36.9927C72.9837 36.9885 73.0373 36.9973 73.0864 37.0185L73.0127 37.3796C72.9478 37.3732 72.8824 37.3732 72.8175 37.3796C72.67 37.3949 72.5315 37.4572 72.4228 37.5572C72.3141 37.6572 72.241 37.7894 72.2146 37.934L71.898 39.4168H71.5293L72.0368 37.0744Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M74.7257 39.4171H74.3744L74.4351 39.1291C74.3766 39.2331 74.2919 39.3202 74.1893 39.382C74.0867 39.4437 73.9696 39.4781 73.8496 39.4816C73.29 39.4816 73.1859 38.9873 73.3421 38.2481C73.4505 37.7538 73.6891 37.0102 74.3527 37.0102C74.4524 37.0076 74.5499 37.0391 74.6289 37.0993C74.7079 37.1596 74.7636 37.245 74.7865 37.3412V37.3412L75.012 36.2925H75.3807L74.7257 39.4171ZM73.958 39.1635C74.3657 39.1635 74.5132 38.781 74.6303 38.2481C74.7257 37.7925 74.7474 37.3283 74.3484 37.3283C73.9493 37.3283 73.8409 37.685 73.7238 38.2481C73.6067 38.8111 73.6154 39.1635 73.958 39.1635V39.1635Z",
    fill: "#231815"
  }), React__namespace.default.createElement("path", {
    d: "M75.1029 34.1948H8.74854V34.4828H75.1029V34.1948Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M75.1029 41.1836H8.74854V41.4716H75.1029V41.1836Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M48.0333 51.8339C47.9454 51.8281 47.8573 51.8411 47.7749 51.8719C47.6925 51.9028 47.6177 51.9508 47.5556 52.0127C47.4936 52.0746 47.4456 52.149 47.415 52.2309C47.3844 52.3127 47.3719 52.4001 47.3783 52.4872V53.1362C47.3628 53.2296 47.3681 53.3253 47.3937 53.4166C47.4193 53.5079 47.4646 53.5925 47.5265 53.6647C47.5883 53.7369 47.6653 53.7949 47.7521 53.8347C47.8389 53.8745 47.9333 53.8951 48.0289 53.8951C48.1245 53.8951 48.219 53.8745 48.3057 53.8347C48.3925 53.7949 48.4695 53.7369 48.5314 53.6647C48.5933 53.5925 48.6386 53.5079 48.6642 53.4166C48.6897 53.3253 48.695 53.2296 48.6795 53.1362V52.4872C48.6851 52.401 48.6723 52.3147 48.642 52.2338C48.6116 52.1529 48.5644 52.0793 48.5035 52.0176C48.4425 51.956 48.3691 51.9078 48.2881 51.8761C48.2071 51.8445 48.1203 51.8301 48.0333 51.8339V51.8339Z",
    fill: "#DF3929"
  }), React__namespace.default.createElement("path", {
    d: "M33.4768 51.8428C33.3829 51.8347 33.2885 51.8466 33.1997 51.8777C33.1109 51.9088 33.0299 51.9585 32.9621 52.0232C32.8943 52.088 32.8412 52.1663 32.8066 52.2531C32.7719 52.3399 32.7564 52.433 32.7611 52.5262V53.0892C32.7611 53.2773 32.8365 53.4577 32.9707 53.5907C33.1049 53.7237 33.2869 53.7984 33.4768 53.7984C33.6666 53.7984 33.8486 53.7237 33.9828 53.5907C34.117 53.4577 34.1924 53.2773 34.1924 53.0892V52.5262C34.1971 52.433 34.1816 52.3399 34.1469 52.2531C34.1123 52.1663 34.0592 52.088 33.9914 52.0232C33.9236 51.9585 33.8426 51.9088 33.7538 51.8777C33.665 51.8466 33.5706 51.8347 33.4768 51.8428V51.8428Z",
    fill: "#DF3929"
  }), React__namespace.default.createElement("path", {
    d: "M59.3456 52.4743V50.5703H24.4117V52.4743H8.64941V52.9514H24.4117V54.8984H59.3456V52.9514H75.1035V52.4743H59.3456ZM29.3 54.0775H28.8663V51.5417H29.3V54.0775ZM31.9372 53.3683C31.9372 53.8325 31.5035 54.1592 30.8789 54.1592C30.4551 54.1584 30.0462 54.004 29.7294 53.7251L30.0114 53.4113C30.2685 53.6549 30.6099 53.7918 30.9656 53.7938C31.3169 53.7938 31.4904 53.6391 31.4904 53.4242C31.4904 52.8612 29.8292 53.1491 29.8292 52.2465C29.8292 51.8167 30.2239 51.4772 30.8745 51.4772C31.0814 51.4661 31.2878 51.5058 31.4755 51.5928C31.6631 51.6797 31.8262 51.8113 31.9502 51.9758L31.6423 52.2336C31.5491 52.1201 31.4322 52.0279 31.2997 51.9634C31.1672 51.8989 31.0221 51.8635 30.8745 51.8597C30.5189 51.8597 30.2716 51.993 30.2716 52.2036C30.2716 52.6935 31.9372 52.5001 31.9372 53.3683ZM34.6394 53.0847C34.6143 53.373 34.4809 53.6415 34.2657 53.8371C34.0505 54.0327 33.769 54.1412 33.477 54.1412C33.185 54.1412 32.9035 54.0327 32.6883 53.8371C32.4731 53.6415 32.3397 53.373 32.3146 53.0847V52.5302C32.3397 52.2419 32.4731 51.9734 32.6883 51.7778C32.9035 51.5822 33.185 51.4736 33.477 51.4736C33.769 51.4736 34.0505 51.5822 34.2657 51.7778C34.4809 51.9734 34.6143 52.2419 34.6394 52.5302V53.0847ZM35.225 54.4557H34.9257L35.9624 51.301H36.2573L35.225 54.4557ZM37.0597 54.0775H36.626V51.5417H37.0597V54.0775ZM39.5234 51.9285H38.1094V52.5904H39.1721V52.9514H38.1094V53.7079H39.5234V54.0861H37.667V51.5503H39.5234V51.9285ZM41.1066 53.7852C41.261 53.7889 41.4128 53.7455 41.5416 53.661C41.6704 53.5764 41.7698 53.4548 41.8266 53.3124L42.1953 53.4758C42.0991 53.6853 41.9421 53.8618 41.7444 53.9828C41.5466 54.1037 41.3171 54.1636 41.0849 54.1549C40.9322 54.1663 40.7787 54.1459 40.6344 54.0951C40.4901 54.0442 40.3581 53.9639 40.247 53.8595C40.1359 53.755 40.048 53.6287 39.9892 53.4886C39.9303 53.3485 39.9016 53.1977 39.9051 53.046V52.5904C39.9022 52.4352 39.9321 52.2812 39.9928 52.1382C40.0536 51.9951 40.1438 51.8663 40.2577 51.7598C40.3717 51.6534 40.5068 51.5717 40.6545 51.5201C40.8022 51.4685 40.9591 51.448 41.1153 51.46C41.3451 51.4545 41.5715 51.5164 41.766 51.638C41.9605 51.7596 42.1143 51.9354 42.2083 52.1434L41.8353 52.3067C41.7709 52.1687 41.6682 52.0517 41.5391 51.9695C41.4101 51.8873 41.26 51.8432 41.1066 51.8425C41.0065 51.8329 40.9056 51.845 40.8108 51.878C40.716 51.9111 40.6296 51.9643 40.5577 52.0339C40.4858 52.1035 40.4301 52.1878 40.3946 52.281C40.359 52.3741 40.3444 52.4739 40.3519 52.5732V53.0632C40.3478 53.1609 40.3648 53.2584 40.4017 53.3491C40.4387 53.4398 40.4948 53.5217 40.5662 53.5892C40.6376 53.6567 40.7228 53.7084 40.816 53.7407C40.9092 53.773 41.0082 53.7853 41.1066 53.7766V53.7852ZM44.1124 54.0861H43.6787V51.748C43.7076 51.7519 43.7369 51.7494 43.7647 51.7406C43.7924 51.7318 43.8178 51.717 43.8391 51.6972C43.8603 51.6774 43.8767 51.6532 43.8873 51.6263C43.8978 51.5994 43.9021 51.5704 43.8999 51.5417H44.1081L44.1124 54.0861ZM46.6629 51.8554C46.0391 52.4515 45.6332 53.2362 45.5091 54.0861H45.0493C45.1881 53.2665 45.5897 52.5129 46.1944 51.9371H44.6416V51.5675H46.6629V51.8554ZM49.1179 53.1448C49.0936 53.4132 48.9689 53.6629 48.7682 53.8447C48.5675 54.0266 48.3054 54.1274 48.0335 54.1274C47.7616 54.1274 47.4995 54.0266 47.2988 53.8447C47.0981 53.6629 46.9734 53.4132 46.9491 53.1448V52.5044C46.9734 52.236 47.0981 51.9864 47.2988 51.8045C47.4995 51.6227 47.7616 51.5218 48.0335 51.5218C48.3054 51.5218 48.5675 51.6227 48.7682 51.8045C48.9689 51.9864 49.0936 52.236 49.1179 52.5044V53.1448ZM51.4514 53.7122V54.0904H49.5082V53.9486C49.5082 52.8912 51.0394 52.8053 51.0394 52.2508C51.0394 52.0359 50.8659 51.821 50.5058 51.821C50.3695 51.8212 50.2358 51.8586 50.1195 51.9291C50.0032 51.9996 49.9087 52.1005 49.8466 52.2207L49.5386 52.0015C49.6359 51.8326 49.7777 51.693 49.9488 51.5976C50.1199 51.5022 50.3139 51.4547 50.5102 51.46C51.1434 51.46 51.4601 51.8296 51.4601 52.2207C51.4601 52.9385 50.2152 53.0804 49.9767 53.6993L51.4514 53.7122ZM52.4534 54.0904H52.0196V51.748C52.0485 51.7519 52.0779 51.7494 52.1056 51.7406C52.1334 51.7318 52.1588 51.717 52.18 51.6972C52.2012 51.6774 52.2177 51.6532 52.2282 51.6263C52.2387 51.5994 52.243 51.5704 52.2408 51.5417H52.449L52.4534 54.0904ZM54.3445 53.119H53.1994V52.7838H54.3445V53.119ZM55.3421 54.0904H54.9084V51.748C54.9374 51.7518 54.9669 51.7492 54.9949 51.7405C55.0228 51.7317 55.0485 51.717 55.07 51.6973C55.0915 51.6776 55.1084 51.6534 55.1195 51.6265C55.1305 51.5996 55.1354 51.5707 55.1339 51.5417H55.3421V54.0904Z",
    fill: "#DF3929"
  }), React__namespace.default.createElement("path", {
    d: "M16.942 59.9744V57.632L16.7902 58.0145L15.9227 59.9744H15.5453L14.6778 58.0145L14.526 57.632V59.9744H14.0186V56.9658H14.7472L15.6147 58.9515L15.7535 59.3254L15.8967 58.9558L16.7338 56.9658H17.4625V59.9744H16.942Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M20.2642 59.9744L19.9519 59.2137H18.6506L18.3644 59.9744H17.8525L19.08 56.9658H19.5745L20.815 59.9744H20.2642ZM19.3143 57.5933L18.8371 58.8226H19.8001L19.3143 57.5933Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M23.4222 59.9741L21.9952 58.1776L21.7436 57.8337V59.9827H21.2231V56.9741H21.6873L23.0709 58.7836L23.3181 59.1231V56.9741H23.83V59.9827L23.4222 59.9741Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M26.6495 59.9744L26.3545 59.2137H25.0533L24.7627 59.9744H24.2422L25.4654 56.9658H25.9598L27.2047 59.9744H26.6495ZM25.6996 57.5933L25.2225 58.8226H26.1897L25.6996 57.5933Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M29.7939 59.9741L29.7028 59.6174C29.5909 59.7593 29.4462 59.8725 29.2808 59.9473C29.1155 60.0221 28.9344 60.0564 28.7529 60.0472C28.5743 60.0583 28.3954 60.0319 28.2278 59.9698C28.0602 59.9076 27.9077 59.8111 27.7804 59.6866C27.6531 59.562 27.5537 59.4122 27.4888 59.247C27.424 59.0817 27.395 58.9048 27.4039 58.7277V58.1775C27.4017 57.9942 27.4378 57.8124 27.51 57.6435C27.5822 57.4747 27.6888 57.3225 27.8233 57.1965C27.9578 57.0706 28.1171 56.9735 28.2913 56.9116C28.4654 56.8496 28.6507 56.8241 28.8353 56.8366C29.1013 56.8193 29.3663 56.8834 29.5944 57.0202C29.8225 57.157 30.0026 57.36 30.1105 57.6016L29.6767 57.8337C29.6043 57.6734 29.4869 57.5371 29.3385 57.441C29.1901 57.345 29.0169 57.2933 28.8396 57.2922C28.7213 57.2808 28.6018 57.295 28.4895 57.3337C28.3772 57.3724 28.2747 57.4347 28.189 57.5163C28.1033 57.598 28.0364 57.6971 27.993 57.8068C27.9496 57.9164 27.9306 58.0341 27.9374 58.1518V58.7535C27.9305 58.8682 27.9481 58.983 27.9893 59.0904C28.0304 59.1978 28.0941 59.2954 28.1761 59.3766C28.258 59.4579 28.3565 59.5209 28.4649 59.5617C28.5733 59.6025 28.6892 59.62 28.8049 59.6131C28.9005 59.6202 28.9966 59.6077 29.0871 59.5763C29.1777 59.545 29.2607 59.4956 29.3311 59.431C29.4015 59.3665 29.4578 59.2883 29.4963 59.2013C29.5349 59.1144 29.555 59.0204 29.5553 58.9254V58.8137H28.857V58.3839H30.1018V59.9698L29.7939 59.9741Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M30.7354 59.9744V56.9658H32.9388V57.4214H31.2602V58.2036H32.5311V58.6335H31.2602V59.5317H32.9388V59.9873L30.7354 59.9744Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M36.4342 59.9744V57.632L36.2824 58.0145L35.4149 59.9744H35.0332L34.1657 58.0145L34.0139 57.632V59.9744H33.5107V56.9658H34.2655L35.133 58.9515L35.2761 59.3254L35.4192 58.9558L36.252 56.9658H36.9807V59.9744H36.4342Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M37.6582 59.9744V56.9658H39.866V57.4214H38.17V58.2036H39.4713V58.6335H38.17V59.5317H39.8486V59.9873L37.6582 59.9744Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M42.6284 59.9741L41.2057 58.1776L40.9541 57.8337V59.9827H40.438V56.9741H40.9021L42.2857 58.7836L42.533 59.1231V56.9741H43.0448V59.9827L42.6284 59.9741Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M45.1093 57.4087V59.9875H44.5844V57.4087H43.5435V56.9531H46.1459V57.4087H45.1093Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M49.0133 60.0692C48.5069 60.0614 48.0209 59.8703 47.647 59.5319L47.9853 59.158C48.2883 59.4503 48.6945 59.6137 49.1174 59.6136C49.5511 59.6136 49.742 59.4288 49.742 59.1838C49.742 58.5133 47.7641 58.8571 47.7641 57.7826C47.7641 57.2712 48.2369 56.8672 49.0089 56.8672C49.2543 56.8547 49.499 56.9023 49.7214 57.0058C49.9438 57.1092 50.1371 57.2653 50.2841 57.4603L49.9198 57.7655C49.8077 57.6335 49.6685 57.5269 49.5114 57.4528C49.3542 57.3786 49.1829 57.3387 49.0089 57.3357C48.5752 57.3357 48.2889 57.4947 48.2889 57.7655C48.2889 58.3672 50.2711 58.1351 50.2711 59.1666C50.2798 59.6781 49.768 60.0692 49.0133 60.0692Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M52.2184 58.7583V59.9746H51.6893V58.754L50.4878 56.9531H51.0907L51.9582 58.3457L52.8257 56.9531H53.4069L52.2184 58.7583Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M54.8687 60.0692C54.3625 60.0606 53.8768 59.8697 53.5024 59.5319L53.8408 59.158C54.144 59.4499 54.5501 59.6133 54.9728 59.6136C55.4066 59.6136 55.5974 59.4288 55.5974 59.1838C55.5974 58.5133 53.6196 58.8571 53.6196 57.7826C53.6196 57.2712 54.0923 56.8672 54.8644 56.8672C55.1098 56.8547 55.3544 56.9023 55.5768 57.0058C55.7992 57.1092 55.9925 57.2653 56.1396 57.4603L55.7752 57.7655C55.6632 57.6335 55.5239 57.5269 55.3668 57.4528C55.2097 57.3786 55.0384 57.3387 54.8644 57.3357C54.4306 57.3357 54.1444 57.4947 54.1444 57.7655C54.1444 58.3672 56.1266 58.1351 56.1266 59.1666C56.1266 59.6781 55.6148 60.0692 54.8687 60.0692Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M58.0263 57.4087V59.9875H57.4971V57.4087H56.4604V56.9531H59.0629V57.4087H58.0263Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M59.5796 59.9744V56.9658H61.783V57.4214H60.1044V58.2036H61.3666V58.6335H60.1044V59.5317H61.783V59.9873L59.5796 59.9744Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M65.2787 59.9744V57.632L65.1312 58.0145L64.2637 59.9744H63.8864L63.0189 58.0145L62.8714 57.632V59.9744H62.377V56.9658H63.1056L63.9731 58.9515L64.1163 59.3254L64.2594 58.9558L65.0965 56.9658H65.8209V59.9744H65.2787Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M67.6641 60.0693C67.1579 60.0608 66.6722 59.8698 66.2979 59.532L66.6362 59.1581C66.9413 59.4499 67.3486 59.6132 67.7726 59.6137C68.2063 59.6137 68.3928 59.4289 68.3928 59.1839C68.3928 58.5134 66.4193 58.8573 66.4193 57.7828C66.4193 57.2713 66.8877 56.8673 67.6598 56.8673C67.9058 56.8545 68.1513 56.9019 68.3744 57.0053C68.5976 57.1088 68.7916 57.2651 68.9394 57.4604L68.5707 57.7656C68.4592 57.633 68.32 57.5259 68.1628 57.4517C68.0055 57.3775 67.834 57.338 67.6598 57.3358C67.2261 57.3358 66.9441 57.4948 66.9441 57.7656C66.9441 58.3673 68.922 58.1352 68.922 59.1667C68.9133 59.6782 68.4015 60.0693 67.6641 60.0693Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M20.8849 62.6821C20.8086 62.5178 20.6863 62.3787 20.5325 62.2811C20.3788 62.1836 20.2 62.1319 20.0174 62.132C19.8998 62.122 19.7813 62.1371 19.6701 62.1764C19.5588 62.2157 19.4574 62.2782 19.3727 62.3597C19.2879 62.4412 19.2219 62.5398 19.179 62.6489C19.136 62.7579 19.1173 62.8748 19.1239 62.9916V63.5718C19.1176 63.6905 19.1373 63.8091 19.1818 63.9194C19.2262 64.0297 19.2943 64.1292 19.3813 64.2109C19.4683 64.2927 19.5722 64.3547 19.6858 64.3928C19.7993 64.4308 19.9199 64.444 20.0391 64.4314C20.2246 64.4374 20.4074 64.3865 20.5627 64.2857C20.7179 64.185 20.838 64.0393 20.9066 63.8684L21.3404 64.0661C21.2297 64.3151 21.0471 64.526 20.8154 64.6722C20.5838 64.8183 20.3136 64.8931 20.0391 64.887C19.856 64.9029 19.6717 64.8801 19.4981 64.8203C19.3245 64.7604 19.1657 64.6648 19.0321 64.5398C18.8985 64.4147 18.7932 64.263 18.723 64.0947C18.6529 63.9264 18.6195 63.7453 18.6251 63.5632V63.0174C18.6215 62.8333 18.6569 62.6505 18.7288 62.4807C18.8008 62.3109 18.9079 62.158 19.0431 62.0317C19.1783 61.9054 19.3387 61.8085 19.514 61.7473C19.6893 61.6861 19.8756 61.662 20.0608 61.6764C20.3344 61.6696 20.6038 61.7431 20.8354 61.8877C21.0669 62.0322 21.2501 62.2413 21.362 62.4887L20.8849 62.6821Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M21.8257 64.7928V61.7842H24.0291V62.2398H22.3505V63.022H23.6127V63.4518H22.3505V64.3501H24.0291V64.8057L21.8257 64.7928Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M26.8928 64.81C26.6108 64.81 26.5067 64.6467 26.4981 64.3372V63.9375C26.4981 63.671 26.3723 63.5292 25.9559 63.5292H25.1318V64.7928H24.6069V61.7842H25.9472C26.7063 61.7842 27.0185 62.1151 27.0185 62.575V62.6739C27.0185 63.0048 26.8754 63.2584 26.4026 63.3444C26.4845 63.3398 26.5664 63.3526 26.6429 63.3821C26.7193 63.4116 26.7884 63.4571 26.8456 63.5153C26.9028 63.5736 26.9466 63.6434 26.9742 63.7199C27.0018 63.7965 27.0125 63.878 27.0055 63.959V64.3157C26.9996 64.3787 27.0124 64.442 27.0425 64.4978C27.0726 64.5536 27.1185 64.5994 27.1747 64.6295V64.8229L26.8928 64.81ZM26.5024 62.5922C26.5024 62.3902 26.3723 62.214 26.0036 62.214H25.1361V63.1466H26.0036C26.3376 63.1466 26.5024 62.979 26.5024 62.7168V62.5922Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M29.0175 62.2271V64.8059H28.4926V62.2271H27.4517V61.7715H30.0541V62.2271H29.0175Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M30.5708 64.7928V61.7842H31.0956V64.7928H30.5708Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M32.3442 62.2267V63.0863H33.5847V63.5161H32.3442V64.784H31.8193V61.7754H33.9881V62.231L32.3442 62.2267Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M34.5044 64.7928V61.7842H35.0292V64.7928H34.5044Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M37.9268 62.6822C37.8505 62.5178 37.7282 62.3787 37.5744 62.2811C37.4207 62.1836 37.2419 62.1319 37.0593 62.132C36.9413 62.1213 36.8224 62.136 36.7106 62.175C36.5988 62.2139 36.4969 62.2764 36.4116 62.358C36.3264 62.4395 36.26 62.5384 36.2168 62.6477C36.1736 62.7571 36.1547 62.8744 36.1615 62.9916V63.5718C36.1552 63.6905 36.1749 63.8091 36.2193 63.9194C36.2638 64.0298 36.3318 64.1292 36.4189 64.211C36.5059 64.2927 36.6098 64.3547 36.7233 64.3928C36.8369 64.4309 36.9575 64.444 37.0767 64.4314C37.2623 64.438 37.4454 64.3874 37.6008 64.2866C37.7561 64.1857 37.8761 64.0396 37.9442 63.8684L38.3779 64.0661C38.2673 64.3151 38.0846 64.5261 37.853 64.6722C37.6214 64.8183 37.3512 64.8931 37.0767 64.887C36.8933 64.9035 36.7084 64.8813 36.5343 64.8217C36.3602 64.7622 36.2008 64.6667 36.0668 64.5415C35.9327 64.4164 35.827 64.2645 35.7566 64.0958C35.6861 63.9272 35.6527 63.7457 35.6583 63.5632V63.0174C35.6547 62.8333 35.6901 62.6505 35.7621 62.4807C35.834 62.3109 35.9411 62.158 36.0763 62.0317C36.2115 61.9054 36.372 61.8085 36.5472 61.7473C36.7225 61.6861 36.9088 61.662 37.094 61.6764C37.3679 61.6679 37.6381 61.7407 37.87 61.8855C38.1018 62.0302 38.2848 62.2403 38.3953 62.4887L37.9268 62.6822Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M40.9673 64.7926L40.6724 64.0404H39.3712L39.0849 64.8055H38.5601L39.7832 61.7969H40.2777L41.5225 64.8055L40.9673 64.7926ZM40.0174 62.3943L39.5403 63.6106H40.5076L40.0174 62.3943Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M43.0277 62.2271V64.8059H42.5072V62.2271H41.4619V61.7715H44.0644V62.2271H43.0277Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M44.5801 64.7928V61.7842H45.1092V64.7928H44.5801Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M47.0961 64.9C46.9184 64.9112 46.7403 64.8861 46.5728 64.8263C46.4052 64.7665 46.2519 64.6733 46.1222 64.5525C45.9925 64.4316 45.8892 64.2857 45.8187 64.1237C45.7482 63.9616 45.712 63.787 45.7124 63.6106V62.953C45.7322 62.6032 45.8864 62.2742 46.1433 62.0335C46.4002 61.7928 46.7403 61.6587 47.0939 61.6587C47.4474 61.6587 47.7876 61.7928 48.0445 62.0335C48.3014 62.2742 48.4556 62.6032 48.4754 62.953V63.6106C48.4757 63.7866 48.4396 63.9609 48.3694 64.1226C48.2992 64.2843 48.1963 64.43 48.0671 64.5508C47.9378 64.6716 47.785 64.7649 47.618 64.825C47.451 64.885 47.2734 64.9106 47.0961 64.9V64.9ZM47.9636 62.9573C47.9237 62.763 47.8173 62.5883 47.6624 62.4628C47.5075 62.3373 47.3135 62.2688 47.1134 62.2688C46.9133 62.2688 46.7193 62.3373 46.5644 62.4628C46.4095 62.5883 46.3031 62.763 46.2633 62.9573V63.6106C46.3031 63.8049 46.4095 63.9796 46.5644 64.1051C46.7193 64.2306 46.9133 64.2991 47.1134 64.2991C47.3135 64.2991 47.5075 64.2306 47.6624 64.1051C47.8173 63.9796 47.9237 63.8049 47.9636 63.6106V62.9573Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M51.2729 64.7925L49.8459 62.9959L49.5943 62.6521V64.8011H49.0825V61.7925H49.5466L50.9302 63.6019L51.1775 63.9415V61.7925H51.6893V64.8011L51.2729 64.7925Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M55.0469 64.7928H53.6025V61.7842H55.0209C55.7062 61.7842 56.0055 62.0936 56.0055 62.5492V62.6223C56.0155 62.7785 55.965 62.9327 55.8643 63.0533C55.7635 63.1739 55.6201 63.2519 55.4633 63.2713C55.6247 63.2812 55.7761 63.3524 55.886 63.4701C55.9958 63.5877 56.0557 63.7428 56.0532 63.9031V64.0234C56.0532 64.4704 55.7235 64.7928 55.0469 64.7928ZM55.4806 62.5879C55.4806 62.3816 55.3679 62.214 55.0469 62.214H54.1317V63.0736H54.9992C55.3332 63.0736 55.4893 62.9103 55.4893 62.6696L55.4806 62.5879ZM55.4806 63.8773C55.4806 63.6366 55.3288 63.4776 54.9905 63.4776H54.123V64.363H55.0512C55.3852 64.363 55.485 64.1954 55.485 63.9891L55.4806 63.8773Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M57.9227 64.9C57.745 64.9112 57.5669 64.8861 57.3994 64.8263C57.2319 64.7665 57.0785 64.6733 56.9488 64.5525C56.8191 64.4316 56.7159 64.2857 56.6454 64.1237C56.5749 63.9616 56.5387 63.787 56.5391 63.6106V62.953C56.5589 62.6032 56.713 62.2742 56.9699 62.0335C57.2268 61.7928 57.567 61.6587 57.9205 61.6587C58.2741 61.6587 58.6142 61.7928 58.8712 62.0335C59.1281 62.2742 59.2822 62.6032 59.302 62.953V63.6106C59.3023 63.7866 59.2663 63.9609 59.1961 64.1226C59.1258 64.2843 59.0229 64.43 58.8937 64.5508C58.7645 64.6716 58.6117 64.7649 58.4447 64.825C58.2777 64.885 58.1 64.9106 57.9227 64.9V64.9ZM58.7902 62.9573C58.7504 62.763 58.644 62.5883 58.4891 62.4628C58.3341 62.3373 58.1402 62.2688 57.9401 62.2688C57.74 62.2688 57.546 62.3373 57.3911 62.4628C57.2361 62.5883 57.1297 62.763 57.0899 62.9573V63.6106C57.1297 63.8049 57.2361 63.9796 57.3911 64.1051C57.546 64.2306 57.74 64.2991 57.9401 64.2991C58.1402 64.2991 58.3341 64.2306 58.4891 64.1051C58.644 63.9796 58.7504 63.8049 58.7902 63.6106V62.9573Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M61.1844 64.7928H59.9092V61.7842H61.1844C62.0519 61.7842 62.5377 62.3128 62.5377 62.9618V63.6108C62.5377 64.2641 62.0519 64.7928 61.1844 64.7928ZM62.0128 62.979C62.0155 62.8701 61.9939 62.7619 61.9496 62.6621C61.9054 62.5624 61.8396 62.4735 61.7568 62.4017C61.674 62.3299 61.5764 62.2771 61.4707 62.2469C61.365 62.2167 61.254 62.2098 61.1454 62.2269H60.421V64.3372H61.1584C61.2669 64.3535 61.3776 64.3461 61.483 64.3156C61.5883 64.2851 61.6856 64.2322 61.7682 64.1606C61.8508 64.089 61.9166 64.0004 61.9611 63.901C62.0056 63.8016 62.0277 63.6938 62.0259 63.585L62.0128 62.979Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M64.4245 63.5766V64.793H63.8953V63.5724L62.6938 61.7715H63.2968L64.1642 63.164L65.01 61.7715H65.5913L64.4245 63.5766Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M12.5782 47.1451L12.1445 46.3371H10.2056L9.77188 47.1451H9.13428L10.9126 43.8872H11.4245L13.2288 47.1451H12.5782ZM11.1642 44.5233L10.4485 45.8901H11.9016L11.1642 44.5233Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M19.7611 44.8071C19.4107 44.4744 18.9452 44.2868 18.4599 44.2828C18.2883 44.2687 18.1156 44.2894 17.9523 44.3437C17.789 44.398 17.6387 44.4847 17.5104 44.5986C17.3821 44.7124 17.2786 44.851 17.2062 45.0058C17.1338 45.1607 17.094 45.3285 17.0893 45.4991V45.5593C17.0893 46.1739 17.5881 46.7541 18.5076 46.7541C18.9927 46.7487 19.4577 46.5614 19.8088 46.2297L20.1819 46.6166C19.7148 47.0534 19.0933 47.2911 18.4512 47.2785C17.2064 47.2785 16.4517 46.479 16.4517 45.5979V45.4905C16.4517 44.6309 17.2758 43.7713 18.4773 43.7713C19.0984 43.7614 19.6985 43.9946 20.1472 44.4203L19.7611 44.8071Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M27.0135 44.8066C26.6621 44.4754 26.1973 44.288 25.7123 44.2823C25.5405 44.2675 25.3676 44.2878 25.204 44.3419C25.0405 44.396 24.8899 44.4827 24.7614 44.5966C24.633 44.7106 24.5295 44.8494 24.4573 45.0046C24.3851 45.1597 24.3457 45.3278 24.3417 45.4986V45.5588C24.3417 46.1734 24.8405 46.7536 25.7557 46.7536C26.2404 46.7466 26.7048 46.5594 27.0569 46.2293L27.4256 46.6161C26.9596 47.0518 26.3399 47.2894 25.6993 47.278C24.4544 47.278 23.6997 46.4785 23.6997 45.5974V45.49C23.6997 44.6304 24.5238 43.7708 25.7296 43.7708C26.3495 43.7611 26.9481 43.9943 27.3952 44.4198L27.0135 44.8066Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M33.9798 47.1451C33.815 47.1451 33.7413 46.913 33.7196 46.6207V46.2855C33.7196 45.9631 33.5634 45.8299 32.9475 45.8299H31.7677V47.1451H31.1475V43.8872H32.9388C33.9278 43.8872 34.3702 44.2783 34.3702 44.7812C34.3702 45.1379 34.188 45.4775 33.5461 45.5935C34.188 45.6408 34.3268 45.9288 34.3312 46.3113V46.582C34.324 46.6822 34.3384 46.7827 34.3736 46.8768C34.4087 46.9709 34.4638 47.0565 34.535 47.1279V47.1279L33.9798 47.1451ZM33.7499 44.8586C33.7499 44.6265 33.5591 44.3944 33.0299 44.3944H31.7677V45.3743H33.069C33.5027 45.3743 33.7369 45.1594 33.7369 44.8972L33.7499 44.8586Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M38.2954 47.1451V43.8872H41.2796V44.3944H38.9113V45.2325H40.7331V45.7267H38.9113V46.6336H41.2796V47.1451H38.2954Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M46.7841 47.1451H45.1099V43.8872H46.7928C47.9596 43.8872 48.6969 44.5878 48.6969 45.4646V45.5591C48.6883 46.4402 47.9509 47.1451 46.7841 47.1451ZM48.0854 45.4775C48.0854 44.8457 47.5866 44.3944 46.7841 44.3944H45.7345V46.6465H46.7841C47.5866 46.6465 48.0854 46.1866 48.0854 45.5548V45.4775Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M52.4834 47.1451V43.8872H53.0993V47.1451H52.4834Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M58.9505 44.3944V47.1451H58.3346V44.3944H56.8989V43.8872H60.3689V44.3944H58.9505Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M64.1943 47.1451V43.8872H67.1785V44.3944H64.8016V45.2325H66.6233V45.7267H64.8016V46.6336H67.1698V47.1451H64.1943Z",
    fill: "#004088"
  }), React__namespace.default.createElement("path", {
    d: "M72.6741 47.1451H70.9912V43.8872H72.6741C73.8366 43.8872 74.5783 44.5878 74.5783 45.4646V45.5591C74.5783 46.4402 73.8366 47.1451 72.6741 47.1451ZM73.9754 45.4775C73.9754 44.8457 73.4766 44.3944 72.6741 44.3944H71.6201V46.6465H72.6741C73.4766 46.6465 73.9754 46.1866 73.9754 45.5548V45.4775Z",
    fill: "#004088"
  }));
};

var PrivacyMarkImage = function PrivacyMarkImage(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "Privacy Mark" : _ref$alt;
  var _useId = nextId.useId(1, "image-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    imageId = _useId2[0];
  return React__namespace.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    "aria-label": alt || undefined,
    "aria-hidden": alt === "" ? true : undefined,
    fill: "none",
    width: "120",
    height: "121",
    role: "img"
  }, React__namespace.default.createElement("g", null, React__namespace.default.createElement("image", {
    id: imageId,
    width: "200",
    height: "200",
    href: "data:image/png;base64,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"
  })));
};

var ISMS_CAPTION = "IS 689557 / ISO 27001\nCLOUD 806590 / ISO27017";
var Footer = function Footer(_ref) {
  var companyLabel = _ref.companyLabel,
    linkInfos = _ref.linkInfos,
    _ref$showSecurityInfo = _ref.showSecurityInformation,
    showSecurityInformation = _ref$showSecurityInfo === void 0 ? false : _ref$showSecurityInfo;
  return React__namespace.createElement("footer", {
    className: styles$o.footer
  }, React__namespace.createElement("div", {
    className: styles$o.company
  }, React__namespace.createElement("div", {
    className: styles$o.companyLabel
  }, companyLabel)), showSecurityInformation && React__namespace.createElement("div", {
    className: styles$o.security
  }, React__namespace.createElement("div", {
    className: styles$o.descriptionArea
  }, React__namespace.createElement("div", {
    className: styles$o.description
  }, "\u682A\u5F0F\u4F1A\u793E\u30B0\u30E9\u30D5\u30A1\u30FC\u306F\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DE\u30FC\u30AF\u3068IS 689557 / ISO27001 \u53CA\u3073 CLOUD 806590 / ISO27017\u3092\u53D6\u5F97\u3057\u3066\u3044\u307E\u3059\u3002")), React__namespace.createElement("div", {
    className: styles$o.marks
  }, React__namespace.createElement("div", {
    className: styles$o.privacyMark
  }, React__namespace.createElement("div", {
    className: styles$o.privacyMarkImage
  }, React__namespace.createElement(PrivacyMarkImage, null))), React__namespace.createElement("div", {
    className: styles$o.isms
  }, React__namespace.createElement("div", {
    className: styles$o.ismsImage
  }, React__namespace.createElement(IsmsImage, null)), React__namespace.createElement("div", {
    className: styles$o.ismsCaption
  }, ISMS_CAPTION)))), React__namespace.createElement("ul", {
    className: styles$o.legal
  }, linkInfos.map(function (linkInfo) {
    return React__namespace.createElement("li", {
      key: linkInfo.name,
      className: styles$o.legalItem
    }, linkInfo.blank ? React__namespace.createElement("a", {
      className: styles$o.link,
      href: linkInfo.href,
      target: "_blank",
      rel: "noreferrer noopener"
    }, linkInfo.name) : React__namespace.createElement("a", {
      className: styles$o.link,
      href: linkInfo.href
    }, linkInfo.name));
  })), React__namespace.createElement("div", {
    className: styles$o.copy
  }, "\xA9 2017 Graffer, Inc."));
};

var css_248z$n = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.banner-module__GDK__default___JrfgE {\n  background-color: #454ab8;\n}\n\n.banner-module__GDK__warning___KTQdv {\n  background-color: #f4c776;\n}\n\n.banner-module__GDK__error___dstm5 {\n  background-color: #d53b3a;\n}\n\n.banner-module__GDK__banner___PNsAI {\n  padding: 16px;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n}\n\n.banner-module__GDK__messageWrapper___WfQpx {\n  grid-column-start: 2;\n  display: flex;\n  align-items: center;\n}\n\n.banner-module__GDK__icon___Q4s4D {\n  margin-right: 16px;\n}\n\n.banner-module__GDK__icon___Q4s4D svg {\n  vertical-align: middle;\n}\n\n.banner-module__GDK__message___mxYeR {\n  display: flex;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__message___mxYeR a {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #fff !important;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  -webkit-text-decoration: underline #fff;\n          text-decoration: underline #fff;\n  outline-color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR a {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__message___mxYeR a:active {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #fff !important;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  -webkit-text-decoration: underline #fff;\n          text-decoration: underline #fff;\n  outline-color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR a:active {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__message___mxYeR a:hover {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #fff !important;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  -webkit-text-decoration: underline #fff;\n          text-decoration: underline #fff;\n  outline-color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR a:hover {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__message___mxYeR a:focus {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #fff !important;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  -webkit-text-decoration: underline #fff;\n          text-decoration: underline #fff;\n  outline-color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR a:focus {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__message___mxYeR a:visited {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #fff !important;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  -webkit-text-decoration: underline #fff;\n          text-decoration: underline #fff;\n  outline-color: #fff;\n}\n\n@media screen and (max-width: 800px) {\n\n  .banner-module__GDK__message___mxYeR a:visited {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR {\n  color: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR a {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #1d1c1a !important;\n  -webkit-text-decoration: underline #1d1c1a;\n          text-decoration: underline #1d1c1a;\n  outline-color: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR a:active {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #1d1c1a !important;\n  -webkit-text-decoration: underline #1d1c1a;\n          text-decoration: underline #1d1c1a;\n  outline-color: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR a:hover {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #1d1c1a !important;\n  -webkit-text-decoration: underline #1d1c1a;\n          text-decoration: underline #1d1c1a;\n  outline-color: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR a:focus {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #1d1c1a !important;\n  -webkit-text-decoration: underline #1d1c1a;\n          text-decoration: underline #1d1c1a;\n  outline-color: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__message___mxYeR a:visited {\n  /* TODO: bulmaの対応策として、link.module.css の方で「!important」が指定してあるため、上書きするためにこちらでもやむを得ず指定。bulma改善のタイミングで見直す。 */\n  color: #1d1c1a !important;\n  -webkit-text-decoration: underline #1d1c1a;\n          text-decoration: underline #1d1c1a;\n  outline-color: #1d1c1a;\n}\n\n/* 外部リンクアイコンのサイズを調整 */\n\n.banner-module__GDK__message___mxYeR a svg {\n  width: 20px;\n  height: 20px;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__icon___Q4s4D svg path:first-of-type {\n  fill: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__cancel___VBaP1 svg path {\n  fill: #1d1c1a;\n}\n\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__icon___Q4s4D svg path:last-of-type {\n  fill: #f4c776;\n}\n\n.banner-module__GDK__cancel___VBaP1 {\n  margin-left: auto;\n}\n\n.banner-module__GDK__default___JrfgE .banner-module__GDK__cancel___VBaP1:focus,\n.banner-module__GDK__default___JrfgE .banner-module__GDK__cancel___VBaP1:hover,\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__cancel___VBaP1:focus,\n.banner-module__GDK__warning___KTQdv .banner-module__GDK__cancel___VBaP1:hover,\n.banner-module__GDK__error___dstm5 .banner-module__GDK__cancel___VBaP1:focus,\n.banner-module__GDK__error___dstm5 .banner-module__GDK__cancel___VBaP1:hover {\n  background-color: #ffffff4d;\n}\n\n@media screen and (max-width: 800px) {\n  .banner-module__GDK__message___mxYeR {\n    flex-direction: column;\n  }\n  .banner-module__GDK__banner___PNsAI {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n  .banner-module__GDK__messageWrapper___WfQpx {\n    margin-right: 16px;\n  }\n}\n";
var styles$n = {"default":"banner-module__GDK__default___JrfgE","warning":"banner-module__GDK__warning___KTQdv","error":"banner-module__GDK__error___dstm5","banner":"banner-module__GDK__banner___PNsAI","messageWrapper":"banner-module__GDK__messageWrapper___WfQpx","icon":"banner-module__GDK__icon___Q4s4D","message":"banner-module__GDK__message___mxYeR","cancel":"banner-module__GDK__cancel___VBaP1"};
styleInject(css_248z$n);

var getTimeString$1 = function getTimeString(time) {
  return "".concat(time.year, "-").concat(time.month, "-").concat(time.day, "T").concat(time.hour, ":").concat(time.minute, ":").concat(time.second);
};
var useBannerDisplay = function useBannerDisplay(bannerDisplayDuration) {
  var isShowBanner = React.useMemo(function () {
    if (!bannerDisplayDuration) {
      return true;
    }
    var start = dayjs__default.default.tz(getTimeString$1(bannerDisplayDuration.start), "Asia/Tokyo");
    var end = dayjs__default.default.tz(getTimeString$1(bannerDisplayDuration.end), "Asia/Tokyo");
    var now = dayjs__default.default().tz("Asia/Tokyo");
    return now.isBetween(start, end, null, "[]");
  }, [bannerDisplayDuration]);
  return {
    isShowBanner: isShowBanner
  };
};

// テストで使用するため、export
var getTimeString = function getTimeString(time) {
  return "".concat(time.year, "-").concat(time.month, "-").concat(time.day, "T").concat(time.hour, ":").concat(time.minute, ":").concat(time.second);
};
var BaseBanner = function BaseBanner(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    children = _ref.children,
    onCancel = _ref.onCancel,
    bannerDisplayDuration = _ref.bannerDisplayDuration;
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  var _useBannerDisplay = useBannerDisplay(bannerDisplayDuration),
    isShowBanner = _useBannerDisplay.isShowBanner;
  if (!isShowBanner) {
    return null;
  }
  return React__namespace.createElement("section", {
    className: className
  }, React__namespace.createElement("div", {
    className: styles$n.banner
  }, React__namespace.createElement("div", {
    className: styles$n.messageWrapper
  }, isPc && React__namespace.createElement("span", {
    "aria-hidden": true,
    className: styles$n.icon
  }, icon), React__namespace.createElement("div", {
    className: styles$n.message
  }, children)), onCancel && React__namespace.createElement(CancelButton, {
    className: styles$n.cancel,
    onCancel: onCancel,
    iconSize: isPc ? IconSizes.midium : IconSizes.small,
    ariaLabel: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u9589\u3058\u308B",
    isReversible: true
  })));
};
var DefaultBanner = function DefaultBanner(_ref2) {
  var onCancel = _ref2.onCancel,
    children = _ref2.children,
    bannerDisplayDuration = _ref2.bannerDisplayDuration;
  return React__namespace.createElement(BaseBanner, {
    className: styles$n["default"],
    icon: React__namespace.createElement(InfoIcon, {
      size: 32,
      isReversible: true
    }),
    onCancel: onCancel,
    bannerDisplayDuration: bannerDisplayDuration
  }, children);
};
var ErrorBanner = function ErrorBanner(_ref3) {
  var onCancel = _ref3.onCancel,
    children = _ref3.children,
    bannerDisplayDuration = _ref3.bannerDisplayDuration;
  return React__namespace.createElement(BaseBanner, {
    className: styles$n.error,
    icon: React__namespace.createElement(AttentionIcon, {
      size: 32,
      isReversible: true
    }),
    onCancel: onCancel,
    bannerDisplayDuration: bannerDisplayDuration
  }, children);
};
var WarningBanner = function WarningBanner(_ref4) {
  var onCancel = _ref4.onCancel,
    children = _ref4.children,
    bannerDisplayDuration = _ref4.bannerDisplayDuration;
  return React__namespace.createElement(BaseBanner, {
    className: styles$n.warning,
    icon: React__namespace.createElement(WarningIcon, {
      size: 32
    }),
    onCancel: onCancel,
    bannerDisplayDuration: bannerDisplayDuration
  }, children);
};

var css_248z$m = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.title-wrap-module__GDK__title___KyK1t {\n  display: inline;\n  vertical-align: baseline;\n  color: #1d1c1a;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  word-break: break-all;\n}\n\n@media screen and (max-width: 800px) {\n\n  .title-wrap-module__GDK__title___KyK1t {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.title-wrap-module__GDK__description___HLfAH {\n  display: block;\n  margin-bottom: 8px;\n}\n";
var styles$m = {"title":"title-wrap-module__GDK__title___KyK1t","description":"title-wrap-module__GDK__description___HLfAH"};
styleInject(css_248z$m);

var TitleWrap = function TitleWrap(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    descriptionId = _ref.descriptionId,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("label", {
    className: styles$m.title,
    htmlFor: id,
    id: getLabelId(id)
  }, title, required ? React__namespace.createElement(RequiredTag, null) : React__namespace.createElement(OptionalTag, null)), description && React__namespace.createElement(DefaultBreakingLineDescription, {
    description: description,
    descriptionId: descriptionId,
    className: styles$m.description
  }));
};

var _excluded$m = ["noValidate", "touched", "isValid", "needStatusIcon"];
/**
 * graffer-generatorで使用するinputでバリデーションロジックをもたないコンポーネント
 */
var GrafferSchemasTextInputComponent = React__namespace.forwardRef(function TextInputComponent(_ref, ref) {
  var noValidate = _ref.noValidate,
    touched = _ref.touched,
    isValid = _ref.isValid,
    _ref$needStatusIcon = _ref.needStatusIcon,
    needStatusIcon = _ref$needStatusIcon === void 0 ? true : _ref$needStatusIcon,
    props = _objectWithoutProperties(_ref, _excluded$m);
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: props.id,
      descriptionId: props.descriptionId,
      errorMessageId: props.errorMessageId
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  var formState = FormState.create(touched, isValid, noValidate, props.disabled, undefined, !!props.readOnly);
  return React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    formState: formState,
    needStatusIcon: needStatusIcon,
    id: id,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    ref: ref
  }));
});

/**
 * Graffer Schemasでのみ使用できるErrorMessagesです。
 * https://github.com/graffer-inc/graffer-schemas 以外での使用は禁止します。
 */
var GrafferSchemasErrorMessages = function GrafferSchemasErrorMessages(_ref) {
  var messages = _ref.messages,
    _ref$ariaLive = _ref.ariaLive,
    ariaLive = _ref$ariaLive === void 0 ? "assertive" : _ref$ariaLive;
  var _useGrafferSchemasIds = useGrafferSchemasIds({}),
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  return React__namespace.createElement(ErrorMessages, {
    messages: messages,
    ariaLive: ariaLive,
    id: errorMessageId
  });
};

/**
 * 値の有無をチェックするUtil
 * @param value
 * @param required
 * @returns 空の場合はfalse、それ以外はtrueを返却
 */
var checkExistsValue = function checkExistsValue(value) {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === "string" && !value) {
    return false;
  }
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  // Objectの場合は、全ての要素に値が入っていない場合のみ
  if (_typeof(value) === "object") {
    return !Object.values(value).every(function (value) {
      return !checkExistsValue(value);
    });
  }
  return true;
};

function useFormController(_ref) {
  var value = _ref.value,
    disabled = _ref.disabled,
    error = _ref.error,
    noValidate = _ref.noValidate,
    onError = _ref.onError,
    render = _ref.render;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var formState = FormState.create(touched, error !== undefined ? error.isValid : true, noValidate, disabled, undefined, undefined);
  React.useEffect(function () {
    if (checkExistsValue(value)) {
      setTouched(true);
    }
  }, [value]);
  React.useEffect(function () {
    onError && error && formState.isFail() && onError(error);
  });
  var handleOnBlur = React__namespace.default.useCallback(function () {
    setTouched(true);
  }, []);
  var component = render({
    formState: formState,
    onBlur: handleOnBlur
  });
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, component, formState.isFail() && React__namespace.default.createElement(ErrorMessages, {
    messages: error === null || error === void 0 ? void 0 : error.errorMessage,
    id: error === null || error === void 0 ? void 0 : error.id
  }));
}

/**
 *
 * コンポーネントの状態をハンドリングするラップコンポーネント
 *
 * @param props
 * @returns
 */
var FormController = function FormController(props) {
  return useFormController(props);
};

var _excluded$l = ["type", "formState", "needStatusIcon", "id", "descriptionId", "errorMessageId"],
  _excluded2$9 = ["touched", "isValid", "noValidate"],
  _excluded3$2 = ["noValidate", "value", "disabled"];
/**
 * フォーマット付きのInputのUIコンポーネント。
 */
var BaseNumberInputFormat = function BaseNumberInputFormat(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "text" : _ref$type,
    formState = _ref.formState,
    _ref$needStatusIcon = _ref.needStatusIcon,
    needStatusIcon = _ref$needStatusIcon === void 0 ? false : _ref$needStatusIcon,
    id = _ref.id,
    descriptionId = _ref.descriptionId,
    errorMessageId = _ref.errorMessageId,
    props = _objectWithoutProperties(_ref, _excluded$l);
  var notFailAriaDescribedByValue = getAreaDescribedByValue([descriptionId]);
  return React__namespace.createElement("div", {
    className: inputStyles.wrap
  }, React__namespace.createElement(reactNumberFormat.PatternFormat, _objectSpread2({
    id: id,
    type: type,
    className: classNames__default.default(inputStyles.input, formState.matchType({
      "default": "",
      disabled: inputStyles.disabled,
      success: inputStyles.success,
      fail: inputStyles.fail,
      // readOnlyのユースケースが生じたら対応
      readOnly: ""
    }), needStatusIcon && inputStyles.needStatusIcon),
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true,
      readOnly: false
    }),
    "aria-describedby": formState.matchType({
      "default": notFailAriaDescribedByValue,
      disabled: notFailAriaDescribedByValue,
      success: notFailAriaDescribedByValue,
      fail: getAreaDescribedByValue([descriptionId, errorMessageId]),
      readOnly: notFailAriaDescribedByValue
    }),
    "aria-required": props.required
  }, props)), formState.matchType({
    "default": null,
    disabled: null,
    success: needStatusIcon && React__namespace.createElement(CheckIcon, {
      size: 32,
      className: inputStyles.icon,
      role: "img",
      alt: "\u5165\u529B\u6210\u529F"
    }),
    fail: needStatusIcon && React__namespace.createElement(AttentionIcon, {
      size: 32,
      className: inputStyles.icon,
      role: "img",
      alt: "\u5165\u529B\u30A8\u30E9\u30FC"
    }),
    // readOnlyのユースケースが生じたら対応
    readOnly: null
  }));
};
/**
 * form-generatorで使用するフォーマット付きのInputでバリデーションロジックをもたないコンポーネント
 */
var GrafferSchemasNumberInputFormatComponent = function GrafferSchemasNumberInputFormatComponent(_ref2) {
  var touched = _ref2.touched,
    isValid = _ref2.isValid,
    noValidate = _ref2.noValidate,
    props = _objectWithoutProperties(_ref2, _excluded2$9);
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: props.id
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  var formState = FormState.create(touched, isValid, noValidate, props.disabled, undefined, undefined);
  return React__namespace.createElement(BaseNumberInputFormat, _objectSpread2(_objectSpread2({
    formState: formState
  }, props), {}, {
    id: id,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId
  }));
};
/**
 * フォーマット付きのInputコンポーネント
 */
var NumberInputFormat = function NumberInputFormat(_ref3) {
  var noValidate = _ref3.noValidate,
    value = _ref3.value,
    disabled = _ref3.disabled,
    props = _objectWithoutProperties(_ref3, _excluded3$2);
  return React__namespace.createElement(FormController, {
    disabled: disabled,
    noValidate: noValidate,
    value: value,
    render: function render(_ref4) {
      var formState = _ref4.formState;
      return React__namespace.createElement(BaseNumberInputFormat, _objectSpread2({
        formState: formState,
        value: value,
        disabled: disabled
      }, props));
    }
  });
};

var css_248z$l = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.stepbar-module__GDK__container___T400Z {\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.stepbar-module__GDK__wrapper___A-DL0 {\n  display: flex;\n  justify-content: center;\n  height: 24px;\n  align-items: center;\n}\n\n.stepbar-module__GDK__progress___t3BvE {\n  height: 6px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n       appearance: none;\n  display: block;\n  overflow: hidden;\n  padding: 0;\n  width: 100%;\n}\n\n.stepbar-module__GDK__progress___t3BvE:not(:last-child) {\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-right: 8px;\n}\n\n.stepbar-module__GDK__progress___t3BvE::-webkit-progress-bar {\n  background-color: #dcd9d8;\n}\n\n.stepbar-module__GDK__progress___t3BvE::-moz-progress-bar {\n  background-color: #dcd9d8;\n}\n\n.stepbar-module__GDK__progress___t3BvE::-webkit-progress-value {\n  background-color: #237f6d;\n}\n\n.stepbar-module__GDK__progress___t3BvE::-moz-progress-bar {\n  background-color: #237f6d;\n}\n\n.stepbar-module__GDK__title___bYjB7 {\n  display: flex;\n  justify-content: center;\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n.stepbar-module__GDK__current___NsFiw {\n  font-family: \"Hiragino Sans\";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 24px;\n  color: #5c5959;\n}\n\n@media screen and (max-width: 800px) {\n  .stepbar-module__GDK__container___T400Z {\n    margin-top: 24px;\n    margin-bottom: 24px;\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n}\n";
var styles$l = {"container":"stepbar-module__GDK__container___T400Z","wrapper":"stepbar-module__GDK__wrapper___A-DL0","progress":"stepbar-module__GDK__progress___t3BvE","title":"stepbar-module__GDK__title___bYjB7","current":"stepbar-module__GDK__current___NsFiw"};
styleInject(css_248z$l);

var StepProgress = function StepProgress(_ref) {
  var id = _ref.id,
    current = _ref.current,
    max = _ref.max,
    title = _ref.title,
    ariaLabel = _ref.ariaLabel,
    _ref$showPercentage = _ref.showPercentage,
    showPercentage = _ref$showPercentage === void 0 ? true : _ref$showPercentage,
    ariaLive = _ref["aria-live"];
  return React__namespace.default.createElement("div", {
    className: styles$l.container,
    "aria-hidden": !showPercentage,
    "aria-live": ariaLive
  }, !!title && React__namespace.default.createElement("label", {
    htmlFor: id,
    className: styles$l.title
  }, title), React__namespace.default.createElement("div", {
    className: styles$l.wrapper
  }, React__namespace.default.createElement("progress", {
    id: id,
    className: classNames__default.default(styles$l.progress),
    value: current,
    max: max,
    "aria-label": ariaLabel
  }), showPercentage && React__namespace.default.createElement("p", {
    className: styles$l.current
  }, "".concat(Math.round(current / max * 100), "%"))));
};

var css_248z$k = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.status-tag-module__GDK__tag___ux7FM {\n  display: inline-block;\n  color: #1d1c1a;\n  background-color: #dcd9d8;\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 4px;\n  display: inline-block;\n  letter-spacing: 1px;\n  padding: 4px 8px 3px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.status-tag-module__GDK__primary___CJYWO {\n  background-color: #b6c5eb;\n}\n\n.status-tag-module__GDK__secondary___0cMqW {\n  background-color: #dcd9d8;\n}\n\n.status-tag-module__GDK__success___rUGxh {\n  background-color: #9ae0c7;\n}\n\n.status-tag-module__GDK__warn___HLt6E {\n  background-color: #f4c776;\n}\n\n.status-tag-module__GDK__error___xe2cY {\n  background-color: #f49b9b;\n}\n\n.status-tag-module__GDK__light___l-fCi {\n  background-color: #fff;\n  border: 1px solid #3d3b3a;\n}\n\n.status-tag-module__GDK__dark___7XoYt {\n  background-color: #1d1c1a;\n  color: #fff;\n}\n";
var styles$k = {"tag":"status-tag-module__GDK__tag___ux7FM","primary":"status-tag-module__GDK__primary___CJYWO","secondary":"status-tag-module__GDK__secondary___0cMqW","success":"status-tag-module__GDK__success___rUGxh","warn":"status-tag-module__GDK__warn___HLt6E","error":"status-tag-module__GDK__error___xe2cY","light":"status-tag-module__GDK__light___l-fCi","dark":"status-tag-module__GDK__dark___7XoYt"};
styleInject(css_248z$k);

var STATUS_CLASS_NAME = {
  PRIMARY: styles$k.primary,
  SECONDARY: styles$k.secondary,
  SUCCESS: styles$k.success,
  WARN: styles$k.warn,
  ERROR: styles$k.error,
  LIGHT: styles$k.light,
  DARK: styles$k.dark
};
var StatusTag = function StatusTag(_ref) {
  var statusType = _ref.statusType,
    children = _ref.children;
  return React__namespace.createElement("span", {
    className: classNames__default.default(styles$k.tag, STATUS_CLASS_NAME[statusType])
  }, children);
};

var css_248z$j = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.graffer-schemas-tags-module__GDK__wrapper___B37XK {\n  display: inline-flex;\n  align-items: center;\n}\n\n.graffer-schemas-tags-module__GDK__firstChild___hIpFF.graffer-schemas-tags-module__GDK__wrapper___B37XK div:first-of-type,\n.graffer-schemas-tags-module__GDK__firstChild___hIpFF.graffer-schemas-tags-module__GDK__wrapper___B37XK p:first-of-type {\n  margin-left: inherit;\n}\n\n.graffer-schemas-tags-module__GDK__tag___edyoz {\n  display: inline-block;\n  height: 18px;\n  color: #5c5959;\n  font: 10px/16px Meiryo, Arial, system-ui, sans-serif;\n  border-radius: 4px;\n  display: inline-block;\n  letter-spacing: 1px;\n  padding: 1px 4px;\n  margin-left: 16px;\n  white-space: nowrap;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.graffer-schemas-tags-module__GDK__default___o18p0 {\n  background-color: #dcd9d8;\n}\n\n.graffer-schemas-tags-module__GDK__warn___b6QXP {\n  background-color: #ffe08a;\n}\n\n.graffer-schemas-tags-module__GDK__informationTag___OTYic {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  height: 20px;\n  border: 1px solid #3d3b3a;\n  border-radius: 30px;\n  background-color: #fff;\n  letter-spacing: 1px;\n  padding: 2px 10px;\n  margin-left: 16px;\n  white-space: nowrap;\n}\n\n.graffer-schemas-tags-module__GDK__informationTagLabel___odK7O {\n  color: #3d3b3a;\n  font: 10px/16px Meiryo, Arial, system-ui, sans-serif;\n  font-weight: 600;\n}\n";
var styles$j = {"wrapper":"graffer-schemas-tags-module__GDK__wrapper___B37XK","firstChild":"graffer-schemas-tags-module__GDK__firstChild___hIpFF","tag":"graffer-schemas-tags-module__GDK__tag___edyoz","default":"graffer-schemas-tags-module__GDK__default___o18p0","warn":"graffer-schemas-tags-module__GDK__warn___b6QXP","informationTag":"graffer-schemas-tags-module__GDK__informationTag___OTYic","informationTagLabel":"graffer-schemas-tags-module__GDK__informationTagLabel___odK7O"};
styleInject(css_248z$j);

var isRequiredTagType = function isRequiredTagType(x) {
  if (x && Object.prototype.hasOwnProperty.call(x, "required")) return true;
  return false;
};
var isCustomTagType = function isCustomTagType(x) {
  if (x && Object.prototype.hasOwnProperty.call(x, "color")) return true;
  return false;
};
var Tag = function Tag(tag, index) {
  if (tag.hidden) {
    return null;
  }
  if (isRequiredTagType(tag)) {
    return tag.required ? React__namespace.createElement(RequiredTag, {
      key: "required-tag-".concat(index)
    }) : React__namespace.createElement(OptionalTag, {
      key: "optional-tag-".concat(index)
    });
  }
  if (isCustomTagType(tag)) {
    return React__namespace.createElement("span", {
      key: "".concat(tag.label, "-").concat(index),
      className: classNames__default.default(styles$j.tag, COLORS[tag.color])
    }, tag.label);
  }
  // Graffer-Schemasの繰り返し項目で最大件数の説明に使用。
  return React__namespace.createElement("span", {
    key: "".concat(tag.label, "-").concat(index),
    className: styles$j.informationTag
  }, React__namespace.createElement("span", {
    className: styles$j.informationTagLabel
  }, tag.label));
};
var COLORS = {
  "default": styles$j["default"],
  warn: styles$j.warn
};
/**
 * Graffer Schemasでのみ使用できるタグです。
 * https://github.com/graffer-inc/graffer-schemas 以外での使用は禁止します。
 */
var GrafferSchemasTags = function GrafferSchemasTags(_ref) {
  var _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags,
    _ref$isFirstChild = _ref.isFirstChild,
    isFirstChild = _ref$isFirstChild === void 0 ? false : _ref$isFirstChild;
  return React__namespace.createElement("span", {
    className: classNames__default.default(styles$j.wrapper, isFirstChild && styles$j.firstChild)
  }, tags.map(function (tag, index) {
    return Tag(tag, index);
  }));
};

var css_248z$i = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25em;\n  max-width: 100%;\n  width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  margin-top: 4px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .markdown-description-module__GDK__markdownContent___KUW7R {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R h1,\n.markdown-description-module__GDK__markdownContent___KUW7R h2,\n.markdown-description-module__GDK__markdownContent___KUW7R h3,\n.markdown-description-module__GDK__markdownContent___KUW7R a,\n.markdown-description-module__GDK__markdownContent___KUW7R ul,\n.markdown-description-module__GDK__markdownContent___KUW7R ol,\n.markdown-description-module__GDK__markdownContent___KUW7R p,\n.markdown-description-module__GDK__markdownContent___KUW7R p:not(:last-child),\n.markdown-description-module__GDK__markdownContent___KUW7R ol:not(:last-child),\n.markdown-description-module__GDK__markdownContent___KUW7R ul:not(:last-child),\n.markdown-description-module__GDK__markdownContent___KUW7R h3:not(:first-child) {\n  margin: 0;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R p {\n  white-space: pre-wrap;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R h2 {\n  color: #1d1c1a;\n  border-left: 4px solid #454ab8;\n  text-align: left;\n  padding-left: 0.75em;\n  font:\n    2em/1.5em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R h3 {\n  color: #1d1c1a;\n  text-align: left;\n  font:\n    bold 1.5em/1.5em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R ol {\n  list-style-type: decimal;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R ul {\n  list-style-type: circle;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R ol li,\n.markdown-description-module__GDK__markdownContent___KUW7R ul li {\n  margin-left: 1.5em;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R ol li + li,\n.markdown-description-module__GDK__markdownContent___KUW7R ul li + li {\n  margin-top: 0.25em;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R a {\n  font:\n    1em/1.25em Meiryo,\n    Arial,\n    system-ui,\n    sans-serif !important;\n  -webkit-text-decoration: underline #454ab8;\n          text-decoration: underline #454ab8;\n  padding: 0.25em 0.5em;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R a:focus {\n  outline: 2px solid #454ab8;\n  border-radius: 8px;\n  background-color: transparent;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R a svg {\n  width: 1.5em;\n}\n\n.markdown-description-module__GDK__markdownContent___KUW7R a:visited {\n  -webkit-text-decoration: underline #7b319a;\n          text-decoration: underline #7b319a;\n  color: #7b319a !important;\n}\n";
var styles$i = {"markdownContent":"markdown-description-module__GDK__markdownContent___KUW7R"};
styleInject(css_248z$i);

var MarkdownDescription = function MarkdownDescription(_ref) {
  var descriptionId = _ref.descriptionId,
    description = _ref.description,
    className = _ref.className;
  return React__namespace.createElement("div", {
    id: descriptionId,
    className: classNames__default.default(className, styles$i.markdownContent)
  }, description);
};

var _excluded$k = ["title", "description", "tags"];
/**
 * Graffer Schemasでのみ使用できるTitleWrapです。
 * https://github.com/graffer-inc/graffer-schemas 以外での使用は禁止します。
 */
var GrafferSchemasTitleWrap = function GrafferSchemasTitleWrap(_ref) {
  var title = _ref.title,
    description = _ref.description,
    tags = _ref.tags,
    props = _objectWithoutProperties(_ref, _excluded$k);
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: props.id
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("label", {
    className: styles$m.title,
    htmlFor: id,
    id: getLabelId(props.id)
  }, title, React__namespace.createElement(GrafferSchemasTags, {
    tags: tags,
    isFirstChild: !title
  })), description && (typeof description === "string" ? React__namespace.createElement(DefaultBreakingLineDescription, {
    description: description,
    descriptionId: descriptionId,
    className: styles$m.description
  }) : React__namespace.createElement(MarkdownDescription, {
    description: description,
    descriptionId: descriptionId,
    className: styles$m.description
  })));
};

/**
 * Graffer Schemasでのみ使用できるFieldsetWrapです。
 * ラジオ・チェックボックス・日付系のコンポーネント等でグループ化の為に使用。
 * https://github.com/graffer-inc/graffer-schemas 以外での使用は禁止します。
 */
var GrafferSchemasFieldsetWrap = function GrafferSchemasFieldsetWrap(_ref) {
  var title = _ref.title,
    description = _ref.description,
    children = _ref.children,
    tags = _ref.tags;
  var _useGrafferSchemasIds = useGrafferSchemasIds({}),
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  return React__namespace.createElement("fieldset", {
    className: styles$D.fieldset,
    "aria-describedby": getAreaDescribedByValue([descriptionId, errorMessageId])
  }, React__namespace.createElement("legend", {
    className: styles$D.legend
  }, React__namespace.createElement("span", {
    className: styles$D.title
  }, title), !!(tags === null || tags === void 0 ? void 0 : tags.length) && React__namespace.createElement(GrafferSchemasTags, {
    tags: tags,
    isFirstChild: !title
  })), description && (typeof description === "string" ? React__namespace.createElement(DefaultBreakingLineDescription, {
    description: description,
    descriptionId: descriptionId,
    className: styles$D.description
  }) : React__namespace.createElement(MarkdownDescription, {
    description: description,
    descriptionId: descriptionId,
    className: styles$D.description
  })), children);
};

var useTimeInput = function useTimeInput(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    validate = _ref.validate,
    generatedID = _ref.generatedID;
  var getValueFromProps = React.useCallback(function () {
    var convertedValue = dateToValue(value, "HH:mm");
    var _splitTimeInputString = splitTimeInputString(convertedValue),
      hour = _splitTimeInputString.hour,
      minutes = _splitTimeInputString.minutes;
    return {
      hour: hour,
      minutes: minutes
    };
  }, [value]);
  var _useState = React.useState(getValueFromProps()),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  // Propsから渡ってきたvalueの値を保存。
  var _useState3 = React.useState(getValueFromProps()),
    _useState4 = _slicedToArray(_useState3, 2),
    propsValue = _useState4[0],
    setPropsValue = _useState4[1];
  var getValidateResult = React.useCallback(function (value) {
    var valueString = "".concat(value.hour, ":").concat(value.minutes);
    var _splitTimeInputString2 = splitTimeInputString(valueString),
      hour = _splitTimeInputString2.hour,
      minutes = _splitTimeInputString2.minutes;
    var validateHourResult = !validateHours(hour) ? [{
      message: "時間は0~23の間で入力してください",
      elements: ["Hour"],
      id: "errorMessage-hour-".concat(generatedID)
    }] : [];
    var validateMinutesResult = !validateMinutes(minutes) ? [{
      message: "分は0~59の間で入力してください",
      elements: ["Minutes"],
      id: "errorMessage-minutes-".concat(generatedID)
    }] : [];
    // 初めに、GDKのバリデーションチェック。
    var errorSet = [].concat(validateHourResult, validateMinutesResult);
    // エラーがあれば、エラーセットを返却。
    if (errorSet.length > 0) {
      return errorSet;
    }
    // 次に、Propsで受け取ったバリデーションチェック。
    var validateResult = validate(valueString);
    // エラーがあればIDを追加したエラーセットを返却。
    return validateResult === true ? true : validateResult.map(function (v, i) {
      return _objectSpread2(_objectSpread2({}, v), {
        id: "errorMessage".concat(i + 1, "-").concat(generatedID)
      });
    });
  }, [generatedID, validate]);
  var _useState5 = React.useState(getValidateResult(innerValue)),
    _useState6 = _slicedToArray(_useState5, 2),
    validateResult = _useState6[0],
    setValidateResult = _useState6[1];
  var _useState7 = React.useState(!!value),
    _useState8 = _slicedToArray(_useState7, 2),
    isTouched = _useState8[0],
    setIsTouched = _useState8[1];
  var setNewValue = React.useCallback(function (newValue) {
    setInnerValue({
      hour: newValue.hour,
      minutes: newValue.minutes
    });
    var newValueString = "".concat(newValue.hour, ":").concat(newValue.minutes);
    var date = timeValueToDate(newValueString);
    if (date) {
      setValue(date);
    }
  }, [setValue]);
  var handleHourChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, innerValue), {}, {
      hour: value.substr(0, 2)
    }));
  }, [innerValue, setNewValue]);
  var handleMinutesChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, innerValue), {}, {
      minutes: value.substr(0, 2)
    }));
  }, [innerValue, setNewValue]);
  //  Propsとして渡ってくるvalueが更新された時に、inputの値を更新するための処理。
  React.useEffect(function () {
    var valueFromProps = getValueFromProps();
    var hour = valueFromProps.hour,
      minutes = valueFromProps.minutes;
    // 前回Propsとして受け取った値と比較。同じ場合は処理をしない。
    if (hour === propsValue.hour && minutes === propsValue.minutes) {
      return;
    }
    // Propsとして受け取ったvalue値は保存。
    setPropsValue(valueFromProps);
    // Propsとして受け取った値が、ユーザーが変更した値と同じ場合は処理をしない。
    // 子(changeイベント)→親→子の流れで、値が渡ってきたと判断できるため。
    if (hour === innerValue.hour && minutes === innerValue.minutes) {
      return;
    }
    setInnerValue(valueFromProps);
    setValidateResult(getValidateResult(valueFromProps));
    if (value) {
      setIsTouched(true);
    }
  }, [getValidateResult, getValueFromProps, innerValue.hour, innerValue.minutes, propsValue.hour, propsValue.minutes, value]);
  var handleBlur = React.useCallback(function () {
    setIsTouched(true);
    setValidateResult(getValidateResult(innerValue));
  }, [getValidateResult, innerValue]);
  return _objectSpread2(_objectSpread2({}, innerValue), {}, {
    validateResult: validateResult,
    isTouched: isTouched,
    handleBlur: handleBlur,
    handleHourChange: handleHourChange,
    handleMinutesChange: handleMinutesChange
  });
};

var css_248z$h = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.time-input-module__GDK__wrapper___q-wzf {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.time-input-module__GDK__grafferSchemasWrapper___qZDpl {\n  margin-bottom: 0;\n}\n\n.time-input-module__GDK__description___TjjPB {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .time-input-module__GDK__description___TjjPB {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$h = {"wrapper":"time-input-module__GDK__wrapper___q-wzf","grafferSchemasWrapper":"time-input-module__GDK__grafferSchemasWrapper___qZDpl","description":"time-input-module__GDK__description___TjjPB"};
styleInject(css_248z$h);

var css_248z$g = ".time-select-module__GDK__inputWrapper___uYFbJ {\n  width: 100px;\n}\n\n.time-select-module__GDK__unit___i01n9 {\n  padding: 0 16px 0 8px;\n}\n\n.time-select-module__GDK__unit___i01n9:nth-of-type(2) {\n  padding: 0 0 0 8px;\n}\n";
var styles$g = {"inputWrapper":"time-select-module__GDK__inputWrapper___uYFbJ","unit":"time-select-module__GDK__unit___i01n9"};
styleInject(css_248z$g);

var renderHours = function renderHours() {
  var hours = [];
  for (var index = 0; index < 24; index++) {
    var value = {
      text: ("0" + index.toString()).slice(-2),
      value: ("0" + index.toString()).slice(-2)
    };
    hours.push(value);
  }
  return hours;
};
var renderMinutes = function renderMinutes(intervals) {
  var hours = [];
  var increments = intervals ? intervals : 1;
  for (var index = 0; index < 60; index += increments) {
    var value = {
      text: ("0" + index.toString()).slice(-2),
      value: ("0" + index.toString()).slice(-2)
    };
    hours.push(value);
  }
  return hours;
};

var css_248z$f = ".image-encode__GDK__check-background-image___rkviR {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z%22%20fill%3D%22%23237F6D%22%2F%3E%3Cpath%20d%3D%22M14.1605%2022.92L8.14453%2016.6L9.88053%2014.944L14.1765%2019.448L22.8245%2010.48L24.5525%2012.144L14.1605%2022.92Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E\");\n}.image-encode__GDK__fail-background-image___vs8q7 {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M16%2032C24.8366%2032%2032%2024.8366%2032%2016C32%207.16344%2024.8366%200%2016%200C7.16344%200%200%207.16344%200%2016C0%2024.8366%207.16344%2032%2016%2032Z%22%20fill%3D%22%23D53B3A%22%2F%3E%3Cpath%20d%3D%22M14.0488%2023.1599C14.0488%2021.8639%2014.9848%2020.8559%2016.2328%2020.8559C17.4808%2020.8559%2018.4408%2021.8639%2018.4408%2023.1599C18.4408%2024.4559%2017.4808%2025.4639%2016.2328%2025.4639C14.9848%2025.4639%2014.0488%2024.4559%2014.0488%2023.1599ZM14.5768%2010.2239L14.4568%206.88794H18.0088L17.8888%2010.2239L17.3848%2019.0799H15.0808L14.5768%2010.2239Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E\");\n}.image-encode__GDK__down-arrow-background-image___brdJ8 {\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFJSURBVHgB7ZK/TsNADMbtJIWVkbG8AZVolBH6BBVTNwpTFVAJvABhY+Ok/lEWBDwFYqF0QSEdYISJjmzASpMcX1NUoRDKbTDkGxyfz/bvYpkoV65c/0KcDjhOo0iRcUqjcFN43pAUhJrxZwl1J6jbStdp3yqiwi7sKhX0ntMAUAUgxwD9Csc1mjPq6Rw9HfCD4NIyTSbmKulctVbKfX8weM4E2DYexSVi/QZDWQTsULTa7q+QT9D1FKRxDf4jYg9fc/aa28Qa12EucJynWO6LTucoq18mZAoql98SEFPNskzyb4N+8gfNHVh2SfIxnBei2BbtrvdTL41mCC8TFMUlDH2IUbhofpBcMJpLgi+fcF8Rre7ZrD5MCppsnN5DehEV9wAsJ4BRVFHZQCVIBuiO3sN11RVXhkxAzgKH4YY0jHMhxCvlyvXn+gDQ0XlO1uNvHgAAAABJRU5ErkJggg==);\n}\n\n:root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.time-select-part-module__GDK__select___fkAoh {\n  height: 56px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  color: #1d1c1a;\n  background-color: #fff;\n  padding-left: 16px;\n  padding-right: 16px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 1px solid #706d6c;\n  border-radius: 8px;\n  outline: none;\n  width: 100%;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: right 18.25px bottom 50%;\n}\n\n@media screen and (max-width: 800px) {\n\n  .time-select-part-module__GDK__select___fkAoh {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.time-select-part-module__GDK__select___fkAoh.time-select-part-module__GDK__half___S5fDQ {\n  width: 50%;\n}\n\n.time-select-part-module__GDK__select___fkAoh:hover {\n  background-color: #fff;\n  border-color: #3d3b3a;\n}\n\n.time-select-part-module__GDK__select___fkAoh:focus {\n  background-color: #fff;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.time-select-part-module__GDK__select___fkAoh.time-select-part-module__GDK__fail___Uj9gm {\n  background-color: #fff7f8;\n  border-color: #de3226;\n}\n\n.time-select-part-module__GDK__select___fkAoh:hover.time-select-part-module__GDK__fail___Uj9gm {\n  background-color: #fff7f8;\n  border-color: #f64c41;\n}\n\n.time-select-part-module__GDK__select___fkAoh:focus.time-select-part-module__GDK__fail___Uj9gm {\n  background-color: #fff7f8;\n  outline: 0;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.time-select-part-module__GDK__placeholderColor___RwxH0 {\n  color: #b8b5b4;\n}\n\n.time-select-part-module__GDK__select___fkAoh:disabled {\n  border-color: #faf9f7;\n  background-color: #faf9f7;\n  color: #706d6c;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n/* WiondowのChromeの場合、文字がホワイトアウトしてしまうので明示的に色を指定する */\n\n.time-select-part-module__GDK__option___vIFGE {\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n  .time-select-part-module__GDK__select___fkAoh.time-select-part-module__GDK__half___S5fDQ {\n    width: 100%;\n  }\n}\n";
var styles$f = {"select":"time-select-part-module__GDK__select___fkAoh image-encode__GDK__down-arrow-background-image___brdJ8","half":"time-select-part-module__GDK__half___S5fDQ","fail":"time-select-part-module__GDK__fail___Uj9gm","placeholderColor":"time-select-part-module__GDK__placeholderColor___RwxH0","option":"time-select-part-module__GDK__option___vIFGE"};
styleInject(css_248z$f);

var _excluded$j = ["half", "options", "onChange", "value", "disabled", "formState", "id", "placeholder", "required", "descriptionId", "elementName", "ariaLabel"];
var ClassNameState = /*#__PURE__*/function (_BaseType) {
  function ClassNameState() {
    _classCallCheck(this, ClassNameState);
    return _callSuper(this, ClassNameState, arguments);
  }
  _inherits(ClassNameState, _BaseType);
  return _createClass(ClassNameState, null, [{
    key: "create",
    value: function create(isHalf, elementName, formState, value, options) {
      var half = isHalf ? "half" : "full";
      var failed = formState.matchCallWithIsError(elementName, {
        "default": function _default() {
          return "not_failed";
        },
        disabled: function disabled() {
          return "not_failed";
        },
        success: function success() {
          return "not_failed";
        },
        fail: function fail(isError) {
          return isError ? "failed" : "not_failed";
        }
      });
      var placeholder = options.find(function (v) {
        return v.value === value;
      }) ? "not_placeholder" : "placeholder";
      return new ClassNameState("".concat(half, "-").concat(failed, "-").concat(placeholder));
    }
  }]);
}(BaseType); // 状態管理のclass「FieldsetFormState」を受け取りたかったため、GDK既存の<Select>コンポーネントを真似て、新規で作成。
var TimeSelectPart = function TimeSelectPart(_ref) {
  var _ref$half = _ref.half,
    half = _ref$half === void 0 ? false : _ref$half,
    options = _ref.options,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    disabled = _ref.disabled,
    formState = _ref.formState,
    id = _ref.id,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    descriptionId = _ref.descriptionId,
    elementName = _ref.elementName,
    ariaLabel = _ref.ariaLabel,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var _useId = nextId.useId(1, "TimeSelectPart-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var handleChange = React.useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  return React__namespace.default.createElement("select", _objectSpread2(_objectSpread2({}, props), {}, {
    id: htmlId,
    className: "".concat(styles$f.select, " ").concat(ClassNameState.create(half, elementName, formState, value, options).matchType({
      "half-failed-placeholder": "".concat(styles$f.half, " ").concat(styles$f.fail, " ").concat(styles$f.placeholderColor),
      "half-failed-not_placeholder": "".concat(styles$f.half, " ").concat(styles$f.fail),
      "half-not_failed-placeholder": "".concat(styles$f.half, " ").concat(styles$f.placeholderColor),
      "half-not_failed-not_placeholder": "".concat(styles$f.half),
      "full-not_failed-placeholder": "".concat(styles$f.placeholderColor),
      "full-not_failed-not_placeholder": "",
      "full-failed-placeholder": "".concat(styles$f.fail, " ").concat(styles$f.placeholderColor),
      "full-failed-not_placeholder": "".concat(styles$f.fail)
    })),
    value: value,
    onChange: handleChange,
    disabled: disabled,
    required: required,
    "aria-required": required,
    "aria-invalid": formState.matchCallWithIsError(elementName, {
      "default": function _default() {
        return false;
      },
      disabled: function disabled() {
        return false;
      },
      success: function success() {
        return false;
      },
      fail: function fail(isError) {
        return isError;
      }
    }),
    "aria-describedby": formState.getAreaDescribedByValue([descriptionId], elementName),
    "aria-label": ariaLabel
  }), React__namespace.default.createElement("option", {
    selected: true,
    disabled: true,
    hidden: true,
    value: "",
    "aria-label": "項目を選択してください"
  }, placeholder || "----"), options.map(function (o) {
    return React__namespace.default.createElement("option", {
      key: o.value,
      value: o.value,
      className: styles$f.option
    }, o.text);
  }));
};

var _excluded$i = ["hour", "minutes", "placeholder", "handleHourChange", "handleMinutesChange", "handleHourBlur", "handleMinutesBlur", "timeIntervals", "formState", "minutesUnitText", "descriptionId", "required", "hourAriaLabel", "minutesAriaLabel", "elementName"];
var TimeSelect = function TimeSelect(_ref) {
  var hour = _ref.hour,
    minutes = _ref.minutes,
    placeholder = _ref.placeholder,
    handleHourChange = _ref.handleHourChange,
    handleMinutesChange = _ref.handleMinutesChange,
    handleHourBlur = _ref.handleHourBlur,
    handleMinutesBlur = _ref.handleMinutesBlur,
    timeIntervals = _ref.timeIntervals,
    formState = _ref.formState,
    minutesUnitText = _ref.minutesUnitText,
    descriptionId = _ref.descriptionId,
    required = _ref.required,
    hourAriaLabel = _ref.hourAriaLabel,
    minutesAriaLabel = _ref.minutesAriaLabel,
    elementName = _ref.elementName,
    props = _objectWithoutProperties(_ref, _excluded$i);
  var _useId = nextId.useId(1, "TimeSelect-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var hourInputId = "hour-".concat(generatedID);
  var minutesInputId = "minutes-".concat(generatedID);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
    className: styles$g.inputWrapper
  }, React__namespace.createElement(TimeSelectPart, {
    value: hour,
    onChange: handleHourChange,
    options: renderHours(),
    formState: formState,
    onBlur: handleHourBlur,
    disabled: props.disabled,
    descriptionId: descriptionId,
    required: required,
    id: hourInputId,
    ariaLabel: hourAriaLabel,
    elementName: elementName.hour,
    placeholder: placeholder.hour
  })), React__namespace.createElement("label", {
    className: styles$g.unit,
    htmlFor: hourInputId
  }, "\u6642"), React__namespace.createElement("div", {
    className: styles$g.inputWrapper
  }, React__namespace.createElement(TimeSelectPart, {
    value: minutes,
    onChange: handleMinutesChange,
    options: renderMinutes(timeIntervals),
    formState: formState,
    onBlur: handleMinutesBlur,
    disabled: props.disabled,
    descriptionId: descriptionId,
    required: required,
    id: minutesInputId,
    ariaLabel: minutesAriaLabel,
    elementName: elementName.minutes,
    placeholder: placeholder.minutes
  })), React__namespace.createElement("label", {
    className: styles$g.unit,
    htmlFor: minutesInputId
  }, minutesUnitText ? minutesUnitText : "分"));
};

/**
 * <Fieldset></Fieldset>グループ内のUIの状態を管理するStateを生成する
 * 【「エラーメッセージ」「エラー対象の要素(配列)」「エラーID」】 ← この組み合わせの配列を受け取り、処理をする。
 */
var FieldsetFormState = /*#__PURE__*/function (_BaseType) {
  function FieldsetFormState(value, errorSet) {
    var _this;
    _classCallCheck(this, FieldsetFormState);
    _this = _callSuper(this, FieldsetFormState, [value]);
    _this.errorSet = errorSet;
    return _this;
  }
  _inherits(FieldsetFormState, _BaseType);
  return _createClass(FieldsetFormState, [{
    key: "matchComponentsWithErrorSets",
    value: function matchComponentsWithErrorSets(matcher) {
      return matcher[this.value](this.errorSet);
    }
  }, {
    key: "matchCallWithIsError",
    value: function matchCallWithIsError(element, matcher) {
      var isError = this.getErrorMessageId(element) !== undefined;
      return matcher[this.value](isError);
    }
  }, {
    key: "getErrorMessageId",
    value: function getErrorMessageId(element) {
      if (this.errorSet === undefined) {
        return undefined;
      }
      var errorIds = this.errorSet.filter(function (v) {
        return !!v.elements.find(function (v) {
          return v === element;
        });
      }).map(function (v) {
        return v.id;
      });
      return errorIds.length > 0 ? errorIds : undefined;
    }
    // aria-describedby に設定する値を返却。
  }, {
    key: "getAreaDescribedByValue",
    value: function getAreaDescribedByValue$1(ids, element) {
      var _a;
      return getAreaDescribedByValue([].concat(_toConsumableArray(ids), _toConsumableArray((_a = this.getErrorMessageId(element)) !== null && _a !== void 0 ? _a : [undefined])));
    }
  }], [{
    key: "create",
    value: function create(isTouched,
    //validateに通っている場合はtrueを、通っていない場合は、エラーセットの配列を受け取る。
    validateResult, noValidate, disabled) {
      if (disabled) {
        return new FieldsetFormState("disabled");
      }
      if (!isTouched) {
        return new FieldsetFormState("default");
      }
      if (noValidate) {
        return new FieldsetFormState("default");
      }
      if (validateResult === true) {
        return new FieldsetFormState("success");
      }
      if (validateResult.length > 0) {
        return new FieldsetFormState("fail", validateResult);
      }
      return new FieldsetFormState("default");
    }
  }]);
}(BaseType);

var css_248z$e = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.errorSet-message-module__GDK__failText___lkyof {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  padding-top: 8px;\n  color: #8e1b19;\n}\n\n@media screen and (max-width: 800px) {\n\n  .errorSet-message-module__GDK__failText___lkyof {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$e = {"failText":"errorSet-message-module__GDK__failText___lkyof"};
styleInject(css_248z$e);

/**
 *  FieldsetFormStateの状態が「fail」の際に表示する、エラーメッセージのコンポーネント。
 *   (複数のエラー文が存在し、各々にidを指定するために作成。)
 */
var ErrorSetMessages = function ErrorSetMessages(_ref) {
  var errorSet = _ref.errorSet,
    ariaLive = _ref.ariaLive;
  if (!errorSet || errorSet.length < 1) {
    return null;
  }
  return React__namespace.createElement("div", {
    "aria-live": ariaLive !== null && ariaLive !== void 0 ? ariaLive : "assertive"
  }, errorSet.map(function (v, index) {
    return React__namespace.createElement("p", {
      className: styles$e.failText,
      key: index,
      id: v.id
    }, v.message);
  }));
};

var useTimeInputController = function useTimeInputController(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    onBlur = _ref.onBlur;
  var isString = typeof value === "string";
  var _React$useState = React__namespace.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasDefaultValue = _React$useState2[0],
    setHasDefaultValue = _React$useState2[1];
  var convertedValue = React__namespace.default.useMemo(function () {
    if (value === undefined || value === null) return null;
    if (typeof value === "string") return value;
    return dateToValue(value, "HH:mm");
  }, [value]);
  var _React$useMemo = React__namespace.default.useMemo(function () {
      return splitTimeInputString(convertedValue);
    }, [convertedValue]),
    hour = _React$useMemo.hour,
    minutes = _React$useMemo.minutes;
  var _React$useState3 = React__namespace.default.useState({
      hour: hour,
      minutes: minutes
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    innerValue = _React$useState4[0],
    setInnerValue = _React$useState4[1];
  var _React$useState5 = React__namespace.default.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    hourTouched = _React$useState6[0],
    setHourTouched = _React$useState6[1];
  var _React$useState7 = React__namespace.default.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    minutesTouched = _React$useState8[0],
    setMinutesTouched = _React$useState8[1];
  var setNewValue = React__namespace.default.useCallback(function (newValue) {
    var newValueString = "".concat(newValue.hour, ":").concat(newValue.minutes);
    var date = timeValueToDate(newValueString);
    if (isString) {
      setValue(newValueString);
    } else if (date) {
      setValue(date);
    }
    setInnerValue({
      hour: newValue.hour,
      minutes: newValue.minutes
    });
  }, [isString, setValue]);
  var handleHourChange = React__namespace.default.useCallback(function (v) {
    setNewValue(_objectSpread2(_objectSpread2({}, innerValue), {}, {
      hour: v
    }));
  }, [innerValue, setNewValue]);
  var handleMinutesChange = React__namespace.default.useCallback(function (v) {
    setNewValue(_objectSpread2(_objectSpread2({}, innerValue), {}, {
      minutes: v
    }));
  }, [innerValue, setNewValue]);
  var handleHourBlur = React__namespace.default.useCallback(function (e) {
    setHourTouched(true);
    minutesTouched && onBlur && onBlur(e);
  }, [minutesTouched, onBlur]);
  var handleMinutesBlur = React__namespace.default.useCallback(function (e) {
    setMinutesTouched(true);
    hourTouched && onBlur && onBlur(e);
  }, [hourTouched, onBlur]);
  React__namespace.default.useEffect(function () {
    if (hour && minutes && !hasDefaultValue) {
      setInnerValue({
        hour: hour,
        minutes: minutes
      });
      setHasDefaultValue(true);
      return;
    }
    if (!value) {
      setInnerValue({
        hour: "",
        minutes: ""
      });
      return;
    }
  }, [hasDefaultValue, hour, isString, minutes, value]);
  return _objectSpread2(_objectSpread2({}, innerValue), {}, {
    onBlur: {
      hour: handleHourBlur,
      minutes: handleMinutesBlur
    },
    onChange: {
      hour: handleHourChange,
      minutes: handleMinutesChange
    }
  });
};

var _excluded$h = ["touched", "disabled", "value", "id", "setValue", "onBlur", "timeIntervals", "errorMessage", "description", "hourAriaLabel", "minutesAriaLabel", "elementName", "placeholder"],
  _excluded2$8 = ["value", "setValue", "validate", "description", "timeIntervals"];
var ID_PREFIX = "TimeInput-id-";
/**
 *
 * form-generatorのerrorMessageをErrorSetWithIdに変換。（graffer-schemaではエラーまとめているので時、分での区別はしない）
 *
 * @param id
 * @param errors
 * @returns
 */
var useGenerateErrorSetWithId = function useGenerateErrorSetWithId(id, elementName, errors) {
  var elements = Object.values(elementName).map(function (elem) {
    return elem;
  });
  return React__namespace.useMemo(function () {
    if (errors && typeof errors !== "string" && errors.length > 0) {
      return errors.map(function (error) {
        return {
          message: error,
          elements: elements,
          id: id
        };
      });
    }
    if (errors && typeof errors === "string") {
      return [{
        message: errors,
        elements: elements,
        id: id
      }];
    }
    return true;
  }, [elements, errors, id]);
};
/**
 *
 * form-generatorで使用するTimeInputコンポーネント（touched , errorMessage）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasTimeInputComponent = function GrafferSchemasTimeInputComponent(_ref) {
  var touched = _ref.touched,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    value = _ref.value,
    id = _ref.id,
    setValue = _ref.setValue,
    onBlur = _ref.onBlur,
    timeIntervals = _ref.timeIntervals,
    errorMessage = _ref.errorMessage,
    description = _ref.description,
    _ref$hourAriaLabel = _ref.hourAriaLabel,
    hourAriaLabel = _ref$hourAriaLabel === void 0 ? "時" : _ref$hourAriaLabel,
    _ref$minutesAriaLabel = _ref.minutesAriaLabel,
    minutesAriaLabel = _ref$minutesAriaLabel === void 0 ? "分" : _ref$minutesAriaLabel,
    _ref$elementName = _ref.elementName,
    elementName = _ref$elementName === void 0 ? {
      hour: "Hour",
      minutes: "Minutes"
    } : _ref$elementName,
    placeholder = _ref.placeholder,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var _useTimeInputControll = useTimeInputController({
      value: value,
      setValue: setValue,
      onBlur: onBlur
    }),
    hour = _useTimeInputControll.hour,
    minutes = _useTimeInputControll.minutes,
    _useTimeInputControll2 = _useTimeInputControll.onBlur,
    onBlurHour = _useTimeInputControll2.hour,
    onBlurMinutes = _useTimeInputControll2.minutes,
    _useTimeInputControll3 = _useTimeInputControll.onChange,
    onChangeHour = _useTimeInputControll3.hour,
    onChangeMinutes = _useTimeInputControll3.minutes;
  var _useId = nextId.useId(1, ID_PREFIX),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var descriptionId = description ? "description-".concat(id !== null && id !== void 0 ? id : generatedID) : undefined;
  var errors = useGenerateErrorSetWithId(id !== null && id !== void 0 ? id : generatedID, elementName, errorMessage);
  var formState = React.useMemo(function () {
    return FieldsetFormState.create(touched, errors, false, disabled);
  }, [disabled, errors, touched]);
  return React__namespace.createElement("div", {
    className: classNames__default.default(styles$h.wrapper, styles$h.grafferSchemasWrapper),
    "data-testid": props["data-testid"],
    id: id
  }, React__namespace.createElement(TimeSelect, _objectSpread2(_objectSpread2({}, props), {}, {
    hour: hour,
    minutes: minutes,
    descriptionId: descriptionId,
    formState: formState,
    handleHourChange: onChangeHour,
    handleMinutesChange: onChangeMinutes,
    handleHourBlur: onBlurHour,
    handleMinutesBlur: onBlurMinutes,
    timeIntervals: timeIntervals,
    hourAriaLabel: hourAriaLabel,
    minutesAriaLabel: minutesAriaLabel,
    elementName: elementName,
    disabled: disabled,
    placeholder: placeholder
  })));
};
var TimeInput = function TimeInput(_ref2) {
  var value = _ref2.value,
    setValue = _ref2.setValue,
    validate = _ref2.validate,
    description = _ref2.description,
    timeIntervals = _ref2.timeIntervals,
    props = _objectWithoutProperties(_ref2, _excluded2$8);
  var _useId3 = nextId.useId(1, ID_PREFIX),
    _useId4 = _slicedToArray(_useId3, 1),
    generatedID = _useId4[0];
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var _useTimeInput = useTimeInput({
      value: value,
      setValue: setValue,
      validate: validate,
      generatedID: generatedID
    }),
    hour = _useTimeInput.hour,
    minutes = _useTimeInput.minutes,
    validateResult = _useTimeInput.validateResult,
    isTouched = _useTimeInput.isTouched,
    handleBlur = _useTimeInput.handleBlur,
    handleHourChange = _useTimeInput.handleHourChange,
    handleMinutesChange = _useTimeInput.handleMinutesChange;
  var formState = React.useMemo(function () {
    return FieldsetFormState.create(isTouched, validateResult, false, props.disabled);
  }, [isTouched, props.disabled, validateResult]);
  return React__namespace.createElement("div", null, React__namespace.createElement(FieldsetWrap, {
    title: props.title,
    description: description,
    descriptionId: descriptionId,
    required: props.required
  }, React__namespace.createElement("div", {
    className: styles$h.wrapper
  }, React__namespace.createElement(TimeSelect, _objectSpread2(_objectSpread2({}, props), {}, {
    hour: hour,
    minutes: minutes,
    descriptionId: descriptionId,
    formState: formState,
    handleHourChange: handleHourChange,
    handleMinutesChange: handleMinutesChange,
    handleHourBlur: handleBlur,
    handleMinutesBlur: handleBlur,
    timeIntervals: timeIntervals,
    hourAriaLabel: "時",
    minutesAriaLabel: "分",
    elementName: {
      hour: "Hour",
      minutes: "Minutes"
    },
    placeholder: {
      hour: "",
      minutes: ""
    }
  }))), formState.matchComponentsWithErrorSets({
    "default": function _default() {
      return null;
    },
    disabled: function disabled() {
      return null;
    },
    success: function success() {
      return null;
    },
    fail: function fail(errorSet) {
      return React__namespace.createElement(ErrorSetMessages, {
        errorSet: errorSet
      });
    }
  })));
};

var useTimeRange = function useTimeRange(_ref) {
  var startValue = _ref.startValue,
    endValue = _ref.endValue,
    setValue = _ref.setValue,
    validate = _ref.validate,
    generatedID = _ref.generatedID;
  var getValueFromProps = React.useCallback(function () {
    var convertedStartValue = dateToValue(startValue, "HH:mm");
    var convertedEndValue = dateToValue(endValue, "HH:mm");
    var _splitTimeRangeString = splitTimeRangeString("".concat(convertedStartValue, "~").concat(convertedEndValue)),
      startHour = _splitTimeRangeString.startHour,
      startMinutes = _splitTimeRangeString.startMinutes,
      endHour = _splitTimeRangeString.endHour,
      endMinutes = _splitTimeRangeString.endMinutes;
    return {
      innerStartHour: startHour,
      innerStartMinutes: startMinutes,
      innerEndHour: endHour,
      innerEndMinutes: endMinutes
    };
  }, [endValue, startValue]);
  var _useState = React.useState(getValueFromProps()),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  // Propsから渡ってきたvalueの値を保存。
  var _useState3 = React.useState(getValueFromProps()),
    _useState4 = _slicedToArray(_useState3, 2),
    propsValue = _useState4[0],
    setPropsValue = _useState4[1];
  var getValidateResult = React.useCallback(function (value) {
    var valueString = "".concat(value.innerStartHour, ":").concat(value.innerStartMinutes, "~").concat(value.innerEndHour, ":").concat(value.innerEndMinutes);
    var _splitTimeRangeString2 = splitTimeRangeString(valueString),
      startHour = _splitTimeRangeString2.startHour,
      startMinutes = _splitTimeRangeString2.startMinutes,
      endHour = _splitTimeRangeString2.endHour,
      endMinutes = _splitTimeRangeString2.endMinutes;
    var validateHourResult = function validateHourResult() {
      if (!validateHours(startHour) || !validateHours(endHour)) {
        var start = !validateHours(startHour) ? ["StartHour"] : [];
        var end = !validateHours(endHour) ? ["EndHour"] : [];
        return [{
          message: "時間は0~23の間で入力してください",
          elements: [].concat(start, end),
          id: "errorMessage-hour-".concat(generatedID)
        }];
      } else {
        return [];
      }
    };
    var validateMinutesResult = function validateMinutesResult() {
      if (!validateMinutes(startMinutes) || !validateMinutes(endMinutes)) {
        var start = !validateMinutes(startMinutes) ? ["StartMinutes"] : [];
        var end = !validateMinutes(endMinutes) ? ["EndMinutes"] : [];
        return [{
          message: "分は0~59の間で入力してください",
          elements: [].concat(start, end),
          id: "errorMessage-minutes-".concat(generatedID)
        }];
      } else {
        return [];
      }
    };
    // 初めに、GDKのバリデーションチェック。
    var errorSet = [].concat(_toConsumableArray(validateHourResult()), _toConsumableArray(validateMinutesResult()));
    // エラーがあれば、エラーセットを返却。
    if (errorSet.length > 0) {
      return errorSet;
    }
    // 次に、Propsで受け取ったバリデーションチェック。
    var validateResult = validate(valueString);
    // エラーがあればIDを追加したエラーセットを返却。
    return validateResult === true ? true : validateResult.map(function (v, i) {
      return _objectSpread2(_objectSpread2({}, v), {
        id: "errorMessage".concat(i + 1, "-").concat(generatedID)
      });
    });
  }, [generatedID, validate]);
  var _useState5 = React.useState(getValidateResult(currentValue)),
    _useState6 = _slicedToArray(_useState5, 2),
    validateResult = _useState6[0],
    setValidateResult = _useState6[1];
  var _useState7 = React.useState(!!startValue || !!endValue),
    _useState8 = _slicedToArray(_useState7, 2),
    isTouched = _useState8[0],
    setIsTouched = _useState8[1];
  var _useTimeRangeValue = useTimeRangeValue({
      currentValue: currentValue,
      setCurrentValue: setCurrentValue,
      setValue: setValue
    }),
    handleStartHourChange = _useTimeRangeValue.handleStartHourChange,
    handleStartMinutesChange = _useTimeRangeValue.handleStartMinutesChange,
    handleEndHourChange = _useTimeRangeValue.handleEndHourChange,
    handleEndMinutesChange = _useTimeRangeValue.handleEndMinutesChange,
    innerStartHour = _useTimeRangeValue.innerStartHour,
    innerStartMinutes = _useTimeRangeValue.innerStartMinutes,
    innerEndHour = _useTimeRangeValue.innerEndHour,
    innerEndMinutes = _useTimeRangeValue.innerEndMinutes;
  //  Propsとして渡ってくるvalueが更新された時に、inputの値を更新するための処理。
  React.useEffect(function () {
    var valueFromProps = getValueFromProps();
    var innerStartHour = valueFromProps.innerStartHour,
      innerStartMinutes = valueFromProps.innerStartMinutes,
      innerEndHour = valueFromProps.innerEndHour,
      innerEndMinutes = valueFromProps.innerEndMinutes;
    // 前回Propsとして受け取った値と比較。同じ場合は処理をしない。
    if (innerStartHour === propsValue.innerStartHour && innerStartMinutes === propsValue.innerStartMinutes && innerEndHour === propsValue.innerEndHour && innerEndMinutes === propsValue.innerEndMinutes) {
      return;
    }
    // Propsとして受け取ったvalue値は保存。
    setPropsValue(valueFromProps);
    // Propsとして受け取った値が、ユーザーが変更した値と同じ場合は処理をしない。
    // 子(changeイベント)→親→子の流れで、値が渡ってきたと判断できるため。
    if (innerStartHour === currentValue.innerStartHour && innerStartMinutes === currentValue.innerStartMinutes && innerEndHour === currentValue.innerEndHour && innerEndMinutes === currentValue.innerEndMinutes) {
      return;
    }
    setCurrentValue(valueFromProps);
    setValidateResult(getValidateResult(valueFromProps));
    if (!!startValue || !!endValue) {
      setIsTouched(true);
    }
  }, [currentValue.innerEndHour, currentValue.innerEndMinutes, currentValue.innerStartHour, currentValue.innerStartMinutes, endValue, getValidateResult, getValueFromProps, propsValue.innerEndHour, propsValue.innerEndMinutes, propsValue.innerStartHour, propsValue.innerStartMinutes, startValue]);
  var handleBlur = React.useCallback(function () {
    setIsTouched(true);
    setValidateResult(getValidateResult(currentValue));
  }, [currentValue, getValidateResult]);
  return {
    innerStartHour: innerStartHour,
    innerStartMinutes: innerStartMinutes,
    innerEndHour: innerEndHour,
    innerEndMinutes: innerEndMinutes,
    validateResult: validateResult,
    handleStartHourChange: handleStartHourChange,
    handleStartMinutesChange: handleStartMinutesChange,
    handleEndHourChange: handleEndHourChange,
    handleEndMinutesChange: handleEndMinutesChange,
    isTouched: isTouched,
    handleBlur: handleBlur
  };
};
var useTimeRangeValue = function useTimeRangeValue(_ref2) {
  var currentValue = _ref2.currentValue,
    setCurrentValue = _ref2.setCurrentValue,
    setValue = _ref2.setValue;
  var setNewValue = React.useCallback(function (newValue) {
    setCurrentValue({
      innerStartHour: newValue.innerStartHour,
      innerStartMinutes: newValue.innerStartMinutes,
      innerEndHour: newValue.innerEndHour,
      innerEndMinutes: newValue.innerEndMinutes
    });
    var startValue = timeValueToDate("".concat(newValue.innerStartHour, ":").concat(newValue.innerStartMinutes));
    var endValue = timeValueToDate("".concat(newValue.innerEndHour, ":").concat(newValue.innerEndMinutes));
    if (startValue && endValue) {
      setValue(startValue, endValue);
    }
  }, [setCurrentValue, setValue]);
  var handleStartHourChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      innerStartHour: value.substr(0, 2)
    }));
  }, [currentValue, setNewValue]);
  var handleStartMinutesChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      innerStartMinutes: value.substr(0, 2)
    }));
  }, [currentValue, setNewValue]);
  var handleEndHourChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      innerEndHour: value.substr(0, 2)
    }));
  }, [currentValue, setNewValue]);
  var handleEndMinutesChange = React.useCallback(function (v) {
    var value = v.replace(/[^0-9]/g, "");
    setNewValue(_objectSpread2(_objectSpread2({}, currentValue), {}, {
      innerEndMinutes: value.substr(0, 2)
    }));
  }, [currentValue, setNewValue]);
  return _objectSpread2({
    handleStartHourChange: handleStartHourChange,
    handleStartMinutesChange: handleStartMinutesChange,
    handleEndHourChange: handleEndHourChange,
    handleEndMinutesChange: handleEndMinutesChange
  }, currentValue);
};
var splitTimeRangeString = function splitTimeRangeString(timeRangeString) {
  var _a, _b, _c, _d;
  var timeRangeSplited = timeRangeString.split("~");
  if (timeRangeSplited[0] === "" || timeRangeSplited.length === 1) {
    return {
      startHour: "",
      startMinutes: "",
      endHour: "",
      endMinutes: ""
    };
  }
  var startTime = timeRangeSplited[0];
  var endTime = timeRangeSplited[1];
  var startTimeSplited = startTime.split(":");
  var endTimeSplited = endTime.split(":");
  //「:」で分割できない場合
  if (startTimeSplited.length === 1 || endTimeSplited.length === 1) {
    return {
      startHour: "",
      startMinutes: "",
      endHour: "",
      endMinutes: ""
    };
  }
  return {
    startHour: (_a = startTimeSplited[0]) !== null && _a !== void 0 ? _a : "",
    startMinutes: (_b = startTimeSplited[1]) !== null && _b !== void 0 ? _b : "",
    endHour: (_c = endTimeSplited[0]) !== null && _c !== void 0 ? _c : "",
    endMinutes: (_d = endTimeSplited[1]) !== null && _d !== void 0 ? _d : ""
  };
};

var css_248z$d = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.time-range-module__GDK__wrapper___-Z6tG {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.time-range-module__GDK__to___TlW4G {\n  padding: 0 16px;\n}\n\n.time-range-module__GDK__start___-W3Sq {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .time-range-module__GDK__start___-W3Sq {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.time-range-module__GDK__end___7kbHA {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .time-range-module__GDK__end___7kbHA {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.time-range-module__GDK__inputWrapper___mWQ5z {\n  width: 100px;\n}\n\n.time-range-module__GDK__hourUnit___D6mVt {\n  padding: 0 24px 0 16px;\n}\n\n.time-range-module__GDK__minutesUnit___PwbD4 {\n  padding: 0 0 0 16px;\n}\n";
var styles$d = {"wrapper":"time-range-module__GDK__wrapper___-Z6tG","to":"time-range-module__GDK__to___TlW4G","start":"time-range-module__GDK__start___-W3Sq","end":"time-range-module__GDK__end___7kbHA","inputWrapper":"time-range-module__GDK__inputWrapper___mWQ5z","hourUnit":"time-range-module__GDK__hourUnit___D6mVt","minutesUnit":"time-range-module__GDK__minutesUnit___PwbD4"};
styleInject(css_248z$d);

var _excluded$g = ["startValue", "endValue", "setValue", "validate", "timeIntervals"];
/**
 * form-generator用のコンポーネントでエラーを一括でしか表示できない。（GDKものは時間、分でエラーを分けて管理している）
 * graffer-schemasでは時間、分どちらでエラーが発生しているかを管理していないため。
 * @param param0
 * @returns
 */
var GrafferSchemasTimeRangeComponent = function GrafferSchemasTimeRangeComponent(_ref) {
  var disabled = _ref.disabled,
    startProps = _ref.startProps,
    endProps = _ref.endProps,
    description = _ref.description;
  var _useId = nextId.useId(1, "TimeRange-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
    className: styles$d.start
  }, "\u958B\u59CB\u6642\u9593"), React__namespace.createElement("div", {
    className: styles$d.wrapper
  }, React__namespace.createElement(GrafferSchemasTimeInputComponent, _objectSpread2(_objectSpread2({}, startProps), {}, {
    descriptionId: descriptionId,
    disabled: disabled,
    hourAriaLabel: "開始 時",
    minutesAriaLabel: "開始 分",
    placeholder: {
      hour: "",
      minutes: ""
    },
    elementName: {
      hour: "StartHour",
      minutes: "StartMinutes"
    }
  }))), React__namespace.createElement("div", {
    className: styles$d.end
  }, "\u7D42\u4E86\u6642\u9593"), React__namespace.createElement("div", {
    className: styles$d.wrapper
  }, React__namespace.createElement(GrafferSchemasTimeInputComponent, _objectSpread2(_objectSpread2({}, endProps), {}, {
    disabled: disabled,
    descriptionId: descriptionId,
    hourAriaLabel: "終了 時",
    minutesAriaLabel: "終了 分",
    elementName: {
      hour: "EndHour",
      minutes: "EndMinutes"
    },
    placeholder: {
      hour: "",
      minutes: ""
    }
  }))));
};
var TimeRange = function TimeRange(_ref2) {
  var startValue = _ref2.startValue,
    endValue = _ref2.endValue,
    setValue = _ref2.setValue,
    validate = _ref2.validate,
    timeIntervals = _ref2.timeIntervals,
    props = _objectWithoutProperties(_ref2, _excluded$g);
  var _useId3 = nextId.useId(1, "TimeRange-id-"),
    _useId4 = _slicedToArray(_useId3, 1),
    generatedID = _useId4[0];
  var descriptionId = props.description ? "description-".concat(generatedID) : undefined;
  var _useTimeRange = useTimeRange({
      startValue: startValue,
      endValue: endValue,
      setValue: setValue,
      validate: validate,
      generatedID: generatedID
    }),
    innerStartHour = _useTimeRange.innerStartHour,
    innerStartMinutes = _useTimeRange.innerStartMinutes,
    innerEndHour = _useTimeRange.innerEndHour,
    innerEndMinutes = _useTimeRange.innerEndMinutes,
    validateResult = _useTimeRange.validateResult,
    handleStartHourChange = _useTimeRange.handleStartHourChange,
    handleStartMinutesChange = _useTimeRange.handleStartMinutesChange,
    handleEndHourChange = _useTimeRange.handleEndHourChange,
    handleEndMinutesChange = _useTimeRange.handleEndMinutesChange,
    isTouched = _useTimeRange.isTouched,
    handleBlur = _useTimeRange.handleBlur;
  var formState = React.useMemo(function () {
    return FieldsetFormState.create(isTouched, validateResult, false, props.disabled);
  }, [isTouched, props.disabled, validateResult]);
  return React__namespace.createElement("div", null, React__namespace.createElement(FieldsetWrap, {
    title: props.title,
    description: props.description,
    descriptionId: descriptionId,
    required: props.required
  }, React__namespace.createElement("div", null, React__namespace.createElement("div", {
    className: styles$d.start
  }, "\u958B\u59CB\u6642\u9593"), React__namespace.createElement("div", {
    className: styles$d.wrapper
  }, React__namespace.createElement(TimeSelect, _objectSpread2(_objectSpread2({}, props), {}, {
    hour: innerStartHour,
    minutes: innerStartMinutes,
    formState: formState,
    handleHourChange: handleStartHourChange,
    handleMinutesChange: handleStartMinutesChange,
    handleHourBlur: handleBlur,
    handleMinutesBlur: handleBlur,
    timeIntervals: timeIntervals,
    hourAriaLabel: "開始 時",
    minutesAriaLabel: "開始 分",
    elementName: {
      hour: "StartHour",
      minutes: "StartMinutes"
    },
    descriptionId: descriptionId,
    placeholder: {
      hour: "",
      minutes: ""
    }
  }))), React__namespace.createElement("div", {
    className: styles$d.end
  }, "\u7D42\u4E86\u6642\u9593"), React__namespace.createElement("div", {
    className: styles$d.wrapper
  }, React__namespace.createElement(TimeSelect, _objectSpread2(_objectSpread2({}, props), {}, {
    hour: innerEndHour,
    minutes: innerEndMinutes,
    formState: formState,
    handleHourChange: handleEndHourChange,
    handleMinutesChange: handleEndMinutesChange,
    handleHourBlur: handleBlur,
    handleMinutesBlur: handleBlur,
    timeIntervals: timeIntervals,
    hourAriaLabel: "終了 時",
    minutesAriaLabel: "終了 分",
    elementName: {
      hour: "EndHour",
      minutes: "EndMinutes"
    },
    descriptionId: descriptionId,
    placeholder: {
      hour: "",
      minutes: ""
    }
  })))), formState.matchComponentsWithErrorSets({
    "default": function _default() {
      return null;
    },
    disabled: function disabled() {
      return null;
    },
    success: function success() {
      return null;
    },
    fail: function fail(errorSet) {
      return React__namespace.createElement(ErrorSetMessages, {
        errorSet: errorSet
      });
    }
  })));
};

var _excluded$f = ["title", "description", "id", "value", "noValidate", "validate", "errorMessage", "helperText", "onChange", "onBlur", "required", "onErrorStateChange"];
var TextField = function TextField(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    value = _ref.value,
    noValidate = _ref.noValidate,
    validate = _ref.validate,
    errorMessage = _ref.errorMessage,
    helperText = _ref.helperText,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    onErrorStateChange = _ref.onErrorStateChange,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var _useId = nextId.useId(1, "TextField-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var descriptionId = description ? "description-".concat(htmlId) : undefined;
  var errorMessageId = "errorMessage-".concat(htmlId);
  var helperTextId = helperText ? "helperText-".concat(htmlId) : undefined;
  var _useFormState = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: props.disabled,
      errorMessage: errorMessage,
      onBlur: onBlur,
      readOnly: !!props.readOnly
    }),
    formState = _useFormState.formState,
    handleBlur = _useFormState.handleBlur;
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(formState.isFail());
  }, [formState, onErrorStateChange]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TitleWrap, {
    title: title,
    description: description,
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    id: htmlId,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    helperTextId: helperTextId,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    formState: formState,
    needStatusIcon: true,
    required: required
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: formState.errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }), !!helperText && React__namespace.createElement(HelperText, {
    text: helperText,
    descriptionId: helperTextId
  }));
};

var css_248z$c = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.text-area-module__GDK__wrapper___-yCBa {\n  width: 100%;\n}\n\n.text-area-module__GDK__textAreaWrapper___YZRjE {\n  display: flex;\n  flex-direction: column;\n}\n\n.text-area-module__GDK__label___1Egxb {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .text-area-module__GDK__label___1Egxb {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.text-area-module__GDK__description___noHuh {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .text-area-module__GDK__description___noHuh {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.text-area-module__GDK__textArea___Mdiwm {\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  padding: 16px 32px 16px 24px;\n  border-radius: 8px;\n  border: 1px solid #706d6c;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n@media screen and (max-width: 800px) {\n\n  .text-area-module__GDK__textArea___Mdiwm {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.text-area-module__GDK__textArea___Mdiwm::-moz-placeholder {\n  color: #b8b5b4;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n.text-area-module__GDK__textArea___Mdiwm::placeholder {\n  color: #b8b5b4;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .text-area-module__GDK__textArea___Mdiwm::-moz-placeholder {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  .text-area-module__GDK__textArea___Mdiwm::placeholder {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.text-area-module__GDK__fullWidth___a6BZh {\n  width: 100%;\n}\n\n.text-area-module__GDK__vertical___cOg-H {\n  resize: vertical;\n}\n\n@media (hover: hover) {\n  .text-area-module__GDK__textAreaNoError___oqQ23:hover {\n    border: 1px solid #3d3b3a;\n    box-shadow: none;\n  }\n}\n\n.text-area-module__GDK__textAreaNoError___oqQ23:focus {\n  outline: 0;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.text-area-module__GDK__success___7jDIa {\n  border-color: #237f6d;\n}\n\n@media (hover: hover) {\n  .text-area-module__GDK__success___7jDIa:hover {\n    border-color: #175243;\n  }\n}\n\n.text-area-module__GDK__success___7jDIa:focus {\n  outline: 0;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n  background-color: #fff;\n}\n\n.text-area-module__GDK__error___eqhFE {\n  border-color: #d53b3a;\n  background-color: #fff7f8;\n}\n\n@media (hover: hover) {\n  .text-area-module__GDK__error___eqhFE:hover {\n    border-color: #b42828;\n  }\n}\n\n.text-area-module__GDK__error___eqhFE:focus {\n  outline: 0;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.text-area-module__GDK__disabled___JM3Fr {\n  border: none;\n  background-color: #faf9f7;\n  color: #706d6c;\n}\n\n@media screen and (max-width: 800px) {\n  .text-area-module__GDK__textArea___Mdiwm {\n    padding: 16px 24px;\n  }\n\n  .text-area-module__GDK__textArea___Mdiwm::-moz-placeholder {\n    font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  .text-area-module__GDK__textArea___Mdiwm::placeholder {\n    font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$c = {"wrapper":"text-area-module__GDK__wrapper___-yCBa","textAreaWrapper":"text-area-module__GDK__textAreaWrapper___YZRjE","label":"text-area-module__GDK__label___1Egxb","description":"text-area-module__GDK__description___noHuh","textArea":"text-area-module__GDK__textArea___Mdiwm","fullWidth":"text-area-module__GDK__fullWidth___a6BZh","vertical":"text-area-module__GDK__vertical___cOg-H","textAreaNoError":"text-area-module__GDK__textAreaNoError___oqQ23","success":"text-area-module__GDK__success___7jDIa","error":"text-area-module__GDK__error___eqhFE","disabled":"text-area-module__GDK__disabled___JM3Fr"};
styleInject(css_248z$c);

var css_248z$b = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.char-count-module__GDK__charCount___Taurw {\n  font: 300 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  text-align: right;\n  letter-spacing: 1px;\n  color: #1d1c1a;\n}\n";
var styles$b = {"charCount":"char-count-module__GDK__charCount___Taurw"};
styleInject(css_248z$b);

var CharCount = function CharCount(_ref) {
  var id = _ref.id,
    text = _ref.text,
    maxLength = _ref.maxLength;
  return React__namespace.default.createElement("p", {
    id: id,
    className: styles$b.charCount
  }, text.length, "/", maxLength);
};

var _excluded$e = ["id", "value", "onChange", "onBlur", "placeholder", "disabled", "formState", "required", "fullWidth", "resize", "maxLength"],
  _excluded2$7 = ["isValid", "touched", "noValidate", "disabled", "placeholder", "fullWidth", "resize"],
  _excluded3$1 = ["value", "validate", "noValidate", "errorMessage", "id", "title", "description", "onBlur", "disabled", "required", "onErrorStateChange"];
/**
 * テキストエリアUIコンポーネント
 */
var BaseTextArea = React__namespace.forwardRef(function BaseTextArea(_ref, ref) {
  var id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    formState = _ref.formState,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    fullWidth = _ref.fullWidth,
    resize = _ref.resize,
    maxLength = _ref.maxLength,
    props = _objectWithoutProperties(_ref, _excluded$e);
  var ariaDescriptionId = getAreaDescribedByValue([props["aria-describedby"], maxLength ? "text-area-char-count" : undefined]);
  return React__namespace.createElement("div", {
    className: styles$c.wrapper
  }, React__namespace.createElement("textarea", _objectSpread2(_objectSpread2({}, props), {}, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    className: "".concat(styles$c.textArea, " ").concat(formState.matchType({
      "default": styles$c.textAreaNoError,
      disabled: styles$c.disabled,
      success: styles$c.success,
      fail: styles$c.error,
      readOnly: ""
    }), " ").concat(fullWidth ? styles$c.fullWidth : "", " ").concat(resize === "vertical" ? styles$c.vertical : ""),
    placeholder: placeholder,
    disabled: disabled,
    id: id,
    required: required,
    "aria-required": required,
    ref: ref,
    "aria-invalid": formState.isFail(),
    "aria-describedby": ariaDescriptionId
  })), !!maxLength && React__namespace.createElement(CharCount, {
    id: "text-area-char-count",
    text: value !== null && value !== void 0 ? value : "",
    maxLength: maxLength
  }));
});
/**
 *
 * form-generatorで使用するテキストエリアコンポーネント（isValid,touched）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasTextAreaComponent = React__namespace.forwardRef(function TextAreaComponent(_ref2, ref) {
  var isValid = _ref2.isValid,
    touched = _ref2.touched,
    noValidate = _ref2.noValidate,
    disabled = _ref2.disabled,
    placeholder = _ref2.placeholder,
    fullWidth = _ref2.fullWidth,
    resize = _ref2.resize,
    props = _objectWithoutProperties(_ref2, _excluded2$7);
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: props.id
    }),
    id = _useGrafferSchemasIds.id,
    descriptionId = _useGrafferSchemasIds.descriptionId,
    errorMessageId = _useGrafferSchemasIds.errorMessageId;
  var notFailAriaDescribedByValue = getAreaDescribedByValue([descriptionId]);
  var formState = FormState.create(touched, isValid, noValidate, disabled, undefined, undefined);
  return React__namespace.createElement(BaseTextArea, _objectSpread2(_objectSpread2({}, props), {}, {
    placeholder: placeholder,
    formState: formState,
    disabled: disabled,
    fullWidth: fullWidth,
    resize: resize,
    id: id,
    "aria-describedby": formState.matchType({
      "default": notFailAriaDescribedByValue,
      disabled: notFailAriaDescribedByValue,
      success: notFailAriaDescribedByValue,
      fail: getAreaDescribedByValue([descriptionId, errorMessageId]),
      readOnly: notFailAriaDescribedByValue
    }),
    ref: ref
  }));
});
/**
 *
 * テキストエリアコンポーネント
 *
 * @param param0
 * @returns
 */
var TextArea = function TextArea(_ref3) {
  var _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? "" : _ref3$value,
    _ref3$validate = _ref3.validate,
    validate = _ref3$validate === void 0 ? function () {
      return true;
    } : _ref3$validate,
    noValidate = _ref3.noValidate,
    errorMessage = _ref3.errorMessage,
    id = _ref3.id,
    title = _ref3.title,
    description = _ref3.description,
    onBlur = _ref3.onBlur,
    disabled = _ref3.disabled,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    onErrorStateChange = _ref3.onErrorStateChange,
    props = _objectWithoutProperties(_ref3, _excluded3$1);
  var _useId = nextId.useId(1, "TextArea-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var formState = React.useMemo(function () {
    return FormState.create(touched, validate(value), noValidate, disabled, errorMessage, undefined);
  }, [disabled, errorMessage, noValidate, touched, validate, value]);
  var handleBlur = React.useCallback(function (event) {
    setTouched(true);
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [onBlur]);
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var errorMessageId = formState.errorMessage ? "errorMessage-".concat(generatedID) : undefined;
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(formState.isFail());
  }, [formState, onErrorStateChange]);
  return React__namespace.createElement("div", {
    className: styles$c.textAreaWrapper
  }, React__namespace.createElement(TitleWrap, {
    title: title,
    description: description,
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseTextArea, _objectSpread2(_objectSpread2({}, props), {}, {
    id: htmlId,
    value: value,
    formState: formState,
    "aria-describedby": getAreaDescribedByValue([descriptionId, errorMessageId]),
    onBlur: handleBlur,
    disabled: disabled,
    required: required
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: formState.errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};

var css_248z$a = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.checkbox-input-module__GDK__wrapper___xtNlr > .checkbox-input-module__GDK__item___55Vhd:not(:first-child) {\n  margin-top: 8px;\n}\n\n.checkbox-input-module__GDK__item___55Vhd {\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.checkbox-input-module__GDK__checkbox___xFKJH[type] {\n  opacity: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n}\n\n.checkbox-input-module__GDK__label___k67tj {\n  min-height: 56px;\n  border: 1px solid #706d6c;\n  padding: 16px;\n  width: 100%;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  cursor: pointer;\n  background-color: #fff;\n  border-radius: 8px;\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n\n  .checkbox-input-module__GDK__label___k67tj {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.checkbox-input-module__GDK__checkboxIcon___zln6Z {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  background: #fff;\n  border: 1px solid #706d6c;\n  border-radius: 20%;\n}\n\n.checkbox-input-module__GDK__checked___PK9io .checkbox-input-module__GDK__checkboxIcon___zln6Z {\n  background: #454ab8;\n  border-color: #454ab8;\n}\n\n.checkbox-input-module__GDK__checked___PK9io .checkbox-input-module__GDK__checkboxIcon___zln6Z::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 37%;\n  left: 58%;\n  width: 40%;\n  height: 2px;\n  transform: translate(-5px, 6px) rotateZ(-135deg);\n  transform-origin: 1px 1px;\n  background: #ffffff;\n}\n\n.checkbox-input-module__GDK__failLabel___Hhc5g .checkbox-input-module__GDK__checkboxIcon___zln6Z {\n  border-color: #d53b3a;\n}\n\n.checkbox-input-module__GDK__checked___PK9io .checkbox-input-module__GDK__failLabel___Hhc5g .checkbox-input-module__GDK__checkboxIcon___zln6Z {\n  background: #d53b3a;\n}\n\n.checkbox-input-module__GDK__checked___PK9io .checkbox-input-module__GDK__checkboxIcon___zln6Z::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 37%;\n  left: 58%;\n  width: 70%;\n  height: 2px;\n  transform: translate(-5px, 6px) rotateZ(-45deg);\n  transform-origin: 1px 1px;\n  background: #ffffff;\n}\n\n.checkbox-input-module__GDK__appearance___jYmDP {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n@media (hover: hover) {\n  .checkbox-input-module__GDK__label___k67tj:not(.checkbox-input-module__GDK__failLabel___Hhc5g):hover {\n    border-color: #3d3b3a;\n  }\n  .checkbox-input-module__GDK__label___k67tj.checkbox-input-module__GDK__failLabel___Hhc5g:hover {\n    border-color: #b42828;\n  }\n  .checkbox-input-module__GDK__label___k67tj.checkbox-input-module__GDK__failLabel___Hhc5g:hover svg path {\n    fill: #b42828;\n  }\n  .checkbox-input-module__GDK__label___k67tj.checkbox-input-module__GDK__failLabel___Hhc5g:hover svg rect {\n    stroke: #b42828;\n  }\n}\n\n.checkbox-input-module__GDK__checkbox___xFKJH:focus + .checkbox-input-module__GDK__label___k67tj {\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.checkbox-input-module__GDK__failLabel___Hhc5g.checkbox-input-module__GDK__label___k67tj {\n  border-color: #d53b3a;\n  background-color: #fff7f8;\n}\n\n.checkbox-input-module__GDK__failLabel___Hhc5g svg path {\n  fill: #d53b3a;\n}\n\n.checkbox-input-module__GDK__failLabel___Hhc5g svg rect {\n  stroke: #d53b3a;\n}\n\n@media screen and (max-width: 800px) {\n  .checkbox-input-module__GDK__wrapper___xtNlr > .checkbox-input-module__GDK__item___55Vhd:not(:first-child) {\n    margin-top: 16px;\n  }\n}\n\n.checkbox-input-module__GDK__agreementCheckboxText___HcHHP {\n  display: inline;\n  vertical-align: middle;\n}\n\n.checkbox-input-module__GDK__appearance___jYmDP.checkbox-input-module__GDK__agreementCheckboxTextWrapper___jh4nY {\n  display: inline;\n}\n";
var styles$a = {"wrapper":"checkbox-input-module__GDK__wrapper___xtNlr","item":"checkbox-input-module__GDK__item___55Vhd","checkbox":"checkbox-input-module__GDK__checkbox___xFKJH","label":"checkbox-input-module__GDK__label___k67tj","checkboxIcon":"checkbox-input-module__GDK__checkboxIcon___zln6Z","checked":"checkbox-input-module__GDK__checked___PK9io","failLabel":"checkbox-input-module__GDK__failLabel___Hhc5g","appearance":"checkbox-input-module__GDK__appearance___jYmDP","agreementCheckboxText":"checkbox-input-module__GDK__agreementCheckboxText___HcHHP","agreementCheckboxTextWrapper":"checkbox-input-module__GDK__agreementCheckboxTextWrapper___jh4nY"};
styleInject(css_248z$a);

var _excluded$d = ["isValid", "touched", "noValidate", "disabled", "value"],
  _excluded2$6 = ["title", "description", "value", "disabled", "noValidate", "validate", "errorMessage", "required", "onBlur"];
/**
 *
 * チェックボックスのUIコンポーネント
 *
 * @param param0
 * @returns
 */
var BaseCheckBoxes = function BaseCheckBoxes(_ref) {
  var className = _ref.className,
    options = _ref.options,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    disabled = _ref.disabled,
    name = _ref.name,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    formState = _ref.formState;
  var handleChange = React.useCallback(function (e) {
    var newValue = e.currentTarget.value;
    if (value.includes(newValue)) {
      onChange(value.filter(function (v) {
        return v !== newValue;
      }));
    } else {
      onChange([].concat(_toConsumableArray(value), [newValue]));
    }
  }, [value, onChange]);
  return React__namespace.default.createElement("ul", {
    className: "".concat(className, " ").concat(styles$a.wrapper)
  }, options.map(function (o) {
    var _a;
    var checked = value.includes((_a = o.value) !== null && _a !== void 0 ? _a : "");
    var generatedID = nextId__default.default("CheckboxInput-id-");
    return React__namespace.default.createElement("li", {
      className: classNames__default.default(styles$a.item, checked && styles$a.checked),
      key: o.value
    }, React__namespace.default.createElement("input", {
      type: "checkbox",
      className: styles$a.checkbox,
      value: o.value,
      checked: checked,
      disabled: disabled,
      name: name,
      onChange: handleChange,
      onBlur: onBlur,
      id: generatedID
    }), React__namespace.default.createElement("label", {
      className: "".concat(styles$a.label, " ").concat(formState.matchType({
        "default": "",
        disabled: "",
        success: "",
        fail: styles$a.failLabel,
        readOnly: ""
      })),
      htmlFor: generatedID
    }, React__namespace.default.createElement("span", {
      className: styles$a.checkboxIcon
    }), React__namespace.default.createElement("span", {
      className: styles$a.appearance
    }, o.text)));
  }));
};
/**
 *
 * form-generatorで使用するチェックボックスコンポーネント（isValid,touched）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasCheckBoxInputComponent = function GrafferSchemasCheckBoxInputComponent(_ref2) {
  var isValid = _ref2.isValid,
    touched = _ref2.touched,
    noValidate = _ref2.noValidate,
    disabled = _ref2.disabled,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? [] : _ref2$value,
    props = _objectWithoutProperties(_ref2, _excluded$d);
  var formState = FormState.create(touched, isValid, noValidate, disabled, undefined, undefined);
  return React__namespace.default.createElement(BaseCheckBoxes, _objectSpread2({}, _objectSpread2({
    value: value,
    disabled: disabled,
    formState: formState
  }, props)));
};
/**
 * チェックボックスコンポーネント
 * @param param0
 * @returns
 */
var CheckboxInput = function CheckboxInput(_ref3) {
  var title = _ref3.title,
    description = _ref3.description,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? [] : _ref3$value,
    disabled = _ref3.disabled,
    noValidate = _ref3.noValidate,
    _ref3$validate = _ref3.validate,
    validate = _ref3$validate === void 0 ? function () {
      return true;
    } : _ref3$validate,
    errorMessage = _ref3.errorMessage,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    onBlur = _ref3.onBlur,
    props = _objectWithoutProperties(_ref3, _excluded2$6);
  var _useFormState = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: disabled,
      errorMessage: errorMessage,
      onBlur: onBlur,
      readOnly: undefined
    }),
    formState = _useFormState.formState,
    handleBlur = _useFormState.handleBlur;
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement(FieldsetWrap, {
    title: title,
    description: description,
    required: required
  }, React__namespace.default.createElement(BaseCheckBoxes, _objectSpread2({
    onBlur: handleBlur
  }, _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: errorMessage,
    formState: formState,
    required: required,
    value: value
  })))), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.default.createElement(ErrorMessages, {
      messages: errorMessage
    }),
    readOnly: null
  }));
};
/**
 * 利用規約同意チェックに使用する、チェックが一つのみのチェックボックスコンポーネント
 * ① タイトルは表示しない（利用規約ページへの外部リンクを含んだ説明を、チェックボックスの上あたりにプロダクト側で設定するケースが多いため）
 * ② 説明文は表示しない （チェックボックスのラベル部分に「"利用規約に同意してください"」等と設定できるため不要と判断）
 * ③ 「必須」or「任意」ラベルは表示する （必須の場合には input にも reauire 属性を付与）
 * ④ エラー文は表示する（ input にも紐付ける ）
 * @returns
 */
var AgreementSingleCheckboxInput = function AgreementSingleCheckboxInput(_ref4) {
  var value = _ref4.value,
    text = _ref4.text,
    disabled = _ref4.disabled,
    noValidate = _ref4.noValidate,
    _ref4$validate = _ref4.validate,
    validate = _ref4$validate === void 0 ? function () {
      return true;
    } : _ref4$validate,
    errorMessage = _ref4.errorMessage,
    _ref4$required = _ref4.required,
    required = _ref4$required === void 0 ? true : _ref4$required,
    onBlur = _ref4.onBlur,
    onChange = _ref4.onChange,
    checked = _ref4.checked,
    name = _ref4.name;
  var generatedID = React__namespace.default.useId();
  var id = "Agreement-Checkbox-".concat(generatedID);
  var errorMessageId = "Error-Message-Agreement-Checkbox-".concat(generatedID);
  var _useFormState2 = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: disabled,
      errorMessage: errorMessage,
      onBlur: onBlur,
      readOnly: undefined
    }),
    formState = _useFormState2.formState,
    handleBlur = _useFormState2.handleBlur;
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement("div", {
    className: classNames__default.default(styles$a.item, checked && styles$a.checked)
  }, React__namespace.default.createElement("input", {
    type: "checkbox",
    className: classNames__default.default(styles$a.checkbox),
    value: value,
    name: name,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onBlur: handleBlur,
    id: id,
    required: required,
    "aria-required": required,
    "aria-invalid": formState.matchType({
      "default": false,
      disabled: false,
      success: false,
      fail: true,
      readOnly: false
    }),
    "aria-describedby": formState.matchType({
      "default": undefined,
      disabled: undefined,
      success: undefined,
      fail: errorMessageId,
      readOnly: undefined
    })
  }), React__namespace.default.createElement("label", {
    className: "".concat(styles$a.label, " ").concat(formState.matchType({
      "default": "",
      disabled: "",
      success: "",
      fail: styles$a.failLabel,
      readOnly: ""
    })),
    htmlFor: id
  }, React__namespace.default.createElement("span", {
    className: styles$a.checkboxIcon
  }), React__namespace.default.createElement("span", {
    className: "".concat(styles$a.appearance, " ").concat(styles$a.agreementCheckboxTextWrapper)
  }, React__namespace.default.createElement("span", {
    className: styles$a.agreementCheckboxText
  }, text), required ? React__namespace.default.createElement(RequiredTag, null) : React__namespace.default.createElement(OptionalTag, null)))), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.default.createElement(ErrorMessages, {
      messages: errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};

var css_248z$9 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.radio-input-module__GDK__wrapper___ZPkHo > .radio-input-module__GDK__item___P1AF-:not(:first-child) {\n  margin-top: 8px;\n}\n\n.radio-input-module__GDK__item___P1AF- {\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.radio-input-module__GDK__radio___RYJVA[type] {\n  opacity: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  position: absolute;\n}\n\n.radio-input-module__GDK__label___IycQW {\n  min-height: 56px;\n  border: 1px solid #706d6c;\n  padding: 16px;\n  width: 100%;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 8px;\n  color: #1d1c1a;\n}\n\n@media screen and (max-width: 800px) {\n\n  .radio-input-module__GDK__label___IycQW {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.radio-input-module__GDK__appearance___Dkud- {\n  display: flex;\n  align-items: center;\n  position: relative;\n  word-break: break-all;\n}\n\n.radio-input-module__GDK__appearance___Dkud-:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  border: 1px solid #706d6c;\n  flex-shrink: 0;\n  height: 24px;\n  width: 24px;\n  margin-right: 16px;\n}\n\n.radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__label___IycQW .radio-input-module__GDK__appearance___Dkud-:before {\n  border-color: #454ab8;\n}\n\n.radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__label___IycQW .radio-input-module__GDK__appearance___Dkud-:after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  top: calc(100% - 50%);\n  transform: translate(-50%, -50%);\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  background-color: #454ab8;\n}\n\n/* エラー */\n\n.radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW {\n  border-color: #d53b3a;\n  background-color: #fff7f8;\n}\n\n.radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW .radio-input-module__GDK__appearance___Dkud-:before {\n  border-color: #d53b3a;\n}\n\n.radio-input-module__GDK__failAppearance___8hyT6:before {\n  border-color: #d53b3a;\n}\n\n.radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW .radio-input-module__GDK__appearance___Dkud-:after {\n  background-color: #d53b3a;\n}\n\n@media (hover: hover) {\n  .radio-input-module__GDK__label___IycQW:hover {\n    cursor: pointer;\n  }\n  .radio-input-module__GDK__label___IycQW:not(.radio-input-module__GDK__failLabel___A-gIR):hover {\n    border-color: #3d3b3a;\n  }\n\n  /* エラー */\n  .radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW:hover {\n    border-color: #b42828;\n  }\n\n  .radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW:hover .radio-input-module__GDK__appearance___Dkud-:before {\n    border-color: #b42828;\n  }\n\n  .radio-input-module__GDK__failAppearance___8hyT6:before {\n    border-color: #b42828;\n  }\n\n  .radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__failLabel___A-gIR.radio-input-module__GDK__label___IycQW:hover .radio-input-module__GDK__appearance___Dkud-:after {\n    background-color: #b42828;\n  }\n}\n\n.radio-input-module__GDK__radio___RYJVA:focus + .radio-input-module__GDK__label___IycQW {\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n@media screen and (max-width: 800px) {\n  .radio-input-module__GDK__radio___RYJVA[type]:checked + .radio-input-module__GDK__label___IycQW .radio-input-module__GDK__appearance___Dkud-:after {\n    top: calc(100% - 50%);\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .radio-input-module__GDK__wrapper___ZPkHo > .radio-input-module__GDK__item___P1AF-:not(:first-child) {\n    margin-top: 16px;\n  }\n}\n";
var styles$9 = {"wrapper":"radio-input-module__GDK__wrapper___ZPkHo","item":"radio-input-module__GDK__item___P1AF-","radio":"radio-input-module__GDK__radio___RYJVA","label":"radio-input-module__GDK__label___IycQW","appearance":"radio-input-module__GDK__appearance___Dkud-","failLabel":"radio-input-module__GDK__failLabel___A-gIR","failAppearance":"radio-input-module__GDK__failAppearance___8hyT6"};
styleInject(css_248z$9);

var _excluded$c = ["isValid", "touched", "noValidate", "disabled"],
  _excluded2$5 = ["title", "description", "value", "disabled", "noValidate", "validate", "errorMessage", "required", "onBlur"];
/**
 *
 * ラジオボックスのUIコンポーネント
 *
 * @param param0
 * @returns
 */
var BaseRadios = function BaseRadios(_ref) {
  var className = _ref.className,
    options = _ref.options,
    value = _ref.value,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    name = _ref.name,
    formState = _ref.formState;
  var handleClick = React.useCallback(function (e) {
    var targetValue = e.currentTarget.value;
    if (targetValue === value || !targetValue || targetValue === "") {
      onClick("");
    } else {
      onClick(targetValue);
    }
  }, [onClick, value]);
  return React__namespace.default.createElement("ul", {
    className: "".concat(className, " ").concat(styles$9.wrapper)
  }, options.map(function (o) {
    var generatedID = nextId__default.default("RadioInput-id-");
    return React__namespace.default.createElement("li", {
      className: styles$9.item,
      key: o.value
    }, React__namespace.default.createElement("input", {
      type: "radio",
      className: styles$9.radio,
      value: o.value,
      checked: value === o.value,
      disabled: disabled,
      name: name,
      id: generatedID,
      onClick: handleClick,
      onBlur: onBlur
    }), React__namespace.default.createElement("label", {
      className: "".concat(styles$9.label, " ").concat(formState.matchType({
        "default": "",
        disabled: "",
        success: "",
        fail: styles$9.failLabel,
        readOnly: ""
      })),
      htmlFor: generatedID
    }, React__namespace.default.createElement("span", {
      className: "".concat(styles$9.appearance, " ").concat(formState.matchType({
        "default": "",
        disabled: "",
        success: "",
        fail: styles$9.failAppearance,
        readOnly: ""
      }))
    }, o.text)));
  }));
};
/**
 *
 * form-generatorで使用するラジオボックスコンポーネント（isValid,touched）を引数で受け取る
 *
 * @param param0
 * @returns
 */
var GrafferSchemasRadioInputComponent = function GrafferSchemasRadioInputComponent(_ref2) {
  var isValid = _ref2.isValid,
    touched = _ref2.touched,
    noValidate = _ref2.noValidate,
    disabled = _ref2.disabled,
    props = _objectWithoutProperties(_ref2, _excluded$c);
  var formState = FormState.create(touched, isValid, noValidate, disabled, undefined, undefined);
  return React__namespace.default.createElement(BaseRadios, _objectSpread2({}, _objectSpread2({
    disabled: disabled,
    formState: formState
  }, props)));
};
/**
 *
 * ラジオボタンコンポーネント
 *
 * @param param0
 * @returns
 */
var RadioInput = function RadioInput(_ref3) {
  var title = _ref3.title,
    description = _ref3.description,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? "" : _ref3$value,
    disabled = _ref3.disabled,
    noValidate = _ref3.noValidate,
    _ref3$validate = _ref3.validate,
    validate = _ref3$validate === void 0 ? function () {
      return true;
    } : _ref3$validate,
    errorMessage = _ref3.errorMessage,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    onBlur = _ref3.onBlur,
    props = _objectWithoutProperties(_ref3, _excluded2$5);
  var _useFormState = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: disabled,
      errorMessage: errorMessage,
      onBlur: onBlur,
      readOnly: undefined
    }),
    formState = _useFormState.formState,
    handleBlur = _useFormState.handleBlur;
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement(FieldsetWrap, {
    title: title,
    description: description,
    required: required
  }, React__namespace.default.createElement(BaseRadios, _objectSpread2(_objectSpread2({}, props), {}, {
    onBlur: handleBlur,
    formState: formState,
    value: value,
    disabled: disabled
  }))), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.default.createElement(ErrorMessages, {
      messages: errorMessage
    }),
    readOnly: null
  }));
};

var defaultValidate = function defaultValidate() {
  return true;
};
var SelectInput = function SelectInput(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    className = _ref.className,
    name = _ref.name,
    options = _ref.options,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? defaultValidate : _ref$validate,
    noValidate = _ref.noValidate,
    errorMessage = _ref.errorMessage,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$half = _ref.half,
    half = _ref$half === void 0 ? false : _ref$half,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "選択してください" : _ref$placeholder,
    autoComplete = _ref.autoComplete;
  var _useId = nextId.useId(1, "SelectInput-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var errorMessageId = "errorMessage-".concat(generatedID);
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var formState = React.useMemo(function () {
    return FormState.create(touched, validate(value), noValidate, disabled, errorMessage, undefined);
  }, [disabled, errorMessage, noValidate, touched, validate, value]);
  var handleOnChange = React.useCallback(function (value) {
    setTouched(true);
    onChange(value);
  }, [onChange]);
  var handleBlur = React.useCallback(function (event) {
    setTouched(true);
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [onBlur]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TitleWrap, {
    title: title,
    description: description,
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.createElement("div", {
    className: className
  }, React__namespace.createElement(Select, {
    id: htmlId,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    onChange: handleOnChange,
    options: options,
    formState: formState,
    onFocus: onFocus,
    onBlur: handleBlur,
    disabled: disabled,
    half: half,
    name: name,
    value: value,
    placeholder: placeholder,
    required: required,
    autoComplete: autoComplete
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};

var css_248z$8 = ".postalCode-search-module__GDK__inputWrap___ZcKtI {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 290px);\n  grid-column-gap: 16px;\n  grid-row-gap: 8px;\n  align-items: center;\n}\n\n.postalCode-search-module__GDK__buttonArea___yZ3gD {\n  display: contents;\n}\n\n@media screen and (max-width: 800px) {\n  .postalCode-search-module__GDK__inputWrap___ZcKtI {\n    grid-template-columns: 1fr;\n  }\n}\n";
var styles$8 = {"inputWrap":"postalCode-search-module__GDK__inputWrap___ZcKtI","buttonArea":"postalCode-search-module__GDK__buttonArea___yZ3gD"};
styleInject(css_248z$8);

var PostalCodeErrorType = /*#__PURE__*/function (_BaseType) {
  function PostalCodeErrorType() {
    _classCallCheck(this, PostalCodeErrorType);
    return _callSuper(this, PostalCodeErrorType, arguments);
  }
  _inherits(PostalCodeErrorType, _BaseType);
  return _createClass(PostalCodeErrorType, null, [{
    key: "create",
    value: function create(required, value) {
      if (required && (!value || value.length === 0)) {
        return new PostalCodeErrorType("REQUIRED");
      }
      var splitStr = value ? value.split("") : [];
      var invalidStr = splitStr.filter(function (v) {
        return !v.match(/^\d{1}$/);
      });
      if (invalidStr.length > 0) {
        return new PostalCodeErrorType("INVALID_CHARACTER");
      }
      if (splitStr.length > 0 && value.length !== 7) {
        return new PostalCodeErrorType("WORD_COUNT");
      }
      return new PostalCodeErrorType("SUCCESS");
    }
  }]);
}(BaseType);
/**
 * 期待された郵便番号が入力されていれば「undefined」を、されていない場合は入力内容に応じたエラーメッセージを返却。
 */
var getPostalCodeErrorMessage = function getPostalCodeErrorMessage(required) {
  return function (value) {
    return PostalCodeErrorType.create(required, value).matchType({
      REQUIRED: "入力必須の項目です",
      INVALID_CHARACTER: "無効な文字が含まれています。半角数字のみの7桁で入力してください",
      WORD_COUNT: "文字数エラー。7桁の半角数字を入力してください",
      SUCCESS: undefined
    });
  };
};
/**
 * 期待された郵便番号が入力されていれば「true」を、されていない場合は「false」を返却。
 * FormState の createメソッドに渡す引数等として使用。
 */
var postalCodeValidateFunc = function postalCodeValidateFunc(required) {
  return function (value) {
    return PostalCodeErrorType.create(required, value).matchType({
      REQUIRED: false,
      INVALID_CHARACTER: false,
      WORD_COUNT: false,
      SUCCESS: true
    });
  };
};
/**
 * ユーザーが入力した値を必要に応じて変換して返却。
 */
var convertUserPostalCodeInput = function convertUserPostalCodeInput(str) {
  var hankaku = str
  // 全角ハイフンは半角に置き換える。
  .replace(/ー/g, "-")
  // 全角数字は半角に置き換える。
  .replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
  // 「○○○-○○○○」の形で数字とハイフンのみで構成されていた場合に、ハイフンは削除。
  if (hankaku.match(/^\d{3}-?\d{4}$/)) {
    return hankaku.replace(/-/, "");
  }
  return hankaku;
};

var css_248z$7 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.helperText-module__GDK__helperTextWrapper___iK9ak {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0;\n  color: #706d6c;\n}\n\n.helperText-module__GDK__iconArea___EZ0Gt {\n  display: flex;\n  align-items: center;\n}\n\n.helperText-module__GDK__helperText___0KajR {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  color: #706d6c;\n}\n\n@media screen and (max-width: 800px) {\n\n  .helperText-module__GDK__helperText___0KajR {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n";
var styles$7 = {"helperTextWrapper":"helperText-module__GDK__helperTextWrapper___iK9ak","iconArea":"helperText-module__GDK__iconArea___EZ0Gt","helperText":"helperText-module__GDK__helperText___0KajR"};
styleInject(css_248z$7);

/**
 * usecases
 * 自動郵便番号入力ボタンの補足説明として表示
 * TextFieldの補足説明として表示
 */
var HelperText = function HelperText(_ref) {
  var text = _ref.text,
    descriptionId = _ref.descriptionId;
  return React__namespace.default.createElement("div", {
    className: styles$7.helperTextWrapper,
    id: descriptionId
  }, React__namespace.default.createElement("div", {
    className: styles$7.iconArea,
    "aria-hidden": true
  }, React__namespace.default.createElement(InfoOutlineIcon, {
    size: 20
  })), React__namespace.default.createElement("p", {
    className: styles$7.helperText
  }, text));
};

var _excluded$b = ["id", "value", "onChange", "onBlur", "onClickButton", "isValid", "touched", "noValidate", "required", "errorMessageWithFetchDataId", "postalCodeSearchHelperTextId", "onErrorStateChange", "hiddenButton", "showError"],
  _excluded2$4 = ["id", "value", "noValidate", "onChange", "onBlur", "onClickButton", "required", "errorMessageWithFetchDataId", "onErrorStateChange"];
var ADDRESS_AUTO_INPUT_INFO_TEXT = "「郵便番号から住所を入力」を押すと、住所の一部が自動入力されます。";
var ASK_USER_TO_COMPLETE_ADDRESS_FORM_TEXT = "自動入力後、番地、マンション名、部屋番号など、住所の続きがあれば入力してください。";
/**
 * 「郵便番号から住所を入力」ボタンに設定されたIDを取得するための関数（ボタンが表示されているかの判定に使用する）
 * @param id
 * @returns
 */
var getAutoCompleteAddressButtonId = function getAutoCompleteAddressButtonId(id) {
  return id ? "auto-complete-address-button-id-".concat(id) : undefined;
};
/**
 * タイトルと説明文を持たない、Inputのみの郵便番号入力
 */
var PostalCodeSearchInput = function PostalCodeSearchInput(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onClickButton = _ref.onClickButton,
    isValid = _ref.isValid,
    touched = _ref.touched,
    noValidate = _ref.noValidate,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    errorMessageWithFetchDataId = _ref.errorMessageWithFetchDataId,
    postalCodeSearchHelperTextId = _ref.postalCodeSearchHelperTextId,
    onErrorStateChange = _ref.onErrorStateChange,
    _ref$hiddenButton = _ref.hiddenButton,
    hiddenButton = _ref$hiddenButton === void 0 ? false : _ref$hiddenButton,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var _useId = nextId.useId(1, "PostalCodeSearch-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var errorMessageId = "errorMessage-".concat(generatedID);
  // GuseGrafferSchemasIds()を通して取得したIDだと分かるように、変数名を変更（変数名が重複したため）
  var _useGrafferSchemasIds = useGrafferSchemasIds({
      id: htmlId,
      descriptionId: props.descriptionId
    }),
    idFromUseGrafferSchemasIds = _useGrafferSchemasIds.id,
    descriptionIdFromUseGrafferSchemasIds = _useGrafferSchemasIds.descriptionId,
    errorMessageIdFromUseGrafferSchemasIds = _useGrafferSchemasIds.errorMessageId;
  var formState = React__namespace.useMemo(function () {
    return FormState.create(touched,
    // isTouched
    !getPostalCodeErrorMessage(required)(value) && isValid, noValidate, props.disabled, getPostalCodeErrorMessage(required)(value), undefined);
  }, [props.disabled, value, required, isValid, noValidate, touched]);
  var handleClickButton = React.useCallback(function () {
    onClickButton(value);
  }, [onClickButton, value]);
  var handleBlur = React.useCallback(function (event) {
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [onBlur]);
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(formState.isFail());
  }, [formState, onErrorStateChange]);
  var baseTextInputErrorMessageId = React.useMemo(function () {
    //このコンポーネント内に実装してあるエラーメッセージのIDは、表示されている場合のみ設定する
    var componentErrorMessageId = showError && formState.equals("fail") ? errorMessageId : undefined;
    if (errorMessageIdFromUseGrafferSchemasIds) {
      return componentErrorMessageId ? "".concat(errorMessageIdFromUseGrafferSchemasIds, " ").concat(componentErrorMessageId) : errorMessageIdFromUseGrafferSchemasIds;
    }
    return componentErrorMessageId ? componentErrorMessageId : undefined;
  }, [showError, formState, errorMessageIdFromUseGrafferSchemasIds, errorMessageId]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("div", {
    className: styles$8.inputWrap
  }, React__namespace.createElement("div", {
    className: "".concat(styles$8.inputArea)
  }, React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    type: "text",
    id: idFromUseGrafferSchemasIds,
    descriptionId: descriptionIdFromUseGrafferSchemasIds,
    errorMessageId: baseTextInputErrorMessageId,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    formState: formState,
    needStatusIcon: true,
    autoComplete: "postal-code",
    required: required,
    inputMode: "numeric"
  }))), !hiddenButton && React__namespace.createElement("div", {
    className: styles$8.buttonArea
  }, React__namespace.createElement(SecondaryButton, {
    id: getAutoCompleteAddressButtonId(idFromUseGrafferSchemasIds),
    type: "button",
    text: "郵便番号から住所を入力",
    onClick: handleClickButton,
    disabled: props.disabled || formState.isFail() || !value,
    "aria-describedby": getAreaDescribedByValue([errorMessageWithFetchDataId, postalCodeSearchHelperTextId])
  }))), showError && formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: formState.errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};
/**
 * タイトルと説明文をもつ郵便番号入力、エラー表示がdefault
 */
var PostalCodeSearch = function PostalCodeSearch(_ref2) {
  var id = _ref2.id,
    value = _ref2.value,
    noValidate = _ref2.noValidate,
    onChange = _ref2.onChange,
    onBlur = _ref2.onBlur,
    onClickButton = _ref2.onClickButton,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    errorMessageWithFetchDataId = _ref2.errorMessageWithFetchDataId,
    onErrorStateChange = _ref2.onErrorStateChange,
    props = _objectWithoutProperties(_ref2, _excluded2$4);
  var _useId3 = nextId.useId(1, "PostalCodeSearch-id-"),
    _useId4 = _slicedToArray(_useId3, 1),
    generatedID = _useId4[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var descriptionId = "description-".concat(generatedID);
  var postalCodeSearchHelperTextId = "helper-text-".concat(generatedID);
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTouched = _useState2[0],
    setIsTouched = _useState2[1];
  var isValid = React__namespace.useMemo(function () {
    return postalCodeValidateFunc(required)(value);
  }, [value, required]);
  var handleChange = React.useCallback(function (event) {
    var value = event.target.value;
    var convertedValue = convertUserPostalCodeInput(value);
    onChange(convertedValue);
  }, [onChange]);
  var handleBlur = React.useCallback(function (event) {
    setIsTouched(true);
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [onBlur]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TitleWrap, {
    title: "郵便番号（ハイフンなし）",
    description: "郵便番号はハイフン、スペース（空白）無しの半角数字7桁で入力してください。",
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), !props.disabled && props.help, React__namespace.createElement(PostalCodeSearchInput, _objectSpread2({}, _objectSpread2(_objectSpread2({}, props), {}, {
    id: id,
    value: value,
    noValidate: noValidate,
    onChange: handleChange,
    onBlur: handleBlur,
    touched: isTouched,
    isValid: isValid,
    required: required,
    onClickButton: onClickButton,
    errorMessageWithFetchDataId: errorMessageWithFetchDataId,
    onErrorStateChange: onErrorStateChange,
    showError: true,
    descriptionId: descriptionId,
    postalCodeSearchHelperTextId: postalCodeSearchHelperTextId
  }))), React__namespace.createElement(HelperText, {
    text: ADDRESS_AUTO_INPUT_INFO_TEXT,
    descriptionId: postalCodeSearchHelperTextId
  }));
};

var _excluded$a = ["title", "description", "file", "onClear", "onRead", "acceptMimeTypes", "maxFileSize", "required"];
var FileUploadInput = function FileUploadInput(_ref) {
  var title = _ref.title,
    description = _ref.description,
    file = _ref.file,
    onClear = _ref.onClear,
    onRead = _ref.onRead,
    acceptMimeTypes = _ref.acceptMimeTypes,
    maxFileSize = _ref.maxFileSize,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var _a;
  var _useId = nextId.useId(1, "FileUploadInput-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = (_a = props.id) !== null && _a !== void 0 ? _a : generatedID;
  var descriptionId = "description-".concat(generatedID);
  return React__namespace.default.createElement(React__namespace.default.Fragment, null, React__namespace.default.createElement(TitleWrap, {
    title: title,
    required: required,
    description: description,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.default.createElement(SingleFileUpload, _objectSpread2({
    id: htmlId,
    descriptionId: descriptionId,
    file: file,
    onRead: onRead,
    onClear: onClear,
    maxFileSize: maxFileSize,
    acceptMimeTypes: acceptMimeTypes,
    required: required
  }, props)));
};

var css_248z$6 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n/* buttonのブラウザ標準のスタイルは使用しない */\n\nbutton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n/*フォント周りの共通設定、変数*/\n\nbody {\n  color: #1d1c1a;\n}\n\n.day-input-module__GDK__wrapper___79sRq {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.day-input-module__GDK__icon___gqnUm {\n  margin-left: 16px;\n}\n\n@media screen and (max-width: 800px) {\n  .day-input-module__GDK__icon___gqnUm {\n    margin-left: calc(16px - 1px);\n  }\n}\n";
var styles$6 = {"wrapper":"day-input-module__GDK__wrapper___79sRq","icon":"day-input-module__GDK__icon___gqnUm"};
styleInject(css_248z$6);

/**
 *
 * 日付入力コンポーネントコントローラー
 *
 * @param props
 * @returns
 */
var useDayInputController = function useDayInputController(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    showMonthYearPicker = _ref.showMonthYearPicker;
  var _React$useState = React__namespace.default.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var isString = typeof value === "string";
  var format = showMonthYearPicker ? "YYYY/MM" : "YYYY/MM/DD";
  var _React$useState3 = React__namespace.default.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hasDefaultValue = _React$useState4[0],
    setHasDefaultValue = _React$useState4[1];
  var date = React.useMemo(function () {
    if (isString) {
      return convertToDate(value, format);
    }
    return value === undefined ? null : value;
  }, [format, isString, value]);
  var onSetDate = React.useCallback(function (date) {
    if (date) {
      var dateString = dayjs__default.default(date).format(showMonthYearPicker ? "YYYY/MM" : "YYYY/MM/DD");
      if (isString) {
        setValue(dateString);
      } else {
        setValue(date);
      }
      setInputValue(dateString);
      return;
    }
    setInputValue("");
    setValue(isString ? "" : date);
  }, [isString, setValue, showMonthYearPicker]);
  var onSetValue = React.useCallback(function (value) {
    var format = showMonthYearPicker ? "YYYY/MM" : "YYYY/MM/DD";
    var dateString = formatValue(value, format);
    if (!value) {
      setValue(undefined);
      setInputValue("");
      return;
    }
    var date = new Date(dateString);
    setInputValue(dateString);
    if (isString) {
      setValue(dateString);
      return;
    }
    setValue(date);
  }, [isString, setValue, showMonthYearPicker]);
  var onChange = React.useCallback(function (e) {
    var value = e.target.value.replace(/[^0-9]/g, "");
    onSetValue(value);
  }, [onSetValue]);
  React.useEffect(function () {
    var format = showMonthYearPicker ? "YYYY/MM" : "YYYY/MM/DD";
    if (value && !hasDefaultValue) {
      if (typeof value === "string" && isValidDateString(value, format)) {
        setInputValue(value);
      } else if (isValidDateAndDateString(value, format)) {
        setInputValue(dayjs__default.default(value).format(format));
      }
      setHasDefaultValue(true);
      return;
    }
    if (!value) {
      setInputValue(value !== null && value !== void 0 ? value : "");
      return;
    }
  }, [hasDefaultValue, isString, showMonthYearPicker, value]);
  return {
    date: date,
    inputValue: inputValue,
    onSetValue: onSetValue,
    onChange: onChange,
    onSetDate: onSetDate
  };
};

var getIsEmpty = function getIsEmpty(value) {
  var year = value.year,
    month = value.month,
    day = value.day;
  var isYearEmpty = year === "";
  var isMonthEmpty = month === "" || month === "00";
  var isDayEmpty = day === "" || day === "00";
  var isAllEmpty = isYearEmpty && isMonthEmpty && isDayEmpty;
  return {
    isYearEmpty: isYearEmpty,
    isMonthEmpty: isMonthEmpty,
    isDayEmpty: isDayEmpty,
    isAllEmpty: isAllEmpty
  };
};
/**
 *
 * 年月日を入力するコンポーネントのバリデーション
 *
 * @param param
 * @returns
 */
var validateBirthDay = function validateBirthDay(_ref) {
  var value = _ref.value,
    year = _ref.year,
    month = _ref.month,
    day = _ref.day,
    id = _ref.id,
    format = _ref.format;
  var _getIsEmpty = getIsEmpty({
      year: year,
      month: month,
      day: day
    }),
    isYearEmpty = _getIsEmpty.isYearEmpty,
    isMonthEmpty = _getIsEmpty.isMonthEmpty,
    isDayEmpty = _getIsEmpty.isDayEmpty,
    isAllEmpty = _getIsEmpty.isAllEmpty;
  if (!isAllEmpty && (isYearEmpty || isMonthEmpty || isDayEmpty)) {
    return {
      id: id,
      code: "EMPTY_INPUT",
      errorMessage: "年・月・日の全てに値を入力してください。",
      isValid: false
    };
  }
  if (year.length !== 4) {
    return {
      id: id,
      code: "YEAR_DIGIT_COUNT",
      errorMessage: "年には、西暦4桁を入力してください。",
      isValid: false
    };
  }
  if (!isValidDateAndDateString(value, format)) {
    return {
      id: id,
      code: "INVALID_DATE",
      errorMessage: "日付の値が不正です。",
      isValid: false
    };
  }
  return null;
};

var _excluded$9 = ["callback"];
/**
 * 共通バリデーションクラス
 */
var CommonValidator = /*#__PURE__*/function () {
  function CommonValidator(v) {
    _classCallCheck(this, CommonValidator);
    this.v = v;
    this.defaultState = {
      id: v === null || v === void 0 ? void 0 : v.id,
      isValid: true
    };
  }
  /**
   * 必須チェック
   * @returns ErrorState
   */
  return _createClass(CommonValidator, [{
    key: "required",
    value: function required() {
      var _a, _b;
      if (!checkExistsValue((_a = this.v) === null || _a === void 0 ? void 0 : _a.value) && ((_b = this.v) === null || _b === void 0 ? void 0 : _b.required)) {
        return {
          id: this.v.id,
          code: "REQUIRED",
          errorMessage: "必須入力項目です。",
          isValid: false
        };
      }
      return this.defaultState;
    }
    /**
     * カスタムバリデーション
     * GDKを使用する側でハンドルしたいバリデーションがある場合、このメソッドが呼び出される
     * @returns ErrorState
     */
  }, {
    key: "customValidation",
    value: function customValidation() {
      var _a;
      if ((_a = this.v) === null || _a === void 0 ? void 0 : _a.customValidation) {
        var _this$v$customValidat = this.v.customValidation,
          callback = _this$v$customValidat.callback,
          props = _objectWithoutProperties(_this$v$customValidat, _excluded$9);
        return !callback(this.v.value) ? _objectSpread2({
          id: this.v.id,
          isValid: false
        }, props) : this.defaultState;
      }
      return this.defaultState;
    }
  }]);
}();

/**
 *
 * 日付入力バリデーション
 *
 * @param param0
 * @returns
 */
var validateDate = function validateDate(_ref) {
  var value = _ref.value,
    id = _ref.id,
    format = _ref.format;
  if (!isValidDateAndDateString(value, format)) {
    return {
      id: id,
      code: "INVALID_DATE",
      errorMessage: "日付の値が不正です。",
      isValid: false
    };
  }
  return null;
};

var getErrorState = function getErrorState(validator) {
  if (!validator) return null;
  switch (validator.type) {
    case "birthDay":
      {
        return validateBirthDay(validator);
      }
    case "date":
      {
        return validateDate(validator);
      }
    default:
      {
        return null;
      }
  }
};
function useValidator(_ref) {
  var validator = _ref.validator;
  var errorState = React__namespace.default.useMemo(function () {
    var _validator = new CommonValidator(validator);
    var _required = _validator.required();
    if (!_required.isValid) {
      return _required;
    }
    var _errorState = getErrorState(validator);
    if (_errorState !== null) {
      return _errorState;
    }
    var _customValidation = _validator.customValidation();
    if (!_customValidation.isValid) {
      return _customValidation;
    }
    return _validator.defaultState;
  }, [validator]);
  return {
    errorState: errorState
  };
}

var _excluded$8 = ["control", "formState", "disabled", "data-testid", "showMonthYearPicker"],
  _excluded2$3 = ["value", "touched", "isValid", "setValue", "disabled", "noValidate", "showMonthYearPicker"],
  _excluded3 = ["validator", "setValue", "value", "noValidate", "title", "description", "disabled", "onError"];
/**
 *
 * 日付入力UIコンポーネント
 *
 * @param props
 * @returns
 */
var BaseDayInput = React.forwardRef(function BaseDayComponent(_ref, ref) {
  var control = _ref.control,
    formState = _ref.formState,
    disabled = _ref.disabled,
    dataTestId = _ref["data-testid"],
    showMonthYearPicker = _ref.showMonthYearPicker,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var date = control.date,
    inputValue = control.inputValue,
    onChange = control.onChange,
    onSetDate = control.onSetDate,
    onSetValue = control.onSetValue;
  return React__namespace.default.createElement("div", {
    className: styles$6.wrapper,
    "data-testid": dataTestId
  }, React__namespace.default.createElement("div", {
    className: styles$6.input
  }, React__namespace.default.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    "data-testid": dataTestId ? "".concat(dataTestId, "-input-text") : undefined,
    ref: ref,
    disabled: disabled,
    value: inputValue,
    onChange: onChange,
    type: "text",
    formState: formState,
    inputMode: "numeric",
    needStatusIcon: true
  }))), React__namespace.default.createElement("div", {
    className: styles$6.icon
  }, React__namespace.default.createElement(DatePicker, {
    disabled: disabled,
    showMonthYearPicker: showMonthYearPicker,
    showFullMonthYearPicker: showMonthYearPicker,
    setValue: onSetValue,
    onChange: onSetDate,
    iconTitle: showMonthYearPicker ? "カレンダーで年・月を選択する" : "カレンダーで日付を選択する",
    date: date
  })));
});
/**
 *
 * form-generatorで使用する日付入力コンポーネント (ガイドラインに即してないコンポーネントのため非推奨)
 *
 * @param props
 * @returns
 * @deprecated
 */
var GrafferSchemasDayInputComponent = React.forwardRef(function DayInputComponent(_ref2, ref) {
  var _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? "" : _ref2$value,
    touched = _ref2.touched,
    isValid = _ref2.isValid,
    setValue = _ref2.setValue,
    disabled = _ref2.disabled,
    noValidate = _ref2.noValidate,
    showMonthYearPicker = _ref2.showMonthYearPicker,
    props = _objectWithoutProperties(_ref2, _excluded2$3);
  var control = useDayInputController({
    value: value,
    setValue: setValue,
    showMonthYearPicker: showMonthYearPicker
  });
  var formState = FormState.create(touched, isValid, noValidate, disabled, undefined, undefined);
  return React__namespace.default.createElement(BaseDayInput, _objectSpread2({
    setValue: setValue,
    value: value,
    control: control,
    ref: ref,
    formState: formState,
    disabled: disabled,
    showMonthYearPicker: showMonthYearPicker
  }, props));
});
/**
 *
 * 日付入力コンポーネント (ガイドラインに即してないコンポーネントのため非推奨)
 *
 * @param props
 * @returns
 * @deprecated
 */
var DayInput = function DayInput(_ref3) {
  var validator = _ref3.validator,
    setValue = _ref3.setValue,
    value = _ref3.value,
    noValidate = _ref3.noValidate,
    title = _ref3.title,
    description = _ref3.description,
    disabled = _ref3.disabled,
    onError = _ref3.onError,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _useValidator = useValidator({
      validator: validator
    }),
    errorState = _useValidator.errorState;
  var control = useDayInputController({
    value: value,
    setValue: setValue
  });
  return React__namespace.default.createElement(FormController, {
    value: value,
    disabled: disabled,
    noValidate: noValidate,
    onError: onError,
    error: errorState,
    render: function render(_ref4) {
      var formState = _ref4.formState;
      return React__namespace.default.createElement(FieldsetWrap, {
        title: title,
        description: description,
        required: validator === null || validator === void 0 ? void 0 : validator.required
      }, React__namespace.default.createElement(BaseDayInput, _objectSpread2({
        setValue: setValue,
        value: value,
        formState: formState,
        control: control,
        disabled: disabled
      }, props)));
    }
  });
};

var css_248z$5 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.address-auto-input-module__GDK__responseErrorArea___i2jla {\n  background-color: #fff7f8;\n  color: #8e1b19;\n  border-radius: 8px;\n  letter-spacing: 1px;\n  padding: 8px;\n  margin-top: 8px;\n}\n\n.address-auto-input-module__GDK__errorTitleWrap___RiVVd {\n  display: flex;\n}\n\n.address-auto-input-module__GDK__errorTitle___Lhtlt {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .address-auto-input-module__GDK__errorTitle___Lhtlt {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.address-auto-input-module__GDK__errorIcon___PMtVs {\n  margin-top: 3px;\n  margin-right: 8px;\n}\n\n.address-auto-input-module__GDK__errorMessage___rBzZ5 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin: 0px 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .address-auto-input-module__GDK__errorMessage___rBzZ5 {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.address-auto-input-module__GDK__address___XRea1 {\n  margin-top: 32px;\n}\n";
var styles$5 = {"responseErrorArea":"address-auto-input-module__GDK__responseErrorArea___i2jla","errorTitleWrap":"address-auto-input-module__GDK__errorTitleWrap___RiVVd","errorTitle":"address-auto-input-module__GDK__errorTitle___Lhtlt","errorIcon":"address-auto-input-module__GDK__errorIcon___PMtVs","errorMessage":"address-auto-input-module__GDK__errorMessage___rBzZ5","address":"address-auto-input-module__GDK__address___XRea1"};
styleInject(css_248z$5);

var TIMEOUT_MS = 5000;
var ERROR_MESSAGES = {
  TIMEOUT: "接続がタイムアウトしました。サーバーからの応答が一定時間内に返ってきませんでした。",
  EXCEPTION: "ただいま、郵便番号検索をご利用いだけません。そのまま住所の入力にお進みください。",
  EMPTY_ADDRESS: "住所が取得できませんでした。"
};

var useAddressAutoInput = function useAddressAutoInput(_ref) {
  var postalCodeValue = _ref.postalCodeValue,
    addressValue = _ref.addressValue,
    onChange = _ref.onChange,
    postalCodeRequest = _ref.postalCodeRequest,
    _ref$timeoutMS = _ref.timeoutMS,
    timeoutMS = _ref$timeoutMS === void 0 ? TIMEOUT_MS : _ref$timeoutMS;
  // 「stateInputAddress」はテストで使用。
  var _useState = React.useState(addressValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputAddress = _useState2[0],
    setStateInputAddress = _useState2[1];
  //  親コンポーネントから渡ってきた値との比較に使用。
  var _useState3 = React.useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    responseAddress = _useState4[0],
    setResponseAddress = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = React.useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessageWithFetchData = _useState8[0],
    setErrorMessageWithFetchData = _useState8[1];
  var _useId = nextId.useId(1, "errorMessageWithFetchData-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    errorMessageWithFetchDataId = _useId2[0];
  var changeValue = function changeValue(key, value) {
    var newStateInput = _objectSpread2(_objectSpread2({}, {
      postalCode: postalCodeValue,
      address: addressValue
    }), _defineProperty({}, key, value));
    setStateInputAddress(newStateInput.address);
    onChange(newStateInput);
  };
  var timeoutTest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(postalCode) {
      var controller, signal, timeout, promise;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            controller = new AbortController();
            signal = controller.signal;
            timeout = function timeout() {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  // タイムアウト
                  controller.abort();
                  resolve({
                    postalCode: postalCode,
                    address: "",
                    errorMessage: ERROR_MESSAGES.TIMEOUT
                  });
                }, timeoutMS);
              });
            };
            promise = postalCodeRequest(postalCode, signal)["catch"](function (err) {
              if (controller.signal.aborted) {
                // abortはtimeoutなので例外を終了させる
                return;
              }
              // エラーオブジェクトの例外は上位の関数に処理させる。
              if (err instanceof Error) {
                throw err;
              }
              return err;
            });
            return _context.abrupt("return", Promise.race([timeout(), promise]));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function timeoutTest(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var searchAddress = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(postalCode) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isLoading) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            setIsLoading(true);
            setErrorMessageWithFetchData("");
            _context2.next = 7;
            return timeoutTest(postalCode);
          case 7:
            response = _context2.sent;
            if (response.errorMessage) {
              setErrorMessageWithFetchData(response.errorMessage);
              setResponseAddress("");
            } else if (!response.address) {
              setErrorMessageWithFetchData(ERROR_MESSAGES.EMPTY_ADDRESS);
              setResponseAddress("");
            } else {
              changeValue("address", response.address);
              setResponseAddress(response.address);
            }
            setResponseAddress(response.address ? response.address : "");
            _context2.next = 16;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](2);
            setErrorMessageWithFetchData(ERROR_MESSAGES.EXCEPTION);
            setResponseAddress("");
          case 16:
            _context2.prev = 16;
            setIsLoading(false);
            return _context2.finish(16);
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 12, 16, 19]]);
    }));
    return function searchAddress(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    stateInputAddress: stateInputAddress,
    responseAddress: responseAddress,
    isLoading: isLoading,
    errorMessageWithFetchData: errorMessageWithFetchData,
    // エラーメッセージがない場合には、IDはundefinedを返す。
    errorMessageWithFetchDataId: errorMessageWithFetchData ? errorMessageWithFetchDataId : undefined,
    changeValue: changeValue,
    searchAddress: searchAddress
  };
};

var useAddressField = function useAddressField(_ref) {
  var value = _ref.value,
    noValidate = _ref.noValidate,
    validate = _ref.validate,
    errorMessage = _ref.errorMessage,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onErrorStateChange = _ref.onErrorStateChange,
    resAddress = _ref.resAddress,
    disabled = _ref.disabled;
  var _useState = React.useState(FormState.create(false,
    // isTouched
    validate(value), noValidate, disabled, errorMessage, undefined)),
    _useState2 = _slicedToArray(_useState, 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var callSetFormState = React.useCallback(function () {
    return setFormState(FormState.create(true, validate(value), noValidate, disabled, errorMessage, undefined));
  }, [validate, value, noValidate, disabled, errorMessage]);
  var handleBlur = React.useCallback(function (event) {
    callSetFormState();
    if (onBlur !== undefined) {
      onBlur(event);
    }
  }, [callSetFormState, onBlur]);
  React.useEffect(function () {
    /*
     APIレスポンスのアドレスと、親から渡ってきたアドレスを比較。
     同じだった場合は自動入力が使用されたと判断し、状態を更新。
     （この処理が無いとエラー状態が更新されない。）
    */
    if (!!resAddress && resAddress === value) {
      callSetFormState();
    }
  }, [callSetFormState, resAddress, validate, value]);
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(formState.isFail());
  }, [formState, onErrorStateChange]);
  return {
    handleBlur: handleBlur,
    formState: formState,
    onChange: onChange,
    callSetFormState: callSetFormState
  };
};

var _excluded$7 = ["title", "description", "id", "value", "noValidate", "validate", "errorMessage", "onChange", "onBlur", "required", "onErrorStateChange", "resAddress"];
var AddressField = function AddressField(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    value = _ref.value,
    noValidate = _ref.noValidate,
    validate = _ref.validate,
    errorMessage = _ref.errorMessage,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    onErrorStateChange = _ref.onErrorStateChange,
    resAddress = _ref.resAddress,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var _useAddressField = useAddressField({
      value: value,
      noValidate: noValidate,
      validate: validate,
      errorMessage: errorMessage,
      onChange: onChange,
      onBlur: onBlur,
      onErrorStateChange: onErrorStateChange,
      resAddress: resAddress,
      disabled: props.disabled
    }),
    handleBlur = _useAddressField.handleBlur,
    formState = _useAddressField.formState;
  var _useId = nextId.useId(1, "AddressField-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var errorMessageId = "errorMessage-".concat(generatedID);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TitleWrap, {
    title: title,
    description: description,
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    id: htmlId,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    formState: formState,
    needStatusIcon: true,
    required: required
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: formState.errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};

var AddressAutoInput = function AddressAutoInput(_ref) {
  var onChange = _ref.onChange,
    required = _ref.required,
    postalCode = _ref.postalCode,
    address = _ref.address,
    postalCodeRequest = _ref.postalCodeRequest;
  var _a, _b;
  var _useAddressAutoInput = useAddressAutoInput({
      postalCodeValue: postalCode.value,
      addressValue: address.value,
      onChange: onChange,
      postalCodeRequest: postalCodeRequest
    }),
    errorMessageWithFetchData = _useAddressAutoInput.errorMessageWithFetchData,
    errorMessageWithFetchDataId = _useAddressAutoInput.errorMessageWithFetchDataId,
    changeValue = _useAddressAutoInput.changeValue,
    searchAddress = _useAddressAutoInput.searchAddress,
    isLoading = _useAddressAutoInput.isLoading,
    responseAddress = _useAddressAutoInput.responseAddress;
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(PostalCodeSearch, _objectSpread2(_objectSpread2({}, postalCode), {}, {
    value: postalCode.value,
    id: postalCode.id,
    placeholder: (_a = postalCode.placeHolder) !== null && _a !== void 0 ? _a : "0000000",
    noValidate: postalCode.noValidate,
    required: required,
    onChange: function onChange(value) {
      return changeValue("postalCode", value);
    },
    onClickButton: searchAddress,
    help: postalCode.help,
    disabled: isLoading,
    errorMessageWithFetchDataId: errorMessageWithFetchDataId,
    onErrorStateChange: postalCode.onErrorStateChange
  })), errorMessageWithFetchData && React__namespace.createElement("div", {
    id: errorMessageWithFetchDataId,
    "aria-live": "assertive",
    className: styles$5.responseErrorArea
  }, React__namespace.createElement("div", {
    className: styles$5.errorTitleWrap
  }, React__namespace.createElement("div", {
    className: styles$5.errorIcon
  }, React__namespace.createElement(AttentionIcon, {
    size: 24
  })), React__namespace.createElement("div", {
    className: styles$5.errorTitle
  }, "自動入力エラー")), React__namespace.createElement("div", {
    className: styles$5.errorMessage
  }, errorMessageWithFetchData)), React__namespace.createElement("div", {
    className: styles$5.address
  }, React__namespace.createElement(AddressField, _objectSpread2(_objectSpread2({}, address), {}, {
    title: "住所",
    description: "入力例：山上県東市1丁目2番地3",
    value: address.value,
    id: address.id,
    placeholder: (_b = address.placeHolder) !== null && _b !== void 0 ? _b : "山上県東市1丁目2番地3",
    noValidate: address.noValidate,
    required: required,
    validate: address.validate,
    errorMessage: address.errorMessage,
    onChange: function onChange(event) {
      return changeValue("address", event.target.value);
    },
    disabled: isLoading,
    onErrorStateChange: address.onErrorStateChange,
    resAddress: responseAddress
  })), React__namespace.createElement(HelperText, {
    text: ASK_USER_TO_COMPLETE_ADDRESS_FORM_TEXT
  })));
};

var covertToInnerValue = function covertToInnerValue(_ref) {
  var timeValue = _ref.timeValue,
    dateValue = _ref.dateValue,
    format = _ref.format;
  var _a;
  var convertedValue = dateToValue(timeValue, "HH:mm");
  var _splitTimeInputString = splitTimeInputString(convertedValue),
    hour = _splitTimeInputString.hour,
    minutes = _splitTimeInputString.minutes;
  return {
    date: dateValue !== null && dateValue !== void 0 ? dateValue : null,
    dateString: (_a = dateToValue(dateValue, format)) !== null && _a !== void 0 ? _a : "",
    hour: hour,
    minutes: minutes
  };
};
var useTimeAndDateInputHandler = function useTimeAndDateInputHandler(_ref2) {
  var faultValue = _ref2.faultValue,
    innerValue = _ref2.innerValue,
    setValue = _ref2.setValue,
    dispatch = _ref2.dispatch,
    innerValidateResult = _ref2.innerValidateResult,
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? "YYYY/MM/DD" : _ref2$format;
  var setNewValue = React.useCallback(function (innerValue) {
    var timeDate = timeValueToDate("".concat(innerValue.hour, ":").concat(innerValue.minutes));
    var dateTime = createMergedDateTime(innerValue.date, innerValue.hour, innerValue.minutes);
    if (!dateTime || !innerValue.date || !timeDate) {
      return;
    }
    if (innerValidateResult === true) {
      setValue(innerValue.date, dateTime);
      return;
    }
    // 不正な値が有る場合は前回の値に戻す
    setValue(faultValue[0], faultValue[1]);
    dispatch(covertToInnerValue({
      dateValue: faultValue[0],
      timeValue: faultValue[1],
      format: format
    }));
  }, [dispatch, faultValue, format, innerValidateResult, setValue]);
  var handleDateChange = React.useCallback(function (date) {
    var value = dateToValue(date, format);
    var newValue = _objectSpread2(_objectSpread2({}, innerValue), {}, {
      date: date,
      dateString: value !== null && value !== void 0 ? value : ""
    });
    dispatch(newValue);
    setNewValue(newValue);
  }, [dispatch, format, innerValue, setNewValue]);
  var handleHourChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, innerValue), {}, {
      hour: value
    });
    dispatch(newValue);
    setNewValue(newValue);
  }, [dispatch, innerValue, setNewValue]);
  var handleMinutesChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, innerValue), {}, {
      minutes: value
    });
    dispatch(newValue);
    setNewValue(newValue);
  }, [dispatch, innerValue, setNewValue]);
  var handleDateStringChange = React.useCallback(function (value) {
    var date = new Date(value);
    var newValue = _objectSpread2(_objectSpread2({}, innerValue), {}, {
      dateString: formatValue(value.replace(/[^0-9]/g, ""), format),
      date: isValidDate(date) ? date : innerValue.date
    });
    dispatch(newValue);
  }, [dispatch, format, innerValue]);
  var handleBlur = React.useCallback(function () {
    setNewValue(innerValue);
  }, [innerValue, setNewValue]);
  return {
    handleDateChange: handleDateChange,
    handleHourChange: handleHourChange,
    handleMinutesChange: handleMinutesChange,
    handleDateStringChange: handleDateStringChange,
    handleBlur: handleBlur
  };
};
var useTimeAndDateInputState = function useTimeAndDateInputState(_ref3) {
  var dateValue = _ref3.dateValue,
    timeValue = _ref3.timeValue,
    _ref3$format = _ref3.format,
    format = _ref3$format === void 0 ? "YYYY/MM/DD" : _ref3$format;
  var covertToInnerValue = React.useCallback(function () {
    var _a;
    var convertedValue = dateToValue(timeValue, "HH:mm");
    var _splitTimeInputString2 = splitTimeInputString(convertedValue),
      hour = _splitTimeInputString2.hour,
      minutes = _splitTimeInputString2.minutes;
    return {
      date: dateValue !== null && dateValue !== void 0 ? dateValue : null,
      dateString: (_a = dateToValue(dateValue, format)) !== null && _a !== void 0 ? _a : "",
      hour: hour,
      minutes: minutes
    };
  }, [dateValue, format, timeValue]);
  var _useState = React.useState(covertToInnerValue()),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var time = innerValue.hour && innerValue.minutes ? "".concat(innerValue.hour, ":").concat(innerValue.minutes) : "";
  var dateTime = innerValue.dateString && time ? "".concat(innerValue.dateString, " ").concat(time) : "";
  React.useEffect(function () {
    var newInnerValue = covertToInnerValue();
    setInnerValue(newInnerValue);
  }, [covertToInnerValue, dateValue]);
  return {
    innerValue: _objectSpread2(_objectSpread2({}, innerValue), {}, {
      dateTime: dateTime
    }),
    setInnerValue: setInnerValue
  };
};

var css_248z$4 = ".time-and-date-common-module__GDK__wrapper___8ZZYG {\n  display: flex;\n}\n\n.time-and-date-common-module__GDK__range___agM4q {\n  margin-bottom: 16px;\n}\n\n.time-and-date-common-module__GDK__inputWrapper___xhfYX {\n  display: flex;\n  align-items: center;\n}\n\n.time-and-date-common-module__GDK__pickerWrapper___TeWQJ {\n  display: inline-block;\n  position: relative;\n  right: 20%;\n}\n\n.time-and-date-common-module__GDK__timeWrapper___oRgbv {\n  display: flex;\n  align-items: center;\n}\n\n@media screen and (max-width: 800px) {\n  .time-and-date-common-module__GDK__inputWrapper___xhfYX {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n    width: 100%;\n  }\n  .time-and-date-common-module__GDK__wrapper___8ZZYG {\n    flex-direction: column;\n  }\n  .time-and-date-common-module__GDK__pickerWrapper___TeWQJ {\n    position: unset;\n    width: 10%;\n    top: 0;\n    right: 0;\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n}\n";
var styles$4 = {"wrapper":"time-and-date-common-module__GDK__wrapper___8ZZYG","range":"time-and-date-common-module__GDK__range___agM4q","inputWrapper":"time-and-date-common-module__GDK__inputWrapper___xhfYX","pickerWrapper":"time-and-date-common-module__GDK__pickerWrapper___TeWQJ","timeWrapper":"time-and-date-common-module__GDK__timeWrapper___oRgbv"};
styleInject(css_248z$4);

var _excluded$6 = ["dateString", "date", "hour", "minutes", "onDateStringChange", "onDateStringBlur", "onDateChange", "onHourChange", "onHourBlur", "onMinutesChange", "onMinutesBlur", "descriptionId", "formState", "disabled", "required", "dateInputId", "dateAriaLabel", "hourAriaLabel", "minutesAriaLabel", "elementName", "className", "placeholder", "iconTitle"];
var TimeAndDateComponent = function TimeAndDateComponent(_ref) {
  var dateString = _ref.dateString,
    date = _ref.date,
    hour = _ref.hour,
    minutes = _ref.minutes,
    onDateStringChange = _ref.onDateStringChange,
    onDateStringBlur = _ref.onDateStringBlur,
    onDateChange = _ref.onDateChange,
    onHourChange = _ref.onHourChange,
    onHourBlur = _ref.onHourBlur,
    onMinutesChange = _ref.onMinutesChange,
    onMinutesBlur = _ref.onMinutesBlur,
    descriptionId = _ref.descriptionId,
    formState = _ref.formState,
    disabled = _ref.disabled,
    required = _ref.required,
    dateInputId = _ref.dateInputId,
    dateAriaLabel = _ref.dateAriaLabel,
    hourAriaLabel = _ref.hourAriaLabel,
    minutesAriaLabel = _ref.minutesAriaLabel,
    elementName = _ref.elementName,
    className = _ref.className,
    placeholder = _ref.placeholder,
    iconTitle = _ref.iconTitle,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var _useDeviceType = useDeviceType(),
    isPc = _useDeviceType.isPc;
  return React__namespace.createElement("div", {
    className: classNames__default.default(styles$4.wrapper, props.rangeMode && styles$4.range, className)
  }, React__namespace.createElement("div", {
    className: styles$4.inputWrapper
  }, React__namespace.createElement("input", _objectSpread2(_objectSpread2({}, props), {}, {
    placeholder: "",
    value: dateString,
    className: "".concat(inputStyles.input, " ").concat(formState.matchCallWithIsError(elementName.date, {
      "default": function _default() {
        return "";
      },
      disabled: function disabled() {
        return inputStyles.disabled;
      },
      success: function success() {
        return "";
      },
      fail: function fail(isError) {
        return isError ? inputStyles.fail : "";
      }
    })),
    "aria-invalid": formState.matchCallWithIsError(elementName.date, {
      "default": function _default() {
        return false;
      },
      disabled: function disabled() {
        return false;
      },
      success: function success() {
        return false;
      },
      fail: function fail(isError) {
        return isError;
      }
    }),
    "aria-describedby": formState.getAreaDescribedByValue([descriptionId], elementName.date),
    onChange: function onChange(e) {
      onDateStringChange(e.target.value);
    },
    onBlur: onDateStringBlur,
    disabled: disabled,
    required: required,
    "aria-required": required,
    id: dateInputId,
    "aria-label": dateAriaLabel,
    inputMode: "numeric"
  })), React__namespace.createElement("div", {
    className: "".concat(styles$4.pickerWrapper, " ").concat(isPc ? styles$4.wrapIndex : "")
  }, React__namespace.createElement(DatePicker, {
    date: date,
    setValue: function setValue(value) {
      var date = valueToDate$1(value);
      if (date) {
        onDateChange(date);
      }
    },
    iconTitle: iconTitle,
    onChange: function onChange(date) {
      if (!date) {
        return;
      }
      if (!Array.isArray(date)) {
        onDateChange(date);
      }
    },
    disabled: disabled
  }))), React__namespace.createElement("div", {
    className: styles$4.timeWrapper
  }, React__namespace.createElement(TimeSelect, {
    hour: hour,
    minutes: minutes,
    formState: formState,
    handleHourChange: onHourChange,
    handleMinutesChange: onMinutesChange,
    handleHourBlur: onHourBlur,
    handleMinutesBlur: onMinutesBlur,
    disabled: disabled,
    minutesUnitText: props.minutesUnitText,
    descriptionId: descriptionId,
    required: required,
    hourAriaLabel: hourAriaLabel,
    minutesAriaLabel: minutesAriaLabel,
    elementName: {
      hour: elementName.hour,
      minutes: elementName.minutes
    },
    placeholder: placeholder
  })));
};

var PREFIX$1 = "errorMessage";
var useTimeAndDateValidator = function useTimeAndDateValidator(dateTime, validate, errorID) {
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "YYYY/MM/DD";
  var _useMemo = React.useMemo(function () {
      var validateResultFromProps = validate(dateTime);
      var isValidDate = isValidDateAndDateString(dateTime, format);
      if (validateResultFromProps === true && isValidDate) return {
        validateResult: true,
        innerValidateResult: true
      };
      var innerValidateResult = isValidDate ? true : [{
        message: "存在しない日付です。",
        elements: ["Date"],
        id: ""
      }];
      var validateResult = [].concat(_toConsumableArray(innerValidateResult !== true ? innerValidateResult : []), _toConsumableArray(validateResultFromProps !== true ? validateResultFromProps : []));
      return {
        validateResult: validateResult.map(function (v, i) {
          return _objectSpread2(_objectSpread2({}, v), {
            id: "".concat(PREFIX$1).concat(i + 1, "-").concat(errorID)
          });
        }),
        innerValidateResult: innerValidateResult
      };
    }, [dateTime, errorID, format, validate]),
    validateResult = _useMemo.validateResult,
    innerValidateResult = _useMemo.innerValidateResult;
  return {
    validateResult: validateResult,
    innerValidateResult: innerValidateResult
  };
};

/**
 *
 * form-generatorのerrorMessageをErrorSetを返す関数に変換。（graffer-schemaではエラーまとめているので区別はしない）
 *
 * @param id
 * @param errors
 * @returns
 */
var useGenerateValidator = function useGenerateValidator(elements, errors) {
  return React__namespace.default.useMemo(function () {
    if (errors && typeof errors !== "string" && errors.length > 0) {
      return function () {
        return errors.map(function (error) {
          return {
            message: error,
            elements: elements
          };
        });
      };
    }
    if (errors && typeof errors === "string") {
      return function () {
        return [{
          message: errors,
          elements: elements
        }];
      };
    }
    return function () {
      return true;
    };
  }, [elements, errors]);
};

var getDateAndTimeValueFromDateString$1 = function getDateAndTimeValueFromDateString(value) {
  if (!value) return {
    dateValue: null,
    timeValue: null
  };
  var dateTime = new Date(value);
  return {
    dateValue: dateTime,
    timeValue: dateTime
  };
};
/**
 * form-generator用の引数でGDKのlogicを使用できるようにするwrapper
 * @param param0
 * @returns
 */
var GrafferSchemasUseTimeAndDateComponent = function GrafferSchemasUseTimeAndDateComponent(_ref) {
  var dateTimeString = _ref.dateTimeString,
    id = _ref.id,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "YYYY/MM/DD HH:mm" : _ref$format,
    setValue = _ref.setValue,
    errorMessage = _ref.errorMessage,
    onBlur = _ref.onBlur;
  var _useMemo = React.useMemo(function () {
      return getDateAndTimeValueFromDateString$1(dateTimeString);
    }, [dateTimeString]),
    dateValue = _useMemo.dateValue,
    timeValue = _useMemo.timeValue;
  var state = useTimeAndDateInputState({
    dateValue: dateValue,
    timeValue: timeValue
  });
  var validate = useGenerateValidator(["Date", "Hour", "Minutes"], errorMessage);
  var handleDateTime = React.useCallback(function (dateValue, timeValue) {
    var value = formatDateTimeFromDateAndTime(dateValue, timeValue, format);
    setValue(value);
  }, [format, setValue]);
  var _useTimeAndDateValida = useTimeAndDateValidator(state.innerValue.dateString, validate, id),
    validateResult = _useTimeAndDateValida.validateResult,
    innerValidateResult = _useTimeAndDateValida.innerValidateResult;
  var handlers = useTimeAndDateInputHandler({
    faultValue: [dateValue, timeValue],
    innerValidateResult: innerValidateResult,
    innerValue: state.innerValue,
    setValue: handleDateTime,
    dispatch: state.setInnerValue
  });
  var handleOnBlur = React.useCallback(function (e) {
    handlers.handleBlur();
    onBlur && onBlur(e);
  }, [handlers, onBlur]);
  return _objectSpread2(_objectSpread2(_objectSpread2({}, state), {}, {
    validateResult: validateResult
  }, handlers), {}, {
    handleBlur: handleOnBlur
  });
};

var _excluded$5 = ["descriptionId", "isTouched", "noValidate", "validateResult", "disabled", "showError"],
  _excluded2$2 = ["dateValue", "timeValue", "setValue", "validate", "disabled", "required", "description"];
var DEFAULT_PROPS = {
  dateAriaLabel: "日付",
  hourAriaLabel: "時",
  minutesAriaLabel: "分",
  elementName: {
    date: "Date",
    hour: "Hour",
    minutes: "Minutes"
  }
};
var BaseTimeAndDateInput = function BaseTimeAndDateInput(_ref) {
  var descriptionId = _ref.descriptionId,
    isTouched = _ref.isTouched,
    _ref$noValidate = _ref.noValidate,
    noValidate = _ref$noValidate === void 0 ? false : _ref$noValidate,
    validateResult = _ref.validateResult,
    disabled = _ref.disabled,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var formState = FieldsetFormState.create(isTouched, validateResult, noValidate, disabled);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TimeAndDateComponent, _objectSpread2(_objectSpread2(_objectSpread2({
    descriptionId: descriptionId
  }, DEFAULT_PROPS), props), {}, {
    disabled: disabled,
    formState: formState,
    iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u65E5\u4ED8\u3092\u9078\u629E\u3059\u308B"
  })), showError && formState.matchComponentsWithErrorSets({
    "default": function _default() {
      return null;
    },
    disabled: function disabled() {
      return null;
    },
    success: function success() {
      return null;
    },
    fail: function fail(errorSet) {
      return React__namespace.createElement(ErrorSetMessages, {
        errorSet: errorSet
      });
    }
  }));
};
/**
 * form-generator用日付時間コンポーネント
 * @param param0
 * @returns
 */
var GrafferSchemasTimeAndDateInputComponent = function GrafferSchemasTimeAndDateInputComponent(_ref2) {
  var dateTimeString = _ref2.dateTimeString,
    description = _ref2.description,
    errorMessage = _ref2.errorMessage,
    onBlur = _ref2.onBlur,
    disabled = _ref2.disabled,
    touched = _ref2.touched,
    required = _ref2.required,
    id = _ref2.id,
    format = _ref2.format,
    setValue = _ref2.setValue;
  var _GrafferSchemasUseTim = GrafferSchemasUseTimeAndDateComponent({
      dateTimeString: dateTimeString,
      errorMessage: errorMessage,
      id: id,
      format: format,
      setValue: setValue,
      onBlur: onBlur
    }),
    _GrafferSchemasUseTim2 = _GrafferSchemasUseTim.innerValue,
    hour = _GrafferSchemasUseTim2.hour,
    minutes = _GrafferSchemasUseTim2.minutes,
    dateString = _GrafferSchemasUseTim2.dateString,
    date = _GrafferSchemasUseTim2.date,
    handleBlur = _GrafferSchemasUseTim.handleBlur,
    handleDateChange = _GrafferSchemasUseTim.handleDateChange,
    handleDateStringChange = _GrafferSchemasUseTim.handleDateStringChange,
    handleHourChange = _GrafferSchemasUseTim.handleHourChange,
    handleMinutesChange = _GrafferSchemasUseTim.handleMinutesChange,
    validateResult = _GrafferSchemasUseTim.validateResult;
  var descriptionId = description ? "description-".concat(id) : undefined;
  return React__namespace.createElement(BaseTimeAndDateInput, _objectSpread2(_objectSpread2({}, DEFAULT_PROPS), {}, {
    dateString: dateString,
    date: date,
    hour: hour,
    minutes: minutes,
    onDateStringChange: handleDateStringChange,
    onDateStringBlur: handleBlur,
    onDateChange: handleDateChange,
    onHourChange: handleHourChange,
    onHourBlur: handleBlur,
    onMinutesChange: handleMinutesChange,
    onMinutesBlur: handleBlur,
    descriptionId: descriptionId,
    disabled: disabled,
    required: required,
    isTouched: touched,
    validateResult: validateResult,
    showError: false,
    placeholder: {
      hour: "",
      minutes: ""
    }
  }));
};
var TimeAndDateInput = function TimeAndDateInput(_ref3) {
  var dateValue = _ref3.dateValue,
    timeValue = _ref3.timeValue,
    setValue = _ref3.setValue,
    validate = _ref3.validate,
    disabled = _ref3.disabled,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    description = _ref3.description,
    props = _objectWithoutProperties(_ref3, _excluded2$2);
  var _useId = nextId.useId(1, "TimeAndDateInput-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var _useTimeAndDateInputS = useTimeAndDateInputState({
      dateValue: dateValue,
      timeValue: timeValue
    }),
    _useTimeAndDateInputS2 = _useTimeAndDateInputS.innerValue,
    date = _useTimeAndDateInputS2.date,
    dateString = _useTimeAndDateInputS2.dateString,
    hour = _useTimeAndDateInputS2.hour,
    minutes = _useTimeAndDateInputS2.minutes,
    setInnerValue = _useTimeAndDateInputS.setInnerValue;
  var _useTimeAndDateValida = useTimeAndDateValidator(dateString, validate, generatedID),
    validateResult = _useTimeAndDateValida.validateResult,
    innerValidateResult = _useTimeAndDateValida.innerValidateResult;
  var _useTimeAndDateInputH = useTimeAndDateInputHandler({
      faultValue: [dateValue, timeValue],
      innerValidateResult: innerValidateResult,
      innerValue: {
        date: date,
        dateString: dateString,
        hour: hour,
        minutes: minutes
      },
      setValue: setValue,
      dispatch: setInnerValue
    }),
    handleDateChange = _useTimeAndDateInputH.handleDateChange,
    handleHourChange = _useTimeAndDateInputH.handleHourChange,
    handleMinutesChange = _useTimeAndDateInputH.handleMinutesChange,
    handleDateStringChange = _useTimeAndDateInputH.handleDateStringChange,
    handleBlur = _useTimeAndDateInputH.handleBlur;
  var _useMultipleTouched = useMultipleTouched([!!dateString, !!hour, !!minutes], handleBlur),
    isTouched = _useMultipleTouched.isTouched,
    _useMultipleTouched$o = _slicedToArray(_useMultipleTouched.onBlurHandlers, 3),
    handleOnDateBlur = _useMultipleTouched$o[0],
    handleOnHourBlur = _useMultipleTouched$o[1],
    handleOnMinutesBlur = _useMultipleTouched$o[2];
  return React__namespace.createElement(FieldsetWrap, {
    title: props.title,
    description: description,
    descriptionId: descriptionId,
    required: required
  }, React__namespace.createElement(BaseTimeAndDateInput, _objectSpread2(_objectSpread2({}, DEFAULT_PROPS), {}, {
    dateString: dateString,
    date: date,
    hour: hour,
    minutes: minutes,
    onDateStringChange: handleDateStringChange,
    onDateStringBlur: handleOnDateBlur,
    onDateChange: handleDateChange,
    onHourChange: handleHourChange,
    onHourBlur: handleOnHourBlur,
    onMinutesChange: handleMinutesChange,
    onMinutesBlur: handleOnMinutesBlur,
    descriptionId: descriptionId,
    disabled: disabled,
    required: required,
    isTouched: isTouched,
    validateResult: validateResult,
    showError: true,
    placeholder: {
      hour: "",
      minutes: ""
    }
  })));
};

var useTimeAndDateRangeState = function useTimeAndDateRangeState(_ref) {
  var startValue = _ref.startValue,
    endValue = _ref.endValue;
  var startState = useTimeAndDateInputState({
    dateValue: startValue.date,
    timeValue: startValue.time
  });
  var endState = useTimeAndDateInputState({
    dateValue: endValue.date,
    timeValue: endValue.time
  });
  return {
    startState: startState,
    endState: endState
  };
};
var useTimeAndDateRangeHandler = function useTimeAndDateRangeHandler(_ref2) {
  var _ref2$props = _slicedToArray(_ref2.props, 2),
    start = _ref2$props[0],
    end = _ref2$props[1],
    innerValidateResult = _ref2.innerValidateResult,
    setValue = _ref2.setValue;
  var setNewStartValue = React.useCallback(function (innerValue) {
    var dateTime = createMergedDateTime(innerValue.date, innerValue.hour, innerValue.minutes);
    var endDateTime = createMergedDateTime(end.innerValue.date, end.innerValue.hour, end.innerValue.minutes);
    if (!dateTime || !innerValue.date) {
      return;
    }
    setValue(dateTime, endDateTime);
    if (innerValidateResult === true) {
      setValue(dateTime, endDateTime);
      return;
    }
    // 不正な値が有る場合は前回の値に戻す
    setValue(mergeDateTime(start.faultValue[0], start.faultValue[1]), mergeDateTime(end.faultValue[0], end.faultValue[1]));
    start.dispatch(covertToInnerValue({
      dateValue: start.faultValue[0],
      timeValue: start.faultValue[1],
      format: "YYYY/MM/DD"
    }));
  }, [end.faultValue, end.innerValue.date, end.innerValue.hour, end.innerValue.minutes, innerValidateResult, setValue, start]);
  var setNewEndValue = React.useCallback(function (innerValue) {
    var dateTime = createMergedDateTime(innerValue.date, innerValue.hour, innerValue.minutes);
    var startDateTime = createMergedDateTime(start.innerValue.date, start.innerValue.hour, start.innerValue.minutes);
    if (!dateTime || !innerValue.date) {
      return;
    }
    if (innerValidateResult === true) {
      setValue(startDateTime, dateTime);
      return;
    }
    // 不正な値が有る場合は前回の値に戻す
    setValue(mergeDateTime(start.faultValue[0], start.faultValue[1]), mergeDateTime(end.faultValue[0], end.faultValue[1]));
    end.dispatch(covertToInnerValue({
      dateValue: end.faultValue[0],
      timeValue: end.faultValue[1],
      format: "YYYY/MM/DD"
    }));
  }, [end, innerValidateResult, setValue, start.faultValue, start.innerValue.date, start.innerValue.hour, start.innerValue.minutes]);
  var handleStartDateChange = React.useCallback(function (date) {
    var value = dateToValue(date, "YYYY/MM/DD");
    var newValue = _objectSpread2(_objectSpread2({}, start.innerValue), {}, {
      date: date,
      dateString: value !== null && value !== void 0 ? value : ""
    });
    start.dispatch(newValue);
    setNewStartValue(newValue);
  }, [setNewStartValue, start]);
  var handleStartHourChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, start.innerValue), {}, {
      hour: value
    });
    start.dispatch(newValue);
    setNewStartValue(newValue);
  }, [setNewStartValue, start]);
  var handleStartMinutesChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, start.innerValue), {}, {
      minutes: value
    });
    start.dispatch(newValue);
    setNewStartValue(newValue);
  }, [setNewStartValue, start]);
  var handleStartDateStringChange = React.useCallback(function (value) {
    var date = new Date(value);
    var newValue = _objectSpread2(_objectSpread2({}, start.innerValue), {}, {
      dateString: formatValue(value.replace(/[^0-9]/g, ""), "YYYY/MM/DD"),
      date: isValidDate(date) ? date : start.innerValue.date
    });
    start.dispatch(newValue);
  }, [start]);
  var handleStartBlur = React.useCallback(function () {
    setNewStartValue(start.innerValue);
  }, [setNewStartValue, start.innerValue]);
  var handleEndDateChange = React.useCallback(function (date) {
    var value = dateToValue(date, "YYYY/MM/DD");
    var newValue = _objectSpread2(_objectSpread2({}, end.innerValue), {}, {
      date: date,
      dateString: value !== null && value !== void 0 ? value : ""
    });
    end.dispatch(newValue);
    setNewEndValue(newValue);
  }, [end, setNewEndValue]);
  var handleEndHourChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, end.innerValue), {}, {
      hour: value
    });
    end.dispatch(newValue);
    setNewEndValue(newValue);
  }, [end, setNewEndValue]);
  var handleEndMinutesChange = React.useCallback(function (value) {
    var newValue = _objectSpread2(_objectSpread2({}, end.innerValue), {}, {
      minutes: value
    });
    end.dispatch(newValue);
    setNewEndValue(newValue);
  }, [end, setNewEndValue]);
  var handleEndDateStringChange = React.useCallback(function (value) {
    var date = new Date(value);
    var newValue = _objectSpread2(_objectSpread2({}, end.innerValue), {}, {
      dateString: formatValue(value.replace(/[^0-9]/g, ""), "YYYY/MM/DD"),
      date: isValidDate(date) ? date : end.innerValue.date
    });
    end.dispatch(newValue);
  }, [end]);
  var handleEndBlur = React.useCallback(function () {
    setNewStartValue(start.innerValue);
    setNewEndValue(end.innerValue);
  }, [setNewStartValue, start.innerValue, setNewEndValue, end.innerValue]);
  return {
    startHandler: {
      handleDateChange: handleStartDateChange,
      handleHourChange: handleStartHourChange,
      handleMinutesChange: handleStartMinutesChange,
      handleDateStringChange: handleStartDateStringChange,
      handleBlur: handleStartBlur
    },
    endHandler: {
      handleDateChange: handleEndDateChange,
      handleHourChange: handleEndHourChange,
      handleMinutesChange: handleEndMinutesChange,
      handleDateStringChange: handleEndDateStringChange,
      handleBlur: handleEndBlur
    }
  };
};

var css_248z$3 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.time-and-date-range-module__GDK__label___VVS9Y {\n  display: block;\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .time-and-date-range-module__GDK__label___VVS9Y {\n  font: bold 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.time-and-date-range-module__GDK__wrapper___mXZ-R {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.time-and-date-range-module__GDK__inputWrapper___ZsLsP {\n  display: inline-flex;\n  align-items: baseline;\n}\n\n.time-and-date-range-module__GDK__pickerWrapper___Wl3Zm {\n  display: inline-block;\n  position: relative;\n  top: 15%;\n  right: 20%;\n}\n\n.time-and-date-range-module__GDK__timeWrapper___uXaXo {\n  display: flex;\n  align-items: center;\n}\n\n@media screen and (max-width: 800px) {\n  .time-and-date-range-module__GDK__inputWrapper___ZsLsP {\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n    width: 100%;\n  }\n  .time-and-date-range-module__GDK__wrapper___mXZ-R {\n    flex-direction: column;\n  }\n  .time-and-date-range-module__GDK__pickerWrapper___Wl3Zm {\n    position: unset;\n    width: 10%;\n    top: 0;\n    right: 0;\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n}\n";
var styles$3 = {"label":"time-and-date-range-module__GDK__label___VVS9Y","wrapper":"time-and-date-range-module__GDK__wrapper___mXZ-R","inputWrapper":"time-and-date-range-module__GDK__inputWrapper___ZsLsP","pickerWrapper":"time-and-date-range-module__GDK__pickerWrapper___Wl3Zm","timeWrapper":"time-and-date-range-module__GDK__timeWrapper___uXaXo"};
styleInject(css_248z$3);

var PREFIX = "errorMessage";
var DATE_ELEMENTS = ["StartDate", "EndDate"];
/**
 *
 * 日付時間範囲コンポーネントのバリデーション
 *
 * @param dateTime YYYY/MM/DD HH:mm
 * @param validate
 * @param errorID
 * @param format
 * @returns
 */
var useTimeAndDateRangeValidator = function useTimeAndDateRangeValidator(dateTime, validate, errorID) {
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "YYYY/MM/DD HH:mm";
  var _useMemo = React.useMemo(function () {
      var _dateTime = _slicedToArray(dateTime, 2),
        startDateTime = _dateTime[0],
        endDateTime = _dateTime[1];
      var rangeString = "".concat(startDateTime, "~").concat(endDateTime);
      var validateResultFromProps = validate(rangeString);
      var innerValidateResult = _toConsumableArray(dateTime.reduce(function (carry, current, index) {
        carry = [].concat(_toConsumableArray(carry), _toConsumableArray(isValidDateAndDateString(current, format) ? [] : [{
          message: "存在しない日付です。",
          elements: [DATE_ELEMENTS[index]],
          id: ""
        }]));
        return carry;
      }, []));
      if (!innerValidateResult.length && validateResultFromProps === true) return {
        validateResult: true,
        innerValidateResult: true
      };
      var validateResult = [].concat(_toConsumableArray(innerValidateResult), _toConsumableArray(validateResultFromProps !== true ? validateResultFromProps : []));
      return {
        validateResult: validateResult.map(function (v, i) {
          return _objectSpread2(_objectSpread2({}, v), {
            id: "".concat(PREFIX).concat(i + 1, "-").concat(errorID)
          });
        }),
        innerValidateResult: !innerValidateResult.length ? true : innerValidateResult
      };
    }, [dateTime, errorID, format, validate]),
    validateResult = _useMemo.validateResult,
    innerValidateResult = _useMemo.innerValidateResult;
  return {
    validateResult: validateResult,
    innerValidateResult: innerValidateResult
  };
};

var getDateAndTimeValueFromDateString = function getDateAndTimeValueFromDateString(value) {
  if (!value) return {
    dateValue: null,
    timeValue: null
  };
  var dateTime = new Date(value);
  return {
    dateValue: dateTime,
    timeValue: dateTime
  };
};
/**
 * form-generator用の引数でGDKのlogicを使用できるようにするwrapper
 * @param param0
 * @returns
 */
var GrafferSchemasUseTimeAndDateRangeComponent = function GrafferSchemasUseTimeAndDateRangeComponent(_ref) {
  var startValue = _ref.startValue,
    endValue = _ref.endValue,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    setValue = _ref.setValue,
    errorMessage = _ref.errorMessage,
    onBlur = _ref.onBlur,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "YYYY/MM/DD HH:mm" : _ref$format;
  var startDateTime = React.useMemo(function () {
    return getDateAndTimeValueFromDateString(startValue);
  }, [startValue]);
  var endDateTime = React.useMemo(function () {
    return getDateAndTimeValueFromDateString(endValue);
  }, [endValue]);
  var startState = useTimeAndDateInputState(_objectSpread2({}, startDateTime));
  var endState = useTimeAndDateInputState(_objectSpread2({}, endDateTime));
  var validate = useGenerateValidator(["StartDate", "StartHour", "StartMinutes", "EndDate", "EndHour", "EndMinutes"], errorMessage);
  var handleDateTime = React.useCallback(function (startValue, endValue) {
    var start = formatDateTime(startValue, format);
    var end = formatDateTime(endValue, format);
    setValue(start, end);
  }, [format, setValue]);
  var _useTimeAndDateRangeV = useTimeAndDateRangeValidator([startState.innerValue.dateTime, endState.innerValue.dateTime], validate, id),
    validateResult = _useTimeAndDateRangeV.validateResult,
    innerValidateResult = _useTimeAndDateRangeV.innerValidateResult;
  var handlers = useTimeAndDateRangeHandler({
    props: [{
      faultValue: [startDateTime.dateValue, startDateTime.timeValue],
      innerValue: startState.innerValue,
      dispatch: startState.setInnerValue
    }, {
      faultValue: [endDateTime.dateValue, endDateTime.timeValue],
      innerValue: endState.innerValue,
      dispatch: endState.setInnerValue
    }],
    innerValidateResult: innerValidateResult,
    setValue: handleDateTime
  });
  var handleOnBlur = React.useCallback(function (e) {
    handlers.startHandler.handleBlur();
    handlers.endHandler.handleBlur();
    onBlur && onBlur(e);
  }, [handlers, onBlur]);
  return {
    startState: startState,
    endState: endState,
    validateResult: validateResult,
    startHandler: _objectSpread2({}, handlers.startHandler),
    endHandler: _objectSpread2({}, handlers.endHandler),
    onBlur: handleOnBlur
  };
};

var _excluded$4 = ["startValue", "endValue", "setValue", "validate", "disabled", "required", "description"];
/**
 * 日付時間範囲UIコンポーネント
 */
var BaseTimeAndDateRangeInput = function BaseTimeAndDateRangeInput(_ref) {
  var id = _ref.id,
    startProps = _ref.startProps,
    endProps = _ref.endProps,
    isTouched = _ref.isTouched,
    _ref$noValidate = _ref.noValidate,
    noValidate = _ref$noValidate === void 0 ? false : _ref$noValidate,
    validateResult = _ref.validateResult,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError;
  var startDateInputId = "start-dateInput-".concat(id);
  var endDateInputId = "end-dateInput-".concat(id);
  var formState = FieldsetFormState.create(isTouched, validateResult, noValidate, disabled);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("label", {
    className: styles$3.label,
    htmlFor: startDateInputId
  }, "\u958B\u59CB\u65E5\u30FB\u6642\u9593"), React__namespace.createElement(TimeAndDateComponent, _objectSpread2(_objectSpread2({}, startProps), {}, {
    dateInputId: startDateInputId,
    formState: formState,
    disabled: disabled,
    rangeMode: true,
    dateAriaLabel: "開始 日付",
    hourAriaLabel: "開始 時",
    minutesAriaLabel: "開始 分",
    elementName: {
      date: "StartDate",
      hour: "StartHour",
      minutes: "StartMinutes"
    },
    iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u958B\u59CB\u65E5\u3092\u9078\u629E\u3059\u308B"
  })), React__namespace.createElement("label", {
    className: styles$3.label,
    htmlFor: endDateInputId
  }, "\u7D42\u4E86\u65E5\u30FB\u6642\u9593"), React__namespace.createElement(TimeAndDateComponent, _objectSpread2(_objectSpread2({}, endProps), {}, {
    dateInputId: endDateInputId,
    formState: formState,
    disabled: disabled,
    dateAriaLabel: "終了 日付",
    hourAriaLabel: "終了 時",
    minutesAriaLabel: "終了 分",
    elementName: {
      date: "EndDate",
      hour: "EndHour",
      minutes: "EndMinutes"
    },
    iconTitle: "\u30AB\u30EC\u30F3\u30C0\u30FC\u3067\u7D42\u4E86\u65E5\u3092\u9078\u629E\u3059\u308B"
  })), showError && formState.matchComponentsWithErrorSets({
    "default": function _default() {
      return null;
    },
    disabled: function disabled() {
      return null;
    },
    success: function success() {
      return null;
    },
    fail: function fail(errorSet) {
      return React__namespace.createElement(ErrorSetMessages, {
        errorSet: errorSet
      });
    }
  }));
};
/**
 * form-generator用の日付時間範囲コンポーネント
 * @param param0
 * @returns
 */
var GrafferSchemasTimeAndDateRangeInputComponent = function GrafferSchemasTimeAndDateRangeInputComponent(_ref2) {
  var startValue = _ref2.startValue,
    endValue = _ref2.endValue,
    description = _ref2.description,
    setValue = _ref2.setValue,
    errorMessage = _ref2.errorMessage,
    disabled = _ref2.disabled,
    touched = _ref2.touched,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? "" : _ref2$id,
    required = _ref2.required,
    onBlur = _ref2.onBlur,
    format = _ref2.format;
  var descriptionId = description ? "description-".concat(id) : undefined;
  var _GrafferSchemasUseTim = GrafferSchemasUseTimeAndDateRangeComponent({
      startValue: startValue,
      endValue: endValue,
      id: id,
      setValue: setValue,
      errorMessage: errorMessage,
      onBlur: onBlur,
      format: format
    }),
    startState = _GrafferSchemasUseTim.startState,
    startHandler = _GrafferSchemasUseTim.startHandler,
    endState = _GrafferSchemasUseTim.endState,
    endHandler = _GrafferSchemasUseTim.endHandler,
    validateResult = _GrafferSchemasUseTim.validateResult,
    handleOnBlur = _GrafferSchemasUseTim.onBlur;
  return React__namespace.createElement(BaseTimeAndDateRangeInput, {
    id: id,
    startProps: {
      dateString: startState.innerValue.dateString,
      date: startState.innerValue.date,
      hour: startState.innerValue.hour,
      minutes: startState.innerValue.minutes,
      onDateStringChange: startHandler.handleDateStringChange,
      onDateStringBlur: handleOnBlur,
      onDateChange: startHandler.handleDateChange,
      onHourChange: startHandler.handleHourChange,
      onHourBlur: handleOnBlur,
      onMinutesChange: startHandler.handleMinutesChange,
      onMinutesBlur: handleOnBlur,
      descriptionId: descriptionId,
      rangeMode: true,
      required: required,
      placeholder: {
        hour: "",
        minutes: ""
      }
    },
    endProps: {
      dateString: endState.innerValue.dateString,
      date: endState.innerValue.date,
      hour: endState.innerValue.hour,
      minutes: endState.innerValue.minutes,
      onDateStringChange: endHandler.handleDateStringChange,
      onDateStringBlur: handleOnBlur,
      onDateChange: endHandler.handleDateChange,
      onHourChange: endHandler.handleHourChange,
      onHourBlur: handleOnBlur,
      onMinutesChange: endHandler.handleMinutesChange,
      onMinutesBlur: handleOnBlur,
      descriptionId: descriptionId,
      required: required,
      placeholder: {
        hour: "",
        minutes: ""
      }
    },
    showError: false,
    isTouched: touched,
    noValidate: false,
    validateResult: validateResult,
    disabled: disabled
  });
};
/**
 * 日付時間範囲コンポーネント
 */
var TimeAndDateRangeInput = function TimeAndDateRangeInput(_ref3) {
  var startValue = _ref3.startValue,
    endValue = _ref3.endValue,
    setValue = _ref3.setValue,
    validate = _ref3.validate,
    disabled = _ref3.disabled,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    description = _ref3.description,
    props = _objectWithoutProperties(_ref3, _excluded$4);
  var _useId = nextId.useId(1, "TimeAndDateRange-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var _useTimeAndDateRangeS = useTimeAndDateRangeState({
      startValue: startValue,
      endValue: endValue
    }),
    startState = _useTimeAndDateRangeS.startState,
    endState = _useTimeAndDateRangeS.endState;
  var _useTimeAndDateRangeV = useTimeAndDateRangeValidator([startState.innerValue.dateTime, endState.innerValue.dateTime], validate, generatedID),
    validateResult = _useTimeAndDateRangeV.validateResult,
    innerValidateResult = _useTimeAndDateRangeV.innerValidateResult;
  var _useTimeAndDateRangeH = useTimeAndDateRangeHandler({
      props: [{
        faultValue: [startValue.date, startValue.time],
        innerValue: startState.innerValue,
        dispatch: startState.setInnerValue
      }, {
        faultValue: [endValue.date, endValue.time],
        innerValue: endState.innerValue,
        dispatch: endState.setInnerValue
      }],
      innerValidateResult: innerValidateResult,
      setValue: setValue
    }),
    startHandler = _useTimeAndDateRangeH.startHandler,
    endHandler = _useTimeAndDateRangeH.endHandler;
  var _useMultipleTouched = useMultipleTouched([!!startValue.date, !!startValue.time, !!startValue.time, !!endValue.date, !!endValue.time, !!endValue.time], [startHandler.handleBlur, startHandler.handleBlur, startHandler.handleBlur, endHandler.handleBlur, endHandler.handleBlur, endHandler.handleBlur]),
    isTouched = _useMultipleTouched.isTouched,
    _useMultipleTouched$o = _slicedToArray(_useMultipleTouched.onBlurHandlers, 6),
    handleOnStartDateBlur = _useMultipleTouched$o[0],
    handleOnStartHourBlur = _useMultipleTouched$o[1],
    handleOnStartMinutesBlur = _useMultipleTouched$o[2],
    handleOnEndDateBlur = _useMultipleTouched$o[3],
    handleOnEndHourBlur = _useMultipleTouched$o[4],
    handleOnEndMinutesBlur = _useMultipleTouched$o[5];
  return React__namespace.createElement(FieldsetWrap, {
    title: props.title,
    description: description,
    descriptionId: descriptionId,
    required: required
  }, React__namespace.createElement(BaseTimeAndDateRangeInput, {
    id: generatedID,
    startProps: {
      dateString: startState.innerValue.dateString,
      date: startState.innerValue.date,
      hour: startState.innerValue.hour,
      minutes: startState.innerValue.minutes,
      onDateStringChange: startHandler.handleDateStringChange,
      onDateStringBlur: handleOnStartDateBlur,
      onDateChange: startHandler.handleDateChange,
      onHourChange: startHandler.handleHourChange,
      onHourBlur: handleOnStartHourBlur,
      onMinutesChange: startHandler.handleMinutesChange,
      onMinutesBlur: handleOnStartMinutesBlur,
      descriptionId: descriptionId,
      rangeMode: true,
      required: required,
      placeholder: {
        hour: "",
        minutes: ""
      }
    },
    endProps: {
      dateString: endState.innerValue.dateString,
      date: endState.innerValue.date,
      hour: endState.innerValue.hour,
      minutes: endState.innerValue.minutes,
      onDateStringChange: endHandler.handleDateStringChange,
      onDateStringBlur: handleOnEndDateBlur,
      onDateChange: endHandler.handleDateChange,
      onHourChange: endHandler.handleHourChange,
      onHourBlur: handleOnEndHourBlur,
      onMinutesChange: endHandler.handleMinutesChange,
      onMinutesBlur: handleOnEndMinutesBlur,
      descriptionId: descriptionId,
      required: required,
      placeholder: {
        hour: "",
        minutes: ""
      }
    },
    showError: true,
    isTouched: isTouched,
    noValidate: false,
    validateResult: validateResult,
    disabled: disabled
  }));
};

// copied from https://github.com/graffer-inc/graffer-design-kit/blob/3f6f150bf09a1a799ca5928e8c994877e5e653ea/src/utils/format.ts#L21-L32
var format = function format(corporateId) {
  if (!corporateId) {
    return "";
  }
  if (corporateId.length !== 13) {
    throw new Error("Invalid corporate id. corporateId: ".concat(corporateId));
  }
  var result = corporateId.slice(1);
  result = insertHyphen(result, 6);
  result = insertHyphen(result, 4);
  return result;
};
// copied from https://github.com/graffer-inc/graffer-design-kit/blob/3f6f150bf09a1a799ca5928e8c994877e5e653ea/src/utils/format.ts#L5-L10
var insertHyphen = function insertHyphen(target, index) {
  if (index < 0 || target.length < index) {
    return target;
  }
  return "".concat(target.slice(0, index), "-").concat(target.slice(index));
};

// corporate search form の使用例に従い、 http まわりを定義。
// 参照；
// 呼び出し元 https://github.com/graffer-inc/graffer-design-kit/blob/3f6f150bf09a1a799ca5928e8c994877e5e653ea/src/components/organisms/corporation-search-form.tsx#L190-L197
// getClient https://github.com/graffer-inc/graffer-design-kit/blob/3f6f150bf09a1a799ca5928e8c994877e5e653ea/src/utils/http.ts#L29-L35
// callApi https://github.com/graffer-inc/graffer-design-kit/blob/3f6f150bf09a1a799ca5928e8c994877e5e653ea/src/utils/http.ts#L56-L67
var ApiError = /*#__PURE__*/function (_Error) {
  function ApiError(status, response) {
    var _this;
    _classCallCheck(this, ApiError);
    _this = _callSuper(this, ApiError, ["Request failed with status ".concat(status)]);
    _this.name = "ApiError";
    _this.status = status;
    _this.response = response;
    return _this;
  }
  _inherits(ApiError, _Error);
  return _createClass(ApiError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var callGetApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var onSuccess,
      onFail,
      res,
      data,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          onSuccess = _args.length > 1 && _args[1] !== undefined ? _args[1] : function () {
            return;
          };
          onFail = _args.length > 2 && _args[2] !== undefined ? _args[2] : function () {
            return;
          };
          _context.prev = 2;
          _context.next = 5;
          return fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          });
        case 5:
          res = _context.sent;
          _context.next = 8;
          return res.json();
        case 8:
          data = _context.sent;
          if (res.ok) {
            _context.next = 11;
            break;
          }
          throw new ApiError(res.status, data);
        case 11:
          onSuccess(data);
          return _context.abrupt("return", data);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](2);
          onFail(_context.t0);
          throw _context.t0;
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 15]]);
  }));
  return function callGetApi(_x) {
    return _ref.apply(this, arguments);
  };
}();

var css_248z$2 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.corporation-search-form-module__GDK__input___21-R2,\n.corporation-search-form-module__GDK__select___8HjRz,\n.corporation-search-form-module__GDK__button___nXTlr {\n  font-size: 1rem;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  position: relative;\n  vertical-align: top;\n  line-height: 1.5;\n  display: inline-flex;\n  align-items: center;\n  box-shadow: none;\n  height: 2.5em;\n}\n\n.corporation-search-form-module__GDK__input___21-R2,\n.corporation-search-form-module__GDK__select___8HjRz {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  justify-content: flex-start;\n  padding-bottom: calc(0.5em - 1px);\n  padding-left: calc(0.75em - 1px);\n  padding-right: calc(0.75em - 1px);\n  padding-top: calc(0.5em - 1px);\n}\n\n.corporation-search-form-module__GDK__button___nXTlr {\n  fill: #454ab8;\n  padding: 0 0.5em;\n  background-color: #fff;\n  color: #363636;\n  cursor: pointer;\n  justify-content: center;\n  text-align: center;\n  white-space: nowrap;\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.corporation-search-form-module__GDK__selectControl___n2bnJ:not(.corporation-search-form-module__GDK__is-multiple___h-A4-):not(.corporation-search-form-module__GDK__isLoading___r9tBf)::after {\n  border: 3px solid #454ab8;\n  border-radius: 2px;\n  border-right: 0;\n  border-top: 0;\n  content: \" \";\n  display: block;\n  height: 0.625em;\n  margin-top: -0.4375em;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  right: 1.125em;\n  transform: rotate(-45deg);\n  transform-origin: center;\n  width: 0.625em;\n  z-index: 4;\n}\n\n.corporation-search-form-module__GDK__button___nXTlr[disabled] {\n  background-color: #fff;\n  box-shadow: none;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.corporation-search-form-module__GDK__button___nXTlr.corporation-search-form-module__GDK__isLoading___r9tBf {\n  color: transparent !important;\n  pointer-events: none;\n}\n\n.corporation-search-form-module__GDK__button___nXTlr.corporation-search-form-module__GDK__isLoading___r9tBf::after {\n  position: absolute;\n  left: calc(50% - (1em * 0.5));\n  top: calc(50% - (1em * 0.5));\n  position: absolute !important;\n  animation: corporation-search-form-module__GDK__spinAround___9uKO6 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 9999px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  width: 1em;\n}\n\n.corporation-search-form-module__GDK__legend___3huOQ {\n  display: inline;\n  vertical-align: baseline;\n  color: #1d1c1a;\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  word-break: break-all;\n  margin-bottom: 8px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .corporation-search-form-module__GDK__legend___3huOQ {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.corporation-search-form-module__GDK__select___8HjRz:not([multiple]) {\n  padding-left: 0.5em;\n  padding-right: 2.2em;\n}\n\n.corporation-search-form-module__GDK__isLoading___r9tBf {\n  box-shadow: none;\n  color: transparent !important;\n  pointer-events: none;\n}\n\n.corporation-search-form-module__GDK__control___nR92X {\n  box-sizing: border-box;\n  clear: both;\n  font-size: 1rem;\n  position: relative;\n  text-align: inherit;\n}\n\n.corporation-search-form-module__GDK__control___nR92X:not(:last-of-type) {\n  margin-right: -1px;\n}\n\n.corporation-search-form-module__GDK__control___nR92X.corporation-search-form-module__GDK__isExpanded___7dDDY {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.corporation-search-form-module__GDK__field___X-uZS {\n  display: flex;\n  justify-content: flex-start;\n  margin: 0;\n}\n\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X:not(:last-child) {\n  margin-right: -1px;\n}\n\n.corporation-search-form-module__GDK__input___21-R2 {\n  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);\n  max-width: 100%;\n  width: 100%;\n}\n\n.corporation-search-form-module__GDK__selectControl___n2bnJ {\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top;\n}\n\n.corporation-search-form-module__GDK__select___8HjRz {\n  cursor: pointer;\n  display: block;\n  font-size: 1em;\n  max-width: 100%;\n  outline: none;\n}\n\n.corporation-search-form-module__GDK__input___21-R2 {\n  background-color: #fff;\n  border-color: #dbdbdb;\n  border-radius: 4px;\n  color: #363636;\n}\n\n.corporation-search-form-module__GDK__select___8HjRz {\n  background-color: #fff;\n  border-color: #dbdbdb;\n  border-radius: 4px;\n  color: #363636;\n}\n\n.corporation-search-form-module__GDK__selectControl___n2bnJ:not(.corporation-search-form-module__GDK__is-multiple___h-A4-) {\n  height: 2.5em;\n}\n\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X:not(:first-child):not(:last-child) .corporation-search-form-module__GDK__button___nXTlr,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X:not(:first-child):not(:last-child) .corporation-search-form-module__GDK__input___21-R2,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X:not(:first-child):not(:last-child) .corporation-search-form-module__GDK__select___8HjRz {\n  border-radius: 0;\n}\n\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X:first-child:not(:only-child) .corporation-search-form-module__GDK__select___8HjRz {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.corporation-search-form-module__GDK__input___21-R2 {\n  border-color: #706d6c;\n}\n\n.corporation-search-form-module__GDK__select___8HjRz {\n  border-color: #706d6c;\n}\n\n.corporation-search-form-module__GDK__button___nXTlr {\n  border-color: #706d6c;\n}\n\n.corporation-search-form-module__GDK__button___nXTlr:disabled {\n  border-color: #706d6c;\n}\n\n.corporation-search-form-module__GDK__input___21-R2:focus {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.corporation-search-form-module__GDK__input___21-R2:focus:not(:active) {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.corporation-search-form-module__GDK__select___8HjRz:focus {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.corporation-search-form-module__GDK__select___8HjRz:focus:not(:active) {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.corporation-search-form-module__GDK__button___nXTlr:focus {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n.corporation-search-form-module__GDK__button___nXTlr:focus:not(:active) {\n  outline: none;\n  border-color: #454ab8;\n  box-shadow: 0px 0px 4px rgba(57, 68, 179, 0.6);\n}\n\n@media (hover: hover) {\n  .corporation-search-form-module__GDK__input___21-R2:hover {\n    border-color: #3d3b3a;\n  }\n  .corporation-search-form-module__GDK__select___8HjRz:hover {\n    border-color: #3d3b3a;\n  }\n  .corporation-search-form-module__GDK__button___nXTlr:hover {\n    border-color: #3d3b3a;\n  }\n\n  .corporation-search-form-module__GDK__selectControl___n2bnJ:not(.corporation-search-form-module__GDK__is-multiple___h-A4-):not(.corporation-search-form-module__GDK__isLoading___r9tBf):hover::after {\n    border-color: #454ab8;\n  }\n}\n\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__button___nXTlr:not([disabled]):focus,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__button___nXTlr:not([disabled]).corporation-search-form-module__GDK__is-focused___TkiBQ,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__button___nXTlr:not([disabled]):active,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__button___nXTlr:not([disabled]).corporation-search-form-module__GDK__is-active___3LYmE,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__input___21-R2:not([disabled]):focus,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__input___21-R2:not([disabled]).corporation-search-form-module__GDK__is-focused___TkiBQ,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__input___21-R2:not([disabled]):active,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__input___21-R2:not([disabled]).corporation-search-form-module__GDK__is-active___3LYmE,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__select___8HjRz:not([disabled]):focus,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__select___8HjRz:not([disabled]).corporation-search-form-module__GDK__is-focused___TkiBQ,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__select___8HjRz:not([disabled]):active,\n.corporation-search-form-module__GDK__field___X-uZS .corporation-search-form-module__GDK__control___nR92X .corporation-search-form-module__GDK__select___8HjRz:not([disabled]).corporation-search-form-module__GDK__is-active___3LYmE {\n  z-index: 3;\n}\n\n.corporation-search-form-module__GDK__searchResults___046xD {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow:\n    0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),\n    0 0px 0 1px rgba(10, 10, 10, 0.02);\n  color: #4a4a4a;\n  display: block;\n  position: absolute;\n  z-index: 1;\n  top: 42px;\n  max-height: 300px;\n  width: 100%;\n  filter: drop-shadow(rgba(0, 0, 0, 0.2) 10px 10px 10px);\n  overflow-y: scroll;\n}\n\n.corporation-search-form-module__GDK__corporationName___O4456 {\n  font-weight: 700;\n}\n\n.corporation-search-form-module__GDK__corporationDescription___YelJx {\n  display: flex;\n  font-size: 0.75rem;\n}\n\n.corporation-search-form-module__GDK__descriptionHead___Proyp {\n  white-space: nowrap;\n}\n\n.corporation-search-form-module__GDK__message___z0l2k {\n  background-color: #fffaeb;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.corporation-search-form-module__GDK__messageBody___xhf-p {\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 0 0 0 4px;\n  border-color: #ffe08a;\n  color: #946c00;\n  padding: 20px 15px;\n  font-weight: 700;\n}\n\n.corporation-search-form-module__GDK__messageBodyNote___nKA75 {\n  font-size: 0.75rem;\n}\n\n@keyframes corporation-search-form-module__GDK__spinAround___9uKO6 {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n";
var styles$2 = {"input":"corporation-search-form-module__GDK__input___21-R2","select":"corporation-search-form-module__GDK__select___8HjRz","button":"corporation-search-form-module__GDK__button___nXTlr","selectControl":"corporation-search-form-module__GDK__selectControl___n2bnJ","is-multiple":"corporation-search-form-module__GDK__is-multiple___h-A4-","isLoading":"corporation-search-form-module__GDK__isLoading___r9tBf","spinAround":"corporation-search-form-module__GDK__spinAround___9uKO6","legend":"corporation-search-form-module__GDK__legend___3huOQ","control":"corporation-search-form-module__GDK__control___nR92X","isExpanded":"corporation-search-form-module__GDK__isExpanded___7dDDY","field":"corporation-search-form-module__GDK__field___X-uZS","is-focused":"corporation-search-form-module__GDK__is-focused___TkiBQ","is-active":"corporation-search-form-module__GDK__is-active___3LYmE","searchResults":"corporation-search-form-module__GDK__searchResults___046xD","corporationName":"corporation-search-form-module__GDK__corporationName___O4456","corporationDescription":"corporation-search-form-module__GDK__corporationDescription___YelJx","descriptionHead":"corporation-search-form-module__GDK__descriptionHead___Proyp","message":"corporation-search-form-module__GDK__message___z0l2k","messageBody":"corporation-search-form-module__GDK__messageBody___xhf-p","messageBodyNote":"corporation-search-form-module__GDK__messageBodyNote___nKA75"};
styleInject(css_248z$2);

var _excluded$3 = ["onEnter"];
var Input = React__namespace.default.forwardRef(function InputText(_ref, ref) {
  var onEnter = _ref.onEnter,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var keyPress = function keyPress(e) {
    if (e.key === "Enter") onEnter === null || onEnter === void 0 ? void 0 : onEnter(e);
  };
  return React__namespace.default.createElement("input", _objectSpread2(_objectSpread2({}, props), {}, {
    onKeyPress: function onKeyPress(e) {
      var _a;
      keyPress(e);
      (_a = props.onKeyPress) === null || _a === void 0 ? void 0 : _a.call(props, e);
    },
    ref: ref
  }));
});
var format2Digit = function format2Digit(value) {
  return String(value).length === 1 ? "0".concat(String(value)) : String(value);
};
var createUrl = function createUrl(keyword, pref) {
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/api/corporate-certs/v1/corporations";
  var url = new URL(baseUrl, window.location.origin);
  url.search = new URLSearchParams({
    keyword: keyword,
    pref: pref
  }).toString();
  return url.toString();
};
var prefectures = ["北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県", "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県", "新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県", "三重県", "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県", "鳥取県", "島根県", "岡山県", "広島県", "山口県", "徳島県", "香川県", "愛媛県", "高知県", "福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"];
var Item = function Item(_ref2) {
  var corporation = _ref2.corporation,
    onSelect = _ref2.onSelect,
    index = _ref2.index;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var style = {
    margin: "10px",
    padding: "10px 5px",
    cursor: "pointer",
    borderRadius: "5px",
    lineHeight: "1.5"
  };
  var hoveredStyle = _objectSpread2(_objectSpread2({}, style), {}, {
    backgroundColor: "#f5f5f5"
  });
  var ref = React.useRef(null);
  React.useEffect(function () {
    var _a;
    if (index === 0) {
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [index]);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      // Enterキーもしくは、Spaceが押された場合の処理
      // キーボード操作でonClickが呼び出されなかったため、onClick発火時と同じ処理を行う
      onSelect(corporation);
    }
  };
  return React__namespace.default.createElement("li", null, React__namespace.default.createElement("div", {
    role: "button",
    style: isHovered ? hoveredStyle : style,
    onClick: function onClick() {
      return onSelect(corporation);
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    onKeyDown: handleKeyDown,
    ref: ref,
    tabIndex: 0
  }, React__namespace.default.createElement("p", {
    className: styles$2.corporationName
  }, corporation.name), React__namespace.default.createElement("dl", {
    className: styles$2.corporationDescription
  }, React__namespace.default.createElement("dt", {
    className: styles$2.descriptionHead
  }, "\u6CD5\u4EBA\u756A\u53F7\uFF1A"), React__namespace.default.createElement("dd", null, corporation.id, " / ", format(corporation.id))), React__namespace.default.createElement("dl", {
    className: styles$2.corporationDescription
  }, React__namespace.default.createElement("dt", {
    className: styles$2.descriptionHead
  }, "\u672C\u5E97\u6240\u5728\u5730\uFF1A"), React__namespace.default.createElement("dd", null, "\u3012", corporation.postal_code, " ", corporation.pref, corporation.city, corporation.street))));
};
var Result = function Result(_ref3) {
  var _ref3$corporations = _ref3.corporations,
    corporations = _ref3$corporations === void 0 ? [] : _ref3$corporations,
    onSelect = _ref3.onSelect,
    error = _ref3.error;
  var getErrorMessage = function getErrorMessage() {
    var _a, _b;
    if (!error) return null;
    if (error.status === 400 && ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.code) === null || _b === void 0 ? void 0 : _b.startsWith("too.many.results"))) {
      return React__namespace.default.createElement("article", {
        className: styles$2.message,
        "aria-live": "polite"
      }, React__namespace.default.createElement("div", {
        className: styles$2.messageBody
      }, React__namespace.default.createElement("p", null, "\u691C\u7D22\u7D50\u679C\u304C\u591A\u3059\u304E\u307E\u3059\u3002"), React__namespace.default.createElement("p", null, "\u5225\u306E\u6761\u4EF6\u3092\u6307\u5B9A\u3057\u3066\u518D\u5EA6\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044\u3002")));
    }
    if (error.status === 429) {
      return React__namespace.default.createElement("article", {
        className: styles$2.message,
        "aria-live": "polite"
      }, React__namespace.default.createElement("div", {
        className: styles$2.messageBody
      }, React__namespace.default.createElement("p", null, "\u30A2\u30AF\u30BB\u30B9\u304C\u96C6\u4E2D\u3057\u3066\u3044\u307E\u3059\u3002"), React__namespace.default.createElement("p", null, "\u6642\u9593\u3092\u304A\u3044\u3066\u518D\u5EA6\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044\u3002")));
    }
    return React__namespace.default.createElement("article", {
      className: styles$2.message,
      "aria-live": "polite"
    }, React__namespace.default.createElement("div", {
      className: styles$2.messageBody
    }, React__namespace.default.createElement("p", null, "\u691C\u7D22\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002"), React__namespace.default.createElement("p", null, "\u6642\u9593\u3092\u304A\u3044\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002")));
  };
  return React__namespace.default.createElement("div", {
    className: styles$2.searchResults
  }, error ? getErrorMessage() : corporations.length === 0 ? React__namespace.default.createElement("article", {
    className: styles$2.message,
    "aria-live": "polite"
  }, React__namespace.default.createElement("div", {
    className: styles$2.messageBody
  }, React__namespace.default.createElement("p", null, "\u8A72\u5F53\u306E\u6CD5\u4EBA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002"), React__namespace.default.createElement("p", null, "\u6CD5\u4EBA\u540D\u307E\u305F\u306F\u6CD5\u4EBA\u756A\u53F7\u3092\u78BA\u8A8D\u3057\u3066\u518D\u5EA6\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"), React__namespace.default.createElement("p", {
    className: styles$2.messageBodyNote
  }, "\u203B\u8A2D\u7ACB\u767B\u8A18\u624B\u7D9A\u304D\u4E2D\u306E\u6CD5\u4EBA\u306F\u691C\u7D22\u7D50\u679C\u306B\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002"))) : React__namespace.default.createElement("ul", null, corporations.map(function (c, index) {
    return React__namespace.default.createElement(Item, {
      key: c.id,
      corporation: c,
      onSelect: onSelect,
      index: index
    });
  })));
};
var Form = function Form(_ref4) {
  var _onSelect = _ref4.onSelect,
    baseUrl = _ref4.baseUrl,
    initKeyword = _ref4.initKeyword;
  var _useState3 = React.useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    corporations = _useState4[0],
    setCorporations = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSearching = _useState6[0],
    setIsSearching = _useState6[1];
  var _useState7 = React.useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    pref = _useState8[0],
    setPref = _useState8[1];
  var _useState9 = React.useState(initKeyword || ""),
    _useState10 = _slicedToArray(_useState9, 2),
    keyword = _useState10[0],
    setKeyword = _useState10[1];
  var _useState11 = React.useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDisplaySearchResult = _useState12[0],
    setIsDisplaySearchResult = _useState12[1];
  var _useState13 = React.useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showErrorMessage = _useState14[0],
    setShowErrorMessage = _useState14[1];
  var _useState15 = React.useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    apiError = _useState16[0],
    setApiError = _useState16[1];
  // 共通して "結果をクリアし、エラー（任意）を表示パネルに反映" する処理をまとめる
  var clearAndShow = function clearAndShow(err) {
    setApiError(err);
    setCorporations([]);
    setIsDisplaySearchResult(true);
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Form.handleClickOutside = function () {
    return setIsDisplaySearchResult(false);
  };
  var inputRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  // 検索結果一覧をescapeキーで閉じた後に、フォーカスを戻す場所を判定する為に保持。
  var _React$useState = React__namespace.default.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchFrom = _React$useState2[0],
    setSearchFrom = _React$useState2[1];
  var handleKeyPress = React.useCallback(function (e) {
    var _a, _b;
    if (e.key === "Escape") {
      setIsDisplaySearchResult(false);
      if (searchFrom === "input") {
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      } else if (searchFrom === "button") {
        (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
      }
    }
  }, [setIsDisplaySearchResult, searchFrom]);
  React.useEffect(function () {
    if (isDisplaySearchResult) {
      document.addEventListener("keyup", handleKeyPress);
    }
    return function cleanup() {
      document.removeEventListener("keyup", handleKeyPress);
    };
  }, [isDisplaySearchResult, handleKeyPress]);
  React.useEffect(function () {
    if (initKeyword) {
      setKeyword(initKeyword);
    }
  }, [initKeyword]);
  var search = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var kw, _yield$callGetApi, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          kw = keyword.trim();
          if (kw) {
            _context.next = 4;
            break;
          }
          setShowErrorMessage(true);
          return _context.abrupt("return");
        case 4:
          setIsSearching(true);
          setApiError(undefined);
          _context.prev = 6;
          _context.next = 9;
          return callGetApi(createUrl(kw, pref, baseUrl));
        case 9:
          _yield$callGetApi = _context.sent;
          data = _yield$callGetApi.data;
          if (Array.isArray(data) && data.length > 0) {
            setCorporations(data);
            setIsDisplaySearchResult(true);
          } else {
            // 0 件時はメッセージだけ表示
            clearAndShow();
          }
          _context.next = 17;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](6);
          clearAndShow(_context.t0);
        case 17:
          _context.prev = 17;
          setIsSearching(false);
          return _context.finish(17);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 14, 17, 20]]);
  })), [keyword, pref, baseUrl]);
  var onInputEnter = function onInputEnter(e) {
    e.preventDefault();
    setSearchFrom("input");
    search();
  };
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    setSearchFrom("button");
    search();
  };
  React.useEffect(function () {
    if (keyword.length > 0) {
      setShowErrorMessage(false);
      return;
    }
  }, [keyword]);
  return React__namespace.default.createElement("div", null, React__namespace.default.createElement("div", {
    className: styles$2.field
  }, React__namespace.default.createElement("div", {
    className: styles$2.control
  }, React__namespace.default.createElement("span", {
    className: styles$2.selectControl
  }, React__namespace.default.createElement("select", {
    value: pref,
    className: styles$2.select,
    onChange: function onChange(e) {
      return setPref(e.target.value);
    },
    "aria-label": "\u90FD\u9053\u5E9C\u770C"
  }, React__namespace.default.createElement("option", {
    value: ""
  }, "\u5168\u56FD"), prefectures.map(function (p, i) {
    return React__namespace.default.createElement("option", {
      key: p,
      value: format2Digit(i + 1)
    }, p);
  })))), React__namespace.default.createElement("div", {
    className: "".concat(styles$2.control, " ").concat(styles$2.isExpanded)
  }, React__namespace.default.createElement(Input, {
    type: "text",
    "aria-label": "\u6CD5\u4EBA\u540D\u307E\u305F\u306F\u6CD5\u4EBA\u756A\u53F7",
    value: keyword,
    onChange: function onChange(e) {
      return setKeyword(e.target.value);
    },
    onEnter: onInputEnter,
    className: styles$2.input,
    ref: inputRef
  })), React__namespace.default.createElement("div", {
    className: styles$2.control
  }, React__namespace.default.createElement("button", {
    type: "submit",
    className: "".concat(styles$2.button, " ").concat(isSearching && styles$2.isLoading),
    onClick: onButtonClick,
    disabled: isSearching,
    "aria-label": "\u691C\u7D22",
    ref: buttonRef
  }, React__namespace.default.createElement(SearchIcon, {
    size: IconSizes.small
  })))), isDisplaySearchResult && React__namespace.default.createElement(Result, {
    corporations: corporations,
    onSelect: function onSelect(c) {
      _onSelect(c);
      setIsDisplaySearchResult(false);
    },
    error: apiError
  }), showErrorMessage && React__namespace.default.createElement(ErrorMessages, {
    messages: "法人名または法人番号を入力してから検索してください",
    ariaLive: "assertive"
  }));
};
var clickOutsideConfig = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClickOutside: function handleClickOutside() {
    return Form.handleClickOutside;
  }
};
var SearchForm = onClickOutside__default.default(Form, clickOutsideConfig);
var CorporationSearchForm = function CorporationSearchForm(props) {
  // <legend> 部分をクリックした際にもResultプルダウンを閉じたかったため、Form内には含めず、外側に定義。
  return React__namespace.default.createElement("fieldset", {
    style: {
      position: "relative"
    }
  }, React__namespace.default.createElement("legend", {
    className: styles$2.legend
  }, "\u6CD5\u4EBA\u540D\u307E\u305F\u306F\u6CD5\u4EBA\u756A\u53F7\u3067\u691C\u7D22"), React__namespace.default.createElement(SearchForm, _objectSpread2({}, props)));
};

var css_248z$1 = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.base-year-month-day-input-module__GDK__inputWrapper___u-12l {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: center;\n  width: 100%;\n}\n\n.base-year-month-day-input-module__GDK__legend___K7iIJ {\n  margin-bottom: 8px;\n}\n\n.base-year-month-day-input-module__GDK__description___bKzFB {\n  margin-bottom: 8px;\n}\n\n.base-year-month-day-input-module__GDK__label___lXCeJ {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  vertical-align: middle;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-year-month-day-input-module__GDK__label___lXCeJ {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.base-year-month-day-input-module__GDK__description___bKzFB {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-year-month-day-input-module__GDK__description___bKzFB {\n  font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.base-year-month-day-input-module__GDK__year___GMJjF {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.base-year-month-day-input-module__GDK__month___a-HBh {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.base-year-month-day-input-module__GDK__day___j71Ic {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.base-year-month-day-input-module__GDK__year___GMJjF select {\n  text-align: left;\n  width: 130px;\n}\n\n.base-year-month-day-input-module__GDK__wareki___yPyKA .base-year-month-day-input-module__GDK__year___GMJjF {\n  width: 100%;\n}\n\n.base-year-month-day-input-module__GDK__wareki___yPyKA .base-year-month-day-input-module__GDK__year___GMJjF select {\n  width: 320px;\n}\n\n.base-year-month-day-input-module__GDK__month___a-HBh select,\n.base-year-month-day-input-module__GDK__day___j71Ic select {\n  width: 94px;\n  text-align: left;\n}\n\n.base-year-month-day-input-module__GDK__unit___3wxKS {\n  max-width: 66px;\n  font: 18px/31px Meiryo, Arial, system-ui, sans-serif;\n  line-height: 28px;\n}\n\n@media screen and (max-width: 800px) {\n\n  .base-year-month-day-input-module__GDK__unit___3wxKS {\n  font: 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.base-year-month-day-input-module__GDK__picker___U2I4e {\n  width: 48px;\n}\n\n.base-year-month-day-input-module__GDK__year___GMJjF select:disabled {\n  background-color: #faf9f7;\n  border: #faf9f7;\n  color: #706d6c;\n  opacity: 1;\n}\n\n.base-year-month-day-input-module__GDK__month___a-HBh select:disabled {\n  background-color: #faf9f7;\n  border: #faf9f7;\n  color: #706d6c;\n  opacity: 1;\n}\n\n.base-year-month-day-input-module__GDK__day___j71Ic select:disabled {\n  background-color: #faf9f7;\n  border: #faf9f7;\n  color: #706d6c;\n  opacity: 1;\n}\n\n@media screen and (max-width: 800px) {\n  .base-year-month-day-input-module__GDK__inputWrapper___u-12l {\n    gap: 8px;\n  }\n\n  .base-year-month-day-input-module__GDK__inputWrapper___u-12l:not(.base-year-month-day-input-module__GDK__yearMonth___PjK5q) .base-year-month-day-input-module__GDK__year___GMJjF {\n    width: 100%;\n  }\n\n  .base-year-month-day-input-module__GDK__year___GMJjF {\n    gap: 8px;\n  }\n\n  .base-year-month-day-input-module__GDK__month___a-HBh {\n    gap: 8px;\n  }\n\n  .base-year-month-day-input-module__GDK__day___j71Ic {\n    gap: 8px;\n  }\n\n  .base-year-month-day-input-module__GDK__year___GMJjF select {\n    height: 48px;\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  @media screen and (max-width: 800px) {\n\n    .base-year-month-day-input-module__GDK__year___GMJjF select {\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n\n  .base-year-month-day-input-module__GDK__month___a-HBh select {\n    height: 48px;\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  @media screen and (max-width: 800px) {\n\n    .base-year-month-day-input-module__GDK__month___a-HBh select {\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n\n  .base-year-month-day-input-module__GDK__day___j71Ic select {\n    height: 48px;\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n  }\n\n  @media screen and (max-width: 800px) {\n\n    .base-year-month-day-input-module__GDK__day___j71Ic select {\n    font: 14px/24px Meiryo, Arial, system-ui, sans-serif;\n    }\n  }\n\n  .base-year-month-day-input-module__GDK__month___a-HBh select,\n  .base-year-month-day-input-module__GDK__day___j71Ic select {\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .base-year-month-day-input-module__GDK__wareki___yPyKA .base-year-month-day-input-module__GDK__year___GMJjF select {\n    width: 100%;\n  }\n}\n";
var styles$1 = {"inputWrapper":"base-year-month-day-input-module__GDK__inputWrapper___u-12l","legend":"base-year-month-day-input-module__GDK__legend___K7iIJ","description":"base-year-month-day-input-module__GDK__description___bKzFB","label":"base-year-month-day-input-module__GDK__label___lXCeJ","year":"base-year-month-day-input-module__GDK__year___GMJjF","month":"base-year-month-day-input-module__GDK__month___a-HBh","day":"base-year-month-day-input-module__GDK__day___j71Ic","wareki":"base-year-month-day-input-module__GDK__wareki___yPyKA","unit":"base-year-month-day-input-module__GDK__unit___3wxKS","picker":"base-year-month-day-input-module__GDK__picker___U2I4e","yearMonth":"base-year-month-day-input-module__GDK__yearMonth___PjK5q"};
styleInject(css_248z$1);

function useDateTouched(hasInitialValue) {
  var isYearMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    yearTouched = _React$useState2[0],
    _setYearTouched = _React$useState2[1];
  var _React$useState3 = React__namespace.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    monthTouched = _React$useState4[0],
    _setMonthTouched = _React$useState4[1];
  var _React$useState5 = React__namespace.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    dayTouched = _React$useState6[0],
    _setDayTouched = _React$useState6[1];
  var setAllTouched = React.useCallback(function () {
    _setYearTouched(true);
    _setMonthTouched(true);
    _setDayTouched(true);
  }, []);
  return React.useMemo(function () {
    var isTouched = isYearMonth ? yearTouched && monthTouched : yearTouched && monthTouched && dayTouched;
    if (hasInitialValue) {
      return {
        isYearMonth: isYearMonth,
        isTouched: isTouched,
        yearTouched: yearTouched,
        monthTouched: monthTouched,
        dayTouched: dayTouched,
        setAllTouched: setAllTouched,
        setYearTouched: setAllTouched,
        setMonthTouched: setAllTouched,
        setDayTouched: setAllTouched
      };
    }
    return {
      isTouched: isTouched,
      yearTouched: yearTouched,
      monthTouched: monthTouched,
      dayTouched: dayTouched,
      setAllTouched: setAllTouched,
      setYearTouched: function setYearTouched() {
        return _setYearTouched(true);
      },
      setMonthTouched: function setMonthTouched() {
        return _setMonthTouched(true);
      },
      setDayTouched: function setDayTouched() {
        return _setDayTouched(true);
      }
    };
  }, [yearTouched, monthTouched, dayTouched, isYearMonth, hasInitialValue, setAllTouched]);
}

function useDateValues(_ref) {
  var value = _ref.value,
    type = _ref.type,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "YYYY/MM/DD" : _ref$format,
    onChange = _ref.onChange;
  var splitValue = React__namespace.useMemo(function () {
    return splitDate(value);
  }, [value]);
  var _React$useState = React__namespace.useState(splitValue[0]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    year = _React$useState2[0],
    setYear = _React$useState2[1];
  var _React$useState3 = React__namespace.useState(splitValue[1]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    month = _React$useState4[0],
    setMonth = _React$useState4[1];
  var _React$useState5 = React__namespace.useState(splitValue[2]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    day = _React$useState6[0],
    setDay = _React$useState6[1];
  var setValue = React__namespace.useCallback(function (value) {
    onChange && onChange(mergeYearMonthDay(_objectSpread2({
      format: format,
      type: type
    }, value)));
  }, [type, format, onChange]);
  var setDate = React.useCallback(function (value, isInitialValue) {
    setYear(splitDate(value)[0]);
    setMonth(splitDate(value)[1]);
    setDay(splitDate(value)[2]);
    if (isInitialValue) return;
    setValue({
      year: splitDate(value)[0],
      month: splitDate(value)[1],
      day: splitDate(value)[2]
    });
  }, [setValue]);
  return React.useMemo(function () {
    return {
      date: {
        year: year,
        month: month,
        day: day
      },
      setValue: setValue,
      setDate: setDate,
      setYear: setYear,
      setMonth: setMonth,
      setDay: setDay
    };
  }, [year, month, day, setValue, setDate]);
}

function useYearMonthDayInput(_ref) {
  var onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "YYYY/MM/DD" : _ref$format,
    _ref$showWareki = _ref.showWareki,
    showWareki = _ref$showWareki === void 0 ? false : _ref$showWareki,
    _ref$baseYear = _ref.baseYear,
    baseYear = _ref$baseYear === void 0 ? new Date().getFullYear() - 20 : _ref$baseYear,
    value = _ref.value,
    _ref$maxYear = _ref.maxYear,
    maxYear = _ref$maxYear === void 0 ? new Date().getFullYear() + 10 : _ref$maxYear,
    _ref$minYear = _ref.minYear,
    minYear = _ref$minYear === void 0 ? 1907 : _ref$minYear;
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasInitialValue = _React$useState2[0],
    setHasInitialValue = _React$useState2[1];
  var touched = useDateTouched(hasInitialValue, format === "YYYY/MM" ? true : false);
  var type = typeof value === "string" ? "string" : "date";
  var dateValues = useDateValues({
    value: value,
    format: format,
    type: type,
    onChange: onChange
  });
  var date = React__namespace.useMemo(function () {
    if (!value) {
      return null;
    }
    if (typeof value === "string") {
      return dayjs__default.default(value, format).toDate();
    }
    return value;
  }, [value, format]);
  var yearOptions = React__namespace.useMemo(function () {
    var options = [];
    for (var i = minYear; i <= maxYear; i++) {
      if (i === baseYear) {
        options.push({
          text: "----",
          value: "",
          selected: true,
          "aria-label": "項目を選択してください"
        });
      }
      options.push({
        text: showWareki ? "".concat(i, "\u5E74(").concat(convertYearToWarekiOnlyYear(i), ")") : "".concat(i),
        value: i.toString()
      });
    }
    return options;
  }, [baseYear, maxYear, minYear, showWareki]);
  var monthOptions = React__namespace.useMemo(function () {
    return _toConsumableArray(Array(12)).map(function (_, i) {
      return i + 1;
    }).map(function (i) {
      return {
        text: "".concat(i),
        value: i.toString()
      };
    });
  }, []);
  var dayOptions = React__namespace.useMemo(function () {
    return _toConsumableArray(Array(31)).map(function (_, i) {
      return i + 1;
    }).map(function (i) {
      return {
        text: "".concat(i),
        value: i.toString()
      };
    });
  }, []);
  var handleOnYearChange = React__namespace.useCallback(function (e) {
    dateValues.setYear(e.target.value);
    touched.setYearTouched();
    if (hasInitialValue || touched.monthTouched && touched.dayTouched) {
      dateValues.setValue(_objectSpread2(_objectSpread2({}, dateValues.date), {}, {
        year: e.target.value
      }));
    }
  }, [touched, hasInitialValue, dateValues]);
  var handleOnMonthChange = React__namespace.useCallback(function (e) {
    dateValues.setMonth(e.target.value);
    touched.setMonthTouched();
    if (hasInitialValue || touched.yearTouched && touched.dayTouched) {
      dateValues.setValue(_objectSpread2(_objectSpread2({}, dateValues.date), {}, {
        month: e.target.value
      }));
    }
  }, [touched, hasInitialValue, dateValues]);
  var handleOnDayChange = React__namespace.useCallback(function (e) {
    touched.setDayTouched();
    dateValues.setDay(e.target.value);
    if (hasInitialValue || touched.yearTouched && touched.monthTouched) {
      dateValues.setValue(_objectSpread2(_objectSpread2({}, dateValues.date), {}, {
        day: e.target.value
      }));
    }
  }, [touched, hasInitialValue, dateValues]);
  var setDate = React__namespace.useCallback(function (date) {
    if (!date) {
      return;
    }
    dateValues.setDate(date, false);
    touched.setAllTouched();
  }, [touched, dateValues]);
  var handlePickerChange = React__namespace.useCallback(function (date) {
    if (!date) {
      return;
    }
    setDate(date);
  }, [setDate]);
  var handleOnSetDate = React__namespace.useCallback(function (date) {
    if (!date) {
      return;
    }
    setDate(date);
  }, [setDate]);
  var handleOnYearBlur = React__namespace.useCallback(function (e) {
    touched.setYearTouched();
    if (touched.monthTouched && touched.dayTouched) {
      onBlur && onBlur(e);
    }
  }, [touched, onBlur]);
  var handleOnMonthBlur = React__namespace.useCallback(function (e) {
    touched.setMonthTouched();
    if (touched.yearTouched && touched.dayTouched) {
      onBlur && onBlur(e);
    }
  }, [onBlur, touched]);
  var handleOnDayBlur = React__namespace.useCallback(function (e) {
    touched.setDayTouched();
    if (touched.yearTouched && touched.monthTouched) {
      onBlur && onBlur(e);
    }
  }, [touched, onBlur]);
  React__namespace.useEffect(function () {
    if (!!value && !hasInitialValue) {
      setHasInitialValue(true);
      dateValues.setDate(value, true);
    }
  }, [value, hasInitialValue, dateValues]);
  return _objectSpread2(_objectSpread2({}, dateValues.date), {}, {
    yearOptions: yearOptions,
    monthOptions: monthOptions,
    dayOptions: dayOptions,
    date: date,
    handleOnYearBlur: handleOnYearBlur,
    handleOnMonthBlur: handleOnMonthBlur,
    handleOnDayBlur: handleOnDayBlur,
    handleOnYearChange: handleOnYearChange,
    handleOnMonthChange: handleOnMonthChange,
    handleOnDayChange: handleOnDayChange,
    handlePickerChange: handlePickerChange,
    handleOnSetDate: handleOnSetDate
  });
}

function BaseYearMonthDayInput(_ref) {
  var dataTestId = _ref["data-test-id"],
    onChange = _ref.onChange,
    value = _ref.value,
    onBlur = _ref.onBlur,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    formState = _ref.formState,
    showWareki = _ref.showWareki,
    format = _ref.format,
    baseYear = _ref.baseYear,
    showCalendar = _ref.showCalendar,
    autoComplete = _ref.autoComplete,
    maxYear = _ref.maxYear,
    minYear = _ref.minYear,
    required = _ref.required;
  var _useYearMonthDayInput = useYearMonthDayInput({
      onChange: onChange,
      value: value,
      onBlur: onBlur,
      showWareki: showWareki,
      format: format,
      baseYear: baseYear,
      maxYear: maxYear,
      minYear: minYear
    }),
    year = _useYearMonthDayInput.year,
    month = _useYearMonthDayInput.month,
    day = _useYearMonthDayInput.day,
    yearOptions = _useYearMonthDayInput.yearOptions,
    monthOptions = _useYearMonthDayInput.monthOptions,
    dayOptions = _useYearMonthDayInput.dayOptions,
    date = _useYearMonthDayInput.date,
    handleOnYearBlur = _useYearMonthDayInput.handleOnYearBlur,
    handleOnMonthBlur = _useYearMonthDayInput.handleOnMonthBlur,
    handleOnDayBlur = _useYearMonthDayInput.handleOnDayBlur,
    handleOnYearChange = _useYearMonthDayInput.handleOnYearChange,
    handleOnMonthChange = _useYearMonthDayInput.handleOnMonthChange,
    handleOnDayChange = _useYearMonthDayInput.handleOnDayChange,
    handleOnSetDate = _useYearMonthDayInput.handleOnSetDate,
    handlePickerChange = _useYearMonthDayInput.handlePickerChange;
  return React__namespace.createElement("div", {
    className: classNames__default.default(styles$1.inputWrapper, showCalendar && styles$1.showCalendar, format === "YYYY/MM" && styles$1.yearMonth, showWareki && styles$1.wareki),
    "data-test-id": dataTestId
  }, React__namespace.createElement("div", {
    className: classNames__default.default(styles$1.year)
  }, React__namespace.createElement(BaseSelect, {
    onBlur: handleOnYearBlur,
    disabled: disabled,
    onChange: handleOnYearChange,
    value: year,
    formState: formState,
    blank: false,
    options: yearOptions,
    placeholder: "",
    enabledSuccessState: true,
    autoComplete: autoComplete === null || autoComplete === void 0 ? void 0 : autoComplete.year,
    required: required
  }), !showWareki && React__namespace.createElement("p", {
    className: "".concat(styles$1.unit, " ").concat(styles$1.yearUnit)
  }, "\u5E74")), React__namespace.createElement("div", {
    className: styles$1.month
  }, React__namespace.createElement(BaseSelect, {
    onBlur: handleOnMonthBlur,
    onChange: handleOnMonthChange,
    disabled: disabled,
    formState: formState,
    value: month,
    options: monthOptions,
    placeholder: "----",
    ariaLabel: "\u6708",
    blank: true,
    enabledSuccessState: true,
    autoComplete: autoComplete === null || autoComplete === void 0 ? void 0 : autoComplete.month,
    required: required
  }), React__namespace.createElement("p", {
    className: "".concat(styles$1.unit, " ").concat(styles$1.monthUnit)
  }, "\u6708")), format !== "YYYY/MM" && React__namespace.createElement("div", {
    className: styles$1.day
  }, React__namespace.createElement(BaseSelect, {
    onBlur: handleOnDayBlur,
    onChange: handleOnDayChange,
    disabled: disabled,
    formState: formState,
    value: day,
    options: dayOptions,
    placeholder: "----",
    ariaLabel: "\u65E5",
    blank: true,
    enabledSuccessState: true,
    autoComplete: autoComplete === null || autoComplete === void 0 ? void 0 : autoComplete.day,
    required: required
  }), React__namespace.createElement("p", {
    className: "".concat(styles$1.unit, " ").concat(styles$1.dayUnit)
  }, "\u65E5")), showCalendar && React__namespace.createElement("div", {
    className: styles$1.picker
  }, React__namespace.createElement(DatePicker, {
    date: date,
    setValue: handleOnSetDate,
    onChange: handlePickerChange,
    disabled: disabled,
    iconTitle: format === "YYYY/MM" ? "カレンダーで年・月を選択する" : "カレンダーで日付を選択する",
    showMonthYearPicker: format === "YYYY/MM"
  })));
}

var _excluded$2 = ["touched", "isValid", "disabled"],
  _excluded2$1 = ["title", "description", "value", "required", "errorMessage", "onBlur", "onChange"];
/**
 * GrafferSchemas用の和暦年月日入力コンポーネント
 * GrafferSchemas以外での使用は非推奨です。
 * @param param0
 * @returns
 */
var GrafferSchemasYearMonthDayInput = function GrafferSchemasYearMonthDayInput(_ref) {
  var touched = _ref.touched,
    isValid = _ref.isValid,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var formState = React__namespace.useMemo(function () {
    return FormState.create(touched, isValid, false, disabled, undefined, undefined);
  }, [touched, isValid, disabled]);
  return React__namespace.createElement(BaseYearMonthDayInput, _objectSpread2(_objectSpread2({}, props), {}, {
    disabled: disabled,
    showWareki: true,
    formState: formState
  }));
};
/**
 * 生年月日入力用コンポーネント
 * @param param0
 * @returns
 */
var BirthDayInput = function BirthDayInput(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? "" : _ref2$value,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    errorMessage = _ref2.errorMessage,
    onBlur = _ref2.onBlur,
    onChange = _ref2.onChange,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var id = React__namespace.useId();
  var descriptionId = description ? "description-".concat(id) : undefined;
  var errorMessageId = "errorMessage-".concat(id);
  var formState = React__namespace.useMemo(function () {
    return FormState.create(touched, !errorMessage, false, false, undefined, undefined);
  }, [errorMessage, touched]);
  var handleOnBlur = React__namespace.useCallback(function (e) {
    setTouched(true);
    onBlur && onBlur(e);
  }, [onBlur]);
  var handleOnChange = React__namespace.useCallback(function (value) {
    setTouched(true);
    onChange && onChange(value);
  }, [onChange]);
  return React__namespace.createElement(FieldsetWrap, _objectSpread2({}, {
    title: title,
    description: description,
    required: required,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseYearMonthDayInput, _objectSpread2(_objectSpread2({}, props), {}, {
    showWareki: true,
    showCalendar: false,
    autoComplete: {
      year: "bday-year",
      month: "bday-month",
      day: "bday-day"
    },
    required: required,
    value: value,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    formState: formState
  })), formState.isFail() && React__namespace.createElement(ErrorMessages, {
    messages: errorMessage,
    id: errorMessageId
  }));
};

var _excluded$1 = ["touched", "isValid"],
  _excluded2 = ["title", "description", "value", "required", "errorMessage", "onBlur", "onChange"];
var BASE_PROPS = {
  showCalendar: true,
  showWareki: false,
  format: "YYYY/MM"
};
/**
 * GrafferSchemas用の年月コンポーネント
 * GrafferSchemas以外での使用は非推奨です。
 * @param param0
 * @deprecated
 * @returns
 */
var GrafferYearMonthInput = function GrafferYearMonthInput(_ref) {
  var touched = _ref.touched,
    isValid = _ref.isValid,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var formState = React__namespace.useMemo(function () {
    return FormState.create(touched, isValid, false, false, undefined, undefined);
  }, [touched, isValid]);
  return React__namespace.createElement(BaseYearMonthDayInput, _objectSpread2(_objectSpread2(_objectSpread2({}, props), BASE_PROPS), {}, {
    formState: formState
  }));
};
var YearMonthInput = function YearMonthInput(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? "" : _ref2$value,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    errorMessage = _ref2.errorMessage,
    onBlur = _ref2.onBlur,
    onChange = _ref2.onChange,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _React$useState = React__namespace.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var id = React__namespace.useId();
  var descriptionId = description ? "description-".concat(id) : undefined;
  var errorMessageId = "errorMessage-".concat(id);
  var formState = React__namespace.useMemo(function () {
    return FormState.create(touched, !errorMessage, false, false, undefined, undefined);
  }, [errorMessage, touched]);
  var handleOnBlur = React__namespace.useCallback(function (e) {
    setTouched(true);
    onBlur && onBlur(e);
  }, [onBlur]);
  var handleOnChange = React__namespace.useCallback(function (value) {
    setTouched(true);
    onChange && onChange(value);
  }, [onChange]);
  return React__namespace.createElement(FieldsetWrap, _objectSpread2({}, {
    title: title,
    description: description,
    required: required,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseYearMonthDayInput, _objectSpread2(_objectSpread2(_objectSpread2({}, BASE_PROPS), props), {}, {
    value: value,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    formState: formState,
    required: required
  })), formState.isFail() && React__namespace.createElement(ErrorMessages, {
    messages: errorMessage,
    id: errorMessageId
  }));
};

var getSBPS_SCRIPT_SRC = function getSBPS_SCRIPT_SRC(env) {
  return env === "production" ? "https://token.sps-system.com/sbpstoken/com_sbps_system_token.js" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js";
};
function generateSbpsToken(formData) {
  return new Promise(function (resolve, reject) {
    // sbpsのjsが読み込まれていないためリロードを促す
    if (!com_sbps_system) {
      return reject("ネットワークエラーが発生しました。画面をリロードしてください。");
    }
    com_sbps_system.generateToken({
      merchantId: formData.merchantId,
      serviceId: formData.serviceId,
      ccNumber: formData.cardNo.replace(/\s+/g, ""),
      ccExpiration: formData.expYear + formData.expMonth,
      securityCode: formData.cvc
    }, function (res) {
      if (!res) {
        return reject("fail to generate SBPS token");
      }
      resolve(res);
    });
  });
}

/**
 * SBPSが提供しているJSをscript要素を動的に構築して読み込む
 */
var appendSbpsScriptElement = function appendSbpsScriptElement(env) {
  // すでに読み込み済みの場合終了
  if (document.getElementById("sbps_script")) {
    return;
  }
  var script = document.createElement("script");
  script.src = getSBPS_SCRIPT_SRC(env);
  script.defer = true;
  script.id = "sbps_script";
  document.head.appendChild(script);
};

/**
 * @deprecated SbpsCreditCardModalへの移行後に削除されます
 */
function resolveSbpsTokenErrorMsg(code) {
  switch (code) {
    case "03003":
      return "カード番号が入力されていません。再度カード番号を入力してください。";
    case "03004":
      return "有効期限が入力されていません。再度有効期限を入力してください。";
    case "03005":
      return "セキュリティーコードが入力されていません。再度セキュリティーコードを入力してください。";
    case "04003":
      return "カード番号に不正な値が入力されています。半角数字のみ入力してください。";
    case "04004":
      return "有効期限に不正な値が入力されています。半角数字のみ入力してください。";
    case "04005":
      return "セキュリティーコードに不正な値が入力されています。半角数字のみ入力してください。";
    case "07003":
      return "カード番号に不正な値が入力されています。半角数字のみ入力してください。";
    case "07004":
      return "有効期限に不正な値が入力されています。半角数字のみ入力してください。";
    case "07005":
      return "カード番号に不正な値が入力されています。半角数字のみ入力してください。";
    default:
      return "システムエラーが発生しています。しばらく時間を置いて操作してください。";
  }
}

var SbpsTokenError = /*#__PURE__*/function (_Error) {
  function SbpsTokenError(message, code) {
    var _this;
    _classCallCheck(this, SbpsTokenError);
    _this = _callSuper(this, SbpsTokenError, [message]);
    _this.name = "SbpsTokenError";
    _this.code = code;
    return _this;
  }
  _inherits(SbpsTokenError, _Error);
  return _createClass(SbpsTokenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var _excluded = ["title", "description", "id", "value", "noValidate", "validate", "errorMessage", "onChange", "onBlur", "required", "onErrorStateChange", "inputRef"];
var CreditCardTextField = function CreditCardTextField(_ref) {
  var title = _ref.title,
    description = _ref.description,
    id = _ref.id,
    value = _ref.value,
    noValidate = _ref.noValidate,
    validate = _ref.validate,
    errorMessage = _ref.errorMessage,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    onErrorStateChange = _ref.onErrorStateChange,
    inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useId = nextId.useId(1, "TextField-id-"),
    _useId2 = _slicedToArray(_useId, 1),
    generatedID = _useId2[0];
  var htmlId = id !== null && id !== void 0 ? id : generatedID;
  var descriptionId = description ? "description-".concat(generatedID) : undefined;
  var errorMessageId = "errorMessage-".concat(generatedID);
  var _useFormState = useFormState({
      value: value,
      validate: validate,
      noValidate: noValidate,
      disabled: props.disabled,
      errorMessage: errorMessage,
      onBlur: onBlur
    }),
    formState = _useFormState.formState,
    handleBlur = _useFormState.handleBlur;
  React.useEffect(function () {
    onErrorStateChange === null || onErrorStateChange === void 0 ? void 0 : onErrorStateChange(formState.isFail());
  }, [formState, onErrorStateChange]);
  return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement(TitleWrap, {
    title: title,
    description: description,
    required: required,
    id: htmlId,
    descriptionId: descriptionId
  }), React__namespace.createElement(BaseTextInput, _objectSpread2(_objectSpread2({}, props), {}, {
    id: htmlId,
    descriptionId: descriptionId,
    errorMessageId: errorMessageId,
    value: value,
    onChange: onChange,
    onBlur: handleBlur,
    formState: formState,
    needStatusIcon: true,
    required: required,
    ref: inputRef
  })), formState.matchComponents({
    "default": null,
    disabled: null,
    success: null,
    fail: React__namespace.createElement(ErrorMessages, {
      messages: formState.errorMessage,
      id: errorMessageId
    }),
    readOnly: null
  }));
};

var css_248z = ":root {\n  /* font */\n  /* color */\n  /* shadow */\n  /* 余白 */\n  /* border-radius */\n}\n\n.sbps-credit-card-modal-component-module__GDK__availableCardTitle___VrwUI {\n  font: bold 18px/31px Meiryo, Arial, system-ui, sans-serif;\n}\n\n@media screen and (max-width: 800px) {\n\n  .sbps-credit-card-modal-component-module__GDK__availableCardTitle___VrwUI {\n  font: bold 16px/28px Meiryo, Arial, system-ui, sans-serif;\n  }\n}\n\n.sbps-credit-card-modal-component-module__GDK__availableCardList___qujub {\n  display: flex;\n  margin-left: 4px;\n  gap: 8px;\n}\n\n.sbps-credit-card-modal-component-module__GDK__creditCard___5fgK-,\n.sbps-credit-card-modal-component-module__GDK__wrapper___KIYaz,\n.sbps-credit-card-modal-component-module__GDK__container___s2rFr {\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .sbps-credit-card-modal-component-module__GDK__creditCard___5fgK- {\n    display: none;\n  }\n}\n\n.sbps-credit-card-modal-component-module__GDK__column___ODO-O {\n  display: flex;\n  justify-content: space-between;\n}\n\n.sbps-credit-card-modal-component-module__GDK__column___ODO-O .sbps-credit-card-modal-component-module__GDK__formControl___2r1n9:first-child {\n  margin-right: 1rem;\n}\n\n.sbps-credit-card-modal-component-module__GDK__formControl___2r1n9 {\n  box-sizing: border-box;\n  clear: both;\n  font-size: 1rem;\n  position: relative;\n  text-align: inherit;\n}\n\n.sbps-credit-card-modal-component-module__GDK__formExpanded___Ak-B- {\n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.sbps-credit-card-modal-component-module__GDK__helpControl___VlC1P,\n.sbps-credit-card-modal-component-module__GDK__helpDescription___16Isi {\n  font-size: 0.75rem;\n}\n\n.sbps-credit-card-modal-component-module__GDK__helpButton___EAV-P {\n  color: #3739a2;\n  display: block;\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.sbps-credit-card-modal-component-module__GDK__helpImage___5FdFT {\n  display: block;\n  position: relative;\n}\n";
var styles = {"availableCardTitle":"sbps-credit-card-modal-component-module__GDK__availableCardTitle___VrwUI","availableCardList":"sbps-credit-card-modal-component-module__GDK__availableCardList___qujub","creditCard":"sbps-credit-card-modal-component-module__GDK__creditCard___5fgK-","wrapper":"sbps-credit-card-modal-component-module__GDK__wrapper___KIYaz","container":"sbps-credit-card-modal-component-module__GDK__container___s2rFr","column":"sbps-credit-card-modal-component-module__GDK__column___ODO-O","formControl":"sbps-credit-card-modal-component-module__GDK__formControl___2r1n9","formExpanded":"sbps-credit-card-modal-component-module__GDK__formExpanded___Ak-B-","helpControl":"sbps-credit-card-modal-component-module__GDK__helpControl___VlC1P","helpDescription":"sbps-credit-card-modal-component-module__GDK__helpDescription___16Isi","helpButton":"sbps-credit-card-modal-component-module__GDK__helpButton___EAV-P","helpImage":"sbps-credit-card-modal-component-module__GDK__helpImage___5FdFT"};
styleInject(css_248z);

// discoverはサポート外なのでvalidationを走らせない
var isValidCardNo = function isValidCardNo(v) {
  return Payment__default.default.fns.cardType(v) !== "discover" && Payment__default.default.fns.validateCardNumber(v);
};
var isValidExpMonth = function isValidExpMonth(v) {
  return v.length > 0;
};
var isValidExpYear = function isValidExpYear(v) {
  return v.length > 0;
};
var isValidCvc = function isValidCvc(v) {
  return Payment__default.default.fns.validateCardCVC(v);
};
var validateCardNo = function validateCardNo(v) {
  if (!v || v.length === 0) {
    return "カード番号を入力してください。";
  }
  if (!isValidCardNo(v)) {
    return "カード番号に誤りがあります。カード番号をご確認ください。";
  }
  return undefined;
};
var validateExpMonth = function validateExpMonth(v) {
  if (!isValidExpMonth(v)) {
    return "有効期限(月)を入力してください。";
  }
  return undefined;
};
var validateExpYear = function validateExpYear(v) {
  if (!isValidExpYear(v)) {
    return "有効期限(年)を入力してください。";
  }
  return undefined;
};
var validateExpCvc = function validateExpCvc(v) {
  if (!isValidCvc(v)) {
    return "セキュリティコードを入力してください。";
  }
  return undefined;
};
var isValidAll = function isValidAll(cardNumber, expYear, expMonth, cvcNumber) {
  return isValidCardNo(cardNumber) && isValidExpMonth(expMonth) && isValidExpYear(expYear) && isValidCvc(cvcNumber);
};
var monthOptions = [{
  text: "月",
  value: ""
}, {
  text: "01",
  value: "01"
}, {
  text: "02",
  value: "02"
}, {
  text: "03",
  value: "03"
}, {
  text: "04",
  value: "04"
}, {
  text: "05",
  value: "05"
}, {
  text: "06",
  value: "06"
}, {
  text: "07",
  value: "07"
}, {
  text: "08",
  value: "08"
}, {
  text: "09",
  value: "09"
}, {
  text: "10",
  value: "10"
}, {
  text: "11",
  value: "11"
}, {
  text: "12",
  value: "12"
}];
var yearOptions = function yearOptions() {
  var result = [{
    text: "年",
    value: ""
  }];
  var current = new Date().getFullYear();
  for (var i = current; i < current + 20; i++) {
    result.push({
      text: i.toString(),
      value: i.toString()
    });
  }
  return result;
};
var SbpsCreditCardModalComponent = function SbpsCreditCardModalComponent(_ref) {
  var isRequesting = _ref.isRequesting,
    buttonTitle = _ref.buttonTitle,
    cvcImgPath = _ref.cvcImgPath,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var cardNumberRef = React__namespace.createRef();
  var cvcNumberRef = React__namespace.createRef();
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCvcNumberValid = _useState2[0],
    setCvcNumberValid = _useState2[1];
  var _useState3 = React.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCardNumberValid = _useState4[0],
    setCardNumberValid = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCardOnBlur = _useState6[0],
    setIsCardOnBlur = _useState6[1];
  var _useState7 = React.useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isCvcNumberOnBlur = _useState8[0],
    setIsCvcNumberOnBlur = _useState8[1];
  var _useState9 = React.useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    cardNumber = _useState10[0],
    setCardNumber = _useState10[1];
  var _useState11 = React.useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    expMonth = _useState12[0],
    setExpMonth = _useState12[1];
  var _useState13 = React.useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    expYear = _useState14[0],
    setExpYear = _useState14[1];
  var _useState15 = React.useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    cvcNumber = _useState16[0],
    setCvcNumber = _useState16[1];
  var _useState17 = React.useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isHelpContentExpanded = _useState18[0],
    setIsHelpContentExpanded = _useState18[1];
  var onSetCardNumber = function onSetCardNumber(card) {
    if (cardNumberRef.current) {
      Payment__default.default.formatCardNumber(cardNumberRef.current);
    }
    setCardNumber(card);
  };
  var onSetCvcNumber = function onSetCvcNumber(cvc) {
    if (cvcNumberRef.current) {
      Payment__default.default.formatCardCVC(cvcNumberRef.current);
    }
    setCvcNumber(cvc);
  };
  var onSubmitCard = function onSubmitCard() {
    onSubmit({
      cardNo: cardNumber,
      expMonth: expMonth,
      expYear: expYear,
      cvc: cvcNumber
    });
  };
  return React__namespace.createElement(DefaultDialog, {
    title: "\u652F\u6255\u3044\u65B9\u6CD5",
    onCancel: onClose,
    onProceed: onSubmitCard,
    cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
    proceedText: buttonTitle,
    proceedDisabled: !isValidAll(cardNumber, expYear, expMonth, cvcNumber) || isRequesting,
    contents: React__namespace.createElement("div", {
      className: styles.wrapper
    }, React__namespace.createElement("div", {
      className: styles.creditCard,
      "aria-hidden": "true"
    }, React__namespace.createElement(Card__default.default, {
      acceptedCards: ["visa", "jcb", "mastercard", "amex", "dinersclub"],
      number: cardNumber,
      expiry: expMonth + expYear,
      cvc: cvcNumber,
      name: ""
    })), React__namespace.createElement("div", {
      className: styles.container
    }, React__namespace.createElement("p", {
      className: styles.availableCardTitle
    }, "\u3054\u5229\u7528\u53EF\u80FD\u306A\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"), React__namespace.createElement("ul", {
      className: styles.availableCardList
    }, React__namespace.createElement("li", null, React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cardIcon",
      icon: freeBrandsSvgIcons.faCcVisa,
      "aria-label": "Visa",
      "aria-hidden": "false",
      size: "xl"
    })), React__namespace.createElement("li", null, React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cardIcon",
      icon: freeBrandsSvgIcons.faCcJcb,
      "aria-label": "Jcb",
      "aria-hidden": "false",
      size: "xl"
    })), React__namespace.createElement("li", null, React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cardIcon",
      icon: freeBrandsSvgIcons.faCcMastercard,
      "aria-label": "Mastercard",
      "aria-hidden": "false",
      size: "xl"
    })), React__namespace.createElement("li", null, React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cardIcon",
      icon: freeBrandsSvgIcons.faCcAmex,
      "aria-label": "American Express",
      "aria-hidden": "false",
      size: "xl"
    })), React__namespace.createElement("li", null, React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      className: "cardIcon",
      icon: freeBrandsSvgIcons.faCcDinersClub,
      "aria-label": "Diners Club",
      "aria-hidden": "false",
      size: "xl"
    })))), React__namespace.createElement("div", {
      className: styles.formControl
    }, React__namespace.createElement("div", {
      className: styles.container
    }, React__namespace.createElement(CreditCardTextField, {
      inputRef: cardNumberRef,
      required: true,
      type: "tel",
      placeholder: "1234 5678 9012 3456",
      value: cardNumber,
      title: "\u30AB\u30FC\u30C9\u756A\u53F7",
      validate: function validate() {
        return isCardNumberValid;
      },
      errorMessage: validateCardNo(cardNumber),
      autoComplete: "cc-number",
      onChange: function onChange(e) {
        return onSetCardNumber(e.target.value);
      },
      onFocus: function onFocus() {
        setIsCardOnBlur(!isCardOnBlur);
      },
      onBlur: function onBlur(e) {
        setIsCardOnBlur(!isCardOnBlur);
        setCardNumberValid(isValidCardNo(e.target.value));
      }
    })), React__namespace.createElement("div", {
      className: styles.container
    }, React__namespace.createElement("div", {
      className: styles.column
    }, React__namespace.createElement("div", {
      className: "".concat(styles.formControl, " ").concat(styles.formExpanded)
    }, React__namespace.createElement(SelectInput, {
      value: expMonth,
      required: true,
      name: "cardExpirationMonth",
      id: "cardExpirationMonth",
      options: monthOptions,
      validate: isValidExpMonth,
      onChange: setExpMonth,
      errorMessage: validateExpMonth(expMonth),
      title: "月",
      placeholder: "\u9078\u629E",
      autoComplete: "cc-exp-month"
    })), React__namespace.createElement("div", {
      className: "".concat(styles.formControl, " ").concat(styles.formExpanded)
    }, React__namespace.createElement(SelectInput, {
      name: "cardExpirationYear",
      id: "cardExpirationYear",
      value: expYear,
      required: true,
      options: yearOptions(),
      validate: isValidExpYear,
      onChange: setExpYear,
      errorMessage: validateExpYear(expYear),
      title: "\u5E74",
      placeholder: "\u9078\u629E",
      autoComplete: "cc-exp-year"
    })))), React__namespace.createElement("div", null, React__namespace.createElement("div", {
      className: styles.container
    }, React__namespace.createElement(CreditCardTextField, {
      inputRef: cvcNumberRef,
      required: true,
      name: "cvc",
      value: cvcNumber,
      type: "password",
      title: "セキュリティコード",
      placeholder: "123",
      validate: function validate() {
        return isCvcNumberValid;
      },
      errorMessage: validateExpCvc(cvcNumber),
      onChange: function onChange(e) {
        onSetCvcNumber(e.target.value);
      },
      onFocus: function onFocus() {
        setIsCvcNumberOnBlur(!isCvcNumberOnBlur);
      },
      onBlur: function onBlur(e) {
        setIsCvcNumberOnBlur(!isCvcNumberOnBlur);
        validateExpCvc(e.target.value);
        setCvcNumberValid(isValidCvc(e.target.value));
      },
      autoComplete: "cc-csc"
    }), cvcImgPath && React__namespace.createElement("p", {
      className: styles.helpControl
    }, React__namespace.createElement("button", {
      className: styles.helpButton,
      onClick: function onClick() {
        setIsHelpContentExpanded(!isHelpContentExpanded);
      }
    }, "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3068\u306F", " ", isHelpContentExpanded ? React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeSolidSvgIcons.faAngleUp
    }) : React__namespace.createElement(reactFontawesome.FontAwesomeIcon, {
      icon: freeSolidSvgIcons.faAngleDown
    }))), isHelpContentExpanded && cvcImgPath && React__namespace.createElement("div", null, React__namespace.createElement("p", {
      className: styles.helpDescription
    }, "\u30AB\u30FC\u30C9\u306E\u80CC\u9762\u3082\u3057\u304F\u306F\u524D\u9762\u306B\u8A18\u8F09\u3055\u308C\u3066\u3044\u308B\u30013\u6841\u3082\u3057\u304F\u306F4\u6841\u306E\u756A\u53F7\u3067\u3059\u3002"), React__namespace.createElement("img", {
      src: cvcImgPath,
      alt: "cvc-sample",
      className: styles.helpImage
    }))))))
  });
};

var SbpsCreditCardModal = function SbpsCreditCardModal(_ref) {
  var serviceId = _ref.serviceId,
    merchantId = _ref.merchantId,
    env = _ref.env,
    isRegisteredCreditCardExist = _ref.isRegisteredCreditCardExist,
    cvcImgPath = _ref.cvcImgPath,
    onSuccess = _ref.onSuccess,
    onFail = _ref.onFail,
    onUnExpectedError = _ref.onUnExpectedError,
    onClose = _ref.onClose;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRequesting = _useState2[0],
    setIsRequesting = _useState2[1];
  React.useEffect(function () {
    appendSbpsScriptElement(env);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var onGenerateSbpsToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var result, msg;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsRequesting(true);
            _context.prev = 1;
            _context.next = 4;
            return generateSbpsToken(_objectSpread2({
              merchantId: merchantId,
              serviceId: serviceId
            }, data));
          case 4:
            result = _context.sent;
            if (!result.errorCode) {
              _context.next = 9;
              break;
            }
            msg = resolveSbpsTokenErrorMsg(result.errorCode);
            onFail(new SbpsTokenError(msg, result.errorCode));
            return _context.abrupt("return");
          case 9:
            onSuccess(result.tokenResponse);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            onUnExpectedError(_context.t0);
          case 15:
            _context.prev = 15;
            setIsRequesting(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12, 15, 18]]);
    }));
    return function onGenerateSbpsToken(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSubmit = function onSubmit(data) {
    onGenerateSbpsToken(data);
  };
  return React__namespace.createElement(SbpsCreditCardModalComponent, {
    isRequesting: isRequesting,
    buttonTitle: isRegisteredCreditCardExist ? "変更する" : "設定する",
    cvcImgPath: cvcImgPath,
    onSubmit: onSubmit,
    onClose: onClose
  });
};

var COLOR_TARGET = "COLOR_TARGET";
// https://www.figma.com/file/yqSs9KgmTCRPrS4lsL95Jm/favicon?type=design&node-id=1242-172&t=d01pDE8rcE80p5Eu-0
var originalFavicon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"none\">\n  <path fill=\"".concat(COLOR_TARGET, "\" d=\"M0 0h16v16H0z\"/>\n  <g clip-path=\"url(#a)\">\n    <mask id=\"b\" width=\"12\" height=\"12\" x=\"2\" y=\"2\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:luminance\">\n      <path fill=\"#fff\" d=\"M13.817 2H2.004v12h11.813V2Z\"/>\n    </mask>\n    <g mask=\"url(#b)\">\n      <mask id=\"c\" width=\"12\" height=\"12\" x=\"2\" y=\"2\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:luminance\">\n        <path fill=\"#fff\" d=\"M13.817 2H2.004v12h11.813V2Z\"/>\n      </mask>\n      <g fill=\"#fff\" mask=\"url(#c)\">\n        <path d=\"M6.37 13.3V7.484a1.118 1.118 0 0 1 1.121-1.12h5.628a.702.702 0 0 0 .702-.7V2.702a.698.698 0 0 0-.436-.649.703.703 0 0 0-.27-.052H3.113a1.107 1.107 0 0 0-1.109 1.103V13.3a.7.7 0 0 0 .702.7h2.962a.703.703 0 0 0 .702-.7Z\"/>\n        <path d=\"M12.881 9.42h-2.717a.935.935 0 0 0-.936.935v2.711c0 .516.419.934.936.934h2.717a.935.935 0 0 0 .936-.934v-2.711a.935.935 0 0 0-.936-.934Z\"/>\n      </g>\n    </g>\n  </g>\n  <defs>\n    <clipPath id=\"a\">\n      <path fill=\"#fff\" d=\"M2 2h11.906v12H2z\"/>\n    </clipPath>\n  </defs>\n</svg>\n");
var colorMap = {
  production: null,
  production_sandbox: null,
  staging: "#DB6A2F",
  staging_sandbox: "#83C7EF",
  dev: "#D8CE46",
  local: "#4EAC7F"
};
var getFavicon = function getFavicon(env) {
  var color = colorMap[env];
  if (!color) {
    // production、production_sandboxでは%PUBLIC_URL%/favicon.pngを使う想定
    // SafariではSVGをfaviconとして使えないため、png形式の画像にしている
    return null;
  }
  return originalFavicon.replace(COLOR_TARGET, color);
};
var replaceFavicon = function replaceFavicon(linkElement, env) {
  var favicon = getFavicon(env);
  if (!favicon) {
    return;
  }
  linkElement.setAttribute("href", "data:image/svg+xml,".concat(encodeURIComponent(favicon)));
};

exports.ADDRESS_AUTO_INPUT_INFO_TEXT = ADDRESS_AUTO_INPUT_INFO_TEXT;
exports.ASK_USER_TO_COMPLETE_ADDRESS_FORM_TEXT = ASK_USER_TO_COMPLETE_ADDRESS_FORM_TEXT;
exports.AddressAutoInput = AddressAutoInput;
exports.AgreementSingleCheckboxInput = AgreementSingleCheckboxInput;
exports.BaseDateInput = BaseDateInput;
exports.BaseNumberInputFormat = BaseNumberInputFormat;
exports.BaseTimeAndDateRangeInput = BaseTimeAndDateRangeInput;
exports.BirthDayInput = BirthDayInput;
exports.ButtonGroup = ButtonGroup;
exports.CancelButton = CancelButton;
exports.CheckboxInput = CheckboxInput;
exports.CorporationSearchForm = CorporationSearchForm;
exports.DangerButton = DangerButton;
exports.DangerSecondaryButton = DangerSecondaryButton;
exports.DateInput = DateInput;
exports.DatePicker = DatePicker;
exports.DateRangeInput = DateRangeInput;
exports.DateRangePicker = DateRangePicker;
exports.DayInput = DayInput;
exports.DefaultBanner = DefaultBanner;
exports.DefaultDialog = DefaultDialog;
exports.DefaultMessage = DefaultMessage;
exports.ErrorBanner = ErrorBanner;
exports.ErrorDialog = ErrorDialog;
exports.ErrorMessage = ErrorMessage;
exports.ErrorMessages = ErrorMessages;
exports.ExternalLink = ExternalLink;
exports.FaqLink = FaqLink;
exports.FieldsetWrap = FieldsetWrap;
exports.FileUploadInput = FileUploadInput;
exports.Footer = Footer;
exports.ForTestSpinnerInner = ForTestSpinnerInner;
exports.Form = Form$1;
exports.FormContainer = FormContainer;
exports.FormItem = FormItem;
exports.GrafferSchemasCheckBoxInputComponent = GrafferSchemasCheckBoxInputComponent;
exports.GrafferSchemasContextProvider = GrafferSchemasContextProvider;
exports.GrafferSchemasDateInputComponent = GrafferSchemasDateInputComponent;
exports.GrafferSchemasDateRangeInputComponent = GrafferSchemasDateRangeInputComponent;
exports.GrafferSchemasDayInputComponent = GrafferSchemasDayInputComponent;
exports.GrafferSchemasErrorMessages = GrafferSchemasErrorMessages;
exports.GrafferSchemasFieldsetWrap = GrafferSchemasFieldsetWrap;
exports.GrafferSchemasMultipleDateRangeInputComponent = GrafferSchemasMultipleDateRangeInputComponent;
exports.GrafferSchemasNumberInputFormatComponent = GrafferSchemasNumberInputFormatComponent;
exports.GrafferSchemasRadioInputComponent = GrafferSchemasRadioInputComponent;
exports.GrafferSchemasSecondaryButton = GrafferSchemasSecondaryButton;
exports.GrafferSchemasSelectComponent = GrafferSchemasSelectComponent;
exports.GrafferSchemasSingleFileUploadComponent = GrafferSchemasSingleFileUploadComponent;
exports.GrafferSchemasTags = GrafferSchemasTags;
exports.GrafferSchemasTextAreaComponent = GrafferSchemasTextAreaComponent;
exports.GrafferSchemasTextInputComponent = GrafferSchemasTextInputComponent;
exports.GrafferSchemasTimeAndDateInputComponent = GrafferSchemasTimeAndDateInputComponent;
exports.GrafferSchemasTimeAndDateRangeInputComponent = GrafferSchemasTimeAndDateRangeInputComponent;
exports.GrafferSchemasTimeInputComponent = GrafferSchemasTimeInputComponent;
exports.GrafferSchemasTimeRangeComponent = GrafferSchemasTimeRangeComponent;
exports.GrafferSchemasTitleWrap = GrafferSchemasTitleWrap;
exports.GrafferSchemasYearMonthDayInput = GrafferSchemasYearMonthDayInput;
exports.GrafferUiModalDialog = GrafferUiModalDialog;
exports.GrafferYearMonthInput = GrafferYearMonthInput;
exports.HelperText = HelperText;
exports.Link = Link;
exports.MessageDialog = MessageDialog;
exports.MobileDatePicker = MobileDatePicker;
exports.NumberInputFormat = NumberInputFormat;
exports.PcDatePicker = PcDatePicker;
exports.PostalCodeSearch = PostalCodeSearch;
exports.PostalCodeSearchInput = PostalCodeSearchInput;
exports.PrimaryButton = PrimaryButton;
exports.RadioInput = RadioInput;
exports.ReviewStars = ReviewStars;
exports.SbpsCreditCardModal = SbpsCreditCardModal;
exports.SecondaryButton = SecondaryButton;
exports.Select = Select;
exports.SelectInput = SelectInput;
exports.SingleFileUpload = SingleFileUpload;
exports.Snackbar = Snackbar;
exports.SnackbarContainer = SnackbarContainer;
exports.SnackbarContent = SnackbarContent;
exports.Spinner = Spinner;
exports.StatusTag = StatusTag;
exports.StepProgress = StepProgress;
exports.SuccessMessage = SuccessMessage;
exports.TextArea = TextArea;
exports.TextButton = TextButton;
exports.TextField = TextField;
exports.TextInput = TextInput;
exports.TimeAndDateInput = TimeAndDateInput;
exports.TimeAndDateRangeInput = TimeAndDateRangeInput;
exports.TimeInput = TimeInput;
exports.TimeRange = TimeRange;
exports.TitleWrap = TitleWrap;
exports.WarningBanner = WarningBanner;
exports.WarningDialog = WarningDialog;
exports.WarningMessage = WarningMessage;
exports.YearMonthInput = YearMonthInput;
exports.getAutoCompleteAddressButtonId = getAutoCompleteAddressButtonId;
exports.getTimeString = getTimeString;
exports.replaceFavicon = replaceFavicon;
exports.useDeviceType = useDeviceType;
exports.useGrafferSchemasIds = useGrafferSchemasIds;
